import { mapState, mapGetters, mapMutations } from 'vuex';
import VueApexCharts from 'vue-apexcharts';
import _ from 'lodash';
import axios from 'axios';
import differenceInYears from 'date-fns/differenceInYears';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$j = {
  name: 'PlayerHeader',
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  data: function data() {
    return {
      isNationalTeam: false,
      hasBeenInNationalTeam: false,
    };
  },
  watch: {
    isNationalTeam: function isNationalTeam(newValue) {
      this.$emit('teamClassChanged', newValue ? 1 : 0);
    },
    player: function player(newValue) {
      this.hasBeenInNationalTeam = newValue ? newValue.is_national_team === 1 : false;
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass:
        "is-bordered-box-shadow-secondary player-container is-hidden-mobile"
    },
    [
      _c("div", { staticClass: "player-info" }, [
        _c("div", { staticClass: "player-picture-and-team" }, [
          _c("div", { staticClass: "player-picture-container" }, [
            _c("img", {
              staticClass: "player-picture",
              attrs: { src: _vm.player.player_photo, alt: "" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "team-image-container" }, [
            _c("img", {
              staticClass: "team-mini-logo",
              attrs: { src: _vm.player.team_logo, alt: "" }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "player-personal-info" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ],
              staticClass: "player-team"
            },
            [
              _c(
                "span",
                {
                  staticClass: "is-clickable",
                  staticStyle: { "margin-right": "12px" },
                  on: {
                    click: function($event) {
                      _vm.isNationalTeam = false;
                    }
                  }
                },
                [_vm._v("CLUB")]
              ),
              _vm._v(" "),
              _c("BSwitch", {
                attrs: {
                  size: "is-small",
                  disabled: _vm.player.is_national_team === 0
                },
                model: {
                  value: _vm.isNationalTeam,
                  callback: function($$v) {
                    _vm.isNationalTeam = $$v;
                  },
                  expression: "isNationalTeam"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "is-clickable",
                  on: {
                    click: function($event) {
                      _vm.isNationalTeam = true;
                    }
                  }
                },
                [_vm._v("SELECCIÓN NACIONAL")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "player-name" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.player.player_name) + "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "player-nationality" }, [
            _c("span", [
              _c("img", { attrs: { src: _vm.player.flag, alt: "" } }),
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("toNationalityName")(_vm.player.nationality_id)
                  ) +
                  " • " +
                  _vm._s(_vm._f("toAge")(_vm.player.dob)) +
                  " años •\n            " +
                  _vm._s(
                    _vm._f("toPlayerPositionName")(_vm.player.position_id)
                  ) +
                  "\n          "
              )
            ])
          ])
        ])
      ])
    ]
  )
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;

  /* style */
  var __vue_inject_styles__$j = function (inject) {
    if (!inject) { return }
    inject("data-v-fcd7672c_0", { source: ".player-container[data-v-fcd7672c] {\n  display: flex;\n  flex-flow: wrap;\n  justify-content: space-between;\n  border-radius: 16px;\n  padding: 18px 27px 9px;\n}\n.player-info[data-v-fcd7672c] {\n  display: flex;\n  flex-flow: wrap;\n}\n.player-picture-and-team[data-v-fcd7672c] {\n  margin-left: 35px;\n  margin-right: 21px;\n  margin-bottom: 9px;\n  position: relative;\n}\n.player-picture-container[data-v-fcd7672c] {\n  width: 85px;\n  height: 121px;\n  border: 3.5px solid #7ed321;\n  border-radius: 8px;\n}\n.player-picture-container > img.player-picture[data-v-fcd7672c] {\n  height: 100%;\n}\n.team-image-container[data-v-fcd7672c] {\n  position: absolute;\n  height: 46px;\n  width: 46px;\n  top: -10px;\n  left: -25px;\n  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.7));\n}\n.team-image-container > img.team-mini-logo[data-v-fcd7672c] {\n  height: 100%;\n}\n.player-personal-info[data-v-fcd7672c] {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  margin-bottom: 9px;\n}\n.player-personal-info .player-team[data-v-fcd7672c] {\n  vertical-align: middle;\n}\n.player-name[data-v-fcd7672c] {\n  font-size: 44px;\n  line-height: 1.23;\n  align-self: center;\n  text-transform: uppercase;\n  color: #808285;\n  margin-top: 30px;\n  text-align: left;\n}\n.player-nationality[data-v-fcd7672c] {\n  font-size: 14px;\n  line-height: normal;\n  color: #808285;\n  vertical-align: middle;\n}\n.player-team[data-v-fcd7672c] {\n  font-size: 10px;\n  line-height: normal;\n  color: #808285;\n}\n.player-number[data-v-fcd7672c] {\n  margin-right: 20px;\n  margin-bottom: 9px;\n  font-size: 177px;\n  font-weight: bold;\n  font-style: normal;\n  line-height: 0.9;\n  letter-spacing: -33px;\n  text-align: right;\n  color: #f2f2f2;\n}\n.player-nationality img[data-v-fcd7672c] {\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n  vertical-align: middle;\n}\n\n/*# sourceMappingURL=PlayerHeader.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/PlayerHeader.vue","PlayerHeader.vue"],"names":[],"mappings":"AAkEA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;ACjEA;ADoEA;EACA,aAAA;EACA,eAAA;ACjEA;ADoEA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;ACjEA;ADoEA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;ACjEA;ADkEA;EACA,YAAA;AChEA;ADoEA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,iDAAA;ACjEA;ADkEA;EACA,YAAA;AChEA;ADoEA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;ACjEA;ADkEA;EACA,sBAAA;AChEA;ADoEA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;ACjEA;ADoEA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;ACjEA;ADoEA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;ACjEA;ADoEA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;ACjEA;ADoEA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;ACjEA;;AAEA,2CAA2C","file":"PlayerHeader.vue","sourcesContent":["<template>\n  <div class=\"is-bordered-box-shadow-secondary player-container is-hidden-mobile\">\n    <!-- Player info -->\n    <div class=\"player-info\">\n      <!-- Picture and team logo -->\n      <div class=\"player-picture-and-team\">\n        <div class=\"player-picture-container\">\n          <img :src=\"player.player_photo\" alt=\"\" class=\"player-picture\" />\n        </div>\n        <div class=\"team-image-container\">\n          <img :src=\"player.team_logo\" alt=\"\" class=\"team-mini-logo\" />\n        </div>\n      </div>\n      <!-- Personal info -->\n      <div class=\"player-personal-info\">\n        <div class=\"player-team\" v-show=\"false\">\n          <span @click=\"isNationalTeam = false\" class=\"is-clickable\" style=\"margin-right: 12px;\">CLUB</span>\n          <BSwitch size=\"is-small\" v-model=\"isNationalTeam\" :disabled=\"player.is_national_team === 0\" />\n          <span class=\"is-clickable\" @click=\"isNationalTeam = true\">SELECCIÓN NACIONAL</span>\n        </div>\n        <div class=\"player-name\">\n          {{ player.player_name }}\n        </div>\n        <div class=\"player-nationality\">\n          <span>\n            <img :src=\"player.flag\" alt=\"\" />\n            {{ player.nationality_id | toNationalityName }} &#8226; {{ player.dob | toAge }} años &#8226;\n            {{ player.position_id | toPlayerPositionName }}\n          </span>\n        </div>\n      </div>\n    </div>\n    <!-- Player number -->\n<!--    <div class=\"player-number\">-->\n<!--      {{ player.jersey_number }}-->\n<!--    </div>-->\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'PlayerHeader',\n  props: {\n    player: {\n      type: Object,\n      required: true,\n    },\n  },\n  data() {\n    return {\n      isNationalTeam: false,\n      hasBeenInNationalTeam: false,\n    };\n  },\n  watch: {\n    isNationalTeam(newValue) {\n      this.$emit('teamClassChanged', newValue ? 1 : 0);\n    },\n    player(newValue) {\n      this.hasBeenInNationalTeam = newValue ? newValue.is_national_team === 1 : false;\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"scss\">\n.player-container {\n  display: flex;\n  flex-flow: wrap;\n  justify-content: space-between;\n  border-radius: 16px;\n  padding: 18px 27px 9px;\n}\n\n.player-info {\n  display: flex;\n  flex-flow: wrap;\n}\n\n.player-picture-and-team {\n  margin-left: 35px;\n  margin-right: 21px;\n  margin-bottom: 9px;\n  position: relative;\n}\n\n.player-picture-container {\n  width: 85px;\n  height: 121px;\n  border: 3.5px solid #7ed321;\n  border-radius: 8px;\n  & > img.player-picture {\n    height: 100%;\n  }\n}\n\n.team-image-container {\n  position: absolute;\n  height: 46px;\n  width: 46px;\n  top: -10px;\n  left: -25px;\n  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.7));\n  & > img.team-mini-logo {\n    height: 100%;\n  }\n}\n\n.player-personal-info {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  margin-bottom: 9px;\n  & .player-team {\n    vertical-align: middle;\n  }\n}\n\n.player-name {\n  font-size: 44px;\n  line-height: 1.23;\n  align-self: center;\n  text-transform: uppercase;\n  color: #808285;\n  margin-top: 30px;\n  text-align: left;\n}\n\n.player-nationality {\n  font-size: 14px;\n  line-height: normal;\n  color: #808285;\n  vertical-align: middle;\n}\n\n.player-team {\n  font-size: 10px;\n  line-height: normal;\n  color: #808285;\n}\n\n.player-number {\n  margin-right: 20px;\n  margin-bottom: 9px;\n  font-size: 177px;\n  font-weight: bold;\n  font-style: normal;\n  line-height: 0.9;\n  letter-spacing: -33px;\n  text-align: right;\n  color: #f2f2f2;\n}\n\n.player-nationality img {\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n  vertical-align: middle;\n}\n</style>\n",".player-container {\n  display: flex;\n  flex-flow: wrap;\n  justify-content: space-between;\n  border-radius: 16px;\n  padding: 18px 27px 9px;\n}\n\n.player-info {\n  display: flex;\n  flex-flow: wrap;\n}\n\n.player-picture-and-team {\n  margin-left: 35px;\n  margin-right: 21px;\n  margin-bottom: 9px;\n  position: relative;\n}\n\n.player-picture-container {\n  width: 85px;\n  height: 121px;\n  border: 3.5px solid #7ed321;\n  border-radius: 8px;\n}\n.player-picture-container > img.player-picture {\n  height: 100%;\n}\n\n.team-image-container {\n  position: absolute;\n  height: 46px;\n  width: 46px;\n  top: -10px;\n  left: -25px;\n  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.7));\n}\n.team-image-container > img.team-mini-logo {\n  height: 100%;\n}\n\n.player-personal-info {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  margin-bottom: 9px;\n}\n.player-personal-info .player-team {\n  vertical-align: middle;\n}\n\n.player-name {\n  font-size: 44px;\n  line-height: 1.23;\n  align-self: center;\n  text-transform: uppercase;\n  color: #808285;\n  margin-top: 30px;\n  text-align: left;\n}\n\n.player-nationality {\n  font-size: 14px;\n  line-height: normal;\n  color: #808285;\n  vertical-align: middle;\n}\n\n.player-team {\n  font-size: 10px;\n  line-height: normal;\n  color: #808285;\n}\n\n.player-number {\n  margin-right: 20px;\n  margin-bottom: 9px;\n  font-size: 177px;\n  font-weight: bold;\n  font-style: normal;\n  line-height: 0.9;\n  letter-spacing: -33px;\n  text-align: right;\n  color: #f2f2f2;\n}\n\n.player-nationality img {\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n  vertical-align: middle;\n}\n\n/*# sourceMappingURL=PlayerHeader.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$j = "data-v-fcd7672c";
  /* module identifier */
  var __vue_module_identifier__$j = undefined;
  /* functional template */
  var __vue_is_functional_template__$j = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$j = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$i = {
  name: 'PlayerHeaderMobile',
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  data: function data() {
    return {
      isNationalTeam: false,
    };
  },
  watch: {
    isNationalTeam: function isNationalTeam(newValue) {
      this.$emit('teamClassChanged', newValue ? 1 : 0);
    },
  },
};

/* script */
var __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("section", { staticClass: "player-header" }, [
    _c("nav", { staticClass: "is-hidden-tablet" }, [
      _c("div", { staticClass: "card is-round-4" }, [
        _c(
          "div",
          { staticClass: "columns is-gapless  is-vcentered is-mobile" },
          [
            _c("div", { staticClass: "column is-3" }, [
              _c("div", { staticClass: "player-picture-container" }, [
                _c("img", {
                  staticClass: "player-picture",
                  attrs: { src: _vm.player.player_photo, alt: "" }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column is-9 " }, [
              _c(
                "div",
                {
                  staticClass:
                    "columns is-gapless is-centered is-vcentered is-mobile"
                },
                [
                  _c("div", { staticClass: "column is-10 " }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "columns is-gapless is-centered is-vcentered is-mobile"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "column is-3 is-gapless team-logo" },
                          [
                            _c(
                              "figure",
                              { staticStyle: { width: "100%", margin: "0" } },
                              [
                                _c("img", {
                                  staticClass: "team-mini-logo",
                                  attrs: { src: _vm.player.team_logo, alt: "" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { visibility: "hidden" } },
                              [_vm._v("CLUB")]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "columns is-gapless box-info is-centered is-vcentered is-mobile"
                },
                [
                  _c("div", { staticClass: "column is-1 " }, [
                    _c("img", {
                      staticClass: "player-picture",
                      attrs: { src: _vm.player.flag, alt: "" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column is-11 " }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("toNationalityName")(_vm.player.nationality_id)
                        ) +
                        " • " +
                        _vm._s(_vm._f("toAge")(_vm.player.dob)) +
                        " años •\n                " +
                        _vm._s(
                          _vm._f("toPlayerPositionName")(_vm.player.position_id)
                        ) +
                        "\n              "
                    )
                  ])
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "columns is-gapless is-mobile is-vcentered" },
          [
            _c("div", { staticClass: "column is-12 player-name-mobile" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.player.player_name) +
                  "\n          "
              )
            ])
          ]
        )
      ])
    ])
  ])
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;

  /* style */
  var __vue_inject_styles__$i = function (inject) {
    if (!inject) { return }
    inject("data-v-18275058_0", { source: ".player-picture-container[data-v-18275058] {\n  width: 85px;\n  height: 121px;\n  border: 3.5px solid #7ed321;\n  border-radius: 8px;\n}\n.player-picture-container > img.player-picture[data-v-18275058] {\n  height: 100%;\n}\n.card[data-v-18275058] {\n  border-radius: 16px 16px 0px 0px;\n  margin: 0px 20px;\n  padding: 20px 0px;\n}\n.column.is-3[data-v-18275058] {\n  display: flex;\n  justify-content: center;\n}\n.team-logo[data-v-18275058] {\n  flex-direction: column;\n  font-size: 0.6rem;\n}\n.team-logo .team-mini-logo[data-v-18275058] {\n  width: fit-content;\n}\n.box-info[data-v-18275058] {\n  background-color: #f7f7f7;\n  color: #808285;\n  font-size: 1rem;\n}\n.player-number-mobile[data-v-18275058] {\n  color: #808285;\n  font-size: 3rem;\n  font-family: Avenir-Bold;\n  line-height: 2rem;\n}\n.player-name-mobile[data-v-18275058] {\n  color: #757575;\n  font-size: 1.5rem;\n  text-align: left;\n  font-family: Avenir-Demi;\n}\n\n/*# sourceMappingURL=PlayerHeaderMobile.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/PlayerHeaderMobile.vue","PlayerHeaderMobile.vue"],"names":[],"mappings":"AAmFA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;AClFA;ADmFA;EACA,YAAA;ACjFA;ADoFA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;ACjFA;ADmFA;EACA,aAAA;EACA,uBAAA;AChFA;ADkFA;EACA,sBAAA;EACA,iBAAA;AC/EA;ADiFA;EACA,kBAAA;AC/EA;ADkFA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AC/EA;ADiFA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AC9EA;ADgFA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;AC7EA;;AAEA,iDAAiD","file":"PlayerHeaderMobile.vue","sourcesContent":["<template>\n  <section class=\"player-header\">\n    <nav class=\"is-hidden-tablet\">\n      <div class=\"card is-round-4\">\n        <div class=\"columns is-gapless  is-vcentered is-mobile\">\n          <div class=\"column is-3\">\n            <div class=\"player-picture-container\">\n              <img :src=\"player.player_photo\" alt=\"\" class=\"player-picture\" />\n            </div>\n          </div>\n\n          <div class=\"column is-9 \">\n            <div class=\"columns is-gapless is-centered is-vcentered is-mobile\">\n              <div class=\"column is-10 \">\n                <div class=\"columns is-gapless is-centered is-vcentered is-mobile\">\n                  <div class=\"column is-3 is-gapless team-logo\">\n                    <figure style=\"width: 100%; margin: 0;\">\n                      <img :src=\"player.team_logo\" alt=\"\" class=\"team-mini-logo\" />\n                    </figure>\n                    <div style=\"visibility: hidden\">CLUB</div>\n                  </div>\n                  <!-- <div class=\"column is-3 team-logo\">\n                    <img :src=\"player.team_logo\" alt=\"\" class=\"team-mini-logo\" />\n                    CLUB\n                  </div>\n                  <div class=\"column is-6\">\n                    <BSwitch\n                      v-show=\"player.is_national_team !== 0\"\n                      size=\"is-medium\"\n                      v-model=\"isNationalTeam\"\n                      passive-type=\"is-primary\"\n                    />\n                  </div>\n                  <div class=\"column is-3 \"></div> -->\n                </div>\n              </div>\n            </div>\n            <div class=\"columns is-gapless box-info is-centered is-vcentered is-mobile\">\n              <div class=\"column is-1 \">\n                <img :src=\"player.flag\" alt=\"\" class=\"player-picture\" />\n              </div>\n              <div class=\"column is-11 \">\n                {{ player.nationality_id | toNationalityName }} &#8226; {{ player.dob | toAge }} años &#8226;\n                {{ player.position_id | toPlayerPositionName }}\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"columns is-gapless is-mobile is-vcentered\">\n<!--          <div class=\"column is-3 player-number-mobile \">-->\n<!--            {{ player.jersey_number }}-->\n<!--          </div>-->\n          <div class=\"column is-12 player-name-mobile\">\n            {{ player.player_name }}\n          </div>\n        </div>\n      </div>\n    </nav>\n  </section>\n</template>\n<script>\nexport default {\n  name: 'PlayerHeaderMobile',\n  props: {\n    player: {\n      type: Object,\n      required: true,\n    },\n  },\n  data() {\n    return {\n      isNationalTeam: false,\n    };\n  },\n  watch: {\n    isNationalTeam(newValue) {\n      this.$emit('teamClassChanged', newValue ? 1 : 0);\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"scss\">\n.player-picture-container {\n  width: 85px;\n  height: 121px;\n  border: 3.5px solid #7ed321;\n  border-radius: 8px;\n  & > img.player-picture {\n    height: 100%;\n  }\n}\n.card {\n  border-radius: 16px 16px 0px 0px;\n  margin: 0px 20px;\n  padding: 20px 0px;\n}\n.column.is-3 {\n  display: flex;\n  justify-content: center;\n}\n.team-logo {\n  flex-direction: column;\n  font-size: 0.6rem;\n\n  .team-mini-logo {\n    width: fit-content;\n  }\n}\n.box-info {\n  background-color: #f7f7f7;\n  color: #808285;\n  font-size: 1rem;\n}\n.player-number-mobile {\n  color: #808285;\n  font-size: 3rem;\n  font-family: Avenir-Bold;\n  line-height: 2rem;\n}\n.player-name-mobile {\n  color: #757575;\n  font-size: 1.5rem;\n  text-align: left;\n  font-family: Avenir-Demi;\n}\n</style>\n",".player-picture-container {\n  width: 85px;\n  height: 121px;\n  border: 3.5px solid #7ed321;\n  border-radius: 8px;\n}\n.player-picture-container > img.player-picture {\n  height: 100%;\n}\n\n.card {\n  border-radius: 16px 16px 0px 0px;\n  margin: 0px 20px;\n  padding: 20px 0px;\n}\n\n.column.is-3 {\n  display: flex;\n  justify-content: center;\n}\n\n.team-logo {\n  flex-direction: column;\n  font-size: 0.6rem;\n}\n.team-logo .team-mini-logo {\n  width: fit-content;\n}\n\n.box-info {\n  background-color: #f7f7f7;\n  color: #808285;\n  font-size: 1rem;\n}\n\n.player-number-mobile {\n  color: #808285;\n  font-size: 3rem;\n  font-family: Avenir-Bold;\n  line-height: 2rem;\n}\n\n.player-name-mobile {\n  color: #757575;\n  font-size: 1.5rem;\n  text-align: left;\n  font-family: Avenir-Demi;\n}\n\n/*# sourceMappingURL=PlayerHeaderMobile.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$i = "data-v-18275058";
  /* module identifier */
  var __vue_module_identifier__$i = undefined;
  /* functional template */
  var __vue_is_functional_template__$i = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$i = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$h = {
  name: 'ImageButton',
  props: {
    title: {
      type: String,
      required: true,
    },
    images: {
      type: Array,
      required: true,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    colors: {
      type: Array,
      required: false,
      default: function() {
        return ['#ffffff', '#7ed321'];
      },
    },
  },
  computed: {
    styleButtonSelected: function styleButtonSelected() {
      return {
        'background-color': this.colors[1],
        'box-shadow': 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.25)',
      };
    },
    styleButtonNormal: function styleButtonNormal() {
      return {
        'background-color': this.colors[0],
        'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.15)',
      };
    },
    styleTextSelected: function styleTextSelected() {
      return { color: '#ffffff' };
    },
    styleTextNormal: function styleTextNormal() {
      return { color: '#5c5c5c' };
    },
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    },
  },
};

/* script */
var __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "custom-image-button is-clickable",
      style: _vm.selected ? _vm.styleButtonSelected : _vm.styleButtonNormal,
      on: { click: _vm.onClick }
    },
    [
      _c("div", { staticClass: "icon-container" }, [
        _c("img", {
          staticClass: "icon",
          attrs: {
            src: _vm.selected ? _vm.images[1] : _vm.images[0],
            alt: "image for button"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-container",
          style: _vm.selected ? _vm.styleTextSelected : _vm.styleTextNormal
        },
        [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
      )
    ]
  )
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

  /* style */
  var __vue_inject_styles__$h = function (inject) {
    if (!inject) { return }
    inject("data-v-0124911d_0", { source: "\n.custom-image-button[data-v-0124911d] {\n  display: inline-block;\n  width: 112px;\n  height: 82px;\n  border-radius: 10px;\n  background-color: #ffffff;\n}\n.custom-image-button > .icon-container[data-v-0124911d] {\n  margin: 0 auto;\n  width: 71px;\n  height: 43px;\n}\n.custom-image-button > div > img.icon[data-v-0124911d] {\n  margin-top: 10px;\n  width: 90%;\n  height: 90%;\n  object-fit: contain;\n}\n.custom-image-button > .text-container[data-v-0124911d] {\n  margin-top: 18px;\n  font-size: 12px;\n  line-height: 1.07;\n  color: #5c5c5c;\n}\n@media screen and (max-width: 768px) {\n.custom-image-button[data-v-0124911d] {\n    width: 100%;\n    border-radius: 0px;\n}\n}\n", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/ImageButton.vue"],"names":[],"mappings":";AAqEA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AACA;AACA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AACA;AACA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AACA;AACA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACA;AACA;AACA;IACA,WAAA;IACA,kBAAA;AACA;AACA","file":"ImageButton.vue","sourcesContent":["<template>\n  <div\n    class=\"custom-image-button is-clickable\"\n    @click=\"onClick\"\n    :style=\"selected ? styleButtonSelected : styleButtonNormal\"\n  >\n    <div class=\"icon-container\">\n      <img class=\"icon\" :src=\"selected ? images[1] : images[0]\" alt=\"image for button\" />\n    </div>\n    <div class=\"text-container\" :style=\"selected ? styleTextSelected : styleTextNormal\">\n      {{ title }}\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'ImageButton',\n  props: {\n    title: {\n      type: String,\n      required: true,\n    },\n    images: {\n      type: Array,\n      required: true,\n    },\n    selected: {\n      type: Boolean,\n      required: false,\n      default: false,\n    },\n    colors: {\n      type: Array,\n      required: false,\n      default: function() {\n        return ['#ffffff', '#7ed321'];\n      },\n    },\n  },\n  computed: {\n    styleButtonSelected() {\n      return {\n        'background-color': this.colors[1],\n        'box-shadow': 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.25)',\n      };\n    },\n    styleButtonNormal() {\n      return {\n        'background-color': this.colors[0],\n        'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.15)',\n      };\n    },\n    styleTextSelected() {\n      return { color: '#ffffff' };\n    },\n    styleTextNormal() {\n      return { color: '#5c5c5c' };\n    },\n  },\n  methods: {\n    onClick() {\n      this.$emit('click');\n    },\n  },\n};\n</script>\n\n<style scoped>\n.custom-image-button {\n  display: inline-block;\n  width: 112px;\n  height: 82px;\n  border-radius: 10px;\n  background-color: #ffffff;\n}\n.custom-image-button > .icon-container {\n  margin: 0 auto;\n  width: 71px;\n  height: 43px;\n}\n.custom-image-button > div > img.icon {\n  margin-top: 10px;\n  width: 90%;\n  height: 90%;\n  object-fit: contain;\n}\n.custom-image-button > .text-container {\n  margin-top: 18px;\n  font-size: 12px;\n  line-height: 1.07;\n  color: #5c5c5c;\n}\n@media screen and (max-width: 768px) {\n  .custom-image-button {\n    width: 100%;\n    border-radius: 0px;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$h = "data-v-0124911d";
  /* module identifier */
  var __vue_module_identifier__$h = undefined;
  /* functional template */
  var __vue_is_functional_template__$h = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    createInjector,
    undefined,
    undefined
  );

var mainServer = 'http://golstats-2-develop.azurewebsites.net';

/**
 * @author Alejandro
 * @description This function fill table's data.
 * @param {Array<PlayerTableRow>} tableRows
 * @param {Array} playList - Play list to fill the table data
 * @param {Array} leaguePlays - League play list to fill avg column
 * @param {Array<number>} timeSelected - Selected time periods to filter the play list
 * @param {number} totalSeasonGamesOrTeams - Amount of current season games or teams
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @param {Object} leaguePlayValuesIndex - Contains index position for the league play values
 * @param {number} teamId
 * @return {Array<(PlayerTableRow|TeamTableRow)>} - the filled data table
 */
function getFilledTableRows(
  tableRows,
  playList,
  leaguePlays,
  timeSelected,
  totalSeasonGamesOrTeams,
  playValuesIndex,
  leaguePlayValuesIndex,
  teamId
) {
  if (playList) {
    playList.forEach(function (play) {
      for (var tableRow of tableRows) {
        if (tableRow.addPlay(play, timeSelected, playValuesIndex, teamId)) { break; }
      }
    });
  }
  if (leaguePlays) {
    if (!Number.isNaN(totalSeasonGamesOrTeams) && totalSeasonGamesOrTeams !== 0) {
      leaguePlays.forEach(function (play) {
        for (var tableRow of tableRows) {
          if (tableRow.addAvgPlay(play, timeSelected, leaguePlayValuesIndex, totalSeasonGamesOrTeams)) { break; }
        }
      });
    }
  }
  return tableRows;
}

/**
 * @author Alejandro
 * @description This function creates an object that contains index position for team and player
 * statistics plays
 * @param {Array<string>} playsValues
 * @return {*}
 */
function getPlayValueIndexesFromArray(playsValues) {
  return playsValues.reduce(function (accumulator, valueName, index) {
    accumulator[valueName] = index;
    return accumulator;
  }, {});
}

//

var script$g = {
  name: 'TeamAnalysis',
  props: {
    value: {
      type: Number,
      default: -1,
    },
    title: {
      type: String,
      default: 'ANÁLISIS',
      required: false,
    },
  },
  components: {
    ImageButton: __vue_component__$h,
  },
  data: function data() {
    return {
      sections: [
        {
          id: 1,
          title: 'POSESIÓN',
          images: [
            (mainServer + "/images/icn-posesion-black.svg"),
            (mainServer + "/images/icn-posesion-white.svg") ],
          selected: false,
        },
        {
          id: 2,
          title: 'OFENSIVO',
          images: [(mainServer + "/images/icn-ofensive-black.svg"), (mainServer + "/images/icn-ofensive-white.svg")],
          selected: false,
        },
        {
          id: 3,
          title: 'DEFENSIVO',
          images: [(mainServer + "/images/icn-defensive-black.svg"), (mainServer + "/images/icn-defensive-white.svg")],
          selected: false,
        } ],
    };
  },
  mounted: function mounted() {
    this.changeSection(this.value);
  },
  computed: {
    sectionsIds: function sectionsIds() {
      return this.sections.map(function (i) { return i.id; });
    },
  },
  methods: {
    changeSection: function changeSection(sectionId) {
      if (this.sectionsIds.includes(sectionId)) {
        this.sections.forEach(function (e) { return (e.selected = false); });
        var section = this.sections.find(function (s) { return s.id === sectionId; });
        if (section) {
          section.selected = true;
          return true;
        }
      }
      return false;
    },
    onChangeSection: function onChangeSection(id) {
      var result = this.changeSection(id);
      if (result) { this.$emit('input', id); }
    },
  },
  watch: {
    value: function value(newId) {
      this.changeSection(newId);
    },
  },
};

/* script */
var __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "analysis-container" }, [
    _c("div", { staticClass: "analysis-title is-hidden-mobile" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "analysis-content" }, [
      _c(
        "div",
        {
          staticClass:
            "columns is-variable is-1-desktop is-vcentered is-centered is-mobile is-multiline"
        },
        _vm._l(_vm.sections, function(section) {
          return _c(
            "div",
            { key: section.id, staticClass: "column is-narrow" },
            [
              _c("ImageButton", {
                attrs: {
                  title: section.title,
                  images: section.images,
                  selected: section.selected
                },
                on: {
                  click: function($event) {
                    return _vm.onChangeSection(section.id)
                  }
                }
              })
            ],
            1
          )
        }),
        0
      )
    ])
  ])
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  var __vue_inject_styles__$g = function (inject) {
    if (!inject) { return }
    inject("data-v-3f07e205_0", { source: "\n.analysis-container[data-v-3f07e205] {\n  border-radius: 16px;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.26);\n  background-color: #ffffff;\n  padding-bottom: 14px;\n}\n.analysis-container > .analysis-title[data-v-3f07e205] {\n  font-size: 16px;\n  color: #727272;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.analysis-container > .analysis-content[data-v-3f07e205] {\n  border-radius: 14px;\n  background-color: #f9f9f9;\n  width: 90%;\n  margin: 0 auto 14px;\n}\n@media screen and (max-width: 768px) {\n.column.is-narrow[data-v-3f07e205] {\n    margin: 0px;\n    padding: 0px;\n    width: 33.33333%;\n    -webkit-box-flex: 0;\n    flex: none;\n}\n.analysis-container[data-v-3f07e205] {\n    margin: 0px 20px;\n    border-radius: 0px 0px 16px 16px;\n}\n}\n", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/Analisis.vue"],"names":[],"mappings":";AAqGA;EACA,mBAAA;EACA,6CAAA;EACA,yBAAA;EACA,oBAAA;AACA;AACA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AACA;AACA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;AACA;AACA;AACA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,mBAAA;IACA,UAAA;AACA;AACA;IACA,gBAAA;IACA,gCAAA;AACA;AACA","file":"Analisis.vue","sourcesContent":["<template>\n  <div class=\"analysis-container\">\n    <div class=\"analysis-title is-hidden-mobile\">{{ title }}</div>\n    <div class=\"analysis-content\">\n      <div\n        class=\"columns is-variable is-1-desktop is-vcentered is-centered is-mobile is-multiline\"\n      >\n        <div class=\"column is-narrow\" v-for=\"section in sections\" :key=\"section.id\">\n          <ImageButton\n            :title=\"section.title\"\n            :images=\"section.images\"\n            :selected=\"section.selected\"\n            @click=\"onChangeSection(section.id)\"\n          />\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport ImageButton from './ImageButton.vue';\nimport { mainServer } from '../../utils/misc';\n\nexport default {\n  name: 'TeamAnalysis',\n  props: {\n    value: {\n      type: Number,\n      default: -1,\n    },\n    title: {\n      type: String,\n      default: 'ANÁLISIS',\n      required: false,\n    },\n  },\n  components: {\n    ImageButton,\n  },\n  data() {\n    return {\n      sections: [\n        {\n          id: 1,\n          title: 'POSESIÓN',\n          images: [\n            `${mainServer}/images/icn-posesion-black.svg`,\n            `${mainServer}/images/icn-posesion-white.svg`,\n          ],\n          selected: false,\n        },\n        {\n          id: 2,\n          title: 'OFENSIVO',\n          images: [`${mainServer}/images/icn-ofensive-black.svg`, `${mainServer}/images/icn-ofensive-white.svg`],\n          selected: false,\n        },\n        {\n          id: 3,\n          title: 'DEFENSIVO',\n          images: [`${mainServer}/images/icn-defensive-black.svg`, `${mainServer}/images/icn-defensive-white.svg`],\n          selected: false,\n        },\n      ],\n    };\n  },\n  mounted() {\n    this.changeSection(this.value);\n  },\n  computed: {\n    sectionsIds() {\n      return this.sections.map((i) => i.id);\n    },\n  },\n  methods: {\n    changeSection(sectionId) {\n      if (this.sectionsIds.includes(sectionId)) {\n        this.sections.forEach((e) => (e.selected = false));\n        const section = this.sections.find((s) => s.id === sectionId);\n        if (section) {\n          section.selected = true;\n          return true;\n        }\n      }\n      return false;\n    },\n    onChangeSection(id) {\n      const result = this.changeSection(id);\n      if (result) this.$emit('input', id);\n    },\n  },\n  watch: {\n    value(newId) {\n      this.changeSection(newId);\n    },\n  },\n};\n</script>\n\n<style scoped>\n.analysis-container {\n  border-radius: 16px;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.26);\n  background-color: #ffffff;\n  padding-bottom: 14px;\n}\n.analysis-container > .analysis-title {\n  font-size: 16px;\n  color: #727272;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.analysis-container > .analysis-content {\n  border-radius: 14px;\n  background-color: #f9f9f9;\n  width: 90%;\n  margin: 0 auto 14px;\n}\n@media screen and (max-width: 768px) {\n  .column.is-narrow {\n    margin: 0px;\n    padding: 0px;\n    width: 33.33333%;\n    -webkit-box-flex: 0;\n    flex: none;\n  }\n  .analysis-container {\n    margin: 0px 20px;\n    border-radius: 0px 0px 16px 16px;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$g = "data-v-3f07e205";
  /* module identifier */
  var __vue_module_identifier__$g = undefined;
  /* functional template */
  var __vue_is_functional_template__$g = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    createInjector,
    undefined,
    undefined
  );

var filterMixin = {
  computed: Object.assign({}, mapState('playerProfileGlobal', ['isPremiumUser']),
    {isItemDisabled: function isItemDisabled() {
      return !this.isPremiumUser;
    },
    clickModifier: function clickModifier() {
      return [ this.isItemDisabled ? 'element-click--disabled' : 'element-click--auto']
    }}),
  methods: {
    onItemClick: function onItemClick() {
      if (this.isItemDisabled) {
        this.$emit('premium-disabled-clicked');
      }
    }
  }
};

//

var script$f = {
  name: 'NavBarFilter',
  mixins: [filterMixin],
  data: function data() {
    return {
      sections: [1, 2, 3, 4, 5, 6],
      results: [1, 2, 3],
      playingAs: null,
      playingType: [
        {
          playingAs: null,
          label: 'Todos',
        },
        {
          playingAs: 1,
          label: 'Local',
        },
        {
          playingAs: 2,
          label: 'Visitante',
        } ],
      resultsKey: 0,
      sectionsKey: 0,
      initialPositionY: 0,
      isSticky: false,
    };
  },
  created: function created() {
    this.setSections();
    this.setResults();
    this.setPlayingAs();
  },
  mounted: function mounted() {
    var this$1 = this;

    this.$nextTick(function () {
      this$1.initialPositionY = this$1.$refs.playerProfileFilter.getBoundingClientRect().y;
    });
    document.addEventListener('scroll', this.setIsSticky, true);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('scroll', this.setIsSticky, true);
  },
  computed: Object.assign({}, mapGetters('playerProfileFilter', {
      seasons: 'getSeasons',
      seasonId: 'getSeasonId',
      stadisticId: 'getStadisticId',
    }),
    {checkSticky: function checkSticky() {
      return this.isSticky ? 'team-profile__filter--sticky' : '';
    }}),
  watch: {
    sections: function sections(newValue, oldValue) {
      if (newValue.length === 0) {
        this.sections = oldValue;
        this.sectionsKey++;
      }
      this.setSections();
    },
    results: function results(newValue, oldValue) {
      if (newValue.length === 0) {
        this.results = oldValue;
        this.resultsKey++;
      }
      this.setResults();
    },
    playingAs: function playingAs() {
        this.setPlayingAs();
    },
  },
  methods: {
    /**
     * @author José Rafael Gutierrez
     * Set property sections in filterGeneral module.
     * @return void
     */
    setSections: function setSections() {
      this.$store.commit('playerProfileFilter/setSections', this.sections);
      this.$emit('sectionsChanged', this.sections);
    },
    /**
     * @author José Rafael Gutierrez
     * Set property results in filterGeneral module.
     * @return void
     */
    setResults: function setResults() {
      try {
        this.$store.commit('playerProfileFilter/setResults', this.results);
        this.$emit('resultsChanged', this.results);
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * @author José Rafael Gutierrez
     * Set property playingAs in filterGeneral module.
     * @return void
     */
    setPlayingAs: function setPlayingAs() {
      try {
        this.$store.commit('playerProfileFilter/setPlayingAs', this.playingAs);
      } catch (err) {
        console.error(err);
      }
    },
    setIsSticky: function setIsSticky($event) {
      if (!$event.target) { return; }
      var scrollTop = $event.target.scrollTop === undefined
        ? $event.target.scrollingElement.scrollTop
        : $event.target.scrollTop;
      this.isSticky = scrollTop >= this.initialPositionY;
    },
    onSeasonChanged: function onSeasonChanged(value) {
      if (this.$store.getters['playerProfileFilter/getSeasonId'] !== value) {
        this.$store.commit('playerProfileFilter/setSeasonId', value);
        this.$emit('seasonChanged');
      }
    },
    /**
     * @author Cristhian Gómez
     * Set property stadisticId in filterGeneral module.
     * @return void
     */
    onStadisticChanged: function onStadisticChanged(value) {
      this.$store.commit('playerProfileFilter/setStadisticId', value);
      this.$emit('statisticsChanged', value);
    },
    onPlayingAsChanged: function onPlayingAsChanged(value){
      var type = this.playingType.find(function (p) { return p.playingAs == value; }).label;
      this.$emit('playingAsChanged', type);
    },
  },
};

/* script */
var __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "playerProfileFilter", class: _vm.checkSticky }, [
    _c("div", { staticClass: "filter-container" }, [
      _c(
        "div",
        {
          staticClass: "filter-item vertical-align-middle",
          on: { click: _vm.onItemClick }
        },
        [
          _c("span", { staticClass: "filter-item-name" }, [
            _vm._v("\n        TORNEO:\n      ")
          ]),
          _vm._v(" "),
          _c(
            "BSelect",
            {
              staticClass: "is-inline-block vertical-align-middle",
              class: _vm.clickModifier,
              attrs: { placeholder: "Selecciona uno", value: _vm.seasonId },
              on: { input: _vm.onSeasonChanged }
            },
            _vm._l(_vm.seasons, function(season) {
              return _c(
                "option",
                { key: season.id, domProps: { value: season.id } },
                [_vm._v("\n          " + _vm._s(season.name) + "\n        ")]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-item vertical-align-middle",
          on: { click: _vm.onItemClick }
        },
        [
          _c("span", { staticClass: "filter-item-name" }, [
            _vm._v("\n        ESTADÍSTICAS:\n      ")
          ]),
          _vm._v(" "),
          _c(
            "BSelect",
            {
              staticClass: "is-inline-block vertical-align-middle",
              class: _vm.clickModifier,
              attrs: { placeholder: "Seleccione", value: _vm.stadisticId },
              on: { input: _vm.onStadisticChanged }
            },
            [
              _c("option", { domProps: { value: 0 } }, [
                _vm._v("\n          Promedio por partido\n        ")
              ]),
              _vm._v(" "),
              _c("option", { domProps: { value: 1 } }, [
                _vm._v("\n          Totales\n        ")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-item", on: { click: _vm.onItemClick } },
        [
          _c("span", { staticClass: "filter-item-name" }, [
            _vm._v("\n        PARTIDOS:\n      ")
          ]),
          _vm._v(" "),
          _c(
            "BSelect",
            {
              staticClass: "is-inline-block vertical-align-middle",
              class: _vm.clickModifier,
              on: { input: _vm.onPlayingAsChanged },
              model: {
                value: _vm.playingAs,
                callback: function($$v) {
                  _vm.playingAs = $$v;
                },
                expression: "playingAs"
              }
            },
            _vm._l(_vm.playingType, function(playing, index) {
              return _c(
                "option",
                { key: index, domProps: { value: playing.playingAs } },
                [_vm._v("\n          " + _vm._s(playing.label) + "\n        ")]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-item", on: { click: _vm.onItemClick } },
        [
          _c("div", { staticClass: "filter-item__results" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { key: _vm.resultsKey, staticClass: "match-results-options" },
              [
                _c(
                  "div",
                  { staticClass: "match-results-options__game-result" },
                  [
                    _c(
                      "BCheckbox",
                      {
                        staticClass: "vertical-align-middle",
                        class: _vm.clickModifier,
                        attrs: { "native-value": 1 },
                        model: {
                          value: _vm.results,
                          callback: function($$v) {
                            _vm.results = $$v;
                          },
                          expression: "results"
                        }
                      },
                      [_vm._v("\n              Ganados\n            ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "match-results-options__game-result" },
                  [
                    _c(
                      "BCheckbox",
                      {
                        staticClass: "vertical-align-middle",
                        class: _vm.clickModifier,
                        attrs: { "native-value": 3 },
                        model: {
                          value: _vm.results,
                          callback: function($$v) {
                            _vm.results = $$v;
                          },
                          expression: "results"
                        }
                      },
                      [_vm._v("\n              Empatados\n            ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "match-results-options__game-result" },
                  [
                    _c(
                      "BCheckbox",
                      {
                        ref: "lost",
                        staticClass: "vertical-align-middle",
                        class: _vm.clickModifier,
                        attrs: { "native-value": 2 },
                        model: {
                          value: _vm.results,
                          callback: function($$v) {
                            _vm.results = $$v;
                          },
                          expression: "results"
                        }
                      },
                      [_vm._v("\n              Perdidos\n            ")]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-item", on: { click: _vm.onItemClick } },
        [
          _c("span", { staticClass: "filter-item-name" }, [
            _vm._v("\n        TIEMPO:\n      ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { key: _vm.sectionsKey, staticStyle: { display: "inline-block" } },
            [
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _c(
                    "BField",
                    [
                      _c(
                        "BCheckboxButton",
                        {
                          class: _vm.clickModifier,
                          attrs: { "native-value": 1 },
                          model: {
                            value: _vm.sections,
                            callback: function($$v) {
                              _vm.sections = $$v;
                            },
                            expression: "sections"
                          }
                        },
                        [_vm._v("\n              0-15\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "BCheckboxButton",
                        {
                          class: _vm.clickModifier,
                          attrs: { "native-value": 2 },
                          model: {
                            value: _vm.sections,
                            callback: function($$v) {
                              _vm.sections = $$v;
                            },
                            expression: "sections"
                          }
                        },
                        [_vm._v("\n              16-30\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "BCheckboxButton",
                        {
                          class: _vm.clickModifier,
                          attrs: { "native-value": 3 },
                          model: {
                            value: _vm.sections,
                            callback: function($$v) {
                              _vm.sections = $$v;
                            },
                            expression: "sections"
                          }
                        },
                        [_vm._v("\n              31-45\n            ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "10px"
                  }
                },
                [
                  _c(
                    "BField",
                    [
                      _c(
                        "BCheckboxButton",
                        {
                          class: _vm.clickModifier,
                          attrs: { "native-value": 4 },
                          model: {
                            value: _vm.sections,
                            callback: function($$v) {
                              _vm.sections = $$v;
                            },
                            expression: "sections"
                          }
                        },
                        [_vm._v("\n              45-60\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "BCheckboxButton",
                        {
                          class: _vm.clickModifier,
                          attrs: { "native-value": 5 },
                          model: {
                            value: _vm.sections,
                            callback: function($$v) {
                              _vm.sections = $$v;
                            },
                            expression: "sections"
                          }
                        },
                        [_vm._v("\n              61-75\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "BCheckboxButton",
                        {
                          class: _vm.clickModifier,
                          attrs: { "native-value": 6 },
                          model: {
                            value: _vm.sections,
                            callback: function($$v) {
                              _vm.sections = $$v;
                            },
                            expression: "sections"
                          }
                        },
                        [_vm._v("\n              76-90\n            ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ])
  ])
};
var __vue_staticRenderFns__$f = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", [
      _c("span", { staticClass: "filter-item-name" }, [
        _vm._v("\n        RESULTADOS:\n      ")
      ])
    ])
  }
];
__vue_render__$f._withStripped = true;

  /* style */
  var __vue_inject_styles__$f = function (inject) {
    if (!inject) { return }
    inject("data-v-e4c065e8_0", { source: ".filter-container[data-v-e4c065e8] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  text-align: left;\n}\n@media screen and (max-width: 1023px) {\n.filter-container[data-v-e4c065e8] {\n    padding-left: 16px;\n    padding-right: 16px;\n}\n}\n.filter-item[data-v-e4c065e8] {\n  vertical-align: middle;\n  margin: 5px;\n  flex-grow: 0;\n  font-size: 15px;\n  color: #808285;\n}\n.filter-item__results[data-v-e4c065e8] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.filter-item-name[data-v-e4c065e8] {\n  margin-right: 0;\n  vertical-align: middle;\n}\n.vertical-align-middle[data-v-e4c065e8] {\n  vertical-align: middle;\n}\n.match-results-options[data-v-e4c065e8] {\n  border-radius: 6px;\n  border: solid 1px #d8d8d8;\n  background-color: #ffffff;\n  padding: 5px 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.match-results-options__game-result .b-checkbox.checkbox[data-v-e4c065e8] {\n  padding: 0;\n}\n@media screen and (max-width: 768px) {\n.filter-container[data-v-e4c065e8] {\n    justify-content: center;\n}\n.filter-item[data-v-e4c065e8] {\n    text-align: center;\n}\n}\n\n/*# sourceMappingURL=Filter.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/Filter.vue","Filter.vue"],"names":[],"mappings":"AA0RA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;ACzRA;AD2RA;AANA;IAOA,kBAAA;IACA,mBAAA;ACxRE;AACF;AD2RA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;ACxRA;AD0RA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACxRA;AD4RA;EACA,eAAA;EACA,sBAAA;ACzRA;AD4RA;EACA,sBAAA;ACzRA;AD4RA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACzRA;AD2RA;EACA,UAAA;ACzRA;AD6RA;AACA;IACA,uBAAA;AC1RE;AD6RF;IACA,kBAAA;AC1RE;AACF;;AAEA,qCAAqC","file":"Filter.vue","sourcesContent":["<template>\n  <div ref=\"playerProfileFilter\" :class=\"checkSticky\">\n    <div class=\"filter-container\">\n      <!-- Seasons -->\n      <div class=\"filter-item vertical-align-middle\" @click=\"onItemClick\">\n        <span class=\"filter-item-name\">\n          TORNEO:\n        </span>\n        <BSelect\n          class=\"is-inline-block vertical-align-middle\"\n          placeholder=\"Selecciona uno\"\n          :value=\"seasonId\"\n          :class=\"clickModifier\"\n          @input=\"onSeasonChanged\"\n        >\n          <option v-for=\"season in seasons\" :key=\"season.id\" :value=\"season.id\">\n            {{ season.name }}\n          </option>\n        </BSelect>\n      </div>\n      <!-- Stadistics -->\n      <div class=\"filter-item vertical-align-middle\" @click=\"onItemClick\">\n        <span class=\"filter-item-name\">\n          ESTADÍSTICAS:\n        </span>\n        <BSelect\n          class=\"is-inline-block vertical-align-middle\"\n          placeholder=\"Seleccione\"\n          :value=\"stadisticId\"\n          :class=\"clickModifier\"\n          @input=\"onStadisticChanged\"\n        >\n          <option :value=\"0\">\n            Promedio por partido\n          </option>\n          <option :value=\"1\">\n            Totales\n          </option>\n        </BSelect>\n      </div>\n      <!-- Games -->\n      <div class=\"filter-item\" @click=\"onItemClick\">\n        <span class=\"filter-item-name\">\n          PARTIDOS:\n        </span>\n        <BSelect\n          v-model=\"playingAs\"\n          class=\"is-inline-block vertical-align-middle\"\n          :class=\"clickModifier\"\n          @input=\"onPlayingAsChanged\"\n        >\n          <option v-for=\"(playing, index) in playingType\" :key=\"index\" :value=\"playing.playingAs\">\n            {{ playing.label }}\n          </option>\n        </BSelect>\n      </div>\n      <!-- Match result -->\n      <div class=\"filter-item\" @click=\"onItemClick\">\n        <div class=\"filter-item__results\">\n          <div>\n            <span class=\"filter-item-name\">\n          RESULTADOS:\n        </span>\n          </div>\n          <div :key=\"resultsKey\" class=\"match-results-options\">\n            <div class=\"match-results-options__game-result\">\n              <BCheckbox\n                v-model=\"results\"\n                :native-value=\"1\"\n                :class=\"clickModifier\"\n                class=\"vertical-align-middle\"\n              >\n                Ganados\n              </BCheckbox>\n            </div>\n            <div class=\"match-results-options__game-result\">\n              <BCheckbox\n                v-model=\"results\"\n                :native-value=\"3\"\n                :class=\"clickModifier\"\n                class=\"vertical-align-middle\"\n              >\n                Empatados\n              </BCheckbox>\n            </div>\n            <div class=\"match-results-options__game-result\">\n              <BCheckbox\n                v-model=\"results\"\n                ref=\"lost\"\n                :native-value=\"2\"\n                :class=\"clickModifier\"\n                class=\"vertical-align-middle\"\n              >\n                Perdidos\n              </BCheckbox>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- Time -->\n      <div class=\"filter-item\" @click=\"onItemClick\">\n        <span class=\"filter-item-name\">\n          TIEMPO:\n        </span>\n        <div :key=\"sectionsKey\" style=\"display: inline-block;\">\n          <div style=\"display: inline-block;\">\n            <BField>\n              <BCheckboxButton :native-value=\"1\" v-model=\"sections\" :class=\"clickModifier\">\n                0-15\n              </BCheckboxButton>\n              <BCheckboxButton :native-value=\"2\" v-model=\"sections\" :class=\"clickModifier\">\n                16-30\n              </BCheckboxButton>\n              <BCheckboxButton :native-value=\"3\" v-model=\"sections\" :class=\"clickModifier\">\n                31-45\n              </BCheckboxButton>\n            </BField>\n          </div>\n          <div style=\"display: inline-block; margin-left: 10px;\">\n            <BField>\n              <BCheckboxButton :native-value=\"4\" v-model=\"sections\" :class=\"clickModifier\">\n                45-60\n              </BCheckboxButton>\n              <BCheckboxButton :native-value=\"5\" v-model=\"sections\" :class=\"clickModifier\">\n                61-75\n              </BCheckboxButton>\n              <BCheckboxButton :native-value=\"6\" v-model=\"sections\" :class=\"clickModifier\">\n                76-90\n              </BCheckboxButton>\n            </BField>\n          </div>\n        </div>\n      </div>\n      <!-- Button to apply selected options -->\n      <!--      <div class=\"filter-item\">-->\n      <!--        <BButton type=\"is-primary\" @click=\"setUpAndEmitNewFilter\">Aplicar Filtros</BButton>-->\n      <!--      </div>-->\n    </div>\n  </div>\n</template>\n\n<script>\nimport { mapGetters } from 'vuex';\nimport filterMixin from '../../utils/mixins/filter-mixin';\n\nexport default {\n  name: 'NavBarFilter',\n  mixins: [filterMixin],\n  data() {\n    return {\n      sections: [1, 2, 3, 4, 5, 6],\n      results: [1, 2, 3],\n      playingAs: null,\n      playingType: [\n        {\n          playingAs: null,\n          label: 'Todos',\n        },\n        {\n          playingAs: 1,\n          label: 'Local',\n        },\n        {\n          playingAs: 2,\n          label: 'Visitante',\n        },\n      ],\n      resultsKey: 0,\n      sectionsKey: 0,\n      initialPositionY: 0,\n      isSticky: false,\n    };\n  },\n  created() {\n    this.setSections();\n    this.setResults();\n    this.setPlayingAs();\n  },\n  mounted() {\n    this.$nextTick(() => {\n      this.initialPositionY = this.$refs.playerProfileFilter.getBoundingClientRect().y;\n    })\n    document.addEventListener('scroll', this.setIsSticky, true);\n  },\n  beforeDestroy() {\n    document.removeEventListener('scroll', this.setIsSticky, true);\n  },\n  computed: {\n    ...mapGetters('playerProfileFilter', {\n      seasons: 'getSeasons',\n      seasonId: 'getSeasonId',\n      stadisticId: 'getStadisticId',\n    }),\n    checkSticky() {\n      return this.isSticky ? 'team-profile__filter--sticky' : '';\n    },\n  },\n  watch: {\n    sections(newValue, oldValue) {\n      if (newValue.length === 0) {\n        this.sections = oldValue;\n        this.sectionsKey++;\n      }\n      this.setSections();\n    },\n    results(newValue, oldValue) {\n      if (newValue.length === 0) {\n        this.results = oldValue;\n        this.resultsKey++;\n      }\n      this.setResults();\n    },\n    playingAs() {\n        this.setPlayingAs();\n    },\n  },\n  methods: {\n    /**\n     * @author José Rafael Gutierrez\n     * Set property sections in filterGeneral module.\n     * @return void\n     */\n    setSections() {\n      this.$store.commit('playerProfileFilter/setSections', this.sections);\n      this.$emit('sectionsChanged', this.sections);\n    },\n    /**\n     * @author José Rafael Gutierrez\n     * Set property results in filterGeneral module.\n     * @return void\n     */\n    setResults() {\n      try {\n        this.$store.commit('playerProfileFilter/setResults', this.results);\n        this.$emit('resultsChanged', this.results);\n      } catch (err) {\n        console.error(err);\n      }\n    },\n    /**\n     * @author José Rafael Gutierrez\n     * Set property playingAs in filterGeneral module.\n     * @return void\n     */\n    setPlayingAs() {\n      try {\n        this.$store.commit('playerProfileFilter/setPlayingAs', this.playingAs);\n      } catch (err) {\n        console.error(err);\n      }\n    },\n    setIsSticky($event) {\n      if (!$event.target) return;\n      const scrollTop = $event.target.scrollTop === undefined\n        ? $event.target.scrollingElement.scrollTop\n        : $event.target.scrollTop;\n      this.isSticky = scrollTop >= this.initialPositionY;\n    },\n    onSeasonChanged(value) {\n      if (this.$store.getters['playerProfileFilter/getSeasonId'] !== value) {\n        this.$store.commit('playerProfileFilter/setSeasonId', value);\n        this.$emit('seasonChanged');\n      }\n    },\n    /**\n     * @author Cristhian Gómez\n     * Set property stadisticId in filterGeneral module.\n     * @return void\n     */\n    onStadisticChanged(value) {\n      this.$store.commit('playerProfileFilter/setStadisticId', value);\n      this.$emit('statisticsChanged', value);\n    },\n    onPlayingAsChanged(value){\n      let type = this.playingType.find(p => p.playingAs == value).label;\n      this.$emit('playingAsChanged', type);\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"scss\">\n.filter-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  text-align: left;\n\n  @media screen and (max-width: 1023px) {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n.filter-item {\n  vertical-align: middle;\n  margin: 5px;\n  flex-grow: 0;\n  font-size: 15px;\n  color: #808285;\n\n  &__results {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.filter-item-name {\n  margin-right: 0;\n  vertical-align: middle;\n}\n\n.vertical-align-middle {\n  vertical-align: middle;\n}\n\n.match-results-options {\n  border-radius: 6px;\n  border: solid 1px #d8d8d8;\n  background-color: #ffffff;\n  padding: 5px 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &__game-result .b-checkbox.checkbox {\n    padding: 0;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .filter-container {\n    justify-content: center;\n  }\n\n  .filter-item {\n    text-align: center;\n  }\n}\n</style>\n",".filter-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  text-align: left;\n}\n@media screen and (max-width: 1023px) {\n  .filter-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n.filter-item {\n  vertical-align: middle;\n  margin: 5px;\n  flex-grow: 0;\n  font-size: 15px;\n  color: #808285;\n}\n.filter-item__results {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.filter-item-name {\n  margin-right: 0;\n  vertical-align: middle;\n}\n\n.vertical-align-middle {\n  vertical-align: middle;\n}\n\n.match-results-options {\n  border-radius: 6px;\n  border: solid 1px #d8d8d8;\n  background-color: #ffffff;\n  padding: 5px 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.match-results-options__game-result .b-checkbox.checkbox {\n  padding: 0;\n}\n\n@media screen and (max-width: 768px) {\n  .filter-container {\n    justify-content: center;\n  }\n\n  .filter-item {\n    text-align: center;\n  }\n}\n\n/*# sourceMappingURL=Filter.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$f = "data-v-e4c065e8";
  /* module identifier */
  var __vue_module_identifier__$f = undefined;
  /* functional template */
  var __vue_is_functional_template__$f = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$e = {
  name: 'StatisticField',
  props: {
    data: {
      type: Array,
      required: false,
      default: function default$1() {
        return [];
      },
    },
    negative: {
      type: Boolean,
      required: false,
      default: false,
    },
    mainServer: mainServer,
  },
  computed: Object.assign({}, mapGetters('playerProfileFilter', {
      getGamesPlayedByTeam: 'getGamesPlayedByTeam',
    }),
    mapState(['windowWidth']),
    {max: function max() {
      var ref;

      return Math.max.apply(Math, (ref = []).concat.apply(ref, this.dataProccesed));
    },
    dataProccesed: function dataProccesed() {
      var this$1 = this;

      return this.data.map(function (da) { return da.map(function (d) { return +(d / this$1.gamesPlayed).toFixed(2); }); });
    },
    gamesPlayed: function gamesPlayed() {
      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;
    }},
    mapState('playerProfileGlobal', ['windowWidth']),
    {isMinMobile: function isMinMobile() {
      return this.windowWidth < 375;
    },
    svgDimensions: function svgDimensions() {
      var width = this.isMinMobile ? 250 : 310;
      var height = width * 0.9701;
      return {
        width: width,
        height: height,
      };
    }}),
};

/* script */
var __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c(
      "svg",
      {
        staticStyle: { overflow: "hidden" },
        attrs: {
          "xmlns:dc": "http://purl.org/dc/elements/1.1/",
          "xmlns:cc": "http://creativecommons.org/ns#",
          "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
          "xmlns:svg": "http://www.w3.org/2000/svg",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "xmlns:sodipodi":
            "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
          "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
          width: _vm.svgDimensions.width,
          height: _vm.svgDimensions.height,
          viewBox: "0 0 220 250",
          version: "1.1",
          id: "svg166",
          "sodipodi:docname": "cancha-golstats-2.svg",
          "inkscape:version": "0.92.3 (2405546, 2018-03-11)"
        }
      },
      [
        _c(
          "metadata",
          { attrs: { id: "metadata170" } },
          [
            _c(
              "Rdf:RDF",
              [
                _c(
                  "Cc:Work",
                  { attrs: { "rdf:about": "" } },
                  [
                    _c("Dc:Format", [_vm._v("image/svg+xml")]),
                    _vm._v(" "),
                    _c("Dc:Type", {
                      attrs: {
                        "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("Sodipodi:Namedview", {
          attrs: {
            pagecolor: "#ffffff",
            borderColor: "#666666",
            borderopacity: "1",
            objecttolerance: "10",
            gridtolerance: "10",
            guidetolerance: "10",
            "inkscape:pageopacity": "0",
            "inkscape:pageshadow": "2",
            "inkscape:window-width": "1920",
            "inkscape:window-height": "1017",
            id: "namedview168",
            showgrid: "false",
            "inkscape:zoom": "2.4773607",
            "inkscape:cx": "150",
            "inkscape:cy": "168.52067",
            "inkscape:window-x": "1432",
            "inkscape:window-y": "-8",
            "inkscape:window-maximized": "1",
            "inkscape:current-layer": "svg166"
          }
        }),
        _vm._v(" "),
        _c("defs", { attrs: { id: "defs20" } }, [
          _c(
            "marker",
            {
              attrs: {
                id: "arrowhead",
                markerWidth: "10",
                markerHeight: "7",
                refX: "0",
                refY: "3.5",
                orient: "auto"
              }
            },
            [
              _c("polygon", {
                attrs: { points: "0 0, 10 3.5, 0 7", fill: "#808080" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "pattern",
            {
              attrs: {
                id: "maByRegionFieldBackground",
                width: "1",
                height: "1",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "none"
              }
            },
            [
              _c("image", {
                attrs: {
                  "xlink:href":
                    "http://golstats-2-develop.azurewebsites.net/images/fieldbg.png",
                  width: "100",
                  height: "100",
                  preserveAspectRatio: "none",
                  id: "image2"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "filter",
            {
              attrs: {
                id: "maByRegionDropShadow",
                x: "0",
                y: "0",
                width: "120%",
                height: "120%"
              }
            },
            [
              _c("feOffset", {
                attrs: {
                  result: "offOut",
                  in: "SourceAlpha",
                  dx: "5",
                  dy: "5",
                  id: "feOffset5"
                }
              }),
              _vm._v(" "),
              _c("feGaussianBlur", {
                attrs: {
                  result: "blurOut",
                  in: "offOut",
                  stdDeviation: "3",
                  id: "feGaussianBlur7"
                }
              }),
              _vm._v(" "),
              _c(
                "feComponentTransfer",
                { attrs: { id: "feComponentTransfer11" } },
                [
                  _c("feFuncA", {
                    attrs: { type: "linear", slope: "0.5", id: "feFuncA9" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "feMerge",
                { attrs: { id: "feMerge17" } },
                [
                  _c("feMergeNode", { attrs: { id: "feMergeNode13" } }),
                  _vm._v(" "),
                  _c("feMergeNode", {
                    attrs: { in: "SourceGraphic", id: "feMergeNode15" }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "g",
          {
            staticClass: "maByRegionChartFieldBackground",
            attrs: { id: "g24", transform: "translate(25.0001)" }
          },
          [
            _c("path", {
              attrs: {
                d: "M 0,0 H 165.75 V 195 H 0 Z",
                id: "path22",
                "inkscape:connector-curvature": "0"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "g",
          {
            staticClass: "maByRegionChartFieldLines",
            attrs: { id: "g52", transform: "translate(25.0001)" }
          },
          [
            _c("path", {
              attrs: {
                d: "M 0,0 H 165.75 V 195 H 0 Z",
                id: "path26",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M 0,97.5 H 165.75",
                id: "path28",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m 39.98,0 v 35.1 h 85.8 V 0 Z",
                id: "path30",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m 63.38,0 v 11.7 h 39 V 0 Z",
                id: "path32",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m 39.98,195 v -35.1 h 85.8 V 195 Z",
                id: "path34",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m 63.38,195 v -11.7 h 39 V 195 Z",
                id: "path36",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "82.879997", cy: "97.5", r: "19.5", id: "circle38" }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m 67.28,35.1 a 19.5,19.5 0 0 0 31.2,0",
                id: "path40",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m 98.48,159.9 a 19.5,19.5 0 0 0 -31.2,0",
                id: "path42",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M 0,1.95 A 1.95,1.95 0 0 0 1.95,0",
                id: "path44",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m 163.8,0 a 1.95,1.95 0 0 0 1.95,1.95",
                id: "path46",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M 1.95,195 A 1.95,1.95 0 0 0 0,193.05",
                id: "path48",
                "inkscape:connector-curvature": "0"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M 165.75,193.05 A 1.95,1.95 0 0 0 163.8,195",
                id: "path50",
                "inkscape:connector-curvature": "0"
              }
            })
          ]
        ),
        _vm._v(
          "\n    " +
            _vm._s(
              "n" +
                +Math.floor(
                  (_vm.dataProccesed[0][0] * 100) / _vm.max / 10
                ).toFixed(2)
            ) +
            "\n    "
        ),
        _c("g", { attrs: { id: "row-0" } }, [
          _c(
            "g",
            { attrs: { id: "col-0-0", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[0][0] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "0",
                  y: "0",
                  width: "40",
                  height: "48.75",
                  id: "rect126"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "20", y: "24.375", id: "text128" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[0][0]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-0-1", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[0][1] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "40",
                  y: "0",
                  width: "43",
                  height: "48.75",
                  id: "rect132"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "61.5", y: "24.375", id: "text134" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[0][1]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-0-2", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[0][2] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "83",
                  y: "0",
                  width: "43",
                  height: "48.75",
                  id: "rect138"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "104.5", y: "24.375", id: "text140" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[0][2]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-0-3", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[0][3] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "126",
                  y: "0",
                  width: "40",
                  height: "48.75",
                  id: "rect144"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "146", y: "24.375", id: "text146" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[0][3]))]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("g", { attrs: { id: "row-1" } }, [
          _c(
            "g",
            { attrs: { id: "col-1-0", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[1][0] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "0",
                  y: "48.75",
                  width: "40",
                  height: "48.75",
                  id: "rect102"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "20", y: "73.125", id: "text104" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[1][0]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-1-1", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[1][1] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "40",
                  y: "48.75",
                  width: "43",
                  height: "48.75",
                  id: "rect108"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "61.5", y: "73.125", id: "text110" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[1][1]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-1-2", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[1][2] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "83",
                  y: "48.75",
                  width: "43",
                  height: "48.75",
                  id: "rect114"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "104.5", y: "73.125", id: "text116" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[1][2]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-1-3", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[1][3] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "126",
                  y: "48.75",
                  width: "40",
                  height: "48.75",
                  id: "rect120"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "146", y: "73.125", id: "text122" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[1][3]))]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("g", { attrs: { id: "row-2" } }, [
          _c(
            "g",
            { attrs: { id: "col-2-0", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[2][0] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "0",
                  y: "97.5",
                  width: "40",
                  height: "48.75",
                  id: "rect78"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "20", y: "121.875", id: "text80" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[2][0]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-2-1", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[2][1] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "40",
                  y: "97.5",
                  width: "43",
                  height: "48.75",
                  id: "rect84"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "61.5", y: "121.875", id: "text86" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[2][1]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-2-2", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[2][2] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "83",
                  y: "97.5",
                  width: "43",
                  height: "48.75",
                  id: "rect90"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "104.5", y: "121.875", id: "text92" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[2][2]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-2-3", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[2][3] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "126",
                  y: "97.5",
                  width: "40",
                  height: "48.75",
                  id: "rect96"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "146", y: "121.875", id: "text98" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[2][3]))]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("g", { attrs: { id: "row-3" } }, [
          _c(
            "g",
            { attrs: { id: "col-3-0", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[3][0] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "0",
                  y: "146.25",
                  width: "40",
                  height: "48.75",
                  id: "rect54"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "20", y: "170.625", id: "text56" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[3][0]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-3-1", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[3][1] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "40",
                  y: "146.25",
                  width: "43",
                  height: "48.75",
                  id: "rect60"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "61.5", y: "170.625", id: "text62" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[3][1]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-3-2", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[3][2] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "83",
                  y: "146.25",
                  width: "43",
                  height: "48.75",
                  id: "rect66"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "104.5", y: "170.625", id: "text68" }
                },
                [_vm._v(_vm._s(_vm.dataProccesed[3][2]))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            { attrs: { id: "col-3-3", transform: "translate(25.0001)" } },
            [
              _c("rect", {
                class: [
                  "maRegionTier",
                  _vm.negative ? "negative" : "positive",
                  "n" +
                    +Math.floor(
                      (_vm.dataProccesed[3][3] * 100) / _vm.max / 10
                    ).toFixed(2)
                ],
                attrs: {
                  x: "126",
                  y: "146.25",
                  width: "40",
                  height: "48.75",
                  id: "rect72"
                }
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "maRegionPercentageText",
                  attrs: { x: "146", y: "170.625", id: "text74" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(+_vm.dataProccesed[3][3].toFixed(2)) +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("g", { attrs: { id: "vertical-sums" } }, [
          _c(
            "text",
            {
              staticClass: "maTotalPercentageText",
              attrs: {
                x: _vm.isMinMobile ? 10.0001693 : 5,
                y: "24.375",
                id: "sum-row-0"
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    +(
                      _vm.dataProccesed[0][0] +
                      _vm.dataProccesed[0][1] +
                      _vm.dataProccesed[0][2] +
                      _vm.dataProccesed[0][3]
                    ).toFixed(2)
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "text",
            {
              staticClass: "maTotalPercentageText",
              attrs: {
                x: _vm.isMinMobile ? 10.0001693 : 5,
                y: "73.125",
                id: "sum-row-1"
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    +(
                      _vm.dataProccesed[1][0] +
                      _vm.dataProccesed[1][1] +
                      _vm.dataProccesed[1][2] +
                      _vm.dataProccesed[1][3]
                    ).toFixed(2)
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "text",
            {
              staticClass: "maTotalPercentageText",
              attrs: {
                x: _vm.isMinMobile ? 10.0001693 : 5,
                y: "121.875",
                id: "sum-row-2"
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    +(
                      _vm.dataProccesed[2][0] +
                      _vm.dataProccesed[2][1] +
                      _vm.dataProccesed[2][2] +
                      _vm.dataProccesed[2][3]
                    ).toFixed(2)
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "text",
            {
              staticClass: "maTotalPercentageText",
              attrs: {
                x: _vm.isMinMobile ? 10.0001693 : 5,
                y: "170.625",
                id: "sum-row-3"
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    +(
                      _vm.dataProccesed[3][0] +
                      _vm.dataProccesed[3][1] +
                      _vm.dataProccesed[3][2] +
                      _vm.dataProccesed[3][3]
                    ).toFixed(2)
                  ) +
                  "\n      "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "g",
          { attrs: { id: "horizontal-sums", transform: "translate(8)" } },
          [
            _c(
              "text",
              {
                staticClass: "maTotalPercentageText",
                attrs: { x: "37.333332", y: "212", id: "sum-col-0" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      +(
                        _vm.dataProccesed[3][0] +
                        _vm.dataProccesed[2][0] +
                        _vm.dataProccesed[1][0] +
                        _vm.dataProccesed[0][0]
                      ).toFixed(2)
                    ) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "text",
              {
                staticClass: "maTotalPercentageText",
                attrs: { x: "78.583359", y: "212", id: "sum-col-1" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      +(
                        _vm.dataProccesed[3][1] +
                        _vm.dataProccesed[2][1] +
                        _vm.dataProccesed[1][1] +
                        _vm.dataProccesed[0][1]
                      ).toFixed(2)
                    ) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "text",
              {
                staticClass: "maTotalPercentageText",
                attrs: { x: "121.08336", y: "212", id: "sum-col-2" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      +(
                        _vm.dataProccesed[3][2] +
                        _vm.dataProccesed[2][2] +
                        _vm.dataProccesed[1][2] +
                        _vm.dataProccesed[0][2]
                      ).toFixed(2)
                    ) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "text",
              {
                staticClass: "maTotalPercentageText",
                attrs: { x: "162.33327", y: "212", id: "sum-col-3" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      +(
                        _vm.dataProccesed[3][3] +
                        _vm.dataProccesed[2][3] +
                        _vm.dataProccesed[1][3] +
                        _vm.dataProccesed[0][3]
                      ).toFixed(2)
                    ) +
                    "\n      "
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("g", { attrs: { id: "direction", transform: "translate(8)" } }, [
          _c("line", {
            attrs: {
              x1: "194",
              y1: "140",
              x2: "194",
              y2: "60",
              stroke: "#808080",
              "stroke-width": "2",
              "marker-end": "url(#arrowhead)"
            }
          })
        ])
      ],
      1
    )
  ])
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  var __vue_inject_styles__$e = function (inject) {
    if (!inject) { return }
    inject("data-v-4e7cd062_0", { source: "\n.maByRegionChartFieldLines[data-v-4e7cd062] {\n  stroke: #ddd;\n  stroke-width: 0.75;\n  fill: none;\n}\n.maByRegionChartFieldBackground[data-v-4e7cd062] {\n  fill: url(#maByRegionFieldBackground);\n  filter: url(#maByRegionDropShadow);\n}\n.maRegionTier[data-v-4e7cd062] {\n  stroke: #ffffff;\n  stroke-width: 0.5;\n  stroke-opacity: 0.7;\n}\n.positive.n10[data-v-4e7cd062] {\n  fill: rgb(90, 255, 68);\n  fill-opacity: 0.7;\n}\n.positive.n9[data-v-4e7cd062] {\n  fill: rgb(99, 255, 85);\n  fill-opacity: 0.7;\n}\n.positive.n8[data-v-4e7cd062] {\n  fill: rgb(120, 255, 102);\n  fill-opacity: 0.7;\n}\n.positive.n7[data-v-4e7cd062] {\n  fill: rgb(146, 255, 119);\n  fill-opacity: 0.6;\n}\n.positive.n6[data-v-4e7cd062] {\n  fill: rgb(160, 255, 136);\n  fill-opacity: 0.6;\n}\n.positive.n5[data-v-4e7cd062] {\n  fill: rgb(162, 255, 153);\n  fill-opacity: 0.5;\n}\n.positive.n4[data-v-4e7cd062] {\n  fill: rgb(170, 255, 170);\n  fill-opacity: 0.5;\n}\n.positive.n3[data-v-4e7cd062] {\n  fill: rgb(170, 255, 174);\n  fill-opacity: 0.4;\n}\n.positive.n2[data-v-4e7cd062] {\n  fill: rgb(180, 255, 170);\n  fill-opacity: 0.35;\n}\n.positive.n1[data-v-4e7cd062] {\n  fill: rgb(170, 255, 184);\n  fill-opacity: 0.3;\n}\n.positive.n0[data-v-4e7cd062] {\n  fill: rgb(170, 255, 191);\n  fill-opacity: 0.2;\n}\n.positive.nNaN[data-v-4e7cd062] {\n  fill: rgb(170, 255, 191);\n  fill-opacity: 0;\n}\n.negative.nNaN[data-v-4e7cd062] {\n  fill: rgb(255, 68, 68);\n  fill-opacity: 0;\n}\n.negative.n10[data-v-4e7cd062] {\n  fill: rgb(255, 68, 68);\n  fill-opacity: 0.7;\n}\n.negative.n9[data-v-4e7cd062] {\n  fill: rgb(255, 85, 85);\n  fill-opacity: 0.7;\n}\n.negative.n8[data-v-4e7cd062] {\n  fill: rgb(255, 102, 102);\n  fill-opacity: 0.7;\n}\n.negative.n7[data-v-4e7cd062] {\n  fill: rgb(255, 119, 119);\n  fill-opacity: 0.6;\n}\n.negative.n6[data-v-4e7cd062] {\n  fill: rgb(255, 136, 136);\n  fill-opacity: 0.6;\n}\n.negative.n5[data-v-4e7cd062] {\n  fill: rgb(255, 153, 153);\n  fill-opacity: 0.5;\n}\n.negative.n4[data-v-4e7cd062] {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.5;\n}\n.negative.n3[data-v-4e7cd062] {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.4;\n}\n.negative.n2[data-v-4e7cd062] {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.35;\n}\n.negative.n1[data-v-4e7cd062] {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.3;\n}\n.negative.n0[data-v-4e7cd062] {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.2;\n}\n.maRegionPercentageText[data-v-4e7cd062],\n.maRegionCountText[data-v-4e7cd062] {\n  font-size: 14px;\n  text-anchor: middle;\n}\n.maTotalPercentageText[data-v-4e7cd062] {\n  fill: #808080;\n  font-size: 10px;\n  text-anchor: middle;\n}\n.maRegionPercentageText[data-v-4e7cd062] {\n  fill: #fff;\n  font-size: 11px;\n}\n.maRegionCountText[data-v-4e7cd062] {\n  font-size: 9px;\n  fill: #eee;\n}\n", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/StatisticField.vue"],"names":[],"mappings":";AAwaA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AACA;AAEA;EACA,qCAAA;EACA,kCAAA;AACA;AAEA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AACA;AAEA;EACA,sBAAA;EACA,iBAAA;AACA;AACA;EACA,sBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,kBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AAEA;EACA,wBAAA;EACA,eAAA;AACA;AAEA;EACA,sBAAA;EACA,eAAA;AACA;AAEA;EACA,sBAAA;EACA,iBAAA;AACA;AACA;EACA,sBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,kBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AACA;EACA,wBAAA;EACA,iBAAA;AACA;AAEA;;EAEA,eAAA;EACA,mBAAA;AACA;AAEA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AACA;AAEA;EACA,UAAA;EACA,eAAA;AACA;AAEA;EACA,cAAA;EACA,UAAA;AACA","file":"StatisticField.vue","sourcesContent":["<template>\n  <div>\n    <svg\n      xmlns:dc=\"http://purl.org/dc/elements/1.1/\"\n      xmlns:cc=\"http://creativecommons.org/ns#\"\n      xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"\n      xmlns:svg=\"http://www.w3.org/2000/svg\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n      xmlns:sodipodi=\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\"\n      xmlns:inkscape=\"http://www.inkscape.org/namespaces/inkscape\"\n      style=\"overflow: hidden\"\n      :width=\"svgDimensions.width\"\n      :height=\"svgDimensions.height\"\n      viewBox=\"0 0 220 250\"\n      version=\"1.1\"\n      id=\"svg166\"\n      sodipodi:docname=\"cancha-golstats-2.svg\"\n      inkscape:version=\"0.92.3 (2405546, 2018-03-11)\"\n    >\n      <metadata id=\"metadata170\">\n        <Rdf:RDF>\n          <Cc:Work rdf:about>\n            <Dc:Format>image/svg+xml</Dc:Format>\n            <Dc:Type rdf:resource=\"http://purl.org/dc/dcmitype/StillImage\" />\n          </Cc:Work>\n        </Rdf:RDF>\n      </metadata>\n      <Sodipodi:Namedview\n        pagecolor=\"#ffffff\"\n        borderColor=\"#666666\"\n        borderopacity=\"1\"\n        objecttolerance=\"10\"\n        gridtolerance=\"10\"\n        guidetolerance=\"10\"\n        inkscape:pageopacity=\"0\"\n        inkscape:pageshadow=\"2\"\n        inkscape:window-width=\"1920\"\n        inkscape:window-height=\"1017\"\n        id=\"namedview168\"\n        showgrid=\"false\"\n        inkscape:zoom=\"2.4773607\"\n        inkscape:cx=\"150\"\n        inkscape:cy=\"168.52067\"\n        inkscape:window-x=\"1432\"\n        inkscape:window-y=\"-8\"\n        inkscape:window-maximized=\"1\"\n        inkscape:current-layer=\"svg166\"\n      />\n      <defs id=\"defs20\">\n        <marker id=\"arrowhead\" markerWidth=\"10\" markerHeight=\"7\" refX=\"0\" refY=\"3.5\" orient=\"auto\">\n          <polygon points=\"0 0, 10 3.5, 0 7\" fill=\"#808080\" />\n        </marker>\n        <pattern id=\"maByRegionFieldBackground\" width=\"1\" height=\"1\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"none\">\n          <image xlink:href=\"http://golstats-2-develop.azurewebsites.net/images/fieldbg.png\" width=\"100\" height=\"100\" preserveAspectRatio=\"none\" id=\"image2\" />\n        </pattern>\n        <filter id=\"maByRegionDropShadow\" x=\"0\" y=\"0\" width=\"120%\" height=\"120%\">\n          <feOffset result=\"offOut\" in=\"SourceAlpha\" dx=\"5\" dy=\"5\" id=\"feOffset5\" />\n          <feGaussianBlur result=\"blurOut\" in=\"offOut\" stdDeviation=\"3\" id=\"feGaussianBlur7\" />\n          <feComponentTransfer id=\"feComponentTransfer11\">\n            <feFuncA type=\"linear\" slope=\"0.5\" id=\"feFuncA9\" />\n          </feComponentTransfer>\n          <feMerge id=\"feMerge17\">\n            <feMergeNode id=\"feMergeNode13\" />\n            <feMergeNode in=\"SourceGraphic\" id=\"feMergeNode15\" />\n          </feMerge>\n        </filter>\n      </defs>\n      <g class=\"maByRegionChartFieldBackground\" id=\"g24\" transform=\"translate(25.0001)\">\n        <path d=\"M 0,0 H 165.75 V 195 H 0 Z\" id=\"path22\" inkscape:connector-curvature=\"0\" />\n      </g>\n      <g class=\"maByRegionChartFieldLines\" id=\"g52\" transform=\"translate(25.0001)\">\n        <path d=\"M 0,0 H 165.75 V 195 H 0 Z\" id=\"path26\" inkscape:connector-curvature=\"0\" />\n        <path d=\"M 0,97.5 H 165.75\" id=\"path28\" inkscape:connector-curvature=\"0\" />\n        <path d=\"m 39.98,0 v 35.1 h 85.8 V 0 Z\" id=\"path30\" inkscape:connector-curvature=\"0\" />\n        <path d=\"m 63.38,0 v 11.7 h 39 V 0 Z\" id=\"path32\" inkscape:connector-curvature=\"0\" />\n        <path d=\"m 39.98,195 v -35.1 h 85.8 V 195 Z\" id=\"path34\" inkscape:connector-curvature=\"0\" />\n        <path d=\"m 63.38,195 v -11.7 h 39 V 195 Z\" id=\"path36\" inkscape:connector-curvature=\"0\" />\n        <circle cx=\"82.879997\" cy=\"97.5\" r=\"19.5\" id=\"circle38\" />\n        <path d=\"m 67.28,35.1 a 19.5,19.5 0 0 0 31.2,0\" id=\"path40\" inkscape:connector-curvature=\"0\" />\n        <path d=\"m 98.48,159.9 a 19.5,19.5 0 0 0 -31.2,0\" id=\"path42\" inkscape:connector-curvature=\"0\" />\n        <path d=\"M 0,1.95 A 1.95,1.95 0 0 0 1.95,0\" id=\"path44\" inkscape:connector-curvature=\"0\" />\n        <path d=\"m 163.8,0 a 1.95,1.95 0 0 0 1.95,1.95\" id=\"path46\" inkscape:connector-curvature=\"0\" />\n        <path d=\"M 1.95,195 A 1.95,1.95 0 0 0 0,193.05\" id=\"path48\" inkscape:connector-curvature=\"0\" />\n        <path d=\"M 165.75,193.05 A 1.95,1.95 0 0 0 163.8,195\" id=\"path50\" inkscape:connector-curvature=\"0\" />\n      </g>\n      {{ `n${+Math.floor((dataProccesed[0][0] * 100) / max / 10).toFixed(2)}` }}\n      <g id=\"row-0\">\n        <g id=\"col-0-0\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[0][0] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"0\"\n            y=\"0\"\n            width=\"40\"\n            height=\"48.75\"\n            id=\"rect126\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"20\" y=\"24.375\" id=\"text128\">{{ dataProccesed[0][0] }}</text>\n        </g>\n        <g id=\"col-0-1\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[0][1] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"40\"\n            y=\"0\"\n            width=\"43\"\n            height=\"48.75\"\n            id=\"rect132\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"61.5\" y=\"24.375\" id=\"text134\">{{ dataProccesed[0][1] }}</text>\n        </g>\n        <g id=\"col-0-2\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[0][2] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"83\"\n            y=\"0\"\n            width=\"43\"\n            height=\"48.75\"\n            id=\"rect138\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"104.5\" y=\"24.375\" id=\"text140\">{{ dataProccesed[0][2] }}</text>\n        </g>\n        <g id=\"col-0-3\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[0][3] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"126\"\n            y=\"0\"\n            width=\"40\"\n            height=\"48.75\"\n            id=\"rect144\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"146\" y=\"24.375\" id=\"text146\">{{ dataProccesed[0][3] }}</text>\n        </g>\n      </g>\n      <g id=\"row-1\">\n        <g id=\"col-1-0\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[1][0] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"0\"\n            y=\"48.75\"\n            width=\"40\"\n            height=\"48.75\"\n            id=\"rect102\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"20\" y=\"73.125\" id=\"text104\">{{ dataProccesed[1][0] }}</text>\n        </g>\n        <g id=\"col-1-1\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[1][1] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"40\"\n            y=\"48.75\"\n            width=\"43\"\n            height=\"48.75\"\n            id=\"rect108\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"61.5\" y=\"73.125\" id=\"text110\">{{ dataProccesed[1][1] }}</text>\n        </g>\n        <g id=\"col-1-2\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[1][2] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"83\"\n            y=\"48.75\"\n            width=\"43\"\n            height=\"48.75\"\n            id=\"rect114\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"104.5\" y=\"73.125\" id=\"text116\">{{ dataProccesed[1][2] }}</text>\n        </g>\n        <g id=\"col-1-3\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[1][3] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"126\"\n            y=\"48.75\"\n            width=\"40\"\n            height=\"48.75\"\n            id=\"rect120\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"146\" y=\"73.125\" id=\"text122\">{{ dataProccesed[1][3] }}</text>\n        </g>\n      </g>\n      <g id=\"row-2\">\n        <g id=\"col-2-0\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[2][0] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"0\"\n            y=\"97.5\"\n            width=\"40\"\n            height=\"48.75\"\n            id=\"rect78\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"20\" y=\"121.875\" id=\"text80\">{{ dataProccesed[2][0] }}</text>\n        </g>\n        <g id=\"col-2-1\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[2][1] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"40\"\n            y=\"97.5\"\n            width=\"43\"\n            height=\"48.75\"\n            id=\"rect84\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"61.5\" y=\"121.875\" id=\"text86\">{{ dataProccesed[2][1] }}</text>\n        </g>\n        <g id=\"col-2-2\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[2][2] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"83\"\n            y=\"97.5\"\n            width=\"43\"\n            height=\"48.75\"\n            id=\"rect90\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"104.5\" y=\"121.875\" id=\"text92\">{{ dataProccesed[2][2] }}</text>\n        </g>\n        <g id=\"col-2-3\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[2][3] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"126\"\n            y=\"97.5\"\n            width=\"40\"\n            height=\"48.75\"\n            id=\"rect96\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"146\" y=\"121.875\" id=\"text98\">{{ dataProccesed[2][3] }}</text>\n        </g>\n      </g>\n      <g id=\"row-3\">\n        <g id=\"col-3-0\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[3][0] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"0\"\n            y=\"146.25\"\n            width=\"40\"\n            height=\"48.75\"\n            id=\"rect54\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"20\" y=\"170.625\" id=\"text56\">{{ dataProccesed[3][0] }}</text>\n        </g>\n        <g id=\"col-3-1\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[3][1] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"40\"\n            y=\"146.25\"\n            width=\"43\"\n            height=\"48.75\"\n            id=\"rect60\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"61.5\" y=\"170.625\" id=\"text62\">{{ dataProccesed[3][1] }}</text>\n        </g>\n        <g id=\"col-3-2\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[3][2] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"83\"\n            y=\"146.25\"\n            width=\"43\"\n            height=\"48.75\"\n            id=\"rect66\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"104.5\" y=\"170.625\" id=\"text68\">{{ dataProccesed[3][2] }}</text>\n        </g>\n        <g id=\"col-3-3\" transform=\"translate(25.0001)\">\n          <rect\n            :class=\"[\n              'maRegionTier',\n              negative ? 'negative' : 'positive',\n              `n${+Math.floor((dataProccesed[3][3] * 100) / max / 10).toFixed(2)}`,\n            ]\"\n            x=\"126\"\n            y=\"146.25\"\n            width=\"40\"\n            height=\"48.75\"\n            id=\"rect72\"\n          />\n          <text class=\"maRegionPercentageText\" x=\"146\" y=\"170.625\" id=\"text74\">\n            {{ +dataProccesed[3][3].toFixed(2) }}\n          </text>\n        </g>\n      </g>\n      <g id=\"vertical-sums\">\n        <text class=\"maTotalPercentageText\" :x=\"isMinMobile ? 10.0001693 : 5\" y=\"24.375\" id=\"sum-row-0\">\n          {{ +(dataProccesed[0][0] + dataProccesed[0][1] + dataProccesed[0][2] + dataProccesed[0][3]).toFixed(2) }}\n        </text>\n        <text class=\"maTotalPercentageText\" :x=\"isMinMobile ? 10.0001693 : 5\" y=\"73.125\" id=\"sum-row-1\">\n          {{ +(dataProccesed[1][0] + dataProccesed[1][1] + dataProccesed[1][2] + dataProccesed[1][3]).toFixed(2) }}\n        </text>\n        <text class=\"maTotalPercentageText\" :x=\"isMinMobile ? 10.0001693 : 5\" y=\"121.875\" id=\"sum-row-2\">\n          {{ +(dataProccesed[2][0] + dataProccesed[2][1] + dataProccesed[2][2] + dataProccesed[2][3]).toFixed(2) }}\n        </text>\n        <text class=\"maTotalPercentageText\" :x=\"isMinMobile ? 10.0001693 : 5\" y=\"170.625\" id=\"sum-row-3\">\n          {{ +(dataProccesed[3][0] + dataProccesed[3][1] + dataProccesed[3][2] + dataProccesed[3][3]).toFixed(2) }}\n        </text>\n      </g>\n      <g id=\"horizontal-sums\" transform=\"translate(8)\">\n        <text class=\"maTotalPercentageText\" x=\"37.333332\" y=\"212\" id=\"sum-col-0\">\n          {{ +(dataProccesed[3][0] + dataProccesed[2][0] + dataProccesed[1][0] + dataProccesed[0][0]).toFixed(2) }}\n        </text>\n        <text class=\"maTotalPercentageText\" x=\"78.583359\" y=\"212\" id=\"sum-col-1\">\n          {{ +(dataProccesed[3][1] + dataProccesed[2][1] + dataProccesed[1][1] + dataProccesed[0][1]).toFixed(2) }}\n        </text>\n        <text class=\"maTotalPercentageText\" x=\"121.08336\" y=\"212\" id=\"sum-col-2\">\n          {{ +(dataProccesed[3][2] + dataProccesed[2][2] + dataProccesed[1][2] + dataProccesed[0][2]).toFixed(2) }}\n        </text>\n        <text class=\"maTotalPercentageText\" x=\"162.33327\" y=\"212\" id=\"sum-col-3\">\n          {{ +(dataProccesed[3][3] + dataProccesed[2][3] + dataProccesed[1][3] + dataProccesed[0][3]).toFixed(2) }}\n        </text>\n      </g>\n      <g id=\"direction\" transform=\"translate(8)\">\n        <line x1=\"194\" y1=\"140\" x2=\"194\" y2=\"60\" stroke=\"#808080\" stroke-width=\"2\" marker-end=\"url(#arrowhead)\" />\n      </g>\n    </svg>\n  </div>\n</template>\n\n<script>\nimport { mapState, mapGetters } from 'vuex';\nimport { mainServer } from '../../utils/misc';\n\nexport default {\n  name: 'StatisticField',\n  props: {\n    data: {\n      type: Array,\n      required: false,\n      default() {\n        return [];\n      },\n    },\n    negative: {\n      type: Boolean,\n      required: false,\n      default: false,\n    },\n    mainServer,\n  },\n  computed: {\n    ...mapGetters('playerProfileFilter', {\n      getGamesPlayedByTeam: 'getGamesPlayedByTeam',\n    }),\n    ...mapState(['windowWidth']),\n    max() {\n      return Math.max(...[].concat(...this.dataProccesed));\n    },\n    dataProccesed() {\n      return this.data.map((da) => da.map((d) => +(d / this.gamesPlayed).toFixed(2)));\n    },\n    gamesPlayed() {\n      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;\n    },\n    ...mapState('playerProfileGlobal', ['windowWidth']),\n    isMinMobile() {\n      return this.windowWidth < 375;\n    },\n    svgDimensions() {\n      const width = this.isMinMobile ? 250 : 310;\n      const height = width * 0.9701;\n      return {\n        width,\n        height,\n      };\n    },\n  },\n};\n</script>\n\n<style scoped>\n.maByRegionChartFieldLines {\n  stroke: #ddd;\n  stroke-width: 0.75;\n  fill: none;\n}\n\n.maByRegionChartFieldBackground {\n  fill: url(#maByRegionFieldBackground);\n  filter: url(#maByRegionDropShadow);\n}\n\n.maRegionTier {\n  stroke: #ffffff;\n  stroke-width: 0.5;\n  stroke-opacity: 0.7;\n}\n\n.positive.n10 {\n  fill: rgb(90, 255, 68);\n  fill-opacity: 0.7;\n}\n.positive.n9 {\n  fill: rgb(99, 255, 85);\n  fill-opacity: 0.7;\n}\n.positive.n8 {\n  fill: rgb(120, 255, 102);\n  fill-opacity: 0.7;\n}\n.positive.n7 {\n  fill: rgb(146, 255, 119);\n  fill-opacity: 0.6;\n}\n.positive.n6 {\n  fill: rgb(160, 255, 136);\n  fill-opacity: 0.6;\n}\n.positive.n5 {\n  fill: rgb(162, 255, 153);\n  fill-opacity: 0.5;\n}\n.positive.n4 {\n  fill: rgb(170, 255, 170);\n  fill-opacity: 0.5;\n}\n.positive.n3 {\n  fill: rgb(170, 255, 174);\n  fill-opacity: 0.4;\n}\n.positive.n2 {\n  fill: rgb(180, 255, 170);\n  fill-opacity: 0.35;\n}\n.positive.n1 {\n  fill: rgb(170, 255, 184);\n  fill-opacity: 0.3;\n}\n.positive.n0 {\n  fill: rgb(170, 255, 191);\n  fill-opacity: 0.2;\n}\n\n.positive.nNaN {\n  fill: rgb(170, 255, 191);\n  fill-opacity: 0;\n}\n\n.negative.nNaN {\n  fill: rgb(255, 68, 68);\n  fill-opacity: 0;\n}\n\n.negative.n10 {\n  fill: rgb(255, 68, 68);\n  fill-opacity: 0.7;\n}\n.negative.n9 {\n  fill: rgb(255, 85, 85);\n  fill-opacity: 0.7;\n}\n.negative.n8 {\n  fill: rgb(255, 102, 102);\n  fill-opacity: 0.7;\n}\n.negative.n7 {\n  fill: rgb(255, 119, 119);\n  fill-opacity: 0.6;\n}\n.negative.n6 {\n  fill: rgb(255, 136, 136);\n  fill-opacity: 0.6;\n}\n.negative.n5 {\n  fill: rgb(255, 153, 153);\n  fill-opacity: 0.5;\n}\n.negative.n4 {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.5;\n}\n.negative.n3 {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.4;\n}\n.negative.n2 {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.35;\n}\n.negative.n1 {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.3;\n}\n.negative.n0 {\n  fill: rgb(255, 170, 170);\n  fill-opacity: 0.2;\n}\n\n.maRegionPercentageText,\n.maRegionCountText {\n  font-size: 14px;\n  text-anchor: middle;\n}\n\n.maTotalPercentageText {\n  fill: #808080;\n  font-size: 10px;\n  text-anchor: middle;\n}\n\n.maRegionPercentageText {\n  fill: #fff;\n  font-size: 11px;\n}\n\n.maRegionCountText {\n  font-size: 9px;\n  fill: #eee;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$e = "data-v-4e7cd062";
  /* module identifier */
  var __vue_module_identifier__$e = undefined;
  /* functional template */
  var __vue_is_functional_template__$e = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$d = {
  name: 'DataTable',
  props: {
    detailKey: {
      type: String,
      required: false,
      default: 'category',
    },
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    expandedRows: {
      type: Array,
      required: false,
      default: function() {
        return [];
      },
    },
  },
  computed: Object.assign({}, mapGetters({
      gamesPlayedByPlayer: 'playerProfileFilter/getGamesPlayedByPlayer',
      stadisticId: 'playerProfileFilter/getStadisticId',
    }),
    mapState('playerProfileFilter', {
      selectedCategory: 'categoryType',
    }),
    {gamesPlayed: function gamesPlayed() {
      return this.gamesPlayedByPlayer || 1
    }}),
  watch: {
    data: {
      deep: true,
      handler: function handler() {
        this.removeExpandArrows();
      },
    },
  },
  methods: {
    processedAverage: function processedAverage(isAverageOfLeague, value) {
      // when statistic is '1' there's no need to divide because gamesPlayed is 1 and there's no decimals
      var VAL = typeof value === 'string' || this.stadisticId === 1 ? value : (value / this.gamesPlayed).toFixed(2);
      return isAverageOfLeague ? value.toFixed(2) : VAL;
    },
    toggle: function toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
    onOpenDetails: function onOpenDetails(row) {
      this.$emit('showDetails', row.category);
    },
    onCloseDetails: function onCloseDetails(row) {
      this.$emit('hideDetails', row.category);
    },
    removeExpandArrows: function removeExpandArrows() {
      this.data.forEach(function (tableRow, index) {
        if (!tableRow.items) {
          var childCells = document.querySelector((".parent-row-" + index));
          if (childCells) {
            var arrowCell = childCells.parentNode.firstChild;
            if (arrowCell.firstChild) {
              arrowCell.removeChild(arrowCell.firstChild);
            }
          }
        }
      });
    },
  },
  mounted: function mounted() {
    this.removeExpandArrows();
  },
};

/* script */
var __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("section", [
    _c(
      "div",
      { staticClass: "desktop-table is-hidden-mobile" },
      [
        _c("BTable", {
          ref: "table",
          attrs: {
            data: _vm.data,
            detailed: "",
            hoverable: "",
            "custom-detail-row": "",
            "opened-detailed": _vm.expandedRows,
            "detail-key": _vm.detailKey,
            "show-detail-icon": "",
            bordered: "",
            "mobile-cards": true
          },
          on: {
            "details-open": _vm.onOpenDetails,
            "details-close": _vm.onCloseDetails
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return _vm._l(_vm.columns, function(column, index) {
                  return _c(
                    "BTableColumn",
                    {
                      key: index,
                      staticClass: "has-detail-rows",
                      class: "parent-row-" + props.index,
                      attrs: {
                        field: column.name,
                        visible: column.display,
                        label: column.title,
                        sortable: column.sortable,
                        centered: index !== 0,
                        width: column.width || ""
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.processedAverage(
                              column.isAverageOfLeague,
                              props.row[column.name]
                            )
                          ) +
                          "\n        "
                      )
                    ]
                  )
                })
              }
            },
            {
              key: "detail",
              fn: function(props) {
                return _vm._l(props.row.items, function(item) {
                  return _c(
                    "tr",
                    { key: item.category, staticClass: "detailed-row" },
                    [
                      _c("td"),
                      _vm._v(" "),
                      _vm._l(_vm.columns, function(column, index) {
                        return _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: column.display,
                                expression: "column.display"
                              }
                            ],
                            key: index,
                            class: {
                              "has-text-centered": column.name !== _vm.detailKey
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.processedAverage(
                                    column.isAverageOfLeague,
                                    item[column.name]
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                })
              }
            }
          ])
        })
      ],
      1
    )
  ])
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  var __vue_inject_styles__$d = undefined;
  /* scoped */
  var __vue_scope_id__$d = undefined;
  /* module identifier */
  var __vue_module_identifier__$d = undefined;
  /* functional template */
  var __vue_is_functional_template__$d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    undefined,
    undefined,
    undefined
  );

function createNestedItems(nestedRows) {
  return nestedRows.reduce(function (accumulator, nestedRow) {
    accumulator.push(new PlayerTableRow(nestedRow.category, nestedRow.categoryIds, nestedRow.items));
    return accumulator;
  }, []);
}

function PlayerTableRow(category, categoryIds, nestedRows) {
  this.leagueAvg = 0;
  this.totalAccumulated = 0;
  this.period1 = 0;
  this.period2 = 0;
  this.period3 = 0;
  this.period4 = 0;
  this.period5 = 0;
  this.period6 = 0;
  this.items = nestedRows ? createNestedItems(nestedRows) : null;
  this.category = category;
  this.categoryIds = categoryIds;

  this.addAvgPlay = function(play, timeSelected, playValueIndex, seasonGames, parentRow) {
    // If this row has not categoryIds, it is a parent row
    if (this.categoryIds) {
      // Check if current play.categoryId is in categoryIds
      if (
        this.categoryIds.includes(play[playValueIndex.categoryId]) &&
        timeSelected.includes(play[playValueIndex.section])
      ) {
        // if this row has parent row, increment it's period
        if (parentRow) { parentRow.leagueAvg += play[playValueIndex.total] / seasonGames; }
        this.leagueAvg += play[playValueIndex.total] / seasonGames;
        return true;
      }
    } else if (this.items) {
      for (var item of this.items) {
        if (item.addAvgPlay(play, timeSelected, playValueIndex, seasonGames, this)) {
          return true;
        }
      }
    }
  };

  this.addPlay = function(play, timeSelected, playValueIndex, parentRow) {
    // If this row has not categoryIds, it is a parent row
    if (this.categoryIds) {
      // Check if current play.categoryId is in categoryIds
      if (this.categoryIds.includes(play[playValueIndex.categoryId])) {
        // if this row has parent row, increment it's period
        if (parentRow) { parentRow[("period" + (play[playValueIndex.section]))]++; }
        this[("period" + (play[playValueIndex.section]))]++;
        // Check selected time periods with current play time period
        if (!timeSelected || timeSelected.includes(play[playValueIndex.section])) {
          if (parentRow) { parentRow.totalAccumulated++; }
          this.totalAccumulated++;
        }
        return true;
      }
    } else if (this.items) {
      for (var item of this.items) {
        if (item.addPlay(play, timeSelected, playValueIndex, this)) {
          return true;
        }
      }
    }
  };
}

// Data structure for the possession table data rows
var possessionPlayerTableRowItems = [
  {
    category: 'PASES  ACERTADOS',
    categoryIds: null,
    items: [
      {
        category: 'P. ACERTADOS 1/4',
        categoryIds: [213],
      },
      {
        category: 'P. ACERTADOS 2/4',
        categoryIds: [214],
      },
      {
        category: 'P. ACERTADOS 3/4',
        categoryIds: [215],
      },
      {
        category: 'P. ACERTADOS 4/4',
        categoryIds: [216],
      } ],
  },
  {
    category: 'PASES FILTRADOS',
    categoryIds: [217],
  },
  {
    category: 'PASES NO ACERTADOS',
    categoryIds: null,
    items: [
      {
        category: 'P. NO ACERTADOS 1/4',
        categoryIds: [218],
      },
      {
        category: 'P. NO ACERTADOS 2/4',
        categoryIds: [219],
      },
      {
        category: 'P. NO ACERTADOS 3/4',
        categoryIds: [220],
      },
      {
        category: 'P. NO ACERTADOS 4/4',
        categoryIds: [221],
      } ],
  },
  {
    category: 'BALONES RECUPERADOS EN DISPUTA',
    categoryIds: null,
    items: [
      {
        category: 'B.R.E.D CANCHA PROPIA',
        categoryIds: [485, 486],
      },
      {
        category: 'B.R.E.D CANCHA RIVAL',
        categoryIds: [487, 488],
      } ],
  },
  {
    category: 'BALONES RECUPERADOS SIN DISPUTA',
    categoryIds: null,
    items: [
      {
        category: 'B.R.S.D CANCHA PROPIA',
        categoryIds: [489, 490],
      },
      {
        category: 'B.R.S.D CANCHA RIVAL',
        categoryIds: [491, 492],
      } ],
  },
  {
    category: 'BALONES PERDIDOS EN DISPUTA',
    categoryIds: null,
    items: [
      {
        category: 'B.P.E.D. CANCHA PROPIA',
        categoryIds: [496, 497],
      },
      {
        category: 'B.P.E.D. CANCHA RIVAL',
        categoryIds: [498, 499],
      } ],
  },
  {
    category: 'BALONES PERDIDOS SIN DISPUTA',
    categoryIds: null,
    items: [
      {
        category: 'B.P.S.D. CANCHA PROPIA',
        categoryIds: [500, 501],
      },
      {
        category: 'B.P.S.D. CANCHA RIVAL',
        categoryIds: [502, 503],
      } ],
  } ];

// Data structure for the offensive table data rows
var offensivePlayerTableRowItems = [
  {
    category: 'GOLES',
    categoryIds: null,
    items: [
      {
        category: 'GOLES PIE DENTRO DEL ÁREA',
        categoryIds: [57],
      },
      {
        category: 'GOLES PIE FUERA DEL ÁREA',
        categoryIds: [326],
      },
      {
        category: 'GOLES CABEZA',
        categoryIds: [56],
      },
      {
        category: 'GOLES TIRO LIBRE',
        categoryIds: [60],
      },
      {
        category: 'GOLES PENAL',
        categoryIds: [59],
      } ],
  },
  {
    category: 'TIROS A GOL (ORIGEN)',
    categoryIds: null,
    items: [
      {
        category: 'DENTRO DEL ÁREA',
        categoryIds: [514, 516],
      },
      {
        category: 'FUERA DEL ÁREA',
        categoryIds: [513, 515],
      } ],
  },
  {
    category: 'TIROS A GOL (DESTINO)',
    categoryIds: null,
    items: [
      {
        category: 'CON DESTINO A PORTERÍA',
        categoryIds: [537, 540, 544, 547],
      },
      {
        category: 'SIN DESTINO A PORTERÍA',
        categoryIds: [538, 541, 545, 548],
      },
      {
        category: 'BLOQUEADOS',
        categoryIds: [539, 542, 546, 549],
      } ],
  },
  {
    category: 'CENTROS POR IZQUIERDA',
    categoryIds: null,
    items: [
      {
        category: 'C.P.I. ACERTADOS',
        categoryIds: [98, 101, 104, 105],
      },
      {
        category: 'C.P.I. NO ACERTADOS',
        categoryIds: [106, 107, 108],
      } ],
  },
  {
    category: 'CENTROS POR DERECHA',
    categoryIds: null,
    items: [
      {
        category: 'C.P.D. ACERTADOS',
        categoryIds: [109, 112, 115, 116],
      },
      {
        category: 'C.P.D. NO ACERTADOS',
        categoryIds: [117, 118, 119],
      } ],
  },
  {
    category: 'BALONES GANADOS EN ÁREA RIVAL',
    categoryIds: [11],
  } ];

// Data structure for the defensive table data rows
var defensivePlayerTableRowItems = [
  {
    category: 'BALONES RECUPERADOS CANCHA RIVAL',
    categoryIds: null,
    items: [
      {
        category: 'B.R.C.R. EN DISPUTA',
        categoryIds: [487, 488],
      },
      {
        category: 'B.R.C.R. SIN DISPUTA',
        categoryIds: [491, 492],
      } ],
  },
  {
    category: 'BALONES RECUPERADOS CANCHA PROPIA',
    categoryIds: null,
    items: [
      {
        category: 'B.R.C.P. EN DISPUTA',
        categoryIds: [485, 486],
      },
      {
        category: 'B.R.C.P. SIN DISPUTA',
        categoryIds: [489, 490],
      } ],
  },
  {
    category: 'BALONES GANADOS EN ÁREA PROPIA',
    categoryIds: [23],
    items: null,
  },
  {
    category: '1 VS 1 EXITOSOS',
    categoryIds: null,
    items: [
      {
        category: 'OFENSIVOS',
        categoryIds: [4],
      },
      {
        category: 'DEFENSIVOS',
        categoryIds: [5],
      } ],
  },
  {
    category: 'BARRIDAS',
    categoryIds: null,
    items: [
      {
        category: 'CON POSESIÓN',
        categoryIds: [521],
      },
      {
        category: 'SIN POSESIÓN',
        categoryIds: [522],
      },
      {
        category: 'PROVOCA FALTA',
        categoryIds: [543],
      } ],
  },
  {
    category: 'CENTROS PERMITIDOS',
    categoryIds: [517],
    items: null,
  },
  {
    category: 'RECHACES',
    categoryIds: [34],
    items: null,
  } ];

// ToDo: Pending to change a factory to return desired array based on arguments
function createPossessionPlayerRows() {
  return possessionPlayerTableRowItems.map(function (ref) {
    var category = ref.category;
    var categoryIds = ref.categoryIds;
    var items = ref.items;

    return new PlayerTableRow(category, categoryIds, items);
  });
}

function createOffensivePlayerRows() {
  return offensivePlayerTableRowItems.map(function (ref) {
    var category = ref.category;
    var categoryIds = ref.categoryIds;
    var items = ref.items;

    return new PlayerTableRow(category, categoryIds, items);
  });
}

function createDefensivePlayerRows() {
  return defensivePlayerTableRowItems.map(function (ref) {
    var category = ref.category;
    var categoryIds = ref.categoryIds;
    var items = ref.items;

    return new PlayerTableRow(category, categoryIds, items);
  });
}

// Data structure for the possession table data rows
var possessionGoalkeeperTableRowItems = [
  {
    category: 'JUEGO DE PIES',
    categoryIds: null,
    items: [
      {
        category: 'PASE LARGO ACERTADO',
        categoryIds: [310],
      },
      {
        category: 'PASE LARGO NO ACERTADO',
        categoryIds: [311],
      },
      {
        category: 'PASE CORTO ACERTADO',
        categoryIds: [308],
      },
      {
        category: 'PASE CORTO NO ACERTADO',
        categoryIds: [309],
      } ],
  },
  {
    category: 'DESPEJES DE MANO',
    categoryIds: null,
    items: [
      {
        category: 'D.M. ACERTADOS',
        categoryIds: [304],
      },
      {
        category: 'D.M. NO ACERTADOS',
        categoryIds: [305],
      } ],
  },
  {
    category: 'DESPEJES DE PIE',
    categoryIds: null,
    items: [
      {
        category: 'D.P. ACERTADOS',
        categoryIds: [306],
      },
      {
        category: 'D.P. NO ACERTADOS',
        categoryIds: [307],
      } ],
  },
  {
    category: 'PARTICIPACIÓN EN GOL',
    categoryIds: [323],
    items: null,
  } ];

// Data structure for the offensive table data rows
var offensiveGoalkeeperTableRowItems = [
  {
    category: 'JUEGO DE PIES',
    categoryIds: null,
    items: [
      {
        category: 'PASE LARGO ACERTADO',
        categoryIds: [310],
      },
      {
        category: 'PASE LARGO NO ACERTADO',
        categoryIds: [311],
      },
      {
        category: 'PASE CORTO ACERTADO',
        categoryIds: [308],
      },
      {
        category: 'PASE CORTO NO ACERTADO',
        categoryIds: [309],
      } ],
  },
  {
    category: 'DESPEJES DE MANO',
    categoryIds: null,
    items: [
      {
        category: 'D.M. ACERTADOS',
        categoryIds: [304],
      },
      {
        category: 'D.M. NO ACERTADOS',
        categoryIds: [305],
      } ],
  },
  {
    category: 'DESPEJES DE PIE',
    categoryIds: null,
    items: [
      {
        category: 'D.P. ACERTADOS',
        categoryIds: [306],
      },
      {
        category: 'D.P. NO ACERTADOS',
        categoryIds: [307],
      } ],
  },
  {
    category: 'PARTICIPACIÓN EN GOL',
    categoryIds: [323],
    items: null,
  } ];

// Data structure for the offensive table data rows
var defensiveGoalkeeperTableRowItems = [
  {
    category: 'GOLES RECIBIDOS',
    categoryIds: [40],
    items: null,
  },
  {
    category: 'ATAJADAS',
    categoryIds: null,
    items: [
      {
        category: 'SE QUEDA CON EL BALÓN',
        categoryIds: [300],
      },
      {
        category: 'NO SE QUEDA CON EL BALÓN',
        categoryIds: [301],
      } ],
  },
  {
    category: 'JUEGO AÉREO',
    categoryIds: null,
    items: [
      {
        category: 'EXITOSO, SE QUEDA CON EL BALÓN',
        categoryIds: [313],
      },
      {
        category: 'EXITOSO, NO SE QUEDA CON EL BALÓN',
        categoryIds: [314],
      } ],
  },
  {
    category: '1 VS 1',
    categoryIds: [41],
    items: null,
  },
  {
    category: 'BALONES RECUPERADOS',
    categoryIds: [312],
    items: null,
  } ];

// ToDo: Pending to change a factory to return desired array based on arguments
function createPossessionGoalkeeperRows() {
  return possessionGoalkeeperTableRowItems.map(function (ref) {
    var category = ref.category;
    var categoryIds = ref.categoryIds;
    var items = ref.items;

    return new PlayerTableRow(category, categoryIds, items);
  });
}

function createOffensiveGoalkeeperRows() {
  return offensiveGoalkeeperTableRowItems.map(function (ref) {
    var category = ref.category;
    var categoryIds = ref.categoryIds;
    var items = ref.items;

    return new PlayerTableRow(category, categoryIds, items);
  });
}
function createDefensiveGoalkeeperRows() {
  return defensiveGoalkeeperTableRowItems.map(function (ref) {
    var category = ref.category;
    var categoryIds = ref.categoryIds;
    var items = ref.items;

    return new PlayerTableRow(category, categoryIds, items);
  });
}

var baseColumns = [
  {
    name: 'category',
    title: 'CATEGORÍA Y SUBCATEGORÍA',
    display: true,
    sortable: false,
    width: 300,
  },
  {
    name: 'leagueAvg',
    title: 'LIGA',
    display: true,
    sortable: false,
    isAverageOfLeague: true,
  },
  {
    name: 'totalAccumulated',
    title: 'JUGADOR',
    display: true,
    sortable: false,
  },
  // {
  //   name: 'lastMatch',
  //   title: 'ULTIMO PARTIDO',
  //   display: true,
  //   sortable: false,
  // },
  {
    name: 'period1',
    title: 'MIN  0 - 15',
    display: true,
    sortable: false,
  },
  {
    name: 'period2',
    title: 'MIN 16 - 30',
    display: true,
    sortable: false,
  },
  {
    name: 'period3',
    title: 'MIN 31 - 45',
    display: true,
    sortable: false,
  },
  {
    name: 'period4',
    title: 'MIN 45 - 60',
    display: true,
    sortable: false,
  },
  {
    name: 'period5',
    title: 'MIN 61 - 75',
    display: true,
    sortable: false,
  },
  {
    name: 'period6',
    title: 'MIN 76 - 90',
    display: true,
    sortable: false,
  } ];

// Data that configures the Player Possession Table

var possessionDataTable = {
  columns: baseColumns,
  expandedRows: possessionPlayerTableRowItems.map(function (item) {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
  goalkeeperExpandedRows: possessionGoalkeeperTableRowItems.map(function (item) {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$c = {
  props: {
    isActive: {
      required: true,
      type: Boolean,
    },
    item: {
      required: true,
      type: Object,
    },
    subcategorie: {
      required: true,
      type: String,
    },
    displayData: {
      type: Array,
      required: true,
    },
  },
  data: function data() {
    return {
      isComponentModalActive: false,
      formProps: {
        email: 'evan@you.com',
        password: 'testing',
      },
      average: 0,
      max: 0,
      currentSubcategory: null,
      subcategories: [],
      temporary: [],
    };
  },
  computed: {
    columns: function columns() {
      var rows = [];
      if (this.currentSubcategory != null) {
        var currentSubcategory = this.item.items[this.currentSubcategory];
        this.displayData.map(function (r) {
          var title = r.title,
            header = '',
            subtitle = '';
          if (title.startsWith('MIN')) {
            header = 'Del Minuto';
            subtitle = title.substring(4);
          } else {
            var index = title.indexOf(' ', title.indexOf(' ') + 1);
            header = title.substr(0, index);
            subtitle = title.substr(index + 1);
          }
          rows.push({ value: currentSubcategory[r.name], header: header, subtitle: subtitle });
        });
      }
      return rows;
    },
  },
  watch: {
    item: {
      handler: function(newVal) {
        if (newVal) {
          this.average = newVal.leagueAvg;
          this.max = newVal.totalAccumulated;
          this.subcategories = newVal.items.map(function (r, i) {
            return { value: i, title: r.category };
          });
          this.currentSubcategory = this.subcategories.length ? 1 : null;
        }
      },
      inmediate: true,
    },
    subcategorie: {
      handler: function(newVal) {
        if (this.item && newVal) {
          var subcategorie = this.subcategories.find(function (r) { return r.title == newVal; });
          this.currentSubcategory = subcategorie ? subcategorie.value : null;
        }
      },
      inmediate: true,
    },
  },
  methods: {
    onChangeSubcategory: function onChangeSubcategory(value){
      var subcategory = this.subcategories.find(function (s) { return s.value == value; });
      this.$emit("changeSubcategory", subcategory.title);
    }
  }
};

/* script */
var __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "BModal",
    {
      attrs: {
        active: _vm.isActive,
        "has-modal-card": "",
        "full-screen": "",
        "can-cancel": false
      },
      on: {
        "update:active": function($event) {
          _vm.isActive = $event;
        }
      }
    },
    [
      _c("div", { staticClass: "modal-card", staticStyle: { width: "auto" } }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title font-bold" }, [
            _vm._v("\n        " + _vm._s(_vm.item.category) + "\n        "),
            _c(
              "a",
              {
                staticClass: "close-icon",
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_c("BIcon", { attrs: { icon: "close", size: "is-medium" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "modal-card-body" }, [
          _c(
            "div",
            { staticClass: "columns is-mobile is-centered font-medium" },
            [_vm._v("\n        Liga MX\n      ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "is-mobile font-bold avg-max__text" }, [
            _c("div", [_vm._v("\n          Average(AVG)\n        ")]),
            _vm._v(" "),
            _c("div", [_vm._v("\n          |\n        ")]),
            _vm._v(" "),
            _c("div", [_vm._v("\n          Máximo(MAX)\n        ")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "is-mobile avg-max__amount" }, [
            _c("div", { staticClass: "title box-title has-background-light" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("fixed")(_vm.average)) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "title box-title has-background-light" }, [
              _vm._v("\n          " + _vm._s(_vm.max) + "\n        ")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "columns is-mobile is-size-6 font-medium is-centered"
            },
            [_vm._v("\n        Subcategoría\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "columns is-mobile is-centered" },
            [
              _c(
                "BField",
                [
                  _c(
                    "BSelect",
                    {
                      attrs: {
                        size: "is-large",
                        placeholder: "Subcategorías",
                        expanded: ""
                      },
                      on: { input: _vm.onChangeSubcategory },
                      model: {
                        value: _vm.currentSubcategory,
                        callback: function($$v) {
                          _vm.currentSubcategory = $$v;
                        },
                        expression: "currentSubcategory"
                      }
                    },
                    _vm._l(_vm.subcategories, function(subcategorie) {
                      return _c(
                        "option",
                        {
                          key: subcategorie.value,
                          domProps: { value: subcategorie.value }
                        },
                        [_vm._v(_vm._s(subcategorie.title))]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "list-columns" },
            [
              _vm._l(_vm.columns, function(col, i) {
                return [
                  _c(
                    "div",
                    {
                      key: i,
                      staticClass: "columns is-mobile is-vcentered is-centered"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "column has-background-light" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "font-medium heading has-text-left has-text-grey"
                            },
                            [_vm._v(_vm._s(col.header))]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "font-bold has-text-left is-size-5"
                            },
                            [_vm._v(_vm._s(col.subtitle))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "column is-4 font-subtitle" }, [
                        _c("span", [_vm._v(_vm._s(_vm._f("fixed")(col.value)))])
                      ])
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ])
    ]
  )
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  var __vue_inject_styles__$c = function (inject) {
    if (!inject) { return }
    inject("data-v-7dbeb0d9_0", { source: ".box-title[data-v-7dbeb0d9] {\n  border-radius: 10px;\n  padding: 6px 0px;\n  margin: 0px 12px;\n}\n.modal-card-body[data-v-7dbeb0d9] {\n  padding: 20px 0px;\n}\n.list-columns[data-v-7dbeb0d9] {\n  margin-top: 30px;\n}\n.list-columns .columns[data-v-7dbeb0d9] {\n  border: 1px ridge;\n}\n.list-columns .column[data-v-7dbeb0d9] {\n  padding-left: 40px;\n}\n.list-columns .column.is-4[data-v-7dbeb0d9] {\n  width: 45%;\n  padding: 10px;\n  font-size: 1, 3rem;\n}\n.heading[data-v-7dbeb0d9] {\n  margin-bottom: 0px !important;\n}\n.columns[data-v-7dbeb0d9] {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.columns.is-gapless[data-v-7dbeb0d9] {\n  margin-bottom: 15px;\n}\n.close-icon[data-v-7dbeb0d9] {\n  float: right;\n  color: #000000;\n}\n.font-bold[data-v-7dbeb0d9] {\n  font-family: Avenir-Demi;\n}\n.font-medium[data-v-7dbeb0d9] {\n  font-family: Avenir-Demi-Medium;\n}\n.font-subtitle[data-v-7dbeb0d9] {\n  font-family: Avenir-Demi-Medium;\n  font-size: 24px;\n}\n.modal-card-title[data-v-7dbeb0d9] {\n  width: 100%;\n}\n.avg-max__text[data-v-7dbeb0d9] {\n  display: grid;\n  grid-template-columns: 1fr 10px 1fr;\n  column-gap: 16px;\n}\n.avg-max__text > div[data-v-7dbeb0d9]:first-child {\n  justify-self: right;\n}\n.avg-max__text > div[data-v-7dbeb0d9]:last-child {\n  justify-self: left;\n}\n.avg-max__amount[data-v-7dbeb0d9] {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 0.8rem;\n  margin-bottom: 1rem;\n}\n.avg-max__amount > div[data-v-7dbeb0d9] {\n  min-width: 7rem;\n  padding: 0.4rem 0.4rem 0;\n}\n@media screen and (max-width: 380px) {\n.avg-max__amount > div[data-v-7dbeb0d9] {\n    font-size: 1.5rem;\n}\n}\n.avg-max__amount > div[data-v-7dbeb0d9]:first-child {\n  justify-self: right;\n}\n.avg-max__amount > div[data-v-7dbeb0d9]:last-child {\n  justify-self: left;\n}\n\n/*# sourceMappingURL=DetailsDataMobileTable.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/DetailsDataMobileTable.vue","DetailsDataMobileTable.vue"],"names":[],"mappings":"AA2JA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AC1JA;AD4JA;EACA,iBAAA;ACzJA;AD2JA;EACA,gBAAA;ACxJA;AD0JA;EACA,iBAAA;ACvJA;ADyJA;EACA,kBAAA;ACtJA;ADwJA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;ACrJA;ADuJA;EACA,6BAAA;ACpJA;ADsJA;EACA,gBAAA;EACA,iBAAA;ACnJA;ADqJA;EACA,mBAAA;AClJA;ADoJA;EACA,YAAA;EACA,cAAA;ACjJA;ADmJA;EACA,wBAAA;AChJA;ADkJA;EACA,+BAAA;AC/IA;ADiJA;EACA,+BAAA;EACA,eAAA;AC9IA;ADgJA;EACA,WAAA;AC7IA;ADgJA;EACA,aAAA;EACA,mCAAA;EACA,gBAAA;AC7IA;AD+IA;EACA,mBAAA;AC7IA;ADgJA;EACA,kBAAA;AC9IA;ADkJA;EACA,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,mBAAA;AChJA;ADkJA;EACA,eAAA;EACA,wBAAA;AChJA;ADkJA;AAJA;IAKA,iBAAA;AC/IE;AACF;ADkJA;EACA,mBAAA;AChJA;ADmJA;EACA,kBAAA;ACjJA;;AAEA,qDAAqD","file":"DetailsDataMobileTable.vue","sourcesContent":["<template>\n  <BModal :active.sync=\"isActive\" has-modal-card full-screen :can-cancel=\"false\">\n    <div class=\"modal-card\" style=\"width: auto\">\n      <header class=\"modal-card-head\">\n        <p class=\"modal-card-title font-bold\">\n          {{ item.category }}\n          <a class=\"close-icon\" @click=\"$emit('close')\">\n            <BIcon icon=\"close\" size=\"is-medium\"> </BIcon>\n          </a>\n        </p>\n      </header>\n      <section class=\"modal-card-body\">\n        <div class=\"columns is-mobile is-centered font-medium\">\n          Liga MX\n        </div>\n        <div class=\"is-mobile font-bold avg-max__text\">\n          <div>\n            Average(AVG)\n          </div>\n          <div>\n            |\n          </div>\n          <div>\n            Máximo(MAX)\n          </div>\n        </div>\n        <div class=\"is-mobile avg-max__amount\">\n          <div class=\"title box-title has-background-light\">\n            {{ average | fixed }}\n          </div>\n          <div class=\"title box-title has-background-light\">\n            {{ max }}\n          </div>\n        </div>\n        <div class=\"columns is-mobile is-size-6 font-medium is-centered\">\n          Subcategoría\n        </div>\n        <div class=\"columns is-mobile is-centered\">\n          <BField>\n            <BSelect size=\"is-large\" placeholder=\"Subcategorías\" v-model=\"currentSubcategory\" expanded @input=\"onChangeSubcategory\">\n              <option v-for=\"subcategorie in subcategories\" :value=\"subcategorie.value\" :key=\"subcategorie.value\">{{\n                subcategorie.title\n              }}</option>\n            </BSelect>\n          </BField>\n        </div>\n        <div class=\"list-columns\">\n          <template v-for=\"(col, i) in columns\">\n            <div :key=\"i\" class=\"columns is-mobile is-vcentered is-centered\">\n              <div class=\"column has-background-light\">\n                <p class=\"font-medium heading has-text-left has-text-grey\">{{ col.header }}</p>\n                <p class=\"font-bold has-text-left is-size-5\">{{ col.subtitle }}</p>\n              </div>\n              <div class=\"column is-4 font-subtitle\">\n                <span>{{ col.value | fixed }}</span>\n              </div>\n            </div>\n          </template>\n        </div>\n      </section>\n    </div>\n  </BModal>\n</template>\n\n<script>\nexport default {\n  props: {\n    isActive: {\n      required: true,\n      type: Boolean,\n    },\n    item: {\n      required: true,\n      type: Object,\n    },\n    subcategorie: {\n      required: true,\n      type: String,\n    },\n    displayData: {\n      type: Array,\n      required: true,\n    },\n  },\n  data() {\n    return {\n      isComponentModalActive: false,\n      formProps: {\n        email: 'evan@you.com',\n        password: 'testing',\n      },\n      average: 0,\n      max: 0,\n      currentSubcategory: null,\n      subcategories: [],\n      temporary: [],\n    };\n  },\n  computed: {\n    columns() {\n      let rows = [];\n      if (this.currentSubcategory != null) {\n        let currentSubcategory = this.item.items[this.currentSubcategory];\n        this.displayData.map(r => {\n          let title = r.title,\n            header = '',\n            subtitle = '';\n          if (title.startsWith('MIN')) {\n            header = 'Del Minuto';\n            subtitle = title.substring(4);\n          } else {\n            let index = title.indexOf(' ', title.indexOf(' ') + 1);\n            header = title.substr(0, index);\n            subtitle = title.substr(index + 1);\n          }\n          rows.push({ value: currentSubcategory[r.name], header, subtitle });\n        });\n      }\n      return rows;\n    },\n  },\n  watch: {\n    item: {\n      handler: function(newVal) {\n        if (newVal) {\n          this.average = newVal.leagueAvg;\n          this.max = newVal.totalAccumulated;\n          this.subcategories = newVal.items.map((r, i) => {\n            return { value: i, title: r.category };\n          });\n          this.currentSubcategory = this.subcategories.length ? 1 : null;\n        }\n      },\n      inmediate: true,\n    },\n    subcategorie: {\n      handler: function(newVal) {\n        if (this.item && newVal) {\n          let subcategorie = this.subcategories.find(r => r.title == newVal);\n          this.currentSubcategory = subcategorie ? subcategorie.value : null;\n        }\n      },\n      inmediate: true,\n    },\n  },\n  methods: {\n    onChangeSubcategory(value){\n      let subcategory = this.subcategories.find(s => s.value == value);\n      this.$emit(\"changeSubcategory\", subcategory.title);\n    }\n  }\n};\n</script>\n\n<style scoped lang=\"scss\">\n.box-title {\n  border-radius: 10px;\n  padding: 6px 0px;\n  margin: 0px 12px;\n}\n.modal-card-body {\n  padding: 20px 0px;\n}\n.list-columns {\n  margin-top: 30px;\n}\n.list-columns .columns {\n  border: 1px ridge;\n}\n.list-columns .column {\n  padding-left: 40px;\n}\n.list-columns .column.is-4 {\n  width: 45%;\n  padding: 10px;\n  font-size: 1, 3rem;\n}\n.heading {\n  margin-bottom: 0px !important;\n}\n.columns {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.columns.is-gapless {\n  margin-bottom: 15px;\n}\n.close-icon {\n  float: right;\n  color: #000000;\n}\n.font-bold {\n  font-family: Avenir-Demi;\n}\n.font-medium {\n  font-family: Avenir-Demi-Medium;\n}\n.font-subtitle {\n  font-family: Avenir-Demi-Medium;\n  font-size: 24px;\n}\n.modal-card-title {\n  width: 100%;\n}\n.avg-max {\n  &__text {\n    display: grid;\n    grid-template-columns: 1fr 10px 1fr;\n    column-gap: 16px;\n\n    & > div:first-child {\n      justify-self: right;\n    }\n\n    & > div:last-child {\n      justify-self: left;\n    }\n  }\n\n  &__amount {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-column-gap: 0.8rem;\n    margin-bottom: 1rem;\n\n    & > div {\n      min-width: 7rem;\n      padding: 0.4rem 0.4rem 0;\n\n      @media screen and (max-width: 380px) {\n        font-size: 1.5rem;\n      }\n    }\n\n    & > div:first-child {\n      justify-self: right;\n    }\n\n    & > div:last-child {\n      justify-self: left;\n    }\n  }\n}\n</style>\n",".box-title {\n  border-radius: 10px;\n  padding: 6px 0px;\n  margin: 0px 12px;\n}\n\n.modal-card-body {\n  padding: 20px 0px;\n}\n\n.list-columns {\n  margin-top: 30px;\n}\n\n.list-columns .columns {\n  border: 1px ridge;\n}\n\n.list-columns .column {\n  padding-left: 40px;\n}\n\n.list-columns .column.is-4 {\n  width: 45%;\n  padding: 10px;\n  font-size: 1, 3rem;\n}\n\n.heading {\n  margin-bottom: 0px !important;\n}\n\n.columns {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.columns.is-gapless {\n  margin-bottom: 15px;\n}\n\n.close-icon {\n  float: right;\n  color: #000000;\n}\n\n.font-bold {\n  font-family: Avenir-Demi;\n}\n\n.font-medium {\n  font-family: Avenir-Demi-Medium;\n}\n\n.font-subtitle {\n  font-family: Avenir-Demi-Medium;\n  font-size: 24px;\n}\n\n.modal-card-title {\n  width: 100%;\n}\n\n.avg-max__text {\n  display: grid;\n  grid-template-columns: 1fr 10px 1fr;\n  column-gap: 16px;\n}\n.avg-max__text > div:first-child {\n  justify-self: right;\n}\n.avg-max__text > div:last-child {\n  justify-self: left;\n}\n.avg-max__amount {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 0.8rem;\n  margin-bottom: 1rem;\n}\n.avg-max__amount > div {\n  min-width: 7rem;\n  padding: 0.4rem 0.4rem 0;\n}\n@media screen and (max-width: 380px) {\n  .avg-max__amount > div {\n    font-size: 1.5rem;\n  }\n}\n.avg-max__amount > div:first-child {\n  justify-self: right;\n}\n.avg-max__amount > div:last-child {\n  justify-self: left;\n}\n\n/*# sourceMappingURL=DetailsDataMobileTable.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$c = "data-v-7dbeb0d9";
  /* module identifier */
  var __vue_module_identifier__$c = undefined;
  /* functional template */
  var __vue_is_functional_template__$c = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$b = {
  name: 'DataMobileTable',
  components: {
    DetailsDataMobileTable: __vue_component__$c,
    // PieChartsPossessionTeam,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    isSelectorHidden: {
      type: Boolean,
      default: false,
    },
  },
  data: function data() {
    return {
      openDetailModal: false,
      selectedCategorie: {},
      selectedSubcategorie: '',
    };
  },
  computed: Object.assign({}, mapGetters({
      gamesPlayedByPlayer: 'playerProfileFilter/getGamesPlayedByPlayer',
    }),
    {gamesPlayed: function gamesPlayed() {
      return this.gamesPlayedByPlayer || 1
    },
    displayData: function displayData() {
      var columns = [];
      this.columns.map(function (r) {
        if (r.title !== 'CATEGORÍA Y SUBCATEGORÍA' && r.display) {
          columns.push(r);
        }
      });
      return columns;
    }}),
  methods: {
    openModal: function openModal(item, subcategorie) {
      this.selectedCategorie = item;
      this.selectedSubcategorie = subcategorie;
      this.openDetailModal = true;
      this.$emit('openSubcategory', subcategorie);
    },
    onOpenSection: function onOpenSection(sectionName) {
      this.$emit('showDetails', sectionName);
    },
    onCloseSection: function onCloseSection(sectionName) {
      this.$emit('hideDetails', sectionName);
    },
    onChangeSubcategory: function onChangeSubcategory(subcategory) {
      this.$emit('changeSubcategory', subcategory);
    },
  },
};

/* script */
var __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "is-hidden-tablet" },
    [
      _c("table", { staticClass: "table is-fullwidth" }, [
        _c("tbody", [
          _c("tr", [
            _c(
              "section",
              _vm._l(_vm.data, function(categories, index) {
                return _c(
                  "BCollapse",
                  {
                    key: index,
                    staticClass: "card",
                    attrs: {
                      animation: "slide",
                      open: index == 0 ? true : false
                    },
                    on: {
                      open: function($event) {
                        return _vm.onOpenSection(categories.category)
                      },
                      close: function($event) {
                        return _vm.onCloseSection(categories.category)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "trigger",
                          fn: function(props) {
                            return _c(
                              "div",
                              {
                                staticClass:
                                  "columns is-gapless has-background-light\tis-mobile is-vcentered custom-padding-collapse",
                                attrs: { role: "button" }
                              },
                              [
                                _c("div", { staticClass: "column is-1" }, [
                                  categories.items
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "m-0 p-0 card-header-icon has-text-primary"
                                        },
                                        [
                                          _c("BIcon", {
                                            attrs: {
                                              icon: props.open
                                                ? "minus-circle-outline"
                                                : "plus-circle-outline"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "column is-9" }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        " has-text-left has-text-grey title-font is-size-5 is-capitalized"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(categories.category) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "column is-2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "has-background-primary has-text-light title box-title"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            +(
                                              categories.totalAccumulated /
                                              _vm.gamesPlayed
                                            ).toFixed(2)
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _vm._l(categories.items, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "card-content padding-card"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "columns is-mobile is-vcentered is-gapless"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "column is-8 is-offset-1" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        " has-text-left has-text-grey is-4 subtitle-font is-capitalized"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.category) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "column is-3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "columns is-mobile  is-vcentered"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "column is-7 is-offset-2 subtitle has-background-light box-child"
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              +(
                                                item.totalAccumulated /
                                                _vm.gamesPlayed
                                              ).toFixed(2)
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "column is-3 has-text-primary chevron-child",
                                        on: {
                                          click: function($event) {
                                            return _vm.openModal(
                                              categories,
                                              item.category
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("BIcon", {
                                          staticClass: "custom-margin-right",
                                          attrs: {
                                            icon: "chevron-right",
                                            size: "is-medium"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              }),
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("DetailsDataMobileTable", {
        attrs: {
          item: _vm.selectedCategorie,
          isActive: _vm.openDetailModal,
          subcategorie: _vm.selectedSubcategorie,
          displayData: _vm.displayData
        },
        on: {
          close: function($event) {
            _vm.openDetailModal = false;
          },
          changeSubcategory: _vm.onChangeSubcategory
        }
      })
    ],
    1
  )
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  var __vue_inject_styles__$b = function (inject) {
    if (!inject) { return }
    inject("data-v-9e11f9d8_0", { source: "\n.custom-gap[data-v-9e11f9d8] {\n  margin: 3px 10px;\n  padding: 3px 20px;\n  border-radius: 8px;\n}\n.custom-padding-collapse[data-v-9e11f9d8] {\n  padding: 0px 10px;\n}\n.custom-margin-right[data-v-9e11f9d8] {\n  margin-right: 10px;\n}\n.card-content.padding-card[data-v-9e11f9d8] {\n  padding: 12px 20px;\n  border-bottom: 1px ridge;\n}\n.box-child[data-v-9e11f9d8] {\n  border-radius: 10px;\n  padding: 6px 8px;\n  margin: 12px 0px;\n  font-size: 3.71vw;\n}\n.box-title[data-v-9e11f9d8] {\n  border-radius: 10px;\n  padding: 5px 0px;\n  margin: 12px 5px;\n  font-size: 4vw;\n}\n.chevron-child[data-v-9e11f9d8] {\n  margin: 0px;\n  padding: 0px;\n}\n.columns[data-v-9e11f9d8] {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.title-font[data-v-9e11f9d8] {\n  font-family: Avenir-Demi;\n}\n.subtitle-font[data-v-9e11f9d8] {\n  font-family: Avenir-Demi-Medium;\n}\n@media screen and (max-width: 425px) {\n.box-title[data-v-9e11f9d8] {\n    padding: 4px 0px;\n    margin: 0px;\n    font-size: 4.7vw;\n}\n.box-child[data-v-9e11f9d8] {\n    padding: 4px 0px;\n    margin: 0px;\n    font-size: 3.5vw !important;\n}\n.is-size-5[data-v-9e11f9d8] {\n    font-size: 1rem !important;\n}\n}\n", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/DataMobileTable.vue"],"names":[],"mappings":";AAiJA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACA;AAEA;EACA,iBAAA;AACA;AAEA;EACA,kBAAA;AACA;AAEA;EACA,kBAAA;EACA,wBAAA;AACA;AAEA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AACA;AAEA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;AACA;AAEA;EACA,gBAAA;EACA,iBAAA;AACA;AAEA;EACA,wBAAA;AACA;AAEA;EACA,+BAAA;AACA;AAEA;AACA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;AACA;AAEA;IACA,gBAAA;IACA,WAAA;IACA,2BAAA;AACA;AAEA;IACA,0BAAA;AACA;AACA","file":"DataMobileTable.vue","sourcesContent":["<template>\n  <div class=\"is-hidden-tablet\">\n    <table class=\"table is-fullwidth\">\n      <tbody>\n        <tr>\n          <section>\n            <BCollapse\n              class=\"card\"\n              animation=\"slide\"\n              v-for=\"(categories, index) in data\"\n              :key=\"index\"\n              :open=\"index == 0 ? true : false\"\n              @open=\"onOpenSection(categories.category)\"\n              @close=\"onCloseSection(categories.category)\"\n            >\n              <div\n                slot=\"trigger\"\n                slot-scope=\"props\"\n                class=\"columns is-gapless has-background-light\tis-mobile is-vcentered custom-padding-collapse\"\n                role=\"button\"\n              >\n                <div class=\"column is-1\">\n                  <a class=\"m-0 p-0 card-header-icon has-text-primary\" v-if=\"categories.items\">\n                    <BIcon :icon=\"props.open ? 'minus-circle-outline' : 'plus-circle-outline'\"> </BIcon>\n                  </a>\n                </div>\n                <div class=\"column is-9\">\n                  <p class=\" has-text-left has-text-grey title-font is-size-5 is-capitalized\">\n                    {{ categories.category }}\n                  </p>\n                </div>\n\n                <div class=\"column is-2\">\n                  <div class=\"has-background-primary has-text-light title box-title\">\n                    {{ +(categories.totalAccumulated / gamesPlayed).toFixed(2) }}\n                  </div>\n                </div>\n              </div>\n              <div v-for=\"(item, index) in categories.items\" :key=\"index\" class=\"card-content padding-card\">\n                <div class=\"columns is-mobile is-vcentered is-gapless\">\n                  <div class=\"column is-8 is-offset-1\">\n                    <p class=\" has-text-left has-text-grey is-4 subtitle-font is-capitalized\">\n                      {{ item.category }}\n                    </p>\n                  </div>\n                  <div class=\"column is-3\">\n                    <div class=\"columns is-mobile  is-vcentered\">\n                      <div class=\"column is-7 is-offset-2 subtitle has-background-light box-child\">\n                        {{ +(item.totalAccumulated / gamesPlayed).toFixed(2) }}\n                      </div>\n                      <a\n                        class=\"column is-3 has-text-primary chevron-child\"\n                        @click=\"openModal(categories, item.category)\"\n                      >\n                        <BIcon icon=\"chevron-right\" class=\"custom-margin-right\" size=\"is-medium\"> </BIcon>\n                      </a>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </BCollapse>\n          </section>\n        </tr>\n      </tbody>\n    </table>\n    <DetailsDataMobileTable\n      :item=\"selectedCategorie\"\n      :isActive=\"openDetailModal\"\n      :subcategorie=\"selectedSubcategorie\"\n      :displayData=\"displayData\"\n      @close=\"openDetailModal = false\"\n      @changeSubcategory=\"onChangeSubcategory\"\n    />\n  </div>\n</template>\n\n<script>\nimport { mapGetters } from 'vuex';\nimport DetailsDataMobileTable from './DetailsDataMobileTable.vue';\n\nexport default {\n  name: 'DataMobileTable',\n  components: {\n    DetailsDataMobileTable,\n    // PieChartsPossessionTeam,\n  },\n  props: {\n    data: {\n      type: Array,\n      required: true,\n    },\n    columns: {\n      type: Array,\n      required: true,\n    },\n    isSelectorHidden: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  data() {\n    return {\n      openDetailModal: false,\n      selectedCategorie: {},\n      selectedSubcategorie: '',\n    };\n  },\n  computed: {\n    ...mapGetters({\n      gamesPlayedByPlayer: 'playerProfileFilter/getGamesPlayedByPlayer',\n    }),\n    gamesPlayed() {\n      return this.gamesPlayedByPlayer || 1\n    },\n    displayData() {\n      const columns = [];\n      this.columns.map((r) => {\n        if (r.title !== 'CATEGORÍA Y SUBCATEGORÍA' && r.display) {\n          columns.push(r);\n        }\n      });\n      return columns;\n    },\n  },\n  methods: {\n    openModal(item, subcategorie) {\n      this.selectedCategorie = item;\n      this.selectedSubcategorie = subcategorie;\n      this.openDetailModal = true;\n      this.$emit('openSubcategory', subcategorie);\n    },\n    onOpenSection(sectionName) {\n      this.$emit('showDetails', sectionName);\n    },\n    onCloseSection(sectionName) {\n      this.$emit('hideDetails', sectionName);\n    },\n    onChangeSubcategory(subcategory) {\n      this.$emit('changeSubcategory', subcategory);\n    },\n  },\n};\n</script>\n\n<style scoped>\n.custom-gap {\n  margin: 3px 10px;\n  padding: 3px 20px;\n  border-radius: 8px;\n}\n\n.custom-padding-collapse {\n  padding: 0px 10px;\n}\n\n.custom-margin-right {\n  margin-right: 10px;\n}\n\n.card-content.padding-card {\n  padding: 12px 20px;\n  border-bottom: 1px ridge;\n}\n\n.box-child {\n  border-radius: 10px;\n  padding: 6px 8px;\n  margin: 12px 0px;\n  font-size: 3.71vw;\n}\n\n.box-title {\n  border-radius: 10px;\n  padding: 5px 0px;\n  margin: 12px 5px;\n  font-size: 4vw;\n}\n\n.chevron-child {\n  margin: 0px;\n  padding: 0px;\n}\n\n.columns {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.title-font {\n  font-family: Avenir-Demi;\n}\n\n.subtitle-font {\n  font-family: Avenir-Demi-Medium;\n}\n\n@media screen and (max-width: 425px) {\n  .box-title {\n    padding: 4px 0px;\n    margin: 0px;\n    font-size: 4.7vw;\n  }\n\n  .box-child {\n    padding: 4px 0px;\n    margin: 0px;\n    font-size: 3.5vw !important;\n  }\n\n  .is-size-5 {\n    font-size: 1rem !important;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$b = "data-v-9e11f9d8";
  /* module identifier */
  var __vue_module_identifier__$b = undefined;
  /* functional template */
  var __vue_is_functional_template__$b = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$a = {
  name: 'PieCharsTeam',
  components: {
    VueApexCharts: VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    /**
     * player's position id
     */
    type: {
      type: Number,
      default: 0,
    },
  },
  data: function data() {
    return {};
  },
  computed: Object.assign({}, mapGetters({
      getGamesPlayedByTeam: 'playerProfileFilter/getGamesPlayedByTeam',
    }),
    {gamesPlayed: function gamesPlayed() {
      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;
    },
    charts: function charts() {
      if (this.type != 1) {
        return [
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: 'PASES ACERTADOS',
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['1/4', '2/4', '3/4', '4/4'],
              colors: ['#4b47ae', '#0060ff', '#00cae7', '#9aeee1'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function(ref) {
                  var series = ref.series;
                  var seriesIndex = ref.seriesIndex;
                  ref.dataPointIndex;
                  var w = ref.w;

                  var total = 0;
                  for (var x of series) {
                    total += x;
                  }
                  var selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.successfulPasses,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: 'PASES NO ACERTADOS',
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['1/4', '2/4', '3/4', '4/4'],
              colors: ['#b91930', '#ef4a62', '#ffc81d', '#f3f464'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function(ref) {
                  var series = ref.series;
                  var seriesIndex = ref.seriesIndex;
                  ref.dataPointIndex;
                  var w = ref.w;

                  var total = 0;
                  for (var x of series) {
                    total += x;
                  }
                  var selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.unsuccessfulPasses,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: 'BALONES RECUPERADOS',
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['C. PROPIA', 'C. RIVAL'],
              colors: ['#0060ff', '#00cae7'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function(ref) {
                  var series = ref.series;
                  var seriesIndex = ref.seriesIndex;
                  ref.dataPointIndex;
                  var w = ref.w;

                  var total = 0;
                  for (var x of series) {
                    total += x;
                  }
                  var selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.ballsRecovered,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: 'BALONES PERDIDOS',
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['C. PROPIA', 'C. RIVAL'],
              colors: ['#ef4a62', '#ffca4c'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function(ref) {
                  var series = ref.series;
                  var seriesIndex = ref.seriesIndex;
                  ref.dataPointIndex;
                  var w = ref.w;

                  var total = 0;
                  for (var x of series) {
                    total += x;
                  }
                  var selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.lostBalls,
          } ];
      } else {
        return [
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: 'PASES LARGOS',
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['ACERTADOS', 'NO ACERTADOS'],
              colors: ['#4b47ae', '#0060ff', '#00cae7', '#9aeee1'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function(ref) {
                  var series = ref.series;
                  var seriesIndex = ref.seriesIndex;
                  ref.dataPointIndex;
                  var w = ref.w;

                  var total = 0;
                  for (var x of series) {
                    total += x;
                  }
                  var selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.longpasses,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: 'PASES CORTOS',
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['ACERTADOS', 'NO ACERTADOS'],
              colors: ['#b91930', '#ef4a62', '#ffc81d', '#f3f464'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function(ref) {
                  var series = ref.series;
                  var seriesIndex = ref.seriesIndex;
                  ref.dataPointIndex;
                  var w = ref.w;

                  var total = 0;
                  for (var x of series) {
                    total += x;
                  }
                  var selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.shortpasses,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: 'DESPEJES DE MANO',
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['ACERTADOS', 'NO ACERTADOS'],
              colors: ['#0060ff', '#00cae7'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function(ref) {
                  var series = ref.series;
                  var seriesIndex = ref.seriesIndex;
                  ref.dataPointIndex;
                  var w = ref.w;

                  var total = 0;
                  for (var x of series) {
                    total += x;
                  }
                  var selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.handclearance,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: 'DESPEJES DE PIE',
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['ACERTADOS', 'NO ACERTADOS'],
              colors: ['#ef4a62', '#ffca4c'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function(ref) {
                  var series = ref.series;
                  var seriesIndex = ref.seriesIndex;
                  ref.dataPointIndex;
                  var w = ref.w;

                  var total = 0;
                  for (var x of series) {
                    total += x;
                  }
                  var selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.footclearance,
          } ];
      }
    },
    successfulPasses: function successfulPasses() {
      return [
        this.proccesedAverage(this.data[0].items[0].totalAccumulated),
        this.proccesedAverage(this.data[0].items[1].totalAccumulated),
        this.proccesedAverage(this.data[0].items[2].totalAccumulated),
        this.proccesedAverage(this.data[0].items[3].totalAccumulated) ];
    },
    unsuccessfulPasses: function unsuccessfulPasses() {
      return [
        this.proccesedAverage(this.data[2].items[0].totalAccumulated),
        this.proccesedAverage(this.data[2].items[1].totalAccumulated),
        this.proccesedAverage(this.data[2].items[2].totalAccumulated),
        this.proccesedAverage(this.data[2].items[3].totalAccumulated) ];
    },
    ballsRecovered: function ballsRecovered() {
      return [
        this.proccesedAverage(this.data[3].items[0].totalAccumulated + this.data[4].items[0].totalAccumulated),
        this.proccesedAverage(this.data[3].items[1].totalAccumulated + this.data[4].items[1].totalAccumulated) ];
    },
    lostBalls: function lostBalls() {
      return [
        this.proccesedAverage(this.data[5].items[0].totalAccumulated + this.data[6].items[0].totalAccumulated),
        this.proccesedAverage(this.data[5].items[1].totalAccumulated + this.data[6].items[1].totalAccumulated) ];
    },
    longpasses: function longpasses() {
      return [
        this.proccesedAverage(this.data[0].items[0].totalAccumulated),
        this.proccesedAverage(this.data[0].items[1].totalAccumulated) ];
    },
    shortpasses: function shortpasses() {
      return [
        this.proccesedAverage(this.data[0].items[2].totalAccumulated),
        this.proccesedAverage(this.data[0].items[3].totalAccumulated) ];
    },
    handclearance: function handclearance() {
      return [
        this.proccesedAverage(this.data[1].items[0].totalAccumulated),
        this.proccesedAverage(this.data[1].items[1].totalAccumulated) ];
    },
    footclearance: function footclearance() {
      return [
        this.proccesedAverage(this.data[2].items[0].totalAccumulated),
        this.proccesedAverage(this.data[2].items[1].totalAccumulated) ];
    }}),
  methods: {
    proccesedAverage: function proccesedAverage(value) {
      return +(value / this.gamesPlayed).toFixed(2);
    },
    isChartEmpty: function isChartEmpty(chartInfo) {
      var totalAccumulated = chartInfo.series.reduce(function (total, partial) {
        return total + partial;
      }, 0);
      return totalAccumulated === 0;
    },
  },
};

/* script */
var __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c(
      "div",
      { staticClass: "columns is-multiple is-centered" },
      _vm._l(_vm.charts, function(chart, index) {
        return _c(
          "div",
          { key: index, staticClass: "column" },
          [
            _vm.isChartEmpty(chart)
              ? _c("div", { staticClass: "empty-pie" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(chart.options.title.text))
                  ]),
                  _vm._v(" "),
                  _vm._m(0, true)
                ])
              : _c("VueApexCharts", {
                  attrs: {
                    type: "pie",
                    height: "300",
                    options: chart.options,
                    series: chart.series
                  }
                })
          ],
          1
        )
      }),
      0
    )
  ])
};
var __vue_staticRenderFns__$a = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "pie" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Sin información")])
    ])
  }
];
__vue_render__$a._withStripped = true;

  /* style */
  var __vue_inject_styles__$a = function (inject) {
    if (!inject) { return }
    inject("data-v-7685bfb2_0", { source: ".empty-pie[data-v-7685bfb2] {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n}\n.empty-pie .title[data-v-7685bfb2] {\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 900;\n  padding-top: 0.3rem;\n  margin-bottom: 0.7rem;\n}\n.empty-pie .pie[data-v-7685bfb2] {\n  width: 12em;\n  height: 12em;\n  border-radius: 50%;\n  background-color: rgba(224, 231, 241, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.empty-pie .pie > .text[data-v-7685bfb2] {\n  font-family: Avenir-Medium;\n  font-weight: 500;\n  color: white;\n  border-radius: 1.25em;\n  padding: 0.5em 1em;\n  background-color: #cad2de;\n}\n@media screen and (max-width: 926px) {\n.empty-pie[data-v-7685bfb2] {\n    font-size: 0.8rem;\n}\n}\n@media screen and (max-width: 768px) {\n.empty-pie[data-v-7685bfb2] {\n    font-size: 1rem;\n}\n}\n\n/*# sourceMappingURL=PieChartsPossessionTeam.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/PieChartsPossessionTeam.vue","PieChartsPossessionTeam.vue"],"names":[],"mappings":"AA6jBA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;AC5jBA;AD8jBA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AC5jBA;AD+jBA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AC7jBA;AD+jBA;EACA,0BAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;AC7jBA;ADikBA;AAjCA;IAkCA,iBAAA;AC9jBE;AACF;ADgkBA;AArCA;IAsCA,eAAA;AC7jBE;AACF;;AAEA,sDAAsD","file":"PieChartsPossessionTeam.vue","sourcesContent":["<template>\n  <div>\n    <div class=\"columns is-multiple is-centered\">\n      <div class=\"column\" v-for=\"(chart, index) in charts\" :key=\"index\">\n        <div v-if=\"isChartEmpty(chart)\" class=\"empty-pie\">\n          <div class=\"title\">{{ chart.options.title.text }}</div>\n          <div class=\"pie\">\n            <div class=\"text\">Sin información</div>\n          </div>\n        </div>\n        <VueApexCharts v-else type=\"pie\" height=\"300\" :options=\"chart.options\" :series=\"chart.series\" />\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport VueApexCharts from 'vue-apexcharts';\nimport { mapGetters } from 'vuex';\n\nexport default {\n  name: 'PieCharsTeam',\n  components: {\n    VueApexCharts,\n  },\n  props: {\n    data: {\n      type: Array,\n      required: true,\n    },\n    /**\n     * player's position id\n     */\n    type: {\n      type: Number,\n      default: 0,\n    },\n  },\n  data() {\n    return {};\n  },\n  computed: {\n    ...mapGetters({\n      getGamesPlayedByTeam: 'playerProfileFilter/getGamesPlayedByTeam',\n    }),\n    gamesPlayed() {\n      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;\n    },\n    charts() {\n      if (this.type != 1) {\n        return [\n          {\n            options: {\n              dataLabels: {\n                enabled: false,\n              },\n              chart: {\n                height: 300,\n                type: 'pie',\n              },\n              title: {\n                text: 'PASES ACERTADOS',\n                align: 'center',\n                style: {\n                  fontSize: '12px',\n                },\n              },\n              labels: ['1/4', '2/4', '3/4', '4/4'],\n              colors: ['#4b47ae', '#0060ff', '#00cae7', '#9aeee1'],\n              tooltip: {\n                enabled: true,\n                //eslint-disable-next-line no-unused-vars\n                custom: function({ series, seriesIndex, dataPointIndex, w }) {\n                  let total = 0;\n                  for (let x of series) {\n                    total += x;\n                  }\n                  let selected = series[seriesIndex];\n                  return (\n                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'\n                  );\n                },\n              },\n              legend: {\n                position: 'bottom',\n                fontSize: '11px',\n                fontFamily: 'Avenir-Demi',\n                itemMargin: {\n                  horizontal: 7,\n                  vertical: 5,\n                },\n                markers: {\n                  width: 12,\n                  height: 12,\n                  strokeWidth: 0,\n                  strokeColor: '#fff',\n                  fillColors: undefined,\n                  radius: 4,\n                  customHTML: undefined,\n                  onClick: undefined,\n                  offsetX: 0,\n                  offsetY: 0,\n                },\n              },\n            },\n            series: this.successfulPasses,\n          },\n          {\n            options: {\n              dataLabels: {\n                enabled: false,\n              },\n              chart: {\n                height: 300,\n                type: 'pie',\n              },\n              title: {\n                text: 'PASES NO ACERTADOS',\n                align: 'center',\n                style: {\n                  fontSize: '12px',\n                },\n              },\n              labels: ['1/4', '2/4', '3/4', '4/4'],\n              colors: ['#b91930', '#ef4a62', '#ffc81d', '#f3f464'],\n              tooltip: {\n                enabled: true,\n                //eslint-disable-next-line no-unused-vars\n                custom: function({ series, seriesIndex, dataPointIndex, w }) {\n                  let total = 0;\n                  for (let x of series) {\n                    total += x;\n                  }\n                  let selected = series[seriesIndex];\n                  return (\n                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'\n                  );\n                },\n              },\n              legend: {\n                position: 'bottom',\n                fontSize: '11px',\n                fontFamily: 'Avenir-Demi',\n                itemMargin: {\n                  horizontal: 7,\n                  vertical: 5,\n                },\n                markers: {\n                  width: 12,\n                  height: 12,\n                  strokeWidth: 0,\n                  strokeColor: '#fff',\n                  fillColors: undefined,\n                  radius: 4,\n                  customHTML: undefined,\n                  onClick: undefined,\n                  offsetX: 0,\n                  offsetY: 0,\n                },\n              },\n            },\n            series: this.unsuccessfulPasses,\n          },\n          {\n            options: {\n              dataLabels: {\n                enabled: false,\n              },\n              chart: {\n                height: 300,\n                type: 'pie',\n              },\n              title: {\n                text: 'BALONES RECUPERADOS',\n                align: 'center',\n                style: {\n                  fontSize: '12px',\n                },\n              },\n              labels: ['C. PROPIA', 'C. RIVAL'],\n              colors: ['#0060ff', '#00cae7'],\n              tooltip: {\n                enabled: true,\n                //eslint-disable-next-line no-unused-vars\n                custom: function({ series, seriesIndex, dataPointIndex, w }) {\n                  let total = 0;\n                  for (let x of series) {\n                    total += x;\n                  }\n                  let selected = series[seriesIndex];\n                  return (\n                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'\n                  );\n                },\n              },\n              legend: {\n                position: 'bottom',\n                fontSize: '11px',\n                fontFamily: 'Avenir-Demi',\n                itemMargin: {\n                  horizontal: 7,\n                  vertical: 5,\n                },\n                markers: {\n                  width: 12,\n                  height: 12,\n                  strokeWidth: 0,\n                  strokeColor: '#fff',\n                  fillColors: undefined,\n                  radius: 4,\n                  customHTML: undefined,\n                  onClick: undefined,\n                  offsetX: 0,\n                  offsetY: 0,\n                },\n              },\n            },\n            series: this.ballsRecovered,\n          },\n          {\n            options: {\n              dataLabels: {\n                enabled: false,\n              },\n              chart: {\n                height: 300,\n                type: 'pie',\n              },\n              title: {\n                text: 'BALONES PERDIDOS',\n                align: 'center',\n                style: {\n                  fontSize: '12px',\n                },\n              },\n              labels: ['C. PROPIA', 'C. RIVAL'],\n              colors: ['#ef4a62', '#ffca4c'],\n              tooltip: {\n                enabled: true,\n                //eslint-disable-next-line no-unused-vars\n                custom: function({ series, seriesIndex, dataPointIndex, w }) {\n                  let total = 0;\n                  for (let x of series) {\n                    total += x;\n                  }\n                  let selected = series[seriesIndex];\n                  return (\n                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'\n                  );\n                },\n              },\n              legend: {\n                position: 'bottom',\n                fontSize: '11px',\n                fontFamily: 'Avenir-Demi',\n                itemMargin: {\n                  horizontal: 7,\n                  vertical: 5,\n                },\n                markers: {\n                  width: 12,\n                  height: 12,\n                  strokeWidth: 0,\n                  strokeColor: '#fff',\n                  fillColors: undefined,\n                  radius: 4,\n                  customHTML: undefined,\n                  onClick: undefined,\n                  offsetX: 0,\n                  offsetY: 0,\n                },\n              },\n            },\n            series: this.lostBalls,\n          },\n        ];\n      } else {\n        return [\n          {\n            options: {\n              dataLabels: {\n                enabled: false,\n              },\n              chart: {\n                height: 300,\n                type: 'pie',\n              },\n              title: {\n                text: 'PASES LARGOS',\n                align: 'center',\n                style: {\n                  fontSize: '12px',\n                },\n              },\n              labels: ['ACERTADOS', 'NO ACERTADOS'],\n              colors: ['#4b47ae', '#0060ff', '#00cae7', '#9aeee1'],\n              tooltip: {\n                enabled: true,\n                //eslint-disable-next-line no-unused-vars\n                custom: function({ series, seriesIndex, dataPointIndex, w }) {\n                  let total = 0;\n                  for (let x of series) {\n                    total += x;\n                  }\n                  let selected = series[seriesIndex];\n                  return (\n                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'\n                  );\n                },\n              },\n              legend: {\n                position: 'bottom',\n                fontSize: '11px',\n                fontFamily: 'Avenir-Demi',\n                itemMargin: {\n                  horizontal: 7,\n                  vertical: 5,\n                },\n                markers: {\n                  width: 12,\n                  height: 12,\n                  strokeWidth: 0,\n                  strokeColor: '#fff',\n                  fillColors: undefined,\n                  radius: 4,\n                  customHTML: undefined,\n                  onClick: undefined,\n                  offsetX: 0,\n                  offsetY: 0,\n                },\n              },\n            },\n            series: this.longpasses,\n          },\n          {\n            options: {\n              dataLabels: {\n                enabled: false,\n              },\n              chart: {\n                height: 300,\n                type: 'pie',\n              },\n              title: {\n                text: 'PASES CORTOS',\n                align: 'center',\n                style: {\n                  fontSize: '12px',\n                },\n              },\n              labels: ['ACERTADOS', 'NO ACERTADOS'],\n              colors: ['#b91930', '#ef4a62', '#ffc81d', '#f3f464'],\n              tooltip: {\n                enabled: true,\n                //eslint-disable-next-line no-unused-vars\n                custom: function({ series, seriesIndex, dataPointIndex, w }) {\n                  let total = 0;\n                  for (let x of series) {\n                    total += x;\n                  }\n                  let selected = series[seriesIndex];\n                  return (\n                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'\n                  );\n                },\n              },\n              legend: {\n                position: 'bottom',\n                fontSize: '11px',\n                fontFamily: 'Avenir-Demi',\n                itemMargin: {\n                  horizontal: 7,\n                  vertical: 5,\n                },\n                markers: {\n                  width: 12,\n                  height: 12,\n                  strokeWidth: 0,\n                  strokeColor: '#fff',\n                  fillColors: undefined,\n                  radius: 4,\n                  customHTML: undefined,\n                  onClick: undefined,\n                  offsetX: 0,\n                  offsetY: 0,\n                },\n              },\n            },\n            series: this.shortpasses,\n          },\n          {\n            options: {\n              dataLabels: {\n                enabled: false,\n              },\n              chart: {\n                height: 300,\n                type: 'pie',\n              },\n              title: {\n                text: 'DESPEJES DE MANO',\n                align: 'center',\n                style: {\n                  fontSize: '12px',\n                },\n              },\n              labels: ['ACERTADOS', 'NO ACERTADOS'],\n              colors: ['#0060ff', '#00cae7'],\n              tooltip: {\n                enabled: true,\n                //eslint-disable-next-line no-unused-vars\n                custom: function({ series, seriesIndex, dataPointIndex, w }) {\n                  let total = 0;\n                  for (let x of series) {\n                    total += x;\n                  }\n                  let selected = series[seriesIndex];\n                  return (\n                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'\n                  );\n                },\n              },\n              legend: {\n                position: 'bottom',\n                fontSize: '11px',\n                fontFamily: 'Avenir-Demi',\n                itemMargin: {\n                  horizontal: 7,\n                  vertical: 5,\n                },\n                markers: {\n                  width: 12,\n                  height: 12,\n                  strokeWidth: 0,\n                  strokeColor: '#fff',\n                  fillColors: undefined,\n                  radius: 4,\n                  customHTML: undefined,\n                  onClick: undefined,\n                  offsetX: 0,\n                  offsetY: 0,\n                },\n              },\n            },\n            series: this.handclearance,\n          },\n          {\n            options: {\n              dataLabels: {\n                enabled: false,\n              },\n              chart: {\n                height: 300,\n                type: 'pie',\n              },\n              title: {\n                text: 'DESPEJES DE PIE',\n                align: 'center',\n                style: {\n                  fontSize: '12px',\n                },\n              },\n              labels: ['ACERTADOS', 'NO ACERTADOS'],\n              colors: ['#ef4a62', '#ffca4c'],\n              tooltip: {\n                enabled: true,\n                //eslint-disable-next-line no-unused-vars\n                custom: function({ series, seriesIndex, dataPointIndex, w }) {\n                  let total = 0;\n                  for (let x of series) {\n                    total += x;\n                  }\n                  let selected = series[seriesIndex];\n                  return (\n                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'\n                  );\n                },\n              },\n              legend: {\n                position: 'bottom',\n                fontSize: '11px',\n                fontFamily: 'Avenir-Demi',\n                itemMargin: {\n                  horizontal: 7,\n                  vertical: 5,\n                },\n                markers: {\n                  width: 12,\n                  height: 12,\n                  strokeWidth: 0,\n                  strokeColor: '#fff',\n                  fillColors: undefined,\n                  radius: 4,\n                  customHTML: undefined,\n                  onClick: undefined,\n                  offsetX: 0,\n                  offsetY: 0,\n                },\n              },\n            },\n            series: this.footclearance,\n          },\n        ];\n      }\n    },\n    successfulPasses() {\n      return [\n        this.proccesedAverage(this.data[0].items[0].totalAccumulated),\n        this.proccesedAverage(this.data[0].items[1].totalAccumulated),\n        this.proccesedAverage(this.data[0].items[2].totalAccumulated),\n        this.proccesedAverage(this.data[0].items[3].totalAccumulated),\n      ];\n    },\n    unsuccessfulPasses() {\n      return [\n        this.proccesedAverage(this.data[2].items[0].totalAccumulated),\n        this.proccesedAverage(this.data[2].items[1].totalAccumulated),\n        this.proccesedAverage(this.data[2].items[2].totalAccumulated),\n        this.proccesedAverage(this.data[2].items[3].totalAccumulated),\n      ];\n    },\n    ballsRecovered() {\n      return [\n        this.proccesedAverage(this.data[3].items[0].totalAccumulated + this.data[4].items[0].totalAccumulated),\n        this.proccesedAverage(this.data[3].items[1].totalAccumulated + this.data[4].items[1].totalAccumulated),\n      ];\n    },\n    lostBalls() {\n      return [\n        this.proccesedAverage(this.data[5].items[0].totalAccumulated + this.data[6].items[0].totalAccumulated),\n        this.proccesedAverage(this.data[5].items[1].totalAccumulated + this.data[6].items[1].totalAccumulated),\n      ];\n    },\n    longpasses() {\n      return [\n        this.proccesedAverage(this.data[0].items[0].totalAccumulated),\n        this.proccesedAverage(this.data[0].items[1].totalAccumulated),\n      ];\n    },\n    shortpasses() {\n      return [\n        this.proccesedAverage(this.data[0].items[2].totalAccumulated),\n        this.proccesedAverage(this.data[0].items[3].totalAccumulated),\n      ];\n    },\n    handclearance() {\n      return [\n        this.proccesedAverage(this.data[1].items[0].totalAccumulated),\n        this.proccesedAverage(this.data[1].items[1].totalAccumulated),\n      ];\n    },\n    footclearance() {\n      return [\n        this.proccesedAverage(this.data[2].items[0].totalAccumulated),\n        this.proccesedAverage(this.data[2].items[1].totalAccumulated),\n      ];\n    },\n  },\n  methods: {\n    proccesedAverage(value) {\n      return +(value / this.gamesPlayed).toFixed(2);\n    },\n    isChartEmpty(chartInfo) {\n      const totalAccumulated = chartInfo.series.reduce((total, partial) => {\n        return total + partial;\n      }, 0);\n      return totalAccumulated === 0;\n    },\n  },\n};\n</script>\n\n<style lang=\"scss\" scoped>\n.empty-pie {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n\n  & .title {\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 12px;\n    font-weight: 900;\n    padding-top: 0.3rem;\n    margin-bottom: 0.7rem;\n  }\n\n  & .pie {\n    width: 12em;\n    height: 12em;\n    border-radius: 50%;\n    background-color: rgba(224, 231, 241, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    & > .text {\n      font-family: Avenir-Medium;\n      font-weight: 500;\n      color: white;\n      border-radius: 1.25em;\n      padding: 0.5em 1em;\n      background-color: #cad2de;\n    }\n  }\n\n  @media screen and (max-width: 926px) {\n    font-size: 0.8rem;\n  }\n\n  @media screen and (max-width: 768px) {\n    font-size: 1rem;\n  }\n}\n</style>\n\n",".empty-pie {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n}\n.empty-pie .title {\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 900;\n  padding-top: 0.3rem;\n  margin-bottom: 0.7rem;\n}\n.empty-pie .pie {\n  width: 12em;\n  height: 12em;\n  border-radius: 50%;\n  background-color: rgba(224, 231, 241, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.empty-pie .pie > .text {\n  font-family: Avenir-Medium;\n  font-weight: 500;\n  color: white;\n  border-radius: 1.25em;\n  padding: 0.5em 1em;\n  background-color: #cad2de;\n}\n@media screen and (max-width: 926px) {\n  .empty-pie {\n    font-size: 0.8rem;\n  }\n}\n@media screen and (max-width: 768px) {\n  .empty-pie {\n    font-size: 1rem;\n  }\n}\n\n/*# sourceMappingURL=PieChartsPossessionTeam.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$a = "data-v-7685bfb2";
  /* module identifier */
  var __vue_module_identifier__$a = undefined;
  /* functional template */
  var __vue_is_functional_template__$a = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    createInjector,
    undefined,
    undefined
  );

var categoriesDisplayOptions = {
  data: function data() {
    return {
      viewData: 'table',
      displayOptions: [
        {
          value: 'table',
          icon: 'table-large',
        },
        {
          value: 'pie',
          icon: 'chart-pie',
        } ],
    };
  },
};

/************************
 * EVENTOS PARA PLAYERS *
 ************************/

function analisisDeJugadorPosesion(season_id, team_id, player_id, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_posesion',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorOfensivo(season_id, team_id, player_id, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_ofensivo',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorDefensivo(season_id, team_id, player_id, is_premium) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_defensivo',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    is_premium: is_premium
  });
}

function analisisDeJugadorFiltros(season_id, team_id, player_id, view, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_filtros',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorFiltroTemporada(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_filtro_temporada',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorFiltroEstadistica(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_filtro_estadistica',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorFiltroJugadoComo(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_filtro_jugado_como',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorFiltroPorResultado(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_filtro_por_resultado',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorFiltroPorTiempo(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_filtro_por_tiempo',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorSeccionVista(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_seccion_vista',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorCategoriasDeTabla(season_id, team_id, player_id, category, view, value, is_premium,
  golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_categorias_de_tabla',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    category: category,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorTablaGrafica(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_tabla_o_grafica',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorCategoriaDePizarrra(season_id, team_id, player_id, view, category, value, is_premium,
  golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_categoria_de_pizarra',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    category: category,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorSeleccionTodoPizarra(season_id, team_id, player_id, view, value, is_premium,
  golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_selecciontodopizarra',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorVistaPizarra2D3D(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_vista_pizarra_2d_3d',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorCategoriaDePorteria(season_id, team_id, player_id, view, category, value, is_premium,
  golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_categorias_porteria',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    category: category,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorDetallesCategoria(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_detalles_categoria',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

function analisisDeJugadorDetalleSubcategoria(season_id, team_id, player_id, view, value, is_premium, golstats) {
  window.dataLayer.push({
    event: 'analisis_de_jugador_detalle_subcategoria',
    season_id: season_id,
    team_id: team_id,
    player_id: player_id,
    view: view,
    value: value,
    is_premium: is_premium,
    golstats: golstats
  });
}

//
var columns$2 = possessionDataTable.columns;
var expandedRows$2 = possessionDataTable.expandedRows;
var goalkeeperExpandedRows$2 = possessionDataTable.goalkeeperExpandedRows;

var script$9 = {
  name: 'PlayerPossession',
  components: {
    // TopFiveHorizontalScroll,
    StatisticField: __vue_component__$e,
    DataMobileTable: __vue_component__$b,
    DataTable: __vue_component__$d,
    PieChartsPossessionTeam: __vue_component__$a,
  },
  mixins: [categoriesDisplayOptions],
  data: function data() {
    return {
      viewData: 'table',
      columns: columns$2,
      expandedRows: expandedRows$2,
      options: [
        { text: 'Tabla', value: 'table' },
        { text: 'Gráfica', value: 'pie' } ],
    };
  },
  beforeMount: function beforeMount() {
    if (this.player.position_id === 1) {
      this.expandedRows = goalkeeperExpandedRows$2;
    }
  },
  watch: {
    player: function player(newValue) {
      // Check is player is a goalkeeper
      if (newValue && newValue.position_id === 1) {
        this.expandedRows = goalkeeperExpandedRows$2;
      }
    },
    viewData: function viewData(value) {
      analisisDeJugadorTablaGrafica(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
  },
  computed: Object.assign({}, mapGetters('playerProfilePossession', ['fieldStatistics', 'tableData', 'topFiveCategories']),
    mapGetters('playerProfileGeneral', ['player', 'playerId', 'teamId']),
    mapState('playerProfileGlobal', ['isPremiumUser', 'isGolstats']),
    mapGetters({ seasonId: 'playerProfileFilter/getSeasonId', section: 'playerProfileFilter/getCategoryTypeName' })),
  methods: {
    visibilityChanged: function visibilityChanged(isVisible, entry) {
      if (isVisible) {
        var sectionName = entry.target.id;
        analisisDeJugadorSeccionVista(this.seasonId, this.teamId, this.playerId, this.section, sectionName, this.isPremiumUser,
        this.isGolstats);
      }
    },
    onShowDetails: function onShowDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, 'mostrar', this.isPremiumUser,
      this.isGolstats);
    },
    onHideDetails: function onHideDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, 'ocultar', this.isPremiumUser,
      this.isGolstats);
    },
    onOpenSubcategory: function onOpenSubcategory(category) {
      analisisDeJugadorDetallesCategoria(this.seasonId, this.teamId, this.playerId, this.section, category, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeSubcategory: function onChangeSubcategory(subcategory) {
      analisisDeJugadorDetalleSubcategoria(this.seasonId, this.teamId, this.playerId, this.section, subcategory, this.isPremiumUser,
      this.isGolstats);
    },
  },
};

/* script */
var __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c(
      "div",
      { staticClass: "is-bordered-box-shadow-main fields" },
      _vm._l(_vm.fieldStatistics, function(field, index) {
        return _c(
          "div",
          { key: index },
          [
            _c("span", [_vm._v(_vm._s(field.name))]),
            _vm._v(" "),
            _c("StatisticField", {
              attrs: { data: field.data, negative: field.isNegative }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "categories-container" }, [
      _c("nav", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "observe-visibility",
                  rawName: "v-observe-visibility",
                  value: _vm.visibilityChanged,
                  expression: "visibilityChanged"
                }
              ],
              staticClass: "title-section",
              attrs: { id: "categorias-posesion" }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "is-size-4-mobile categories-title has-text-centered-mobile"
                },
                [_vm._v("CATEGORÍAS POSESIÓN")]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "level-right" },
          [
            _c(
              "BField",
              { staticClass: "is-hidden-mobile" },
              _vm._l(_vm.displayOptions, function(option, index) {
                return _c(
                  "BRadioButton",
                  {
                    key: index,
                    attrs: { "native-value": option.value },
                    model: {
                      value: _vm.viewData,
                      callback: function($$v) {
                        _vm.viewData = $$v;
                      },
                      expression: "viewData"
                    }
                  },
                  [_c("BIcon", { attrs: { icon: option.icon } })],
                  1
                )
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "columns is-mobile is-vcentered is-centered is-hidden-tablet"
          },
          [
            _c(
              "div",
              { staticClass: "column is-11" },
              [
                _c(
                  "BField",
                  [
                    _c(
                      "BSelect",
                      {
                        attrs: {
                          placeholder: "-Tabla-",
                          size: "is-medium",
                          expanded: ""
                        },
                        model: {
                          value: _vm.viewData,
                          callback: function($$v) {
                            _vm.viewData = $$v;
                          },
                          expression: "viewData"
                        }
                      },
                      [
                        _vm._l(_vm.options, function(option, index) {
                          return [
                            _c(
                              "option",
                              {
                                key: "option-" + index,
                                domProps: { value: option.value }
                              },
                              [_vm._v(_vm._s(option.text))]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.viewData === "table"
        ? _c(
            "div",
            [
              _c("DataTable", {
                attrs: {
                  columns: _vm.columns,
                  expandedRows: _vm.expandedRows,
                  data: _vm.tableData
                },
                on: {
                  showDetails: _vm.onShowDetails,
                  hideDetails: _vm.onHideDetails
                }
              }),
              _vm._v(" "),
              _c("DataMobileTable", {
                attrs: { columns: _vm.columns, data: _vm.tableData },
                on: {
                  showDetails: _vm.onShowDetails,
                  hideDetails: _vm.onHideDetails,
                  openSubcategory: _vm.onOpenSubcategory,
                  changeSubcategory: _vm.onChangeSubcategory
                }
              })
            ],
            1
          )
        : _vm.viewData === "pie"
        ? _c(
            "div",
            [
              _c("PieChartsPossessionTeam", {
                attrs: { data: _vm.tableData, type: _vm.player.position_id }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

  /* style */
  var __vue_inject_styles__$9 = function (inject) {
    if (!inject) { return }
    inject("data-v-4849b6fb_0", { source: "div.fields[data-v-4849b6fb] {\n  padding-top: 30px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-radius: 20px;\n}\n@media screen and (max-width: 1334px) {\ndiv.fields[data-v-4849b6fb] {\n    grid-template-columns: repeat(3, 1fr);\n}\ndiv.fields > div[data-v-4849b6fb]:last-child {\n    grid-column-start: 2;\n    grid-column-end: 3;\n}\n}\n@media screen and (max-width: 962px) {\ndiv.fields[data-v-4849b6fb] {\n    grid-template-columns: repeat(2, 1fr);\n}\ndiv.fields > div[data-v-4849b6fb]:last-child {\n    grid-column-start: unset;\n    grid-column-end: unset;\n}\n}\n@media screen and (max-width: 656px) {\ndiv.fields[data-v-4849b6fb] {\n    grid-template-columns: 1fr;\n}\n}\n.top-five-container[data-v-4849b6fb] {\n  margin-top: 40px;\n  margin-bottom: 40px;\n  text-align: left;\n}\n.top-five-title[data-v-4849b6fb] {\n  font-size: 30px;\n  line-height: 1.85;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container[data-v-4849b6fb] {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.categories-title[data-v-4849b6fb] {\n  font-size: 40px;\n  line-height: 1.85;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/*# sourceMappingURL=Possession.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/sections/Possession.vue","Possession.vue"],"names":[],"mappings":"AAqKA;EACA,iBAAA;EACA,aAAA;EACA,qCAAA;EACA,mBAAA;ACpKA;ADuKA;AACA;IACA,qCAAA;ACpKE;ADqKF;IACA,oBAAA;IACA,kBAAA;ACnKE;AACF;ADsKA;AACA;IACA,qCAAA;ACpKE;ADqKF;IACA,wBAAA;IACA,sBAAA;ACnKE;AACF;ADsKA;AACA;IACA,0BAAA;ACpKE;AACF;ADuKA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACrKA;ADwKA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;ACrKA;;ADwKA,uBAAA;AACA;EACA,gBAAA;EACA,mBAAA;ACrKA;ADwKA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;ACrKA;;AAEA,yCAAyC","file":"Possession.vue","sourcesContent":["<template>\n  <div>\n    <!-- Fields -->\n    <div class=\"is-bordered-box-shadow-main fields\">\n      <div v-for=\"(field, index) in fieldStatistics\" :key=\"index\">\n        <span>{{ field.name }}</span>\n        <StatisticField :data=\"field.data\" :negative=\"field.isNegative\" />\n      </div>\n    </div>\n    <!-- Top Five Categories -->\n    <!--    <div class=\"top-five-container\">-->\n    <!--      <div class=\"top-five-title\">-->\n    <!--        categorias dentro de top 5-->\n    <!--      </div>-->\n    <!--      <TopFiveHorizontalScroll :categories=\"topFiveCategories\" />-->\n    <!--    </div>-->\n    <!-- Player Categories -->\n    <div class=\"categories-container\">\n      <nav class=\"level\">\n        <div class=\"level-left\">\n          <div class=\"title-section\" id=\"categorias-posesion\" v-observe-visibility=\"visibilityChanged\">\n            <span class=\"is-size-4-mobile categories-title has-text-centered-mobile\">CATEGORÍAS POSESIÓN</span>\n          </div>\n        </div>\n        <div class=\"level-right\">\n          <BField class=\"is-hidden-mobile\">\n            <BRadioButton\n              v-for=\"(option, index) in displayOptions\"\n              v-model=\"viewData\"\n              :native-value=\"option.value\"\n              :key=\"index\"\n            >\n              <BIcon :icon=\"option.icon\" />\n            </BRadioButton>\n          </BField>\n        </div>\n        <div class=\"columns is-mobile is-vcentered is-centered is-hidden-tablet\">\n          <div class=\"column is-11\">\n            <BField>\n              <BSelect placeholder=\"-Tabla-\" size=\"is-medium\" v-model=\"viewData\" expanded>\n                <template v-for=\"(option, index) in options\">\n                  <option :key=\"`option-${index}`\" :value=\"option.value\">{{ option.text }}</option>\n                </template>\n              </BSelect>\n            </BField>\n          </div>\n        </div>\n      </nav>\n      <!-- Categories Table -->\n      <div v-if=\"viewData === 'table'\">\n        <DataTable\n          :columns=\"columns\"\n          :expandedRows=\"expandedRows\"\n          :data=\"tableData\"\n          @showDetails=\"onShowDetails\"\n          @hideDetails=\"onHideDetails\"\n        />\n        <DataMobileTable\n          :columns=\"columns\"\n          :data=\"tableData\"\n          @showDetails=\"onShowDetails\"\n          @hideDetails=\"onHideDetails\"\n          @openSubcategory=\"onOpenSubcategory\"\n          @changeSubcategory=\"onChangeSubcategory\"\n        />\n      </div>\n      <!-- Categories Pie -->\n      <div v-else-if=\"viewData === 'pie'\">\n        <PieChartsPossessionTeam :data=\"tableData\" :type=\"player.position_id\" />\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport StatisticField from '../../components/elements/StatisticField.vue';\nimport DataTable from '../../components/elements/DataTable.vue';\nimport possessionDataTable from '../../data/possession-table-data';\n// import TopFiveHorizontalScroll from '@/components/Elements/TopFiveHorizontalScroll';\nimport DataMobileTable from '../../components/elements/DataMobileTable.vue';\nimport PieChartsPossessionTeam from '../../components/elements/PieChartsPossessionTeam.vue';\nimport { categoriesDisplayOptions } from '../../utils/mixins/categories-display-options';\nimport { mapGetters, mapState } from 'vuex';\nconst { columns, expandedRows, goalkeeperExpandedRows } = possessionDataTable;\nimport {\n  analisisDeJugadorSeccionVista,\n  analisisDeJugadorCategoriasDeTabla,\n  analisisDeJugadorTablaGrafica,\n  analisisDeJugadorDetallesCategoria,\n  analisisDeJugadorDetalleSubcategoria,\n} from '../../utils/analytics';\n\nexport default {\n  name: 'PlayerPossession',\n  components: {\n    // TopFiveHorizontalScroll,\n    StatisticField,\n    DataMobileTable,\n    DataTable,\n    PieChartsPossessionTeam,\n  },\n  mixins: [categoriesDisplayOptions],\n  data() {\n    return {\n      viewData: 'table',\n      columns,\n      expandedRows,\n      options: [\n        { text: 'Tabla', value: 'table' },\n        { text: 'Gráfica', value: 'pie' },\n      ],\n    };\n  },\n  beforeMount() {\n    if (this.player.position_id === 1) {\n      this.expandedRows = goalkeeperExpandedRows;\n    }\n  },\n  watch: {\n    player(newValue) {\n      // Check is player is a goalkeeper\n      if (newValue && newValue.position_id === 1) {\n        this.expandedRows = goalkeeperExpandedRows;\n      }\n    },\n    viewData(value) {\n      analisisDeJugadorTablaGrafica(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n  },\n  computed: {\n    ...mapGetters('playerProfilePossession', ['fieldStatistics', 'tableData', 'topFiveCategories']),\n    ...mapGetters('playerProfileGeneral', ['player', 'playerId', 'teamId']),\n    ...mapState('playerProfileGlobal', ['isPremiumUser', 'isGolstats']),\n    ...mapGetters({ seasonId: 'playerProfileFilter/getSeasonId', section: 'playerProfileFilter/getCategoryTypeName' }),\n  },\n  methods: {\n    visibilityChanged(isVisible, entry) {\n      if (isVisible) {\n        const sectionName = entry.target.id;\n        analisisDeJugadorSeccionVista(this.seasonId, this.teamId, this.playerId, this.section, sectionName, this.isPremiumUser,\n        this.isGolstats);\n      }\n    },\n    onShowDetails(category) {\n      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, 'mostrar', this.isPremiumUser,\n      this.isGolstats);\n    },\n    onHideDetails(category) {\n      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, 'ocultar', this.isPremiumUser,\n      this.isGolstats);\n    },\n    onOpenSubcategory(category) {\n      analisisDeJugadorDetallesCategoria(this.seasonId, this.teamId, this.playerId, this.section, category, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeSubcategory(subcategory) {\n      analisisDeJugadorDetalleSubcategoria(this.seasonId, this.teamId, this.playerId, this.section, subcategory, this.isPremiumUser,\n      this.isGolstats);\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"scss\">\ndiv.fields {\n  padding-top: 30px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-radius: 20px;\n}\n\n@media screen and (max-width: 1334px) {\n  div.fields {\n    grid-template-columns: repeat(3, 1fr);\n    & > div:last-child {\n      grid-column-start: 2;\n      grid-column-end: 3;\n    }\n  }\n}\n@media screen and (max-width: 962px) {\n  div.fields {\n    grid-template-columns: repeat(2, 1fr);\n    & > div:last-child {\n      grid-column-start: unset;\n      grid-column-end: unset;\n    }\n  }\n}\n@media screen and (max-width: 656px) {\n  div.fields {\n    grid-template-columns: 1fr;\n  }\n}\n\n.top-five-container {\n  margin-top: 40px;\n  margin-bottom: 40px;\n  text-align: left;\n}\n\n.top-five-title {\n  font-size: 30px;\n  line-height: 1.85;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.categories-title {\n  font-size: 40px;\n  line-height: 1.85;\n  color: #808285;\n  text-transform: uppercase;\n}\n</style>\n","div.fields {\n  padding-top: 30px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-radius: 20px;\n}\n\n@media screen and (max-width: 1334px) {\n  div.fields {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  div.fields > div:last-child {\n    grid-column-start: 2;\n    grid-column-end: 3;\n  }\n}\n@media screen and (max-width: 962px) {\n  div.fields {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  div.fields > div:last-child {\n    grid-column-start: unset;\n    grid-column-end: unset;\n  }\n}\n@media screen and (max-width: 656px) {\n  div.fields {\n    grid-template-columns: 1fr;\n  }\n}\n.top-five-container {\n  margin-top: 40px;\n  margin-bottom: 40px;\n  text-align: left;\n}\n\n.top-five-title {\n  font-size: 30px;\n  line-height: 1.85;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.categories-title {\n  font-size: 40px;\n  line-height: 1.85;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/*# sourceMappingURL=Possession.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$9 = "data-v-4849b6fb";
  /* module identifier */
  var __vue_module_identifier__$9 = undefined;
  /* functional template */
  var __vue_is_functional_template__$9 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    createInjector,
    undefined,
    undefined
  );

// Data that configures the Player Offensive Table

var offensiveDataTable = {
  columns: baseColumns,
  expandedRows: offensivePlayerTableRowItems.map(function (item) {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
  goalkeeperExpandedRows: offensiveGoalkeeperTableRowItems.map(function (item) {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
};

//
//
//
//
//
//

var script$8 = {
  name: 'tooltip',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    positionTooltip: function positionTooltip() {
      return {
        top: ((this.data.y) + "px"),
        left: ((this.data.x) + "px"),
      };
    },
    showTooltip: function showTooltip() {
      return {
        visible: this.data.visible,
      };
    },
  },
};

/* script */
var __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "box-tooltip",
      class: _vm.showTooltip,
      style: _vm.positionTooltip
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  var __vue_inject_styles__$8 = function (inject) {
    if (!inject) { return }
    inject("data-v-5ae29996_0", { source: "\n.box-tooltip[data-v-5ae29996] {\n  border-radius: 4px !important;\n  pointer-events: none;\n  position: absolute;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.7);\n  padding: 10px 15px;\n  z-index: 5;\n  margin: 0 auto;\n  color: white;\n  display: none;\n  transform: translate(-10%, -50%);\n}\n.box-tooltip.visible[data-v-5ae29996] {\n  display: block;\n}\n", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/Tooltip.vue"],"names":[],"mappings":";AAgCA;EACA,6BAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AACA;AACA;EACA,cAAA;AACA","file":"Tooltip.vue","sourcesContent":["<template>\n  <div class=\"box-tooltip\" :style=\"positionTooltip\" :class=\"showTooltip\">\n    <slot></slot>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'tooltip',\n  props: {\n    data: {\n      type: Object,\n      required: true,\n    },\n  },\n  computed: {\n    positionTooltip() {\n      return {\n        top: `${this.data.y}px`,\n        left: `${this.data.x}px`,\n      };\n    },\n    showTooltip() {\n      return {\n        visible: this.data.visible,\n      };\n    },\n  },\n};\n</script>\n\n<style scoped>\n.box-tooltip {\n  border-radius: 4px !important;\n  pointer-events: none;\n  position: absolute;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.7);\n  padding: 10px 15px;\n  z-index: 5;\n  margin: 0 auto;\n  color: white;\n  display: none;\n  transform: translate(-10%, -50%);\n}\n.box-tooltip.visible {\n  display: block;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$8 = "data-v-5ae29996";
  /* module identifier */
  var __vue_module_identifier__$8 = undefined;
  /* functional template */
  var __vue_is_functional_template__$8 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$7 = {
  name: 'SoccerChalkboard',
  props: {
    plays: {
      type: Array,
      require: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    players: {
      type: Array,
      required: true,
    },
    games: {
      type: Array,
      required: false,
    },
    team: {
      type: Number,
      default: 0,
    },
    playValuesIndex: {
      type: Object,
      required: true,
    },
    analysisType: {
      type: String,
      required: false,
    },
    // Possible values: 'team' or 'player'
    sectionType: {
      type: String,
      required: true,
    },
  },
  components: {
    Tooltip: __vue_component__$8,
  },
  data: function data() {
    return {
      selectedPlays: [],
      negativeColor: 'red',
      perspective: true,
      data: {
        x: 0,
        y: 0,
        visible: false,
      },
      dataPlay: {
        playerName: '',
        minute: 0,
        rivalLogo: '',
        categoryName: '',
        xGi: 0,
        xGf: 0,
        isOwnGoal: false,
      },
      initialSelectedOptions: {
        team: {
          offensive: [0],
          defensive: [6],
        },
        player: {
          offensive: [],
          defensive: [0, 1, 2, 4],
        },
        goalkeeper: {
          offensive: [],
          defensive: [1],
        },
      },
      isVisualizationTextVisible: false,
    };
  },
  mounted: function mounted() {
    if (this.sectionType === 'team') {
      this.updatePlayer({});
    }
    var initialOptions = [];
    if (this.player.position_id !== 1) {
      initialOptions = [].concat( this.initialSelectedOptions[this.sectionType][this.analysisType] );
    } else {
      initialOptions = [].concat( this.initialSelectedOptions.goalkeeper[this.analysisType] );
    }
    this.selectedPlays = initialOptions.length ? initialOptions : this.localCategories.map(function (c) { return c.id; });
    this.setUpResizeObserver();
  },
  watch: {
    perspective: function perspective(newValue) {
      var view = newValue ? '3D' : '2D';
      this.$emit('changePerspective', view);
    },
  },
  computed: Object.assign({}, mapGetters('playerProfileGeneral', ['player']),
    mapState('playerProfileGlobal', ['windowWidth']),

    {categoriesWithXg: function categoriesWithXg() {
      if (this.sectionType === 'team') {
        return [0, 1, 2];
      } if (this.player.position_id === 1) {
        return [];
      }
      return [0, 3, 4];
    },

    chalkboardViewBox: function chalkboardViewBox() {
      return this.windowWidth > 384 ? '0 0 490 684' : '0 0 490 784';
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para convertir el arreglo de jugadas en un json, para trabajarlo con las demas jugadas, por si cambia la estructura o posicion de los elementos
     */
    preparedPlays: function preparedPlays() {
      var this$1 = this;

      return this.plays.map(function (p) { return ({
        playId: p[this$1.playValuesIndex.playId],
        gameId: p[this$1.playValuesIndex.gameId],
        teamId: p[this$1.playValuesIndex.teamId],
        playerId: p[this$1.playValuesIndex.playerId],
        momentOfPlay: p[this$1.playValuesIndex.momentOfPlay],
        categoryId: p[this$1.playValuesIndex.categoryId],
        categoryType: p[this$1.playValuesIndex.categoryType],
        matchLapse: p[this$1.playValuesIndex.matchLapse],
        section: p[this$1.playValuesIndex.section],
        matchResult: p[this$1.playValuesIndex.matchResult],
        playingAs: p[this$1.playValuesIndex.playingAs],
        total: p[this$1.playValuesIndex.total],
        x1: p[this$1.playValuesIndex.coordinate1X] * 100,
        y1: p[this$1.playValuesIndex.coordinate1Y] * 100,
        x2: p[this$1.playValuesIndex.coordinate2X] * 100,
        y2: p[this$1.playValuesIndex.coordinate2Y] * 100,
        x3: p[this$1.playValuesIndex.coordinate3X] * 100,
        y3: p[this$1.playValuesIndex.coordinate3Y] * 100,
        xGi: p[this$1.playValuesIndex.xGi],
        xGf: p[this$1.playValuesIndex.xGf],
      }); });
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener todas las categorias, determinar de cuantos puntos le corresponden, asi como asignar los colres, puntos y categorias golstats
     */
    localCategories: function localCategories() {
      return this.categories.map(function (c, i) { return ({
        id: i,
        name: c.name,
        negative: c.negative || false,
        color: c.color,
        points: c.points,
        numPoints: c.points.length,
        categories: c.categories,
        invert: c.invert || [],
      }); });
    },
    /**
     * @author Cristhian Gómez
     * @description Variable computada que devuelve un booleano dependiendo si todas ñas categorias estan seleccionadas
     */
    isFullCategoriesSelected: function isFullCategoriesSelected() {
      return this.selectedPlays.length == this.localCategories.length;
    },
    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener las categorias correspondientes a 1 punto
     */
    categoriesPlays1: function categoriesPlays1() {
      return Array.from(new Set(
        this.localCategories
          .filter(function (c) { return c.numPoints === 1; })
          .map(function (c) { return c.categories; })
          .flat()
      ));
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener las categorias correspondientes a 2 puntos
     */
    categoriesPlays2: function categoriesPlays2() {
      return Array.from(new Set(
        this.localCategories
          .filter(function (c) { return c.numPoints === 2; })
          .map(function (c) { return c.categories; })
          .flat()
      ));
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener las categorias correspondientes a 3 puntos
     */
    categoriesPlays3: function categoriesPlays3() {
      return Array.from(new Set(
        this.localCategories
          .filter(function (c) { return c.numPoints === 3; })
          .map(function (c) { return c.categories; })
          .flat()
      ));
    },

    /**
     * @author Rigoberto Sanchez
     * @description  Metodo para calcular las jugadas que son de 1 punto, se obtienen las jugadas de la propiedad "plays", y se crea un array con las jugadas correspondientes.
     */
    plays1: function plays1() {
      var this$1 = this;

      var categories = this.categoriesPlays1;
      var selected = this.selectedPlays;
      var plays = this.preparedPlays
        .filter(function (p) { return this$1.findCategoryInPlay(categories, p); })
        .reduce(function (accumulator, p) {
          var category = this$1.localCategories.find(function (c) { return this$1.findCategoryInPlay(c.categories, p); });
          var player = this$1.players.find(function (i) { return i.player_id === p.playerId; });
          var game = this$1.games.find(function (game) { return game.gameId === p.gameId; });
          if (category && player && game) {
            var result = {
              category: category.id,
              categoryName: category.name,
              color: category.color,
              playId: p.playId,
              player: p.playerId,
              playerName: player ? player.name : '',
              jersey: player ? player.jersey : '',
              matchlapse: p.matchLapse,
              x1: category.invert.includes(p.categoryId)
                ? 100 - p[("x" + (category.points[0]))]
                : p[("x" + (category.points[0]))],
              y1: category.invert.includes(p.categoryId)
                ? 100 - p[("y" + (category.points[0]))]
                : p[("y" + (category.points[0]))],
              momentOfPlay: p.momentOfPlay,
              rivalLogo: this$1.getRivalLogo(game, p),
              rivalName: this$1.getRivalName(game, p),
            };

            if (this$1.analysisType === 'offensive' && this$1.categoriesWithXg.includes(category.id)) {
              result.xGi = p.xGi;
              result.xGf = p.xGf;
            }

            accumulator.push(result);
          }
          return accumulator;
        }, []);
      return plays.filter(function (p) { return selected.includes(p.category); });

      // return plays.filter(p => selected.includes(p.category));
    },

    /**
     * @author Rigoberto Sanchez
     * @description  Metodo para calcular las jugadas que son de 2 puntos, se obtienen las jugadas de la propiedad "plays", y se crea un array con las jugadas correspondientes.
     */
    plays2: function plays2() {
      var this$1 = this;

      var categories = this.categoriesPlays2;
      var selected = this.selectedPlays;
      var plays = this.preparedPlays
        .filter(function (p) { return this$1.findCategoryInPlay(categories, p); })
        .reduce(function (accumulator, p) {
          var category = this$1.localCategories.find(function (c) { return this$1.findCategoryInPlay(c.categories, p); });
          var player = this$1.players.find(function (i) { return i.player_id === p.playerId; });
          var game = this$1.games.find(function (g) { return (g ? g.gameId === p.gameId : undefined); });
          if (category && player && game) {
            var result = {
              category: category.id,
              categoryName: category.name,
              arrowColor: category.negative ? this$1.negativeColor : category.color,
              arrowMarkerColor: category.negative ? 'url(#arrow-negative)' : ("url(#arrow-" + (category.id) + ")"),
              markerColor: category.color,
              playId: p.playId,
              player: p.playerId,
              playerName: player ? player.name : '',
              jersey: player ? player.jersey : '',
              matchlapse: p.matchLapse,
              x1: category.invert.includes(p.categoryId)
                ? 100 - p[("x" + (category.points[0]))]
                : p[("x" + (category.points[0]))],
              y1: category.invert.includes(p.categoryId)
                ? 100 - p[("y" + (category.points[0]))]
                : p[("y" + (category.points[0]))],
              x2: category.invert.includes(p.categoryId)
                ? 100 - p[("x" + (category.points[1]))]
                : p[("x" + (category.points[1]))],
              y2: category.invert.includes(p.categoryId)
                ? 100 - p[("y" + (category.points[1]))]
                : p[("y" + (category.points[1]))],
              momentOfPlay: p.momentOfPlay,
              rivalLogo: this$1.getRivalLogo(game, p),
              rivalName: this$1.getRivalName(game, p),
            };

            if (this$1.analysisType === 'offensive' && this$1.categoriesWithXg.includes(category.id)) {
              result.xGi = p.xGi;
              result.xGf = p.xGf;
            }

            accumulator.push(result);
          }
          return accumulator;
        }, []);
      return plays.filter(function (p) { return selected.includes(p.category); });
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para calcular las jugadas que son de 3 puntos, se obtienen las jugadas de la propiedad "plays", y se crea un array con las jugadas correspondientes.
     */
    plays3: function plays3() {
      var this$1 = this;

      var categories = this.categoriesPlays3;
      var selected = this.selectedPlays;
      var plays = this.preparedPlays
        .filter(function (p) {
          var result = this$1.findCategoryInPlay(categories, p);
          return result;
        })
        .reduce(function (accumulator, p) {
          var category = this$1.localCategories.find(function (c) { return this$1.findCategoryInPlay(c.categories, p); });
          var player = this$1.players.find(function (i) { return i.player_id === p.playerId; });
          var game = this$1.games.find(function (g) { return (g ? g.gameId === p.gameId : undefined); });
          if (category && player && game) {
            var result = {
              category: category.id,
              categoryName: category.name,
              arrowColor: category.negative ? this$1.negativeColor : category.color,
              arrowMarkerColor: category.negative ? 'url(#arrow-negative)' : ("url(#arrow-" + (category.id) + ")"),
              markerColor: category.color,
              playId: p.playId,
              player: p.playerId,
              playerName: player ? player.name : '',
              jersey: player ? player.jersey : '',
              matchlapse: p.matchLapse,
              x1: category.invert.includes(p.categoryId)
                ? 100 - p[("x" + (category.points[0]))]
                : p[("x" + (category.points[0]))],
              y1: category.invert.includes(p.categoryId)
                ? 100 - p[("y" + (category.points[0]))]
                : p[("y" + (category.points[0]))],
              x2: category.invert.includes(p.categoryId)
                ? 100 - p[("x" + (category.points[1]))]
                : p[("x" + (category.points[1]))],
              y2: category.invert.includes(p.categoryId)
                ? 100 - p[("y" + (category.points[1]))]
                : p[("y" + (category.points[1]))],
              x3: category.invert.includes(p.categoryId)
                ? 100 - p[("x" + (category.points[2]))]
                : p[("x" + (category.points[2]))],
              y3: category.invert.includes(p.categoryId)
                ? 100 - p[("y" + (category.points[2]))]
                : p[("y" + (category.points[2]))],
              momentOfPlay: p.momentOfPlay,
              rivalLogo: this$1.getRivalLogo(game, p),
              rivalName: this$1.getRivalName(game, p),
            };
            if (category.id === 0 && this$1.analysisType === 'offensive' && p.teamId) {
              result.isOwnGoal = this$1.team !== p.teamId;
            } else if (category.id === 0 && this$1.analysisType === 'defensive' && p.teamId) {
              result.isOwnGoal = this$1.team === p.teamId;
            } else {
              result.isOwnGoal = false;
            }

            if (this$1.analysisType === 'offensive' && this$1.categoriesWithXg.includes(category.id)) {
              result.xGi = p.xGi;
              result.xGf = p.xGf;
            }

            accumulator.push(result);
          }
          return accumulator;
        }, []);
      return plays.filter(function (p) { return selected.includes(p.category); });
    },

    /**
     * @author Fernando Mellone
     * @description propiedad que determina si el xGf acumulado es visible.
     */
    istotalXgfVisible: function istotalXgfVisible() {
      var this$1 = this;

      return this.selectedPlays.some(function (play) { return this$1.categoriesWithXg.includes(play); }) && this.analysisType === 'offensive';
    },

    /**
     * @author Fernando Mellone
     * @description propiedad que calcula el xGf total a mostrarse en pantalla.
     */
    totalXgf: function totalXgf() {
      var this$1 = this;

      var playsByMoment1 = _.groupBy(this.plays1, 'momentOfPlay');
      var playsByMoment2 = _.groupBy(this.plays2, 'momentOfPlay');
      var playsByMoment3 = _.groupBy(this.plays3, 'momentOfPlay');

      var allPlays = Object.assign({}, playsByMoment1, playsByMoment2, playsByMoment3);

      var acc = 0;

      Object.entries(allPlays).forEach(function (play) {
        if (this$1.categoriesWithXg.includes(play[1][0].category) && !play.isOwnGoal) { acc += Number(play[1][0].xGf); }
      });

      return acc;
    },

    totalPlays: function totalPlays() {
      var playsByMoment1 = _.groupBy(this.plays1, 'momentOfPlay');
      var playsByMoment2 = _.groupBy(this.plays2, 'momentOfPlay');
      var playsByMoment3 = _.groupBy(this.plays3, 'momentOfPlay');

      var plays1Qty = Object.keys(playsByMoment1).length;
      var plays2Qty = Object.keys(playsByMoment2).length;
      var plays3Qty = Object.keys(playsByMoment3).length;

      var total = plays1Qty + plays2Qty + plays3Qty;

      return total;
    }}),
  methods: Object.assign({}, mapMutations('playerProfileGeneral', ['updatePlayer']),
    {setUpResizeObserver: function setUpResizeObserver() {
      var this$1 = this;

      if (window.ResizeObserver) {
        var resizeObserver = new ResizeObserver(function () {
          this$1.isVisualizationTextVisible =
            this$1.$refs.chalkboard && this$1.$refs.chalkboard.clientWidth > 524;
        });
        resizeObserver.observe(this.$refs.chalkboard);
      } else {
        throw new Error('Resize observer not supported!');
      }
    },
    /**
     * @author Alejandro
     * @description There are some categories in format categoryId and r, e.g. 35_r, these categories
     * with _r are rival plays. So these method look for those plays an compare it's team id.
     * @param {Array} categories
     * @param {Object} play
     */
    findCategoryInPlay: function findCategoryInPlay(categories, play) {
      var this$1 = this;

      return categories.find(function (category) {
        var categoryAux = 0;
        if (typeof category === 'string') {
          if (play.teamId) {
            categoryAux = Number(category.split('_').shift());
            return categoryAux === play.categoryId && play.teamId !== this$1.team;
          }
        } else {
          // Team plays has a teamId, player plays not.
          return play.teamId ? category === play.categoryId && this$1.team === play.teamId : category === play.categoryId;
        }
        return false;
      });
    },
    getRivalLogo: function getRivalLogo(game, play) {
      if (this.sectionType === 'team') {
        return game.homeTeamId === this.team ? game.visitingTeamLogo : game.homeTeamLogo;
      }
      return play.playingAs === 1 ? game.visitingTeamLogo : game.homeTeamLogo;
    },
    getRivalName: function getRivalName(game, play) {
      if (this.sectionType === 'team') {
        return game.homeTeamId === this.team ? game.visitingTeamName : game.homeTeamName;
      }
      return play.playingAs === 1 ? game.visitingTeamName : game.homeTeamName;
    },
    /**
     * @author Rigoberto Sanchez, Cristhian Gómez
     * @description Metodo para cuando el usuario desea seleccionar todos los elementos, se agregan al elemento "selectedPlays",
     * en caso de que esten todas las categorías seleccionados el método limpiará todas las categorías.
     */
    onClickSelectAll: function onClickSelectAll() {
      if (!this.isFullCategoriesSelected) {
        this.selectedPlays = this.localCategories.map(function (i) { return i.id; });
      } else {
        this.selectedPlays = [];
      }
      this.$emit('changeSelectAll', this.isFullCategoriesSelected);
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para obtener los datos correspondientes a la jugada y mostrarlos en el tooltip
     */
    onMouseOver: function onMouseOver(event, play) {
      var chalkboardBounds = this.$refs.chalkboard.getBoundingClientRect();
      var modalXPosition = event.clientX - chalkboardBounds.x + 35;
      this.dataPlay.playerName = play.playerName || '';
      this.dataPlay.minute = parseInt(play.momentOfPlay.split(':')[0]) || '';
      this.dataPlay.rivalLogo = play.rivalLogo || '';
      this.dataPlay.rivalName = play.rivalName || '';
      this.dataPlay.categoryName = play.categoryName || '';
      this.dataPlay.xGi = String(play.xGi);
      this.dataPlay.xGf = String(play.xGf);
      this.dataPlay.isOwnGoal = play.isOwnGoal;
      this.data.x =
        modalXPosition+ 350 > this.$refs.chalkboard.clientWidth
          ? this.$refs.chalkboard.clientWidth - 350 < 55
          ? 55
          : this.$refs.chalkboard.clientWidth - 350
          : modalXPosition;
      this.data.y = chalkboardBounds.y < 0 ? event.clientY + (-1 * chalkboardBounds.y) : event.clientY - chalkboardBounds.y;
      this.data.y += 80;
      this.data.visible = true;
    },

    /**
     * @author Rigoberto Sanchez
     * @description Metodo para indicar que el usuario ha salido del elemento y dejar de mostrar el tooltip
     */
    onMouseLeave: function onMouseLeave() {
      this.data.visible = false;
    },

    /**
     * @author Rigoberto Sanchez
     * @descripcion Emit event when change category
     */
    onClickCategory: function onClickCategory(value) {
      this.$emit('changeCategory', {
        name: value.target.name,
        checked: value.target.checked,
      });
    }}),
};

/* script */
var __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    { ref: "chalkboard", staticClass: "soccer-chalkboard" },
    [
      _c("div", { staticClass: "columns soccer-chalkboard__header" }, [
        _c(
          "div",
          { staticClass: "column is-8 soccer-chalkboard__header__switch" },
          [
            _vm.isVisualizationTextVisible
              ? _c(
                  "span",
                  {
                    staticClass:
                      "control-label is-inline-flex is-pulled-left field-title"
                  },
                  [_vm._v("\n        Visualización:\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("span", { staticClass: "control-label right" }, [
                  _vm._v("2D")
                ]),
                _vm._v(" "),
                _c("BSwitch", {
                  attrs: { "passive-type": "is-primary" },
                  model: {
                    value: _vm.perspective,
                    callback: function($$v) {
                      _vm.perspective = $$v;
                    },
                    expression: "perspective"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "control-label left" }, [
                  _vm._v("3D")
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "column is-4 has-vertical-divider title" }, [
          _vm._v("Categorías")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-8 has-gray-background" }, [
          _c(
            "svg",
            {
              staticClass: "soccer-chalkboard",
              class: {
                perspective3d: _vm.perspective,
                perspective2d: !_vm.perspective
              },
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: _vm.chalkboardViewBox,
                "xmlns:xlink": "http://www.w3.org/1999/xlink"
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 452 684",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink"
                  }
                },
                [
                  _c(
                    "defs",
                    [
                      _c(
                        "marker",
                        {
                          attrs: {
                            id: "arrow-negative",
                            viewBox: "0 0 10 10",
                            refX: "5",
                            refY: "5",
                            markerWidth: "6",
                            markerHeight: "6",
                            markerUnits: "strokeWidth",
                            orient: "auto"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M 0 0 L 10 5 L 0 10 z",
                              "stroke-width": "2",
                              fill: "red"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.localCategories, function(c) {
                        return _c(
                          "marker",
                          {
                            key: "arrow-color-" + c.id,
                            attrs: {
                              id: "arrow-" + c.id,
                              viewBox: "0 0 10 10",
                              refX: "5",
                              refY: "5",
                              markerWidth: "6",
                              markerHeight: "6",
                              markerUnits: "strokeWidth",
                              orient: "auto"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M 0 0 L 10 5 L 0 10 z",
                                "stroke-width": "2",
                                fill: c.color
                              }
                            })
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "pattern",
                        {
                          attrs: {
                            id: "fieldBackground",
                            width: "1",
                            height: "1",
                            viewBox: "0 0 100 100",
                            preserveAspectRatio: "none"
                          }
                        },
                        [
                          _c("image", {
                            attrs: {
                              "xlink:href":
                                "http://golstats-2-develop.azurewebsites.net/images/fieldbg.png",
                              width: "100",
                              height: "100",
                              preserveAspectRatio: "none",
                              id: "image2"
                            }
                          })
                        ]
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("g", { attrs: { id: "soccer-field" } }, [
                    _c("rect", {
                      attrs: {
                        opacity: ".8",
                        height: "684",
                        width: "452",
                        fill: "url(#fieldBackground)"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "g19",
                          transform: "matrix(1,0,0,0.96314115,0,12.524864)",
                          stroke: "#eeffee",
                          fill: "none",
                          "stroke-width": "3"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "m 11.22,22.62 v 638.8 h 429.6 V 22.62 Z",
                            id: "path4"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { d: "m 11.26,342 h 429.4", id: "path6" }
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cy: "342",
                            cx: "226",
                            r: "54.799999",
                            id: "circle8"
                          }
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cy: "342",
                            cx: "226",
                            r: "2",
                            id: "circle10"
                          }
                        }),
                        _vm._v(" "),
                        _c("g", { attrs: { id: "a" } }, [
                          _c("path", {
                            attrs: {
                              d:
                                "m 9.9,30.07 c 4.85,0 8.82,-4 8.82,-8.9 m 162.5,100.8 a 54.91,54.91 0 0 0 89.6,0 m 76.3,-99.63 v\n                  99.63 h -242.2 l 0.2,-99.63 m 98.6,0.2 V 6.94 l 44.6,0.003 v 15.6 m -77.9,-0.2 v 34.4 h 111.2 v\n                  -34.4 m 160.5,7.7 c -4.9,0 -8.8,-4 -8.8,-8.9",
                              id: "path12"
                            }
                          }),
                          _vm._v(" "),
                          _c("circle", {
                            attrs: {
                              cy: "90",
                              cx: "226",
                              r: "2",
                              id: "circle14"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("use", {
                          attrs: {
                            "xlink:href": "#a",
                            transform: "scale(1,-1)",
                            y: "-684",
                            x: "0",
                            width: "100%",
                            height: "100%"
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.plays3, function(play) {
                    return _c(
                      "g",
                      { key: play.id, attrs: { id: "play-" + play.playId } },
                      [
                        _c("line", {
                          attrs: {
                            x1: play.x1 + "%",
                            y1: play.y1 + "%",
                            x2: play.x2 + "%",
                            y2: play.y2 + "%",
                            stroke: play.arrowColor,
                            "stroke-width": "2"
                          }
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            x1: play.x2 + "%",
                            y1: play.y2 + "%",
                            x2: play.x3 + "%",
                            y2: play.y3 + "%",
                            stroke: play.arrowColor,
                            "stroke-width": "2",
                            "marker-end": play.arrowMarkerColor
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "g",
                          {
                            staticClass: "is-pointer",
                            on: {
                              mouseover: function($event) {
                                return _vm.onMouseOver($event, play)
                              },
                              mouseleave: _vm.onMouseLeave
                            }
                          },
                          [
                            _c("rect", {
                              attrs: {
                                x: play.x1 + "%",
                                y: play.y1 + "%",
                                transform: "translate(-11, -11)",
                                height: "22",
                                width: "22",
                                "stroke-width": "2",
                                fill: "white",
                                stroke: play.markerColor,
                                rx: "4",
                                ry: "4"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "text",
                              {
                                attrs: {
                                  "text-anchor": "middle",
                                  "dominant-baseline": "middle",
                                  x: play.x1 + "%",
                                  y: play.y1 + "%",
                                  dy: "1",
                                  "font-size": "12",
                                  stroke: "black"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(play.jersey) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.plays2, function(play) {
                    return _c(
                      "g",
                      { key: play.id, attrs: { id: "play-" + play.playId } },
                      [
                        _c("line", {
                          attrs: {
                            x1: play.x1 + "%",
                            y1: play.y1 + "%",
                            x2: play.x2 + "%",
                            y2: play.y2 + "%",
                            "stroke-width": "2",
                            stroke: play.arrowColor,
                            "marker-end": play.arrowMarkerColor
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "g",
                          {
                            staticClass: "is-pointer",
                            on: {
                              mouseover: function($event) {
                                return _vm.onMouseOver($event, play)
                              },
                              mouseleave: _vm.onMouseLeave
                            }
                          },
                          [
                            _c("rect", {
                              attrs: {
                                x: play.x1 + "%",
                                y: play.y1 + "%",
                                transform: "translate(-10, -10)",
                                height: "20",
                                width: "20",
                                "stroke-width": "2",
                                fill: "white",
                                stroke: play.markerColor,
                                rx: "4",
                                ry: "4"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "text",
                              {
                                attrs: {
                                  "text-anchor": "middle",
                                  "dominant-baseline": "middle",
                                  x: play.x1 + "%",
                                  y: play.y1 + "%",
                                  dy: "1",
                                  "font-size": "12",
                                  stroke: "black"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(play.jersey) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.plays1, function(play) {
                    return _c(
                      "g",
                      {
                        key: play.id,
                        staticClass: "is-pointer",
                        attrs: { id: "play-" + play.playId },
                        on: {
                          mouseover: function($event) {
                            return _vm.onMouseOver($event, play)
                          },
                          mouseleave: _vm.onMouseLeave
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: play.x1 + "%",
                            y: play.y1 + "%",
                            transform: "translate(-10, -10)",
                            height: "20",
                            width: "20",
                            "stroke-width": "2",
                            fill: "white",
                            stroke: play.color,
                            rx: "4",
                            ry: "4"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            attrs: {
                              "text-anchor": "middle",
                              "dominant-baseline": "middle",
                              x: play.x1 + "%",
                              y: play.y1 + "%",
                              dy: "1",
                              "font-size": "12",
                              stroke: "black"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(play.jersey) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("svg", [
                _c("defs", [
                  _c(
                    "marker",
                    {
                      attrs: {
                        id: "arrow-gray",
                        viewBox: "0 0 10 10",
                        refX: "5",
                        refY: "5",
                        markerWidth: "6",
                        markerHeight: "6",
                        markerUnits: "strokeWidth",
                        orient: "auto"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M 0 0 L 10 5 L 0 10 z",
                          "stroke-width": "2",
                          fill: "#c9c8c8"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("line", {
                  attrs: {
                    x1: "482",
                    y1: "600",
                    x2: "482",
                    y2: "200",
                    stroke: "#c9c8c8",
                    "stroke-width": "3",
                    "marker-end": "url(#arrow-gray)"
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _vm.istotalXgfVisible
            ? _c("div", [
                _vm._v(
                  "xG acumulado: " + _vm._s(_vm._f("ceilMod")(_vm.totalXgf))
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [_vm._v("Eventos totales: " + _vm._s(_vm.totalPlays))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column is-4 has-text-left" },
          [
            _vm._l(_vm.localCategories, function(category) {
              return _c(
                "div",
                {
                  key: "category-" + category.id,
                  staticClass: "field has-horizontal-divider"
                },
                [
                  _c(
                    "BCheckbox",
                    {
                      attrs: {
                        "native-value": category.id,
                        name: category.name
                      },
                      nativeOn: {
                        change: function($event) {
                          return _vm.onClickCategory($event)
                        }
                      },
                      model: {
                        value: _vm.selectedPlays,
                        callback: function($$v) {
                          _vm.selectedPlays = $$v;
                        },
                        expression: "selectedPlays"
                      }
                    },
                    [_vm._v(_vm._s(category.name))]
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field", attrs: { atributo: "atributo" } },
              [
                _c(
                  "BButton",
                  {
                    attrs: { type: "is-primary", expanded: "" },
                    on: { click: _vm.onClickSelectAll }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isFullCategoriesSelected
                          ? "Deseleccionar Todo"
                          : "Seleccionar Todo"
                      )
                    )
                  ]
                )
              ],
              1
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("Tooltip", { attrs: { data: _vm.data } }, [
        _c("div", { staticClass: "tooltip-data has-text-left" }, [
          _c("div", [
            _c("span", { staticClass: "bold" }, [_vm._v("Categoría:")]),
            _vm._v(
              " " +
                _vm._s(
                  _vm.dataPlay.isOwnGoal ? "Autogol" : _vm.dataPlay.categoryName
                )
            )
          ]),
          _vm._v(" "),
          _vm.sectionType === "team"
            ? _c("div", [
                _c("span", { staticClass: "bold" }, [_vm._v("Jugador:")]),
                _vm._v(" " + _vm._s(_vm.dataPlay.playerName))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "bold" }, [_vm._v("Minuto:")]),
            _vm._v(" " + _vm._s(_vm.dataPlay.minute))
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "bold" }, [_vm._v("Rival:")]),
            _vm._v(" " + _vm._s(_vm.dataPlay.rivalName) + "\n        "),
            _c("img", {
              staticStyle: { "vertical-align": "middle" },
              attrs: { src: _vm.dataPlay.rivalLogo, width: "25" }
            })
          ]),
          _vm._v(" "),
          /^[+]?([0-1]+(?:[\.][0-9]*)?|\.[0-9]+)$/.test(_vm.dataPlay.xGi) &&
          _vm.dataPlay.xGi <= 1 &&
          !_vm.dataPlay.isOwnGoal
            ? _c("div", [
                _c("span", { staticClass: "bold" }, [_vm._v("xGi:")]),
                _vm._v(
                  " " +
                    _vm._s(_vm._f("ceilMod")(Number(_vm.dataPlay.xGi), 4)) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          /^[+]?([0-1]+(?:[\.][0-9]*)?|\.[0-9]+)$/.test(_vm.dataPlay.xGf) &&
          _vm.dataPlay.xGf <= 1 &&
          !_vm.dataPlay.isOwnGoal
            ? _c("div", [
                _c("span", { staticClass: "bold" }, [_vm._v("xGf:")]),
                _vm._v(
                  " " +
                    _vm._s(_vm._f("ceilMod")(Number(_vm.dataPlay.xGf), 4)) +
                    "\n      "
                )
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  var __vue_inject_styles__$7 = function (inject) {
    if (!inject) { return }
    inject("data-v-3e9b1261_0", { source: ".soccer-chalkboard__header__switch[data-v-3e9b1261] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.soccer-chalkboard__header .has-vertical-divider.title[data-v-3e9b1261] {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.soccer-chalkboard[data-v-3e9b1261] {\n  position: relative;\n}\n.field[data-v-3e9b1261] {\n  display: inline-flex;\n  align-items: center;\n}\n.field .switch.is-rounded[data-v-3e9b1261] {\n  margin: 0px;\n}\n.field .control-label.left[data-v-3e9b1261] {\n  padding: 0;\n}\n.field .control-label.right[data-v-3e9b1261] {\n  padding-right: 5px;\n}\n.field.has-horizontal-divider[data-v-3e9b1261] {\n  width: 100%;\n}\n.field-title[data-v-3e9b1261] {\n  position: absolute;\n  left: 12px;\n}\nsvg[data-v-3e9b1261] {\n  width: 70%;\n  margin: 0 auto;\n  display: inline-block;\n}\n.perspective3d[data-v-3e9b1261] {\n  transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n  transform-style: preserve-3d;\n  animation: changePerspective3d-data-v-3e9b1261 0.1s;\n}\n.perspective2d[data-v-3e9b1261] {\n  animation: changePerspective2d-data-v-3e9b1261 0.1s;\n}\n@keyframes changePerspective3d-data-v-3e9b1261 {\n0% {\n    transform: perspective(700px) rotateX(0) translate3d(0, 0, 0);\n}\n20% {\n    transform: perspective(700px) rotateX(5deg) translate3d(0, -10px, 0);\n}\n40% {\n    transform: perspective(700px) rotateX(10deg) translate3d(0, -20px, 0);\n}\n60% {\n    transform: perspective(700px) rotateX(15deg) translate3d(0, -30px, 0);\n}\n80% {\n    transform: perspective(700px) rotateX(20deg) translate3d(0, -40px, 0);\n}\n100% {\n    transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n}\n}\n@keyframes changePerspective2d-data-v-3e9b1261 {\n0% {\n    transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n}\n20% {\n    transform: perspective(700px) rotateX(20deg) translate3d(0, -40px, 0);\n}\n40% {\n    transform: perspective(700px) rotateX(15deg) translate3d(0, -30px, 0);\n}\n60% {\n    transform: perspective(700px) rotateX(10deg) translate3d(0, -20px, 0);\n}\n80% {\n    transform: perspective(700px) rotateX(5deg) translate3d(0, -10px, 0);\n}\n100% {\n    transform: perspective(700px) rotateX(0) translate3d(0, 0, 0);\n}\n}\n.has-gray-background[data-v-3e9b1261] {\n  background: #f1f2f2;\n}\n.title[data-v-3e9b1261] {\n  font-family: \"Avenir-Demi\";\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  color: #5b5b5b;\n}\n.has-vertical-divider[data-v-3e9b1261] {\n  border-left: 1px solid #bebcbc;\n  margin: 1rem 0;\n}\n.has-horizontal-divider[data-v-3e9b1261] {\n  border-bottom: 1px solid #d7d7d7;\n}\n.has-gray-background[data-v-3e9b1261] {\n  background: #f1f2f2;\n}\n.is-pointer[data-v-3e9b1261] {\n  cursor: default;\n}\n.tooltip-data[data-v-3e9b1261] {\n  font-family: \"Avenir-Medium\";\n  font-size: 12px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2;\n  letter-spacing: normal;\n  color: #ffffff;\n}\n.tooltip-data .bold[data-v-3e9b1261] {\n  font-family: \"Avenir-Bold\";\n}\n\n/*# sourceMappingURL=SoccerChalkboard.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/SoccerChalkboard.vue","SoccerChalkboard.vue"],"names":[],"mappings":"AAsyBA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACryBA;ADuyBA;EACA,cAAA;EACA,iBAAA;ACryBA;AD0yBA;EACA,kBAAA;ACvyBA;AD0yBA;EACA,oBAAA;EACA,mBAAA;ACvyBA;ADwyBA;EACA,WAAA;ACtyBA;ADyyBA;EACA,UAAA;ACvyBA;ADyyBA;EACA,kBAAA;ACvyBA;AD0yBA;EACA,WAAA;ACxyBA;AD2yBA;EACA,kBAAA;EACA,UAAA;ACxyBA;AD0yBA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;ACvyBA;ADyyBA;EACA,qEAAA;EACA,4BAAA;EACA,mDAAA;ACtyBA;ADwyBA;EACA,mDAAA;ACryBA;ADwyBA;AACA;IACA,6DAAA;ACryBE;ADuyBF;IACA,oEAAA;ACryBE;ADuyBF;IACA,qEAAA;ACryBE;ADuyBF;IACA,qEAAA;ACryBE;ADuyBF;IACA,qEAAA;ACryBE;ADuyBF;IACA,qEAAA;ACryBE;AACF;ADwyBA;AACA;IACA,qEAAA;ACtyBE;ADwyBF;IACA,qEAAA;ACtyBE;ADwyBF;IACA,qEAAA;ACtyBE;ADwyBF;IACA,qEAAA;ACtyBE;ADwyBF;IACA,oEAAA;ACtyBE;ADwyBF;IACA,6DAAA;ACtyBE;AACF;ADwyBA;EACA,mBAAA;ACtyBA;ADwyBA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;ACryBA;ADuyBA;EACA,8BAAA;EACA,cAAA;ACpyBA;ADsyBA;EACA,gCAAA;ACnyBA;ADqyBA;EACA,mBAAA;AClyBA;ADoyBA;EACA,eAAA;ACjyBA;ADmyBA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AChyBA;ADkyBA;EACA,0BAAA;AC/xBA;;AAEA,+CAA+C","file":"SoccerChalkboard.vue","sourcesContent":["<template>\n  <section class=\"soccer-chalkboard\" ref=\"chalkboard\">\n    <div class=\"columns soccer-chalkboard__header\">\n      <div class=\"column is-8 soccer-chalkboard__header__switch\">\n        <span\n          v-if=\"isVisualizationTextVisible\"\n          class=\"control-label is-inline-flex is-pulled-left field-title\"\n        >\n          Visualización:\n        </span>\n        <div class=\"field\">\n          <span class=\"control-label right\">2D</span>\n          <BSwitch v-model=\"perspective\" passive-type=\"is-primary\"></BSwitch>\n          <span class=\"control-label left\">3D</span>\n        </div>\n      </div>\n      <div class=\"column is-4 has-vertical-divider title\">Categorías</div>\n    </div>\n    <div class=\"columns\">\n      <div class=\"column is-8 has-gray-background\">\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          :viewBox=\"chalkboardViewBox\"\n          xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n          class=\"soccer-chalkboard\"\n          :class=\"{ perspective3d: perspective, perspective2d: !perspective }\"\n        >\n          <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 452 684\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n            <!-- Flechas -->\n            <defs>\n              <marker\n                id=\"arrow-negative\"\n                viewBox=\"0 0 10 10\"\n                refX=\"5\"\n                refY=\"5\"\n                markerWidth=\"6\"\n                markerHeight=\"6\"\n                markerUnits=\"strokeWidth\"\n                orient=\"auto\"\n              >\n                <path d=\"M 0 0 L 10 5 L 0 10 z\" stroke-width=\"2\" fill=\"red\" />\n              </marker>\n              <marker\n                v-for=\"c in localCategories\"\n                :key=\"`arrow-color-${c.id}`\"\n                :id=\"`arrow-${c.id}`\"\n                viewBox=\"0 0 10 10\"\n                refX=\"5\"\n                refY=\"5\"\n                markerWidth=\"6\"\n                markerHeight=\"6\"\n                markerUnits=\"strokeWidth\"\n                orient=\"auto\"\n              >\n                <path d=\"M 0 0 L 10 5 L 0 10 z\" stroke-width=\"2\" :fill=\"c.color\" />\n              </marker>\n              <pattern id=\"fieldBackground\" width=\"1\" height=\"1\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"none\">\n                <image\n                  xlink:href=\"http://golstats-2-develop.azurewebsites.net/images/fieldbg.png\"\n                  width=\"100\"\n                  height=\"100\"\n                  preserveAspectRatio=\"none\"\n                  id=\"image2\"\n                />\n              </pattern>\n            </defs>\n            <!-- Cancha -->\n            <g id=\"soccer-field\">\n              <rect opacity=\".8\" height=\"684\" width=\"452\" fill=\"url(#fieldBackground)\" />\n              <g\n                id=\"g19\"\n                transform=\"matrix(1,0,0,0.96314115,0,12.524864)\"\n                stroke=\"#eeffee\"\n                fill=\"none\"\n                stroke-width=\"3\"\n              >\n                <path d=\"m 11.22,22.62 v 638.8 h 429.6 V 22.62 Z\" id=\"path4\" />\n                <path d=\"m 11.26,342 h 429.4\" id=\"path6\" />\n                <circle cy=\"342\" cx=\"226\" r=\"54.799999\" id=\"circle8\" />\n                <circle cy=\"342\" cx=\"226\" r=\"2\" id=\"circle10\" />\n                <g id=\"a\">\n                  <path\n                    d=\"m 9.9,30.07 c 4.85,0 8.82,-4 8.82,-8.9 m 162.5,100.8 a 54.91,54.91 0 0 0 89.6,0 m 76.3,-99.63 v\n                    99.63 h -242.2 l 0.2,-99.63 m 98.6,0.2 V 6.94 l 44.6,0.003 v 15.6 m -77.9,-0.2 v 34.4 h 111.2 v\n                    -34.4 m 160.5,7.7 c -4.9,0 -8.8,-4 -8.8,-8.9\"\n                    id=\"path12\"\n                  />\n                  <circle cy=\"90\" cx=\"226\" r=\"2\" id=\"circle14\" />\n                </g>\n                <use xlink:href=\"#a\" transform=\"scale(1,-1)\" y=\"-684\" x=\"0\" width=\"100%\" height=\"100%\" />\n              </g>\n            </g>\n            <!-- Jugadas de 3 puntos -->\n            <g v-for=\"play in plays3\" :key=\"play.id\" :id=\"`play-${play.playId}`\">\n              <line\n                :x1=\"`${play.x1}%`\"\n                :y1=\"`${play.y1}%`\"\n                :x2=\"`${play.x2}%`\"\n                :y2=\"`${play.y2}%`\"\n                :stroke=\"play.arrowColor\"\n                stroke-width=\"2\"\n              />\n              <line\n                :x1=\"`${play.x2}%`\"\n                :y1=\"`${play.y2}%`\"\n                :x2=\"`${play.x3}%`\"\n                :y2=\"`${play.y3}%`\"\n                :stroke=\"play.arrowColor\"\n                stroke-width=\"2\"\n                :marker-end=\"play.arrowMarkerColor\"\n              />\n              <g @mouseover=\"onMouseOver($event, play)\" @mouseleave=\"onMouseLeave\" class=\"is-pointer\">\n                <rect\n                  :x=\"`${play.x1}%`\"\n                  :y=\"`${play.y1}%`\"\n                  transform=\"translate(-11, -11)\"\n                  height=\"22\"\n                  width=\"22\"\n                  stroke-width=\"2\"\n                  fill=\"white\"\n                  :stroke=\"play.markerColor\"\n                  rx=\"4\"\n                  ry=\"4\"\n                />\n                <text\n                  text-anchor=\"middle\"\n                  dominant-baseline=\"middle\"\n                  :x=\"`${play.x1}%`\"\n                  :y=\"`${play.y1}%`\"\n                  dy=\"1\"\n                  font-size=\"12\"\n                  stroke=\"black\"\n                >\n                  {{ play.jersey }}\n                </text>\n              </g>\n            </g>\n            <!-- Jugadas de 2 puntos -->\n            <g v-for=\"play in plays2\" :key=\"play.id\" :id=\"`play-${play.playId}`\">\n              <line\n                :x1=\"`${play.x1}%`\"\n                :y1=\"`${play.y1}%`\"\n                :x2=\"`${play.x2}%`\"\n                :y2=\"`${play.y2}%`\"\n                stroke-width=\"2\"\n                :stroke=\"play.arrowColor\"\n                :marker-end=\"play.arrowMarkerColor\"\n              />\n              <g @mouseover=\"onMouseOver($event, play)\" @mouseleave=\"onMouseLeave\" class=\"is-pointer\">\n                <rect\n                  :x=\"`${play.x1}%`\"\n                  :y=\"`${play.y1}%`\"\n                  transform=\"translate(-10, -10)\"\n                  height=\"20\"\n                  width=\"20\"\n                  stroke-width=\"2\"\n                  fill=\"white\"\n                  :stroke=\"play.markerColor\"\n                  rx=\"4\"\n                  ry=\"4\"\n                />\n                <text\n                  text-anchor=\"middle\"\n                  dominant-baseline=\"middle\"\n                  :x=\"`${play.x1}%`\"\n                  :y=\"`${play.y1}%`\"\n                  dy=\"1\"\n                  font-size=\"12\"\n                  stroke=\"black\"\n                >\n                  {{ play.jersey }}\n                </text>\n              </g>\n            </g>\n            <!-- Jugadas de 1 punto -->\n            <g\n              v-for=\"play in plays1\"\n              :key=\"play.id\"\n              :id=\"`play-${play.playId}`\"\n              @mouseover=\"onMouseOver($event, play)\"\n              @mouseleave=\"onMouseLeave\"\n              class=\"is-pointer\"\n            >\n              <rect\n                :x=\"`${play.x1}%`\"\n                :y=\"`${play.y1}%`\"\n                transform=\"translate(-10, -10)\"\n                height=\"20\"\n                width=\"20\"\n                stroke-width=\"2\"\n                fill=\"white\"\n                :stroke=\"play.color\"\n                rx=\"4\"\n                ry=\"4\"\n              />\n              <text\n                text-anchor=\"middle\"\n                dominant-baseline=\"middle\"\n                :x=\"`${play.x1}%`\"\n                :y=\"`${play.y1}%`\"\n                dy=\"1\"\n                font-size=\"12\"\n                stroke=\"black\"\n              >\n                {{ play.jersey }}\n              </text>\n            </g>\n          </svg>\n          <svg>\n            <defs>\n              <marker\n                id=\"arrow-gray\"\n                viewBox=\"0 0 10 10\"\n                refX=\"5\"\n                refY=\"5\"\n                markerWidth=\"6\"\n                markerHeight=\"6\"\n                markerUnits=\"strokeWidth\"\n                orient=\"auto\"\n              >\n                <path d=\"M 0 0 L 10 5 L 0 10 z\" stroke-width=\"2\" fill=\"#c9c8c8\" />\n              </marker>\n            </defs>\n            <line x1=\"482\" y1=\"600\" x2=\"482\" y2=\"200\" stroke=\"#c9c8c8\" stroke-width=\"3\" marker-end=\"url(#arrow-gray)\" />\n          </svg>\n        </svg>\n        <div v-if=\"istotalXgfVisible\">xG acumulado: {{ totalXgf | ceilMod }}</div>\n        <div>Eventos totales: {{ totalPlays }}</div>\n      </div>\n      <div class=\"column is-4 has-text-left\">\n        <div class=\"field has-horizontal-divider\" v-for=\"category in localCategories\" :key=\"`category-${category.id}`\">\n          <BCheckbox\n            :native-value=\"category.id\"\n            v-model=\"selectedPlays\"\n            :name=\"category.name\"\n            @change.native=\"onClickCategory\"\n            >{{ category.name }}</BCheckbox\n          >\n        </div>\n        <div atributo=\"atributo\" class=\"field\">\n          <BButton type=\"is-primary\" expanded @click=\"onClickSelectAll\">{{\n            isFullCategoriesSelected ? 'Deseleccionar Todo' : 'Seleccionar Todo'\n          }}</BButton>\n        </div>\n      </div>\n    </div>\n    <Tooltip :data=\"data\">\n      <div class=\"tooltip-data has-text-left\">\n        <div><span class=\"bold\">Categoría:</span> {{ dataPlay.isOwnGoal ? 'Autogol' : dataPlay.categoryName }}</div>\n        <div v-if=\"sectionType === 'team'\"><span class=\"bold\">Jugador:</span> {{ dataPlay.playerName }}</div>\n        <div><span class=\"bold\">Minuto:</span> {{ dataPlay.minute }}</div>\n        <div>\n          <span class=\"bold\">Rival:</span> {{ dataPlay.rivalName }}\n          <img :src=\"dataPlay.rivalLogo\" width=\"25\" style=\"vertical-align:middle;\" />\n        </div>\n        <div\n          v-if=\"/^[+]?([0-1]+(?:[\\.][0-9]*)?|\\.[0-9]+)$/.test(dataPlay.xGi) && dataPlay.xGi <= 1 && !dataPlay.isOwnGoal\"\n        >\n          <span class=\"bold\">xGi:</span> {{ Number(dataPlay.xGi) | ceilMod(4) }}\n        </div>\n        <div\n          v-if=\"/^[+]?([0-1]+(?:[\\.][0-9]*)?|\\.[0-9]+)$/.test(dataPlay.xGf) && dataPlay.xGf <= 1 && !dataPlay.isOwnGoal\"\n        >\n          <span class=\"bold\">xGf:</span> {{ Number(dataPlay.xGf) | ceilMod(4) }}\n        </div>\n      </div>\n    </Tooltip>\n  </section>\n</template>\n\n<script>\nimport { mapGetters, mapMutations, mapState } from 'vuex';\n\nimport _ from 'lodash';\nimport Tooltip from './Tooltip.vue';\n\nexport default {\n  name: 'SoccerChalkboard',\n  props: {\n    plays: {\n      type: Array,\n      require: true,\n    },\n    categories: {\n      type: Array,\n      required: true,\n    },\n    players: {\n      type: Array,\n      required: true,\n    },\n    games: {\n      type: Array,\n      required: false,\n    },\n    team: {\n      type: Number,\n      default: 0,\n    },\n    playValuesIndex: {\n      type: Object,\n      required: true,\n    },\n    analysisType: {\n      type: String,\n      required: false,\n    },\n    // Possible values: 'team' or 'player'\n    sectionType: {\n      type: String,\n      required: true,\n    },\n  },\n  components: {\n    Tooltip,\n  },\n  data() {\n    return {\n      selectedPlays: [],\n      negativeColor: 'red',\n      perspective: true,\n      data: {\n        x: 0,\n        y: 0,\n        visible: false,\n      },\n      dataPlay: {\n        playerName: '',\n        minute: 0,\n        rivalLogo: '',\n        categoryName: '',\n        xGi: 0,\n        xGf: 0,\n        isOwnGoal: false,\n      },\n      initialSelectedOptions: {\n        team: {\n          offensive: [0],\n          defensive: [6],\n        },\n        player: {\n          offensive: [],\n          defensive: [0, 1, 2, 4],\n        },\n        goalkeeper: {\n          offensive: [],\n          defensive: [1],\n        },\n      },\n      isVisualizationTextVisible: false,\n    };\n  },\n  mounted() {\n    if (this.sectionType === 'team') {\n      this.updatePlayer({});\n    }\n    let initialOptions = [];\n    if (this.player.position_id !== 1) {\n      initialOptions = [...this.initialSelectedOptions[this.sectionType][this.analysisType]];\n    } else {\n      initialOptions = [...this.initialSelectedOptions.goalkeeper[this.analysisType]];\n    }\n    this.selectedPlays = initialOptions.length ? initialOptions : this.localCategories.map((c) => c.id);\n    this.setUpResizeObserver();\n  },\n  watch: {\n    perspective(newValue) {\n      const view = newValue ? '3D' : '2D';\n      this.$emit('changePerspective', view);\n    },\n  },\n  computed: {\n    ...mapGetters('playerProfileGeneral', ['player']),\n    ...mapState('playerProfileGlobal', ['windowWidth']),\n\n    categoriesWithXg() {\n      if (this.sectionType === 'team') {\n        return [0, 1, 2];\n      } if (this.player.position_id === 1) {\n        return [];\n      }\n      return [0, 3, 4];\n    },\n\n    chalkboardViewBox() {\n      return this.windowWidth > 384 ? '0 0 490 684' : '0 0 490 784';\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description Metodo para convertir el arreglo de jugadas en un json, para trabajarlo con las demas jugadas, por si cambia la estructura o posicion de los elementos\n     */\n    preparedPlays() {\n      return this.plays.map((p) => ({\n        playId: p[this.playValuesIndex.playId],\n        gameId: p[this.playValuesIndex.gameId],\n        teamId: p[this.playValuesIndex.teamId],\n        playerId: p[this.playValuesIndex.playerId],\n        momentOfPlay: p[this.playValuesIndex.momentOfPlay],\n        categoryId: p[this.playValuesIndex.categoryId],\n        categoryType: p[this.playValuesIndex.categoryType],\n        matchLapse: p[this.playValuesIndex.matchLapse],\n        section: p[this.playValuesIndex.section],\n        matchResult: p[this.playValuesIndex.matchResult],\n        playingAs: p[this.playValuesIndex.playingAs],\n        total: p[this.playValuesIndex.total],\n        x1: p[this.playValuesIndex.coordinate1X] * 100,\n        y1: p[this.playValuesIndex.coordinate1Y] * 100,\n        x2: p[this.playValuesIndex.coordinate2X] * 100,\n        y2: p[this.playValuesIndex.coordinate2Y] * 100,\n        x3: p[this.playValuesIndex.coordinate3X] * 100,\n        y3: p[this.playValuesIndex.coordinate3Y] * 100,\n        xGi: p[this.playValuesIndex.xGi],\n        xGf: p[this.playValuesIndex.xGf],\n      }));\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description Metodo para obtener todas las categorias, determinar de cuantos puntos le corresponden, asi como asignar los colres, puntos y categorias golstats\n     */\n    localCategories() {\n      return this.categories.map((c, i) => ({\n        id: i,\n        name: c.name,\n        negative: c.negative || false,\n        color: c.color,\n        points: c.points,\n        numPoints: c.points.length,\n        categories: c.categories,\n        invert: c.invert || [],\n      }));\n    },\n    /**\n     * @author Cristhian Gómez\n     * @description Variable computada que devuelve un booleano dependiendo si todas ñas categorias estan seleccionadas\n     */\n    isFullCategoriesSelected() {\n      return this.selectedPlays.length == this.localCategories.length;\n    },\n    /**\n     * @author Rigoberto Sanchez\n     * @description Metodo para obtener las categorias correspondientes a 1 punto\n     */\n    categoriesPlays1() {\n      return Array.from(new Set(\n        this.localCategories\n          .filter((c) => c.numPoints === 1)\n          .map((c) => c.categories)\n          .flat(),\n      ));\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description Metodo para obtener las categorias correspondientes a 2 puntos\n     */\n    categoriesPlays2() {\n      return Array.from(new Set(\n        this.localCategories\n          .filter((c) => c.numPoints === 2)\n          .map((c) => c.categories)\n          .flat()\n      ));\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description Metodo para obtener las categorias correspondientes a 3 puntos\n     */\n    categoriesPlays3() {\n      return Array.from(new Set(\n        this.localCategories\n          .filter((c) => c.numPoints === 3)\n          .map((c) => c.categories)\n          .flat(),\n      ));\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description  Metodo para calcular las jugadas que son de 1 punto, se obtienen las jugadas de la propiedad \"plays\", y se crea un array con las jugadas correspondientes.\n     */\n    plays1() {\n      const categories = this.categoriesPlays1;\n      const selected = this.selectedPlays;\n      let plays = this.preparedPlays\n        .filter((p) => this.findCategoryInPlay(categories, p))\n        .reduce((accumulator, p) => {\n          const category = this.localCategories.find((c) => this.findCategoryInPlay(c.categories, p));\n          const player = this.players.find((i) => i.player_id === p.playerId);\n          const game = this.games.find((game) => game.gameId === p.gameId);\n          if (category && player && game) {\n            const result = {\n              category: category.id,\n              categoryName: category.name,\n              color: category.color,\n              playId: p.playId,\n              player: p.playerId,\n              playerName: player ? player.name : '',\n              jersey: player ? player.jersey : '',\n              matchlapse: p.matchLapse,\n              x1: category.invert.includes(p.categoryId)\n                ? 100 - p[`x${category.points[0]}`]\n                : p[`x${category.points[0]}`],\n              y1: category.invert.includes(p.categoryId)\n                ? 100 - p[`y${category.points[0]}`]\n                : p[`y${category.points[0]}`],\n              momentOfPlay: p.momentOfPlay,\n              rivalLogo: this.getRivalLogo(game, p),\n              rivalName: this.getRivalName(game, p),\n            };\n\n            if (this.analysisType === 'offensive' && this.categoriesWithXg.includes(category.id)) {\n              result.xGi = p.xGi;\n              result.xGf = p.xGf;\n            }\n\n            accumulator.push(result);\n          }\n          return accumulator;\n        }, []);\n      return plays.filter((p) => selected.includes(p.category));\n\n      // return plays.filter(p => selected.includes(p.category));\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description  Metodo para calcular las jugadas que son de 2 puntos, se obtienen las jugadas de la propiedad \"plays\", y se crea un array con las jugadas correspondientes.\n     */\n    plays2() {\n      const categories = this.categoriesPlays2;\n      const selected = this.selectedPlays;\n      const plays = this.preparedPlays\n        .filter((p) => this.findCategoryInPlay(categories, p))\n        .reduce((accumulator, p) => {\n          const category = this.localCategories.find((c) => this.findCategoryInPlay(c.categories, p));\n          const player = this.players.find((i) => i.player_id === p.playerId);\n          const game = this.games.find((g) => (g ? g.gameId === p.gameId : undefined));\n          if (category && player && game) {\n            const result = {\n              category: category.id,\n              categoryName: category.name,\n              arrowColor: category.negative ? this.negativeColor : category.color,\n              arrowMarkerColor: category.negative ? 'url(#arrow-negative)' : `url(#arrow-${category.id})`,\n              markerColor: category.color,\n              playId: p.playId,\n              player: p.playerId,\n              playerName: player ? player.name : '',\n              jersey: player ? player.jersey : '',\n              matchlapse: p.matchLapse,\n              x1: category.invert.includes(p.categoryId)\n                ? 100 - p[`x${category.points[0]}`]\n                : p[`x${category.points[0]}`],\n              y1: category.invert.includes(p.categoryId)\n                ? 100 - p[`y${category.points[0]}`]\n                : p[`y${category.points[0]}`],\n              x2: category.invert.includes(p.categoryId)\n                ? 100 - p[`x${category.points[1]}`]\n                : p[`x${category.points[1]}`],\n              y2: category.invert.includes(p.categoryId)\n                ? 100 - p[`y${category.points[1]}`]\n                : p[`y${category.points[1]}`],\n              momentOfPlay: p.momentOfPlay,\n              rivalLogo: this.getRivalLogo(game, p),\n              rivalName: this.getRivalName(game, p),\n            };\n\n            if (this.analysisType === 'offensive' && this.categoriesWithXg.includes(category.id)) {\n              result.xGi = p.xGi;\n              result.xGf = p.xGf;\n            }\n\n            accumulator.push(result);\n          }\n          return accumulator;\n        }, []);\n      return plays.filter((p) => selected.includes(p.category));\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description Metodo para calcular las jugadas que son de 3 puntos, se obtienen las jugadas de la propiedad \"plays\", y se crea un array con las jugadas correspondientes.\n     */\n    plays3() {\n      const categories = this.categoriesPlays3;\n      const selected = this.selectedPlays;\n      const plays = this.preparedPlays\n        .filter((p) => {\n          const result = this.findCategoryInPlay(categories, p);\n          return result;\n        })\n        .reduce((accumulator, p) => {\n          const category = this.localCategories.find((c) => this.findCategoryInPlay(c.categories, p));\n          const player = this.players.find((i) => i.player_id === p.playerId);\n          const game = this.games.find((g) => (g ? g.gameId === p.gameId : undefined));\n          if (category && player && game) {\n            const result = {\n              category: category.id,\n              categoryName: category.name,\n              arrowColor: category.negative ? this.negativeColor : category.color,\n              arrowMarkerColor: category.negative ? 'url(#arrow-negative)' : `url(#arrow-${category.id})`,\n              markerColor: category.color,\n              playId: p.playId,\n              player: p.playerId,\n              playerName: player ? player.name : '',\n              jersey: player ? player.jersey : '',\n              matchlapse: p.matchLapse,\n              x1: category.invert.includes(p.categoryId)\n                ? 100 - p[`x${category.points[0]}`]\n                : p[`x${category.points[0]}`],\n              y1: category.invert.includes(p.categoryId)\n                ? 100 - p[`y${category.points[0]}`]\n                : p[`y${category.points[0]}`],\n              x2: category.invert.includes(p.categoryId)\n                ? 100 - p[`x${category.points[1]}`]\n                : p[`x${category.points[1]}`],\n              y2: category.invert.includes(p.categoryId)\n                ? 100 - p[`y${category.points[1]}`]\n                : p[`y${category.points[1]}`],\n              x3: category.invert.includes(p.categoryId)\n                ? 100 - p[`x${category.points[2]}`]\n                : p[`x${category.points[2]}`],\n              y3: category.invert.includes(p.categoryId)\n                ? 100 - p[`y${category.points[2]}`]\n                : p[`y${category.points[2]}`],\n              momentOfPlay: p.momentOfPlay,\n              rivalLogo: this.getRivalLogo(game, p),\n              rivalName: this.getRivalName(game, p),\n            };\n            if (category.id === 0 && this.analysisType === 'offensive' && p.teamId) {\n              result.isOwnGoal = this.team !== p.teamId;\n            } else if (category.id === 0 && this.analysisType === 'defensive' && p.teamId) {\n              result.isOwnGoal = this.team === p.teamId;\n            } else {\n              result.isOwnGoal = false;\n            }\n\n            if (this.analysisType === 'offensive' && this.categoriesWithXg.includes(category.id)) {\n              result.xGi = p.xGi;\n              result.xGf = p.xGf;\n            }\n\n            accumulator.push(result);\n          }\n          return accumulator;\n        }, []);\n      return plays.filter((p) => selected.includes(p.category));\n    },\n\n    /**\n     * @author Fernando Mellone\n     * @description propiedad que determina si el xGf acumulado es visible.\n     */\n    istotalXgfVisible() {\n      return this.selectedPlays.some((play) => this.categoriesWithXg.includes(play)) && this.analysisType === 'offensive';\n    },\n\n    /**\n     * @author Fernando Mellone\n     * @description propiedad que calcula el xGf total a mostrarse en pantalla.\n     */\n    totalXgf() {\n      const playsByMoment1 = _.groupBy(this.plays1, 'momentOfPlay');\n      const playsByMoment2 = _.groupBy(this.plays2, 'momentOfPlay');\n      const playsByMoment3 = _.groupBy(this.plays3, 'momentOfPlay');\n\n      const allPlays = { ...playsByMoment1, ...playsByMoment2, ...playsByMoment3 };\n\n      let acc = 0;\n\n      Object.entries(allPlays).forEach((play) => {\n        if (this.categoriesWithXg.includes(play[1][0].category) && !play.isOwnGoal) acc += Number(play[1][0].xGf);\n      });\n\n      return acc;\n    },\n\n    totalPlays() {\n      const playsByMoment1 = _.groupBy(this.plays1, 'momentOfPlay');\n      const playsByMoment2 = _.groupBy(this.plays2, 'momentOfPlay');\n      const playsByMoment3 = _.groupBy(this.plays3, 'momentOfPlay');\n\n      const plays1Qty = Object.keys(playsByMoment1).length;\n      const plays2Qty = Object.keys(playsByMoment2).length;\n      const plays3Qty = Object.keys(playsByMoment3).length;\n\n      const total = plays1Qty + plays2Qty + plays3Qty;\n\n      return total;\n    },\n  },\n  methods: {\n    ...mapMutations('playerProfileGeneral', ['updatePlayer']),\n    setUpResizeObserver() {\n      if (window.ResizeObserver) {\n        const resizeObserver = new ResizeObserver(() => {\n          this.isVisualizationTextVisible =\n            this.$refs.chalkboard && this.$refs.chalkboard.clientWidth > 524;\n        });\n        resizeObserver.observe(this.$refs.chalkboard);\n      } else {\n        throw new Error('Resize observer not supported!');\n      }\n    },\n    /**\n     * @author Alejandro\n     * @description There are some categories in format categoryId and r, e.g. 35_r, these categories\n     * with _r are rival plays. So these method look for those plays an compare it's team id.\n     * @param {Array} categories\n     * @param {Object} play\n     */\n    findCategoryInPlay(categories, play) {\n      return categories.find((category) => {\n        let categoryAux = 0;\n        if (typeof category === 'string') {\n          if (play.teamId) {\n            categoryAux = Number(category.split('_').shift());\n            return categoryAux === play.categoryId && play.teamId !== this.team;\n          }\n        } else {\n          // Team plays has a teamId, player plays not.\n          return play.teamId ? category === play.categoryId && this.team === play.teamId : category === play.categoryId;\n        }\n        return false;\n      });\n    },\n    getRivalLogo(game, play) {\n      if (this.sectionType === 'team') {\n        return game.homeTeamId === this.team ? game.visitingTeamLogo : game.homeTeamLogo;\n      }\n      return play.playingAs === 1 ? game.visitingTeamLogo : game.homeTeamLogo;\n    },\n    getRivalName(game, play) {\n      if (this.sectionType === 'team') {\n        return game.homeTeamId === this.team ? game.visitingTeamName : game.homeTeamName;\n      }\n      return play.playingAs === 1 ? game.visitingTeamName : game.homeTeamName;\n    },\n    /**\n     * @author Rigoberto Sanchez, Cristhian Gómez\n     * @description Metodo para cuando el usuario desea seleccionar todos los elementos, se agregan al elemento \"selectedPlays\",\n     * en caso de que esten todas las categorías seleccionados el método limpiará todas las categorías.\n     */\n    onClickSelectAll() {\n      if (!this.isFullCategoriesSelected) {\n        this.selectedPlays = this.localCategories.map((i) => i.id);\n      } else {\n        this.selectedPlays = [];\n      }\n      this.$emit('changeSelectAll', this.isFullCategoriesSelected);\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description Metodo para obtener los datos correspondientes a la jugada y mostrarlos en el tooltip\n     */\n    onMouseOver(event, play) {\n      const chalkboardBounds = this.$refs.chalkboard.getBoundingClientRect();\n      const modalXPosition = event.clientX - chalkboardBounds.x + 35;\n      this.dataPlay.playerName = play.playerName || '';\n      this.dataPlay.minute = parseInt(play.momentOfPlay.split(':')[0]) || '';\n      this.dataPlay.rivalLogo = play.rivalLogo || '';\n      this.dataPlay.rivalName = play.rivalName || '';\n      this.dataPlay.categoryName = play.categoryName || '';\n      this.dataPlay.xGi = String(play.xGi);\n      this.dataPlay.xGf = String(play.xGf);\n      this.dataPlay.isOwnGoal = play.isOwnGoal;\n      this.data.x =\n        modalXPosition+ 350 > this.$refs.chalkboard.clientWidth\n          ? this.$refs.chalkboard.clientWidth - 350 < 55\n          ? 55\n          : this.$refs.chalkboard.clientWidth - 350\n          : modalXPosition;\n      this.data.y = chalkboardBounds.y < 0 ? event.clientY + (-1 * chalkboardBounds.y) : event.clientY - chalkboardBounds.y;\n      this.data.y += 80;\n      this.data.visible = true;\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @description Metodo para indicar que el usuario ha salido del elemento y dejar de mostrar el tooltip\n     */\n    onMouseLeave() {\n      this.data.visible = false;\n    },\n\n    /**\n     * @author Rigoberto Sanchez\n     * @descripcion Emit event when change category\n     */\n    onClickCategory(value) {\n      this.$emit('changeCategory', {\n        name: value.target.name,\n        checked: value.target.checked,\n      });\n    },\n  },\n};\n</script>\n\n<style lang=\"scss\" scoped>\n.soccer-chalkboard {\n  //margin-bottom: 1.5rem;\n  &__header {\n    &__switch {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    & .has-vertical-divider.title {\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n  }\n}\n\n.soccer-chalkboard {\n  position: relative;\n}\n\n.field {\n  display: inline-flex;\n  align-items: center;\n  .switch.is-rounded {\n    margin: 0px;\n  }\n  .control-label {\n    &.left {\n      padding: 0;\n    }\n    &.right {\n      padding-right: 5px;\n    }\n  }\n  &.has-horizontal-divider {\n    width: 100%;\n  }\n}\n.field-title {\n  position: absolute;\n  left: 12px;\n}\nsvg {\n  width: 70%;\n  margin: 0 auto;\n  display: inline-block;\n}\n.perspective3d {\n  transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n  transform-style: preserve-3d;\n  animation: changePerspective3d 0.1s;\n}\n.perspective2d {\n  animation: changePerspective2d 0.1s;\n}\n\n@keyframes changePerspective3d {\n  0% {\n    transform: perspective(700px) rotateX(0) translate3d(0, 0, 0);\n  }\n  20% {\n    transform: perspective(700px) rotateX(5deg) translate3d(0, -10px, 0);\n  }\n  40% {\n    transform: perspective(700px) rotateX(10deg) translate3d(0, -20px, 0);\n  }\n  60% {\n    transform: perspective(700px) rotateX(15deg) translate3d(0, -30px, 0);\n  }\n  80% {\n    transform: perspective(700px) rotateX(20deg) translate3d(0, -40px, 0);\n  }\n  100% {\n    transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n  }\n}\n\n@keyframes changePerspective2d {\n  0% {\n    transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n  }\n  20% {\n    transform: perspective(700px) rotateX(20deg) translate3d(0, -40px, 0);\n  }\n  40% {\n    transform: perspective(700px) rotateX(15deg) translate3d(0, -30px, 0);\n  }\n  60% {\n    transform: perspective(700px) rotateX(10deg) translate3d(0, -20px, 0);\n  }\n  80% {\n    transform: perspective(700px) rotateX(5deg) translate3d(0, -10px, 0);\n  }\n  100% {\n    transform: perspective(700px) rotateX(0) translate3d(0, 0, 0);\n  }\n}\n.has-gray-background {\n  background: #f1f2f2;\n}\n.title {\n  font-family: 'Avenir-Demi';\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  color: #5b5b5b;\n}\n.has-vertical-divider {\n  border-left: 1px solid #bebcbc;\n  margin: 1rem 0;\n}\n.has-horizontal-divider {\n  border-bottom: 1px solid #d7d7d7;\n}\n.has-gray-background {\n  background: #f1f2f2;\n}\n.is-pointer {\n  cursor: default;\n}\n.tooltip-data {\n  font-family: 'Avenir-Medium';\n  font-size: 12px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2;\n  letter-spacing: normal;\n  color: #ffffff;\n}\n.tooltip-data .bold {\n  font-family: 'Avenir-Bold';\n}\n</style>\n",".soccer-chalkboard__header__switch {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.soccer-chalkboard__header .has-vertical-divider.title {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.soccer-chalkboard {\n  position: relative;\n}\n\n.field {\n  display: inline-flex;\n  align-items: center;\n}\n.field .switch.is-rounded {\n  margin: 0px;\n}\n.field .control-label.left {\n  padding: 0;\n}\n.field .control-label.right {\n  padding-right: 5px;\n}\n.field.has-horizontal-divider {\n  width: 100%;\n}\n\n.field-title {\n  position: absolute;\n  left: 12px;\n}\n\nsvg {\n  width: 70%;\n  margin: 0 auto;\n  display: inline-block;\n}\n\n.perspective3d {\n  transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n  transform-style: preserve-3d;\n  animation: changePerspective3d 0.1s;\n}\n\n.perspective2d {\n  animation: changePerspective2d 0.1s;\n}\n\n@keyframes changePerspective3d {\n  0% {\n    transform: perspective(700px) rotateX(0) translate3d(0, 0, 0);\n  }\n  20% {\n    transform: perspective(700px) rotateX(5deg) translate3d(0, -10px, 0);\n  }\n  40% {\n    transform: perspective(700px) rotateX(10deg) translate3d(0, -20px, 0);\n  }\n  60% {\n    transform: perspective(700px) rotateX(15deg) translate3d(0, -30px, 0);\n  }\n  80% {\n    transform: perspective(700px) rotateX(20deg) translate3d(0, -40px, 0);\n  }\n  100% {\n    transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n  }\n}\n@keyframes changePerspective2d {\n  0% {\n    transform: perspective(700px) rotateX(25deg) translate3d(0, -50px, 0);\n  }\n  20% {\n    transform: perspective(700px) rotateX(20deg) translate3d(0, -40px, 0);\n  }\n  40% {\n    transform: perspective(700px) rotateX(15deg) translate3d(0, -30px, 0);\n  }\n  60% {\n    transform: perspective(700px) rotateX(10deg) translate3d(0, -20px, 0);\n  }\n  80% {\n    transform: perspective(700px) rotateX(5deg) translate3d(0, -10px, 0);\n  }\n  100% {\n    transform: perspective(700px) rotateX(0) translate3d(0, 0, 0);\n  }\n}\n.has-gray-background {\n  background: #f1f2f2;\n}\n\n.title {\n  font-family: \"Avenir-Demi\";\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  color: #5b5b5b;\n}\n\n.has-vertical-divider {\n  border-left: 1px solid #bebcbc;\n  margin: 1rem 0;\n}\n\n.has-horizontal-divider {\n  border-bottom: 1px solid #d7d7d7;\n}\n\n.has-gray-background {\n  background: #f1f2f2;\n}\n\n.is-pointer {\n  cursor: default;\n}\n\n.tooltip-data {\n  font-family: \"Avenir-Medium\";\n  font-size: 12px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2;\n  letter-spacing: normal;\n  color: #ffffff;\n}\n\n.tooltip-data .bold {\n  font-family: \"Avenir-Bold\";\n}\n\n/*# sourceMappingURL=SoccerChalkboard.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$7 = "data-v-3e9b1261";
  /* module identifier */
  var __vue_module_identifier__$7 = undefined;
  /* functional template */
  var __vue_is_functional_template__$7 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$6 = {
  name: 'Ball',
  props: {
    play: {
      type: Object,
      require: true,
    },
  },
  computed: {
    /**
     * Id string to apply gradient.
     * @return String
     */
    idGradient: function idGradient() {
      var gradientId;
      switch (this.play.st) {
        case 'st1g':
          gradientId = 'green';
          break;
        case 'st1y':
          gradientId = 'yellow';
          break;
        case 'st1r':
          gradientId = 'red';
          break;
        case 'st1b':
          gradientId = 'blue';
          break;
      }
      return gradientId;
    },
    /**
     * Output Coordinate X
     * @return Number
     */
    // eslint-disable-next-line vue/return-in-computed-property
    x: function x() {
      if (this.isLeftArea) {
        return this.play.x * 2.66666666667 * 58 - 135;
      }
      if (this.isLeftPost) {
        return -57;
      }
      if (this.isGoalArea) {
        return (this.play.x - 0.391) * 4.31034482759 * 637 - 37;
      }
      if (this.isRightPost) {
        return 620;
      }
      if (this.isRightArea) {
        return (this.play.x - 0.639) * 2.77008310249 * 65 + 640;
      }
    },
    /**
     * Output Coordinate Y
     * @return Number
     */
    y: function y() {
      if (this.isSuperiorPost) {
        return 128;
      }
      return 340 - this.play.y * 1371.42857143;
    },
    /**
     * Coordinate X
     * @return {boolean|boolean}
     */
    isLeftArea: function isLeftArea() {
      return this.play.x >= 0 && this.play.x < 0.3738;
    },
    /**
     * Coordinate X
     * @return {boolean|boolean}
     */
    isLeftPost: function isLeftPost() {
      return this.play.x >= 0.3738 && this.play.x <= 0.3822;
    },
    /**
     * Coordinate X
     * @return {boolean|boolean}
     */
    isGoalArea: function isGoalArea() {
      return this.play.x > 0.3822 && this.play.x < 0.6232;
    },
    /**
     * Coordinate X
     * @return {boolean|boolean}
     */
    isRightPost: function isRightPost() {
      return this.play.x >= 0.6232 && this.play.x <= 0.6266;
    },
    /**
     * Coordinate X
     * @return {boolean|boolean}
     */
    isRightArea: function isRightArea() {
      return this.play.x > 0.6266 && this.play.x <= 1;
    },
    /**
     * Coordinate Y
     * @return {boolean|boolean}
     */
    isSuperiorPost: function isSuperiorPost() {
      return this.play.x >= 0.3738 && this.play.x <= 0.6266 && this.play.y >= 0.1384 && this.play.y <= 0.1442;
    },
  },
  methods: {
    /**
     * To show tooltip
     * @param event
     * @return void
     */
    onMouseOver: function onMouseOver(event) {
      var dataTooltip = {
        x: this.x < 350 ? event.pageX + 35 : event.pageX - 220,
        y: event.clientY,
        playerName: this.play.playerName,
        minute: parseInt(this.play.time.split(':')[0]) || '',
        rivalName: this.play.rivalName,
        rivalLogo: this.play.rivalLogo,
      };
      this.$emit('showTooltip', dataTooltip);
    },
    /**
     * To hide tooltip
     * @return void
     */
    onMouseLeave: function onMouseLeave() {
      this.$emit('hideTooltip');
    },
  },
};

/* script */
var __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 450.2 478.3" },
      attrs: {
        version: "1.1",
        id: "ball",
        "xmlns:cc": "http://creativecommons.org/ns#",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
        "xmlns:svg": "http://www.w3.org/2000/svg",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: _vm.x,
        y: _vm.y,
        viewBox: "0 0 6753 7174.5",
        "xml:space": "preserve"
      },
      on: {
        mouseover: function($event) {
          return _vm.onMouseOver($event)
        },
        mouseleave: function($event) {
          return _vm.onMouseLeave()
        }
      }
    },
    [
      _c(
        "g",
        { attrs: { id: "layer1", transform: "translate(-236.97 -366.48)" } },
        [
          _c(
            "radialGradient",
            {
              attrs: {
                id: "path3382_1_",
                cx: "634.4189",
                cy: "565.0641",
                r: "245.83",
                gradientTransform:
                  "matrix(0.8383 0 0 -0.8383 -54.3704 1036.0054)",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#6A6A6A" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#000000" },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st0",
            attrs: {
              id: "path3382",
              d:
                "M687.1,609.6c0,124.3-100.8,225.1-225.1,225.1C337.8,834.7,237,733.8,237,609.6c0-124.2,\n                                            100.8-225.1,225.1-225.1C586.3,384.5,687.1,485.3,687.1,609.6L687.1,609.6z"
            }
          }),
          _vm._v(" "),
          _c(
            "radialGradient",
            {
              attrs: {
                id: _vm.idGradient,
                cx: "548.4",
                cy: "-234.391",
                r: "225.06",
                gradientTransform: "matrix(1 0 0 -1.0001 -69.79 333.8919)",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                style: { "stop-color": _vm.play.category_color },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                style: { "stop-color": _vm.play.category_color },
                attrs: { offset: "0.4702" }
              }),
              _vm._v(" "),
              _c("stop", {
                style: {
                  "stop-color": _vm.play.category_color,
                  "stop-opacity": 0.3
                },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            class: _vm.play.st,
            attrs: {
              id: "path3400",
              d:
                "M462,384.5c-49.1,0-94.6,15.8-131.6,42.5c-16.1,19.5-27.4,39-27.4,39l-20.6,7.9c-28.6,37.7-45.5,84.8-45.5,\n      135.7c0,4.8,0.1,9.5,0.4,14.2c5.1,9.1,8.9,15,8.9,15l-2.6,25.7c14.7,58.7,52.5,108.2,103.1,138.5c3.6,2.3,6.6,3.8,\n      10,5.6c-1.8-1.7-2.3-2.1-3.5-3.2c-13.3-13.7-24.4-29.7-24.4-29.7l32-29.5c0,0,20.6,15.6,43.7,23.6c23.1,8.1,48.8,\n      8.6,48.8,8.6l15.9,40.8c0,0-14,7.2-33.9,10.7c-3.6,0.6-7.3,1.1-11.1,1.6c12.3,2.1,24.9,3.2,37.8,3.2c52,0,100-17.7,\n      138.1-47.4c11.9-16,19.8-29.7,19.8-29.7l17.4-6.8c30.8-38.2,49.4-86.7,\n      49.8-139.5c-6.1-18.2-12.8-28.8-12.8-28.8s1.7-16.6-0.7-34.8c-0.4-2.9,1.5-1.8,\n      3.9-3.4c-0.7-2.6-3.2-10.3-4.5-14c-5-14.5-9.8-21.4-13-27.8c6.2,3.5,0,0,0,0C\n      621.8,432.1,547.5,384.5,462,384.5L462,384.5z M489.3,393c18.7,0.3,38.2,6.3,38.2,6.3s22.2,8.5,38,20.6c15.8,12,\n      25.3,27.6,25.3,27.6l-40.3,27.8c0,0-21.7-14.9-44.3-22.9c-22.6-8-46.3-9.1-46.3-9.1l-11.4-41.5c0,0,17.3-8.1,\n      37-8.7C486.8,393,488,393,489.3,393z M357.7,504.2c13.8,0.1,25.3,1.7,25.3,1.7l20.8,88.4L337,658c0,\n      0-20.9-13.2-35.9-26.2c-15-13-24.3-25.6-24.3-25.6s2.7-25.7,8.8-47.7c6.1-22.1,15.7-40.5,15.7-40.5s16.5-9.5,\n      36.9-12.5C344.7,504.5,351.4,504.2,357.7,504.2L357.7,504.2z M574.3,567.4c0,0,18.8,8.3,34,20.4c15.2,12.2,26.8,\n      28.2,26.8,28.2s-1.1,22-8.3,44.9c-7.3,22.9-20.7,46.6-20.7,46.6s-18.8,6.9-38.6,8.8c-19.8,\n      1.9-40.7-1.3-40.7-1.3l-10.3-43.3l-10.7-44.5c0,0,14.1-17,31.3-32S574.3,567.4,574.3,567.4z"
            }
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "path3514_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "596.1016",
                y1: "-315.9783",
                x2: "713.7116",
                y2: "-337.8783",
                gradientTransform:
                  "matrix(0.9741 0 0 -0.9741 -62.0851 327.3514)"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#000000" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#000000", "stop-opacity": "0" },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st2",
            attrs: {
              id: "path3514",
              d:
                "M633.4,616.7c0,0-1,21.4-8.1,43.7s-20.2,45.4-20.2,45.4s-18.3,6.7-37.6,8.5\n      c-19.3,1.8-39.6-1.3-39.6-1.3l-10.1-42.2l-10.4-43.3c0,0,13.8-16.6,\n      30.5-31.2c16.7-14.6,36.3-27,36.3-27s18.3,8.1,33.2,19.9\n      C622.1,601.1,633.4,616.7,633.4,616.7z"
            }
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "path3516_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "474.3954",
                y1: "-276.598",
                x2: "362.5253",
                y2: "-232.698",
                gradientTransform:
                  "matrix(0.9748 0 0 -0.9748 -68.0912 325.9843)"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#000000" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#000000", "stop-opacity": "0" },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st3",
            attrs: {
              id: "path3516",
              d:
                "M337.1,656.1c0,0-20.3-12.9-35-25.5c-14.7-12.6-23.6-25-23.6-25s2.6-25,8.6-46.5\n      c6-21.5,15.3-39.5,15.3-39.5s16.1-9.3,36-12.2c19.9-2.9,43.6,0.5,43.6,0.5l20.3,86.2L337.1,656.1z"
            }
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "path3518_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "630.8148",
                y1: "-175.4575",
                x2: "652.1248",
                y2: "-105.1275",
                gradientTransform:
                  "matrix(0.8784 0 0 -0.8784 -39.7857 278.0769)"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#333333" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#000000", "stop-opacity": "0" },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st4",
            attrs: {
              id: "path3518",
              d:
                "M526.5,403.6c0,0,19.5,7.5,33.4,18.1c13.9,10.6,22.2,24.2,22.2,24.2l-35.4,\n      24.4c0,0-19-13-38.9-20.1s-47.7-9.8-47.7-9.8l-9.3-36.8c0,0,19.4-6.8,36.7-7.3C504.9,\n      395.8,526.5,403.6,526.5,403.6L526.5,403.6z"
            }
          }),
          _vm._v("\n    />\n    "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3479", d: "M382,507.1c0,0,36.2-48.1,78.4-64.3" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st6",
            attrs: { id: "path3506", d: "M552.8,474.1c0,0,27,42.9,23.5,91.9" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3481", d: "M550.4,474.6c0,0,27.6,44.4,24.1,93.4" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3483", d: "M587.8,447.3c0,0,59.8,23.6,86,98.3" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3485", d: "M635.4,615.9c0,0,21-1.6,39.4-32.8" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3487", d: "M620.4,757.3c0,0,2.9-18.1-14.5-51" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3489", d: "M453.7,778.9c0,0,32.4-8.6,73.4-65.1" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3491", d: "M336.8,657.2c0,0-2,50.4,23.2,90" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3493", d: "M328.9,775.9c0,0-7.4,0.1-35.5-16.8" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3495", d: "M277.3,606.1c0,0-20.1,8.5-31,31.9" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3497", d: "M302.7,466.3c0,0-7.2,27.9-1,51.4" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3499", d: "M326.9,430.6c0,0,60-50.9,121.2-28.3" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: {
              id: "path3501",
              d: "M469.1,819.2c0,0,52.4,13.5,133.2-34.2"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st7",
            attrs: { id: "path3504", d: "M382.2,503.5c0,0,30.1-41.5,74.3-61.3" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st8",
            attrs: { id: "path3508", d: "M454.5,780.7c0,0,30.8-6,71.8-62.5" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st8",
            attrs: { id: "path3510", d: "M334.8,658.3c0,0-1.9,50.4,23.2,90" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st9",
            attrs: { id: "path2453", d: "M404.4,594.6c0,0,26.3,6.2,101.3,32.7" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st10",
            attrs: { id: "path3260", d: "M404.4,593.3c0,0,26.3,6.2,101.3,32.7" }
          })
        ],
        1
      )
    ]
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  var __vue_inject_styles__$6 = function (inject) {
    if (!inject) { return }
    inject("data-v-1984ba73_0", { source: "\n.st0[data-v-1984ba73] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#path3382_1_);\n}\n.st1r[data-v-1984ba73] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#red);\n}\n.st1g[data-v-1984ba73] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#green);\n}\n.st1b[data-v-1984ba73] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#blue);\n}\n.st1y[data-v-1984ba73] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#yellow);\n}\n.st2[data-v-1984ba73] {\n  fill: none;\n  stroke: url(#path3514_1_);\n  stroke-width: 4.8705;\n  stroke-linejoin: round;\n}\n.st3[data-v-1984ba73] {\n  fill: none;\n  stroke: url(#path3516_1_);\n  stroke-width: 4.874;\n  stroke-linejoin: round;\n}\n.st4[data-v-1984ba73] {\n  fill: none;\n  stroke: url(#path3518_1_);\n  stroke-width: 5.0158;\n}\n.st5[data-v-1984ba73] {\n  fill: none;\n  stroke: #666666;\n}\n.st6[data-v-1984ba73] {\n  fill: none;\n  stroke: #ececec;\n  stroke-width: 3;\n}\n.st7[data-v-1984ba73] {\n  fill: none;\n  stroke: #f2f2f2;\n  stroke-width: 3;\n  stroke-linecap: square;\n}\n.st8[data-v-1984ba73] {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 3;\n}\n.st9[data-v-1984ba73] {\n  fill: none;\n  stroke: #999999;\n}\n.st10[data-v-1984ba73] {\n  fill: none;\n  stroke: #ececec;\n}\n", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/Ball.vue"],"names":[],"mappings":";AA8RA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACA;AACA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;AACA;AACA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AACA;AACA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;AACA","file":"Ball.vue","sourcesContent":["<template>\n  <svg\n    @mouseover=\"onMouseOver($event)\"\n    @mouseleave=\"onMouseLeave()\"\n    version=\"1.1\"\n    id=\"ball\"\n    xmlns:cc=\"http://creativecommons.org/ns#\"\n    xmlns:dc=\"http://purl.org/dc/elements/1.1/\"\n    xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"\n    xmlns:svg=\"http://www.w3.org/2000/svg\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    :x=\"x\"\n    :y=\"y\"\n    viewBox=\"0 0 6753 7174.5\"\n    style=\"enable-background:new 0 0 450.2 478.3;\"\n    xml:space=\"preserve\"\n  >\n    <g id=\"layer1\" transform=\"translate(-236.97 -366.48)\">\n      <radialGradient\n        id=\"path3382_1_\"\n        cx=\"634.4189\"\n        cy=\"565.0641\"\n        r=\"245.83\"\n        gradientTransform=\"matrix(0.8383 0 0 -0.8383 -54.3704 1036.0054)\"\n        gradientUnits=\"userSpaceOnUse\"\n      >\n        <stop offset=\"0\" style=\"stop-color:#6A6A6A\" />\n        <stop offset=\"1\" style=\"stop-color:#000000\" />\n      </radialGradient>\n      <path\n        id=\"path3382\"\n        class=\"st0\"\n        d=\"M687.1,609.6c0,124.3-100.8,225.1-225.1,225.1C337.8,834.7,237,733.8,237,609.6c0-124.2,\n                                              100.8-225.1,225.1-225.1C586.3,384.5,687.1,485.3,687.1,609.6L687.1,609.6z\"\n      />\n\n      <radialGradient\n        :id=\"idGradient\"\n        cx=\"548.4\"\n        cy=\"-234.391\"\n        r=\"225.06\"\n        gradientTransform=\"matrix(1 0 0 -1.0001 -69.79 333.8919)\"\n        gradientUnits=\"userSpaceOnUse\"\n      >\n        <stop offset=\"0\" :style=\"{ 'stop-color': play.category_color }\" />\n        <stop offset=\"0.4702\" :style=\"{ 'stop-color': play.category_color }\" />\n        <stop offset=\"1\" :style=\"{ 'stop-color': play.category_color, 'stop-opacity': 0.3 }\" />\n      </radialGradient>\n      <path\n        id=\"path3400\"\n        :class=\"play.st\"\n        d=\"M462,384.5c-49.1,0-94.6,15.8-131.6,42.5c-16.1,19.5-27.4,39-27.4,39l-20.6,7.9c-28.6,37.7-45.5,84.8-45.5,\n        135.7c0,4.8,0.1,9.5,0.4,14.2c5.1,9.1,8.9,15,8.9,15l-2.6,25.7c14.7,58.7,52.5,108.2,103.1,138.5c3.6,2.3,6.6,3.8,\n        10,5.6c-1.8-1.7-2.3-2.1-3.5-3.2c-13.3-13.7-24.4-29.7-24.4-29.7l32-29.5c0,0,20.6,15.6,43.7,23.6c23.1,8.1,48.8,\n        8.6,48.8,8.6l15.9,40.8c0,0-14,7.2-33.9,10.7c-3.6,0.6-7.3,1.1-11.1,1.6c12.3,2.1,24.9,3.2,37.8,3.2c52,0,100-17.7,\n        138.1-47.4c11.9-16,19.8-29.7,19.8-29.7l17.4-6.8c30.8-38.2,49.4-86.7,\n        49.8-139.5c-6.1-18.2-12.8-28.8-12.8-28.8s1.7-16.6-0.7-34.8c-0.4-2.9,1.5-1.8,\n        3.9-3.4c-0.7-2.6-3.2-10.3-4.5-14c-5-14.5-9.8-21.4-13-27.8c6.2,3.5,0,0,0,0C\n        621.8,432.1,547.5,384.5,462,384.5L462,384.5z M489.3,393c18.7,0.3,38.2,6.3,38.2,6.3s22.2,8.5,38,20.6c15.8,12,\n        25.3,27.6,25.3,27.6l-40.3,27.8c0,0-21.7-14.9-44.3-22.9c-22.6-8-46.3-9.1-46.3-9.1l-11.4-41.5c0,0,17.3-8.1,\n        37-8.7C486.8,393,488,393,489.3,393z M357.7,504.2c13.8,0.1,25.3,1.7,25.3,1.7l20.8,88.4L337,658c0,\n        0-20.9-13.2-35.9-26.2c-15-13-24.3-25.6-24.3-25.6s2.7-25.7,8.8-47.7c6.1-22.1,15.7-40.5,15.7-40.5s16.5-9.5,\n        36.9-12.5C344.7,504.5,351.4,504.2,357.7,504.2L357.7,504.2z M574.3,567.4c0,0,18.8,8.3,34,20.4c15.2,12.2,26.8,\n        28.2,26.8,28.2s-1.1,22-8.3,44.9c-7.3,22.9-20.7,46.6-20.7,46.6s-18.8,6.9-38.6,8.8c-19.8,\n        1.9-40.7-1.3-40.7-1.3l-10.3-43.3l-10.7-44.5c0,0,14.1-17,31.3-32S574.3,567.4,574.3,567.4z\"\n      />\n\n      <linearGradient\n        id=\"path3514_1_\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"596.1016\"\n        y1=\"-315.9783\"\n        x2=\"713.7116\"\n        y2=\"-337.8783\"\n        gradientTransform=\"matrix(0.9741 0 0 -0.9741 -62.0851 327.3514)\"\n      >\n        <stop offset=\"0\" style=\"stop-color:#000000\" />\n        <stop offset=\"1\" style=\"stop-color:#000000;stop-opacity:0\" />\n      </linearGradient>\n      <path\n        id=\"path3514\"\n        class=\"st2\"\n        d=\"M633.4,616.7c0,0-1,21.4-8.1,43.7s-20.2,45.4-20.2,45.4s-18.3,6.7-37.6,8.5\n        c-19.3,1.8-39.6-1.3-39.6-1.3l-10.1-42.2l-10.4-43.3c0,0,13.8-16.6,\n        30.5-31.2c16.7-14.6,36.3-27,36.3-27s18.3,8.1,33.2,19.9\n        C622.1,601.1,633.4,616.7,633.4,616.7z\"\n      />\n\n      <linearGradient\n        id=\"path3516_1_\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"474.3954\"\n        y1=\"-276.598\"\n        x2=\"362.5253\"\n        y2=\"-232.698\"\n        gradientTransform=\"matrix(0.9748 0 0 -0.9748 -68.0912 325.9843)\"\n      >\n        <stop offset=\"0\" style=\"stop-color:#000000\" />\n        <stop offset=\"1\" style=\"stop-color:#000000;stop-opacity:0\" />\n      </linearGradient>\n      <path\n        id=\"path3516\"\n        class=\"st3\"\n        d=\"M337.1,656.1c0,0-20.3-12.9-35-25.5c-14.7-12.6-23.6-25-23.6-25s2.6-25,8.6-46.5\n        c6-21.5,15.3-39.5,15.3-39.5s16.1-9.3,36-12.2c19.9-2.9,43.6,0.5,43.6,0.5l20.3,86.2L337.1,656.1z\"\n      />\n\n      <linearGradient\n        id=\"path3518_1_\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"630.8148\"\n        y1=\"-175.4575\"\n        x2=\"652.1248\"\n        y2=\"-105.1275\"\n        gradientTransform=\"matrix(0.8784 0 0 -0.8784 -39.7857 278.0769)\"\n      >\n        <stop offset=\"0\" style=\"stop-color:#333333\" />\n        <stop offset=\"1\" style=\"stop-color:#000000;stop-opacity:0\" />\n      </linearGradient>\n      <path\n        id=\"path3518\"\n        class=\"st4\"\n        d=\"M526.5,403.6c0,0,19.5,7.5,33.4,18.1c13.9,10.6,22.2,24.2,22.2,24.2l-35.4,\n        24.4c0,0-19-13-38.9-20.1s-47.7-9.8-47.7-9.8l-9.3-36.8c0,0,19.4-6.8,36.7-7.3C504.9,\n        395.8,526.5,403.6,526.5,403.6L526.5,403.6z\"\n      />\n      />\n      <path id=\"path3479\" class=\"st5\" d=\"M382,507.1c0,0,36.2-48.1,78.4-64.3\" />\n      <path id=\"path3506\" class=\"st6\" d=\"M552.8,474.1c0,0,27,42.9,23.5,91.9\" />\n      <path id=\"path3481\" class=\"st5\" d=\"M550.4,474.6c0,0,27.6,44.4,24.1,93.4\" />\n      <path id=\"path3483\" class=\"st5\" d=\"M587.8,447.3c0,0,59.8,23.6,86,98.3\" />\n      <path id=\"path3485\" class=\"st5\" d=\"M635.4,615.9c0,0,21-1.6,39.4-32.8\" />\n      <path id=\"path3487\" class=\"st5\" d=\"M620.4,757.3c0,0,2.9-18.1-14.5-51\" />\n      <path id=\"path3489\" class=\"st5\" d=\"M453.7,778.9c0,0,32.4-8.6,73.4-65.1\" />\n      <path id=\"path3491\" class=\"st5\" d=\"M336.8,657.2c0,0-2,50.4,23.2,90\" />\n      <path id=\"path3493\" class=\"st5\" d=\"M328.9,775.9c0,0-7.4,0.1-35.5-16.8\" />\n      <path id=\"path3495\" class=\"st5\" d=\"M277.3,606.1c0,0-20.1,8.5-31,31.9\" />\n      <path id=\"path3497\" class=\"st5\" d=\"M302.7,466.3c0,0-7.2,27.9-1,51.4\" />\n      <path id=\"path3499\" class=\"st5\" d=\"M326.9,430.6c0,0,60-50.9,121.2-28.3\" />\n      <path id=\"path3501\" class=\"st5\" d=\"M469.1,819.2c0,0,52.4,13.5,133.2-34.2\" />\n      <path id=\"path3504\" class=\"st7\" d=\"M382.2,503.5c0,0,30.1-41.5,74.3-61.3\" />\n      <path id=\"path3508\" class=\"st8\" d=\"M454.5,780.7c0,0,30.8-6,71.8-62.5\" />\n      <path id=\"path3510\" class=\"st8\" d=\"M334.8,658.3c0,0-1.9,50.4,23.2,90\" />\n      <path id=\"path2453\" class=\"st9\" d=\"M404.4,594.6c0,0,26.3,6.2,101.3,32.7\" />\n      <path id=\"path3260\" class=\"st10\" d=\"M404.4,593.3c0,0,26.3,6.2,101.3,32.7\" />\n    </g>\n  </svg>\n</template>\n\n<script>\nexport default {\n  name: 'Ball',\n  props: {\n    play: {\n      type: Object,\n      require: true,\n    },\n  },\n  computed: {\n    /**\n     * Id string to apply gradient.\n     * @return String\n     */\n    idGradient() {\n      let gradientId;\n      switch (this.play.st) {\n        case 'st1g':\n          gradientId = 'green';\n          break;\n        case 'st1y':\n          gradientId = 'yellow';\n          break;\n        case 'st1r':\n          gradientId = 'red';\n          break;\n        case 'st1b':\n          gradientId = 'blue';\n          break;\n      }\n      return gradientId;\n    },\n    /**\n     * Output Coordinate X\n     * @return Number\n     */\n    // eslint-disable-next-line vue/return-in-computed-property\n    x() {\n      if (this.isLeftArea) {\n        return this.play.x * 2.66666666667 * 58 - 135;\n      }\n      if (this.isLeftPost) {\n        return -57;\n      }\n      if (this.isGoalArea) {\n        return (this.play.x - 0.391) * 4.31034482759 * 637 - 37;\n      }\n      if (this.isRightPost) {\n        return 620;\n      }\n      if (this.isRightArea) {\n        return (this.play.x - 0.639) * 2.77008310249 * 65 + 640;\n      }\n    },\n    /**\n     * Output Coordinate Y\n     * @return Number\n     */\n    y() {\n      if (this.isSuperiorPost) {\n        return 128;\n      }\n      return 340 - this.play.y * 1371.42857143;\n    },\n    /**\n     * Coordinate X\n     * @return {boolean|boolean}\n     */\n    isLeftArea() {\n      return this.play.x >= 0 && this.play.x < 0.3738;\n    },\n    /**\n     * Coordinate X\n     * @return {boolean|boolean}\n     */\n    isLeftPost() {\n      return this.play.x >= 0.3738 && this.play.x <= 0.3822;\n    },\n    /**\n     * Coordinate X\n     * @return {boolean|boolean}\n     */\n    isGoalArea() {\n      return this.play.x > 0.3822 && this.play.x < 0.6232;\n    },\n    /**\n     * Coordinate X\n     * @return {boolean|boolean}\n     */\n    isRightPost() {\n      return this.play.x >= 0.6232 && this.play.x <= 0.6266;\n    },\n    /**\n     * Coordinate X\n     * @return {boolean|boolean}\n     */\n    isRightArea() {\n      return this.play.x > 0.6266 && this.play.x <= 1;\n    },\n    /**\n     * Coordinate Y\n     * @return {boolean|boolean}\n     */\n    isSuperiorPost() {\n      return this.play.x >= 0.3738 && this.play.x <= 0.6266 && this.play.y >= 0.1384 && this.play.y <= 0.1442;\n    },\n  },\n  methods: {\n    /**\n     * To show tooltip\n     * @param event\n     * @return void\n     */\n    onMouseOver(event) {\n      let dataTooltip = {\n        x: this.x < 350 ? event.pageX + 35 : event.pageX - 220,\n        y: event.clientY,\n        playerName: this.play.playerName,\n        minute: parseInt(this.play.time.split(':')[0]) || '',\n        rivalName: this.play.rivalName,\n        rivalLogo: this.play.rivalLogo,\n      };\n      this.$emit('showTooltip', dataTooltip);\n    },\n    /**\n     * To hide tooltip\n     * @return void\n     */\n    onMouseLeave() {\n      this.$emit('hideTooltip');\n    },\n  },\n};\n</script>\n\n<style scoped>\n.st0 {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#path3382_1_);\n}\n.st1r {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#red);\n}\n.st1g {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#green);\n}\n.st1b {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#blue);\n}\n.st1y {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#yellow);\n}\n.st2 {\n  fill: none;\n  stroke: url(#path3514_1_);\n  stroke-width: 4.8705;\n  stroke-linejoin: round;\n}\n.st3 {\n  fill: none;\n  stroke: url(#path3516_1_);\n  stroke-width: 4.874;\n  stroke-linejoin: round;\n}\n.st4 {\n  fill: none;\n  stroke: url(#path3518_1_);\n  stroke-width: 5.0158;\n}\n.st5 {\n  fill: none;\n  stroke: #666666;\n}\n.st6 {\n  fill: none;\n  stroke: #ececec;\n  stroke-width: 3;\n}\n.st7 {\n  fill: none;\n  stroke: #f2f2f2;\n  stroke-width: 3;\n  stroke-linecap: square;\n}\n.st8 {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 3;\n}\n.st9 {\n  fill: none;\n  stroke: #999999;\n}\n.st10 {\n  fill: none;\n  stroke: #ececec;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$6 = "data-v-1984ba73";
  /* module identifier */
  var __vue_module_identifier__$6 = undefined;
  /* functional template */
  var __vue_is_functional_template__$6 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$5 = {
  name: 'IconBall',
  props: {
    color: {
      type: String,
      required: true,
    },
    st: {
      type: String,
      required: true,
    },
  },
  computed: {
    idGradient: function idGradient() {
      var gradientId;
      switch (this.st) {
        case 'st1g':
          gradientId = 'green';
          break;
        case 'st1y':
          gradientId = 'yellow';
          break;
        case 'st1r':
          gradientId = 'red';
          break;
        case 'st1b':
          gradientId = 'blue';
          break;
      }
      return gradientId;
    },
  },
};

/* script */
var __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 450.2 478.3" },
      attrs: {
        version: "1.1",
        id: "svg2385",
        "xmlns:cc": "http://creativecommons.org/ns#",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
        "xmlns:svg": "http://www.w3.org/2000/svg",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 450.2 478.3",
        "xml:space": "preserve"
      }
    },
    [
      _c(
        "g",
        { attrs: { id: "layer1", transform: "translate(-236.97 -366.48)" } },
        [
          _c(
            "radialGradient",
            {
              attrs: {
                id: "path3382_1_",
                cx: "634.4189",
                cy: "565.0641",
                r: "245.83",
                gradientTransform:
                  "matrix(0.8383 0 0 -0.8383 -54.3704 1036.0054)",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#6A6A6A" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#000000" },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st0",
            attrs: {
              id: "path3382",
              d:
                "M687.1,609.6c0,124.3-100.8,225.1-225.1,225.1C337.8,834.7,237,733.8,237,609.6\n\t\tc0-124.2,100.8-225.1,225.1-225.1C586.3,384.5,687.1,485.3,687.1,609.6L687.1,609.6z"
            }
          }),
          _vm._v(" "),
          _c(
            "radialGradient",
            {
              attrs: {
                id: _vm.idGradient,
                cx: "548.4",
                cy: "-234.391",
                r: "225.06",
                gradientTransform: "matrix(1 0 0 -1.0001 -69.79 333.8919)",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                style: { "stop-color": _vm.color },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                style: { "stop-color": _vm.color },
                attrs: { offset: "0.4702" }
              }),
              _vm._v(" "),
              _c("stop", {
                style: { "stop-color": _vm.color, "stop-opacity": 0.3 },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            class: _vm.st,
            attrs: {
              id: "path3400",
              d:
                "M462,384.5c-49.1,0-94.6,15.8-131.6,42.5c-16.1,19.5-27.4,39-27.4,39l-20.6,7.9\n\t\tc-28.6,37.7-45.5,84.8-45.5,135.7c0,4.8,0.1,9.5,0.4,14.2c5.1,9.1,8.9,15,8.9,15l-2.6,25.7c14.7,58.7,52.5,108.2,103.1,138.5\n\t\tc3.6,2.3,6.6,3.8,10,5.6c-1.8-1.7-2.3-2.1-3.5-3.2c-13.3-13.7-24.4-29.7-24.4-29.7l32-29.5c0,0,20.6,15.6,43.7,23.6\n\t\tc23.1,8.1,48.8,8.6,48.8,8.6l15.9,40.8c0,0-14,7.2-33.9,10.7c-3.6,0.6-7.3,1.1-11.1,1.6c12.3,2.1,24.9,3.2,37.8,3.2\n\t\tc52,0,100-17.7,138.1-47.4c11.9-16,19.8-29.7,19.8-29.7l17.4-6.8c30.8-38.2,49.4-86.7,49.8-139.5c-6.1-18.2-12.8-28.8-12.8-28.8\n\t\ts1.7-16.6-0.7-34.8c-0.4-2.9,1.5-1.8,3.9-3.4c-0.7-2.6-3.2-10.3-4.5-14c-5-14.5-9.8-21.4-13-27.8c6.2,3.5,0,0,0,0\n\t\tC621.8,432.1,547.5,384.5,462,384.5L462,384.5z M489.3,393c18.7,0.3,38.2,6.3,38.2,6.3s22.2,8.5,38,20.6\n\t\tc15.8,12,25.3,27.6,25.3,27.6l-40.3,27.8c0,0-21.7-14.9-44.3-22.9c-22.6-8-46.3-9.1-46.3-9.1l-11.4-41.5c0,0,17.3-8.1,37-8.7\n\t\tC486.8,393,488,393,489.3,393z M357.7,504.2c13.8,0.1,25.3,1.7,25.3,1.7l20.8,88.4L337,658c0,0-20.9-13.2-35.9-26.2\n\t\tc-15-13-24.3-25.6-24.3-25.6s2.7-25.7,8.8-47.7c6.1-22.1,15.7-40.5,15.7-40.5s16.5-9.5,36.9-12.5\n\t\tC344.7,504.5,351.4,504.2,357.7,504.2L357.7,504.2z M574.3,567.4c0,0,18.8,8.3,34,20.4c15.2,12.2,26.8,28.2,26.8,28.2\n\t\ts-1.1,22-8.3,44.9c-7.3,22.9-20.7,46.6-20.7,46.6s-18.8,6.9-38.6,8.8c-19.8,1.9-40.7-1.3-40.7-1.3l-10.3-43.3l-10.7-44.5\n\t\tc0,0,14.1-17,31.3-32S574.3,567.4,574.3,567.4z"
            }
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "path3514_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "596.1016",
                y1: "-315.9783",
                x2: "713.7116",
                y2: "-337.8783",
                gradientTransform:
                  "matrix(0.9741 0 0 -0.9741 -62.0851 327.3514)"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#000000" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#000000", "stop-opacity": "0" },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st2",
            attrs: {
              id: "path3514",
              d:
                "M633.4,616.7c0,0-1,21.4-8.1,43.7s-20.2,45.4-20.2,45.4s-18.3,6.7-37.6,8.5\n\t\tc-19.3,1.8-39.6-1.3-39.6-1.3l-10.1-42.2l-10.4-43.3c0,0,13.8-16.6,30.5-31.2c16.7-14.6,36.3-27,36.3-27s18.3,8.1,33.2,19.9\n\t\tC622.1,601.1,633.4,616.7,633.4,616.7z"
            }
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "path3516_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "474.3954",
                y1: "-276.598",
                x2: "362.5253",
                y2: "-232.698",
                gradientTransform:
                  "matrix(0.9748 0 0 -0.9748 -68.0912 325.9843)"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#000000" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#000000", "stop-opacity": "0" },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st3",
            attrs: {
              id: "path3516",
              d:
                "M337.1,656.1c0,0-20.3-12.9-35-25.5c-14.7-12.6-23.6-25-23.6-25s2.6-25,8.6-46.5\n\t\tc6-21.5,15.3-39.5,15.3-39.5s16.1-9.3,36-12.2c19.9-2.9,43.6,0.5,43.6,0.5l20.3,86.2L337.1,656.1z"
            }
          }),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "path3518_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "630.8148",
                y1: "-175.4575",
                x2: "652.1248",
                y2: "-105.1275",
                gradientTransform:
                  "matrix(0.8784 0 0 -0.8784 -39.7857 278.0769)"
              }
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#333333" },
                attrs: { offset: "0" }
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#000000", "stop-opacity": "0" },
                attrs: { offset: "1" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st4",
            attrs: {
              id: "path3518",
              d:
                "M526.5,403.6c0,0,19.5,7.5,33.4,18.1c13.9,10.6,22.2,24.2,22.2,24.2l-35.4,24.4\n\t\tc0,0-19-13-38.9-20.1s-47.7-9.8-47.7-9.8l-9.3-36.8c0,0,19.4-6.8,36.7-7.3C504.9,395.8,526.5,403.6,526.5,403.6L526.5,403.6z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3479", d: "M382,507.1c0,0,36.2-48.1,78.4-64.3" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st6",
            attrs: { id: "path3506", d: "M552.8,474.1c0,0,27,42.9,23.5,91.9" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3481", d: "M550.4,474.6c0,0,27.6,44.4,24.1,93.4" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3483", d: "M587.8,447.3c0,0,59.8,23.6,86,98.3" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3485", d: "M635.4,615.9c0,0,21-1.6,39.4-32.8" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3487", d: "M620.4,757.3c0,0,2.9-18.1-14.5-51" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3489", d: "M453.7,778.9c0,0,32.4-8.6,73.4-65.1" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3491", d: "M336.8,657.2c0,0-2,50.4,23.2,90" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3493", d: "M328.9,775.9c0,0-7.4,0.1-35.5-16.8" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3495", d: "M277.3,606.1c0,0-20.1,8.5-31,31.9" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3497", d: "M302.7,466.3c0,0-7.2,27.9-1,51.4" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: { id: "path3499", d: "M326.9,430.6c0,0,60-50.9,121.2-28.3" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st5",
            attrs: {
              id: "path3501",
              d: "M469.1,819.2c0,0,52.4,13.5,133.2-34.2"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st7",
            attrs: { id: "path3504", d: "M382.2,503.5c0,0,30.1-41.5,74.3-61.3" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st8",
            attrs: { id: "path3508", d: "M454.5,780.7c0,0,30.8-6,71.8-62.5" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st8",
            attrs: { id: "path3510", d: "M334.8,658.3c0,0-1.9,50.4,23.2,90" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st9",
            attrs: { id: "path2453", d: "M404.4,594.6c0,0,26.3,6.2,101.3,32.7" }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st10",
            attrs: { id: "path3260", d: "M404.4,593.3c0,0,26.3,6.2,101.3,32.7" }
          })
        ],
        1
      )
    ]
  )
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  var __vue_inject_styles__$5 = function (inject) {
    if (!inject) { return }
    inject("data-v-18bce334_0", { source: "\n.st0[data-v-18bce334] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#path3382_1_);\n}\n.st1r[data-v-18bce334] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#red);\n}\n.st1g[data-v-18bce334] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#green);\n}\n.st1b[data-v-18bce334] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#blue);\n}\n.st1y[data-v-18bce334] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#yellow);\n}\n.st2[data-v-18bce334] {\n  fill: none;\n  stroke: url(#path3514_1_);\n  stroke-width: 4.8705;\n  stroke-linejoin: round;\n}\n.st3[data-v-18bce334] {\n  fill: none;\n  stroke: url(#path3516_1_);\n  stroke-width: 4.874;\n  stroke-linejoin: round;\n}\n.st4[data-v-18bce334] {\n  fill: none;\n  stroke: url(#path3518_1_);\n  stroke-width: 5.0158;\n}\n.st5[data-v-18bce334] {\n  fill: none;\n  stroke: #666666;\n}\n.st6[data-v-18bce334] {\n  fill: none;\n  stroke: #ececec;\n  stroke-width: 3;\n}\n.st7[data-v-18bce334] {\n  fill: none;\n  stroke: #f2f2f2;\n  stroke-width: 3;\n  stroke-linecap: square;\n}\n.st8[data-v-18bce334] {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 3;\n}\n.st9[data-v-18bce334] {\n  fill: none;\n  stroke: #999999;\n}\n.st10[data-v-18bce334] {\n  fill: none;\n  stroke: #ececec;\n}\n", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/IconBall.vue"],"names":[],"mappings":";AAqLA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AACA;AACA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACA;AACA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;AACA;AACA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AACA;AACA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;AACA;AACA;EACA,UAAA;EACA,eAAA;AACA","file":"IconBall.vue","sourcesContent":["<template>\n  <svg\n    version=\"1.1\"\n    id=\"svg2385\"\n    xmlns:cc=\"http://creativecommons.org/ns#\"\n    xmlns:dc=\"http://purl.org/dc/elements/1.1/\"\n    xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"\n    xmlns:svg=\"http://www.w3.org/2000/svg\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 450.2 478.3\"\n    style=\"enable-background:new 0 0 450.2 478.3;\"\n    xml:space=\"preserve\"\n  >\n    <g id=\"layer1\" transform=\"translate(-236.97 -366.48)\">\n      <radialGradient\n        id=\"path3382_1_\"\n        cx=\"634.4189\"\n        cy=\"565.0641\"\n        r=\"245.83\"\n        gradientTransform=\"matrix(0.8383 0 0 -0.8383 -54.3704 1036.0054)\"\n        gradientUnits=\"userSpaceOnUse\"\n      >\n        <stop offset=\"0\" style=\"stop-color:#6A6A6A\" />\n        <stop offset=\"1\" style=\"stop-color:#000000\" />\n      </radialGradient>\n      <path\n        id=\"path3382\"\n        class=\"st0\"\n        d=\"M687.1,609.6c0,124.3-100.8,225.1-225.1,225.1C337.8,834.7,237,733.8,237,609.6\n\t\tc0-124.2,100.8-225.1,225.1-225.1C586.3,384.5,687.1,485.3,687.1,609.6L687.1,609.6z\"\n      />\n\n      <radialGradient\n        :id=\"idGradient\"\n        cx=\"548.4\"\n        cy=\"-234.391\"\n        r=\"225.06\"\n        gradientTransform=\"matrix(1 0 0 -1.0001 -69.79 333.8919)\"\n        gradientUnits=\"userSpaceOnUse\"\n      >\n        <stop offset=\"0\" :style=\"{ 'stop-color': color }\" />\n        <stop offset=\"0.4702\" :style=\"{ 'stop-color': color }\" />\n        <stop offset=\"1\" :style=\"{ 'stop-color': color, 'stop-opacity': 0.3 }\" />\n      </radialGradient>\n      <path\n        id=\"path3400\"\n        :class=\"st\"\n        d=\"M462,384.5c-49.1,0-94.6,15.8-131.6,42.5c-16.1,19.5-27.4,39-27.4,39l-20.6,7.9\n\t\tc-28.6,37.7-45.5,84.8-45.5,135.7c0,4.8,0.1,9.5,0.4,14.2c5.1,9.1,8.9,15,8.9,15l-2.6,25.7c14.7,58.7,52.5,108.2,103.1,138.5\n\t\tc3.6,2.3,6.6,3.8,10,5.6c-1.8-1.7-2.3-2.1-3.5-3.2c-13.3-13.7-24.4-29.7-24.4-29.7l32-29.5c0,0,20.6,15.6,43.7,23.6\n\t\tc23.1,8.1,48.8,8.6,48.8,8.6l15.9,40.8c0,0-14,7.2-33.9,10.7c-3.6,0.6-7.3,1.1-11.1,1.6c12.3,2.1,24.9,3.2,37.8,3.2\n\t\tc52,0,100-17.7,138.1-47.4c11.9-16,19.8-29.7,19.8-29.7l17.4-6.8c30.8-38.2,49.4-86.7,49.8-139.5c-6.1-18.2-12.8-28.8-12.8-28.8\n\t\ts1.7-16.6-0.7-34.8c-0.4-2.9,1.5-1.8,3.9-3.4c-0.7-2.6-3.2-10.3-4.5-14c-5-14.5-9.8-21.4-13-27.8c6.2,3.5,0,0,0,0\n\t\tC621.8,432.1,547.5,384.5,462,384.5L462,384.5z M489.3,393c18.7,0.3,38.2,6.3,38.2,6.3s22.2,8.5,38,20.6\n\t\tc15.8,12,25.3,27.6,25.3,27.6l-40.3,27.8c0,0-21.7-14.9-44.3-22.9c-22.6-8-46.3-9.1-46.3-9.1l-11.4-41.5c0,0,17.3-8.1,37-8.7\n\t\tC486.8,393,488,393,489.3,393z M357.7,504.2c13.8,0.1,25.3,1.7,25.3,1.7l20.8,88.4L337,658c0,0-20.9-13.2-35.9-26.2\n\t\tc-15-13-24.3-25.6-24.3-25.6s2.7-25.7,8.8-47.7c6.1-22.1,15.7-40.5,15.7-40.5s16.5-9.5,36.9-12.5\n\t\tC344.7,504.5,351.4,504.2,357.7,504.2L357.7,504.2z M574.3,567.4c0,0,18.8,8.3,34,20.4c15.2,12.2,26.8,28.2,26.8,28.2\n\t\ts-1.1,22-8.3,44.9c-7.3,22.9-20.7,46.6-20.7,46.6s-18.8,6.9-38.6,8.8c-19.8,1.9-40.7-1.3-40.7-1.3l-10.3-43.3l-10.7-44.5\n\t\tc0,0,14.1-17,31.3-32S574.3,567.4,574.3,567.4z\"\n      />\n\n      <linearGradient\n        id=\"path3514_1_\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"596.1016\"\n        y1=\"-315.9783\"\n        x2=\"713.7116\"\n        y2=\"-337.8783\"\n        gradientTransform=\"matrix(0.9741 0 0 -0.9741 -62.0851 327.3514)\"\n      >\n        <stop offset=\"0\" style=\"stop-color:#000000\" />\n        <stop offset=\"1\" style=\"stop-color:#000000;stop-opacity:0\" />\n      </linearGradient>\n      <path\n        id=\"path3514\"\n        class=\"st2\"\n        d=\"M633.4,616.7c0,0-1,21.4-8.1,43.7s-20.2,45.4-20.2,45.4s-18.3,6.7-37.6,8.5\n\t\tc-19.3,1.8-39.6-1.3-39.6-1.3l-10.1-42.2l-10.4-43.3c0,0,13.8-16.6,30.5-31.2c16.7-14.6,36.3-27,36.3-27s18.3,8.1,33.2,19.9\n\t\tC622.1,601.1,633.4,616.7,633.4,616.7z\"\n      />\n\n      <linearGradient\n        id=\"path3516_1_\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"474.3954\"\n        y1=\"-276.598\"\n        x2=\"362.5253\"\n        y2=\"-232.698\"\n        gradientTransform=\"matrix(0.9748 0 0 -0.9748 -68.0912 325.9843)\"\n      >\n        <stop offset=\"0\" style=\"stop-color:#000000\" />\n        <stop offset=\"1\" style=\"stop-color:#000000;stop-opacity:0\" />\n      </linearGradient>\n      <path\n        id=\"path3516\"\n        class=\"st3\"\n        d=\"M337.1,656.1c0,0-20.3-12.9-35-25.5c-14.7-12.6-23.6-25-23.6-25s2.6-25,8.6-46.5\n\t\tc6-21.5,15.3-39.5,15.3-39.5s16.1-9.3,36-12.2c19.9-2.9,43.6,0.5,43.6,0.5l20.3,86.2L337.1,656.1z\"\n      />\n\n      <linearGradient\n        id=\"path3518_1_\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"630.8148\"\n        y1=\"-175.4575\"\n        x2=\"652.1248\"\n        y2=\"-105.1275\"\n        gradientTransform=\"matrix(0.8784 0 0 -0.8784 -39.7857 278.0769)\"\n      >\n        <stop offset=\"0\" style=\"stop-color:#333333\" />\n        <stop offset=\"1\" style=\"stop-color:#000000;stop-opacity:0\" />\n      </linearGradient>\n      <path\n        id=\"path3518\"\n        class=\"st4\"\n        d=\"M526.5,403.6c0,0,19.5,7.5,33.4,18.1c13.9,10.6,22.2,24.2,22.2,24.2l-35.4,24.4\n\t\tc0,0-19-13-38.9-20.1s-47.7-9.8-47.7-9.8l-9.3-36.8c0,0,19.4-6.8,36.7-7.3C504.9,395.8,526.5,403.6,526.5,403.6L526.5,403.6z\"\n      />\n      <path id=\"path3479\" class=\"st5\" d=\"M382,507.1c0,0,36.2-48.1,78.4-64.3\" />\n      <path id=\"path3506\" class=\"st6\" d=\"M552.8,474.1c0,0,27,42.9,23.5,91.9\" />\n      <path id=\"path3481\" class=\"st5\" d=\"M550.4,474.6c0,0,27.6,44.4,24.1,93.4\" />\n      <path id=\"path3483\" class=\"st5\" d=\"M587.8,447.3c0,0,59.8,23.6,86,98.3\" />\n      <path id=\"path3485\" class=\"st5\" d=\"M635.4,615.9c0,0,21-1.6,39.4-32.8\" />\n      <path id=\"path3487\" class=\"st5\" d=\"M620.4,757.3c0,0,2.9-18.1-14.5-51\" />\n      <path id=\"path3489\" class=\"st5\" d=\"M453.7,778.9c0,0,32.4-8.6,73.4-65.1\" />\n      <path id=\"path3491\" class=\"st5\" d=\"M336.8,657.2c0,0-2,50.4,23.2,90\" />\n      <path id=\"path3493\" class=\"st5\" d=\"M328.9,775.9c0,0-7.4,0.1-35.5-16.8\" />\n      <path id=\"path3495\" class=\"st5\" d=\"M277.3,606.1c0,0-20.1,8.5-31,31.9\" />\n      <path id=\"path3497\" class=\"st5\" d=\"M302.7,466.3c0,0-7.2,27.9-1,51.4\" />\n      <path id=\"path3499\" class=\"st5\" d=\"M326.9,430.6c0,0,60-50.9,121.2-28.3\" />\n      <path id=\"path3501\" class=\"st5\" d=\"M469.1,819.2c0,0,52.4,13.5,133.2-34.2\" />\n      <path id=\"path3504\" class=\"st7\" d=\"M382.2,503.5c0,0,30.1-41.5,74.3-61.3\" />\n      <path id=\"path3508\" class=\"st8\" d=\"M454.5,780.7c0,0,30.8-6,71.8-62.5\" />\n      <path id=\"path3510\" class=\"st8\" d=\"M334.8,658.3c0,0-1.9,50.4,23.2,90\" />\n      <path id=\"path2453\" class=\"st9\" d=\"M404.4,594.6c0,0,26.3,6.2,101.3,32.7\" />\n      <path id=\"path3260\" class=\"st10\" d=\"M404.4,593.3c0,0,26.3,6.2,101.3,32.7\" />\n    </g>\n  </svg>\n</template>\n\n<script>\nexport default {\n  name: 'IconBall',\n  props: {\n    color: {\n      type: String,\n      required: true,\n    },\n    st: {\n      type: String,\n      required: true,\n    },\n  },\n  computed: {\n    idGradient() {\n      let gradientId;\n      switch (this.st) {\n        case 'st1g':\n          gradientId = 'green';\n          break;\n        case 'st1y':\n          gradientId = 'yellow';\n          break;\n        case 'st1r':\n          gradientId = 'red';\n          break;\n        case 'st1b':\n          gradientId = 'blue';\n          break;\n      }\n      return gradientId;\n    },\n  },\n};\n</script>\n\n<style scoped>\n.st0 {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#path3382_1_);\n}\n.st1r {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#red);\n}\n.st1g {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#green);\n}\n.st1b {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#blue);\n}\n.st1y {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: url(#yellow);\n}\n.st2 {\n  fill: none;\n  stroke: url(#path3514_1_);\n  stroke-width: 4.8705;\n  stroke-linejoin: round;\n}\n.st3 {\n  fill: none;\n  stroke: url(#path3516_1_);\n  stroke-width: 4.874;\n  stroke-linejoin: round;\n}\n.st4 {\n  fill: none;\n  stroke: url(#path3518_1_);\n  stroke-width: 5.0158;\n}\n.st5 {\n  fill: none;\n  stroke: #666666;\n}\n.st6 {\n  fill: none;\n  stroke: #ececec;\n  stroke-width: 3;\n}\n.st7 {\n  fill: none;\n  stroke: #f2f2f2;\n  stroke-width: 3;\n  stroke-linecap: square;\n}\n.st8 {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 3;\n}\n.st9 {\n  fill: none;\n  stroke: #999999;\n}\n.st10 {\n  fill: none;\n  stroke: #ececec;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$5 = "data-v-18bce334";
  /* module identifier */
  var __vue_module_identifier__$5 = undefined;
  /* functional template */
  var __vue_is_functional_template__$5 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    createInjector,
    undefined,
    undefined
  );

// filters-goal.js
var filtersGoal = {
  2: [
    { category_id: 12000, category_name: 'Gol', category_color: '#00FF00', st: 'st1g' },
    { category_id: 59800, category_name: 'Poste', category_color: '#FFFF00', st: 'st1y' },
    { category_id: 53800, category_name: 'Fuera', category_color: '#FF0000', st: 'st1r' },
    { category_id: 60000, category_name: 'Parado por el portero', category_color: '#00FFFF', st: 'st1b' } ],
  3: [
    { category_id: 12000, category_name: 'Gol Recibido', category_color: '#FF0000', st: 'st1r' },
    { category_id: 59800, category_name: 'Poste', category_color: '#FFFF00', st: 'st1y' },
    { category_id: 53800, category_name: 'Fuera', category_color: '#00FFFF', st: 'st1b' },
    { category_id: 60000, category_name: 'Parado por el portero', category_color: '#00FF00', st: 'st1g' } ],
};

/**
 * Defines the index position of each value inside a goal stat play.
 */
var goalPlayValues$1 = [
  'playId',
  'gameId',
  'playerId',
  'momentOfPlay',
  'categoryId',
  'categoryType',
  'matchLapse',
  'section',
  'matchResult',
  'playingAs',
  'total',
  'coordinateX',
  'coordinateY' ];

var goalPlayIndex$1 = null;

function getGoalPlayIndexes$1() {
  if (!goalPlayIndex$1) {
    goalPlayIndex$1 = getPlayValueIndexesFromArray(goalPlayValues$1);
  }
  return goalPlayIndex$1;
}

//

var INDEXES = getGoalPlayIndexes$1();

var script$4 = {
  name: 'SoccerGoal',
  components: { Ball: __vue_component__$6, IconBall: __vue_component__$5, Tooltip: __vue_component__$8 },
  props: {
    players: {
      type: Array,
      required: true,
    },
    teams: {
      type: Array,
      required: true,
    },
    plays: {
      type: Array,
      required: true,
    },
    // Possible values: 'team' or 'player'
    sectionType: {
      type: String,
      required: true,
    }
  },
  data: function data() {
    return {
      categories: null,
      categoriesSelected: [],
      dataTooltip: { x: 0, y: 0, visible: false },
      dataPlay: {
        playerName: '', minute: 0, rivalName: '', rivalLogo: '',
      },
    };
  },
  mounted: function mounted() {
    this.categories = filtersGoal[this.categoryType];
    this.categoriesSelected = this.categories.map(function (category) { return category.category_id; });
  },
  computed: Object.assign({}, mapGetters('playerProfileGames', ['seasonGamesPlayed']),
    mapGetters('playerProfileGeneral', ['player']),
    /**
     * Prepare the plays to show.
     * @return {{st, play_id: *, category_id: *, playerName: *, x: *, category_type: *, y: *, category_color: (string), time: *}[]}
     */
    {showPlays: function showPlays() {
      var this$1 = this;

      return this.playsFiltered.map(function (play) {
        var game = this$1.seasonGamesPlayed.find(function (game) { return game.game_id === play[INDEXES.gameId]; });
        var team = {};

        if (game) {
          var rivalTeamId = play[INDEXES.playingAs] === 1 ? game.visiting_team : game.home_team;
          team = this$1.teams.find(function (team) { return team.team_id === rivalTeamId; });
          team = team || {};
        }

        var matchedPlayer = this$1.players.find(function (player) { return player.player_id === play[INDEXES.playerId]; });
        return {
          play_id: play[INDEXES.playId],
          playerName: matchedPlayer ? matchedPlayer.name : '',
          time: play[INDEXES.momentOfPlay],
          category_id: play[INDEXES.categoryId],
          category_color: this$1.categories.find(function (category) { return category.category_id === play[INDEXES.categoryId]; })
            .category_color,
          st: this$1.categories.find(function (category) { return category.category_id === play[INDEXES.categoryId]; }).st,
          category_type: play[INDEXES.categoryType],
          x: play[INDEXES.coordinateX],
          y: play[INDEXES.coordinateY],
          rivalName: team.team_name || '',
          rivalLogo: team.logo || '',
        };
      });
    },
    /**
     * Plays Filtered
     * @return Array
     */
    playsFiltered: function playsFiltered() {
      var this$1 = this;

      return this.plays.filter(function (play) {
        var game = this$1.seasonGamesPlayed.find(function (game) { return game.game_id === play[INDEXES.gameId]; });
        var rivalTeamId;
        if (game) {
          rivalTeamId = play[INDEXES.categoryId] === 12000
            ? play[INDEXES.playingAs] === 1
              ? game.visiting_team
              : game.home_team
            : null;
        }

        return (
          this$1.categoriesSelected.includes(play[INDEXES.categoryId])
          && (play[INDEXES.categoryId] !== 12000 ? true : this$1.player.team_id !== rivalTeamId)
        );
      });
    }},
    mapGetters('playerProfileFilter', {
      categoryType: 'getCategoryType',
    })),
  methods: {
    /**
     * Show Tooltip of play
     * @param dataTooltip
     * @return void
     */
    showTooltip: function showTooltip(dataTooltip) {
      var goalBounds = this.$refs.goal.getBoundingClientRect();
      dataTooltip.x = dataTooltip.x - goalBounds.x;
      dataTooltip.y = goalBounds.y < 0 ? dataTooltip.y + (-1 * goalBounds.y) : dataTooltip.y - goalBounds.y;
      dataTooltip.y += 65;
      Object.assign(this.dataPlay, dataTooltip);
      Object.assign(this.dataTooltip, dataTooltip);
      this.dataTooltip.visible = true;
    },
    /**
     * Hide Tooltip
     * @return void
     */
    hideTooltip: function hideTooltip() {
      this.dataPlay = {
        playerName: '', minute: 0, rivalName: '', rivalLogo: '',
      };
      this.dataTooltip.visible = false;
    },
    /**
     * @author Rigoberto Sanchez
     * @descripcion Emit event when change category
     */
    onClickCategory: function onClickCategory(value) {
      this.$emit('changeCategory', {
        name: value.target.name,
        checked: value.target.checked,
      });
    },
  },
};

/* script */
var __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "goal", staticClass: "goal" },
    [
      _c(
        "div",
        { staticClass: "goal__filters" },
        _vm._l(_vm.categories, function(category, index) {
          return _c(
            "div",
            { key: index + "-1" },
            [
              _c(
                "BCheckbox",
                {
                  key: index,
                  attrs: {
                    "native-value": category.category_id,
                    name: category.category_name
                  },
                  nativeOn: {
                    change: function($event) {
                      return _vm.onClickCategory($event)
                    }
                  },
                  model: {
                    value: _vm.categoriesSelected,
                    callback: function($$v) {
                      _vm.categoriesSelected = $$v;
                    },
                    expression: "categoriesSelected"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-list" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(category.category_name) +
                          "\n          "
                      ),
                      _c("IconBall", {
                        attrs: {
                          width: "12px",
                          height: "12px",
                          color: category.category_color,
                          st: category.st
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticStyle: { "enable-background": "new 0 0 888.5 651.6" },
          attrs: {
            version: "1.1",
            id: "Capa_1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            x: "0px",
            y: "0px",
            viewBox: "0 0 888.5 651.6",
            "xml:space": "preserve"
          }
        },
        [
          _c("g", [
            _c("path", {
              staticClass: "st0",
              attrs: {
                d:
                  "M680.2,345.5c0.1,0,0.1,0,0.1,0l0.1,0c0.2,0,0.3,0.1,0.4,0.1l100.7,29.7c2.3,0.7,3.7,1.4,3,3.7c-0.6,1.9-2.3,\n        3.2-4.2,3.2c-0.4,0-0.8-0.1-1.3-0.2L679,354.3H201.3L102.8,382c-0.4,0.1-0.8,0.2-1.2,0.2c-1.9,\n        0-3.6-1.3-4.2-3.2c-0.7-2.3,0.6-3,2.9-3.7l98.7-29.5c0.5-0.2,1-0.3,1.6-0.3c0.1,0,0.2,0,0.3,0h478.7C679.7,\n        345.4,680,345.4,680.2,345.5z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d:
                  "M684.9,334.3l-0.2,15l0.5,0.2l0.2-17L684.9,334.3z M688.7,320.6l-0.4,29.8l0.5,0.2l0.4-31.8L688.7,\n        320.6zM692.6,306.3l-0.6,45.3l0.5,0.2l0.6-47.4L692.6,306.3z M696.8,291.3l-0.7,61.6l0.5,0.2l0.8-63.6L696.8,\n        291.3z M701.2,275.5l-0.9,78.7l0.5,0.2l0.9-80.7L701.2,275.5z M705.7,258.9l-1,96.7l0.5,0.2l1-98.7L705.7,\n        258.9z M710.6,241.5l-1.1,115.6l0.5,0.2l1.2-117.6L710.6,241.5z M715.6,223.1l-1.2,135.5l0.5,\n        0.2l1.3-137.5L715.6,223.1z M721,203.7l-1.3,156.5l0.5,0.2l1.3-158.6L721,203.7z M726.9,182.3l-0.3,\n        0.9L725.3,362l0.5,0.2l1.4-180L726.9,182.3z M732.5,178.8l-1.2,185.1l0.5,0.2l1.2-185.6L732.5,178.8z M738.8,\n        174.8l-1.1,191.1l0.5,0.2l1.1-191.6L738.8,174.8z M745.5,170.6l-0.9,197.5l0.5,0.2l0.9-197.9L745.5,\n        170.6z M752.6,166.1l-0.8,204.3l0.5,0.2l0.8-204.7L752.6,166.1z M760.3,161.3l-0.5,211.6l0.5,\n        0.2l0.5-212.1L760.3,161.3z M768.5,156l-0.3,219.5l0.5,0.2l0.3-219.9L768.5,156z M777.4,150.4v228l0.5,\n        0.2V214.8l-0.2-64.6L777.4,150.4z"
              }
            }),
            _vm._v(" "),
            _c("g", { attrs: { transform: "translate(583.846 5.444)" } }, [
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter",
                      filterUnits: "userSpaceOnUse",
                      x: "101.2",
                      y: "62.7",
                      width: "93.6",
                      height: "92.5"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "101.2",
                    y: "62.7",
                    width: "93.6",
                    height: "92.5",
                    id: "prefix__b_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st2" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__a_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d:
                    "M102.2,154.9l-0.3-0.4c23.2-22,54.9-53.5,91.8-91.1l0.4,0.3C157.1,101.4,125.4,132.9,102.2,154.9"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_1_",
                      filterUnits: "userSpaceOnUse",
                      x: "101.1",
                      y: "75.1",
                      width: "93.7",
                      height: "87.8"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "101.1",
                    y: "75.1",
                    width: "93.7",
                    height: "87.8",
                    id: "prefix__d_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st5" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__c_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st6",
                attrs: {
                  d:
                    "M102.1,162.5l-0.3-0.4c23.2-21.5,55-51.3,91.9-86.4l0.3,0.4C157.1,111.2,125.3,141.1,102.1,162.5"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_2_",
                      filterUnits: "userSpaceOnUse",
                      x: "101",
                      y: "87.5",
                      width: "93.7",
                      height: "83.1"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "101",
                    y: "87.5",
                    width: "93.7",
                    height: "83.1",
                    id: "prefix__f_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st7" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__e_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st8",
                attrs: {
                  d:
                    "M102,170.2l-0.3-0.4c23.2-21,55-49.2,92-81.6l0.3,0.4C157,121,125.2,149.2,102,170.2"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_3_",
                      filterUnits: "userSpaceOnUse",
                      x: "100.9",
                      y: "100",
                      width: "93.8",
                      height: "78.3"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "100.9",
                    y: "100",
                    width: "93.8",
                    height: "78.3",
                    id: "prefix__h_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st9" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__g_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st10",
                attrs: {
                  d:
                    "M101.9,177.9l-0.3-0.4c23.2-18.3,55.1-44.9,92.1-76.8l0.3,0.4C156.9,133,125.1,159.6,101.9,177.9"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_4_",
                      filterUnits: "userSpaceOnUse",
                      x: "100.8",
                      y: "112.6",
                      width: "93.9",
                      height: "73.5"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "100.8",
                    y: "112.6",
                    width: "93.9",
                    height: "73.5",
                    id: "prefix__j_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st11" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__i_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st12",
                attrs: {
                  d:
                    "M101.8,185.7l-0.3-0.4c23.3-17.9,55.1-42.8,92.2-72l0.3,0.4C156.9,142.9,125,167.8,101.8,185.7"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_5_",
                      filterUnits: "userSpaceOnUse",
                      x: "100.7",
                      y: "125.2",
                      width: "94",
                      height: "68.7"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "100.7",
                    y: "125.2",
                    width: "94",
                    height: "68.7",
                    id: "prefix__l_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st13" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__k_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st14",
                attrs: {
                  d:
                    "M101.7,193.4l-0.3-0.4c23.3-17.4,55.2-40.6,92.3-67.2l0.3,0.4C156.8,152.8,124.9,176,101.7,193.4"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_6_",
                      filterUnits: "userSpaceOnUse",
                      x: "100.6",
                      y: "137.8",
                      width: "94.1",
                      height: "63.8"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "100.6",
                    y: "137.8",
                    width: "94.1",
                    height: "63.8",
                    id: "prefix__n_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st15" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__m_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st16",
                attrs: {
                  d:
                    "M101.5,201.2l-0.3-0.4c23.3-14.7,55.2-36.2,92.4-62.3l0.3,0.4C156.8,165,124.8,186.5,101.5,201.2"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_7_",
                      filterUnits: "userSpaceOnUse",
                      x: "100.5",
                      y: "150.5",
                      width: "94.2",
                      height: "58.9"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "100.5",
                    y: "150.5",
                    width: "94.2",
                    height: "58.9",
                    id: "prefix__p_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st17" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__o_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st18",
                attrs: {
                  d:
                    "M101.4,209l-0.3-0.4c23.3-14.2,55.3-34.1,92.5-57.4l0.3,0.4C156.8,174.9,124.8,194.7,101.4,209"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_8_",
                      filterUnits: "userSpaceOnUse",
                      x: "100.4",
                      y: "163.2",
                      width: "94.2",
                      height: "54"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "100.4",
                    y: "163.2",
                    width: "94.2",
                    height: "54",
                    id: "prefix__r_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st19" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__q_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st20",
                attrs: {
                  d:
                    "M101.3,216.8l-0.3-0.4c23.3-13.7,55.3-31.8,92.6-52.4l0.2,0.4C156.7,184.9,124.6,203.1,101.3,216.8"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_9_",
                      filterUnits: "userSpaceOnUse",
                      x: "100.3",
                      y: "176",
                      width: "94.3",
                      height: "49"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "100.3",
                    y: "176",
                    width: "94.3",
                    height: "49",
                    id: "prefix__t_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st21" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__s_1_",
                        d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st22",
                attrs: {
                  d:
                    "M101.2,224.6l-0.2-0.5c23.3-11,55.4-27.4,92.7-47.5l0.2,0.4C156.6,197.2,124.5,213.6,101.2,224.6"
                }
              }),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_10_",
                        filterUnits: "userSpaceOnUse",
                        x: "100.2",
                        y: "188.8",
                        width: "94.4",
                        height: "44"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "100.2",
                      y: "188.8",
                      width: "94.4",
                      height: "44",
                      id: "prefix__v_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st23" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__u_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st24",
                  attrs: {
                    d:
                      "M101.1,232.4l-0.2-0.5c23.4-10.5,55.5-25.2,92.9-42.5l0.2,0.5C156.6,207.2,124.4,221.9,101.1,232.4"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_11_",
                        filterUnits: "userSpaceOnUse",
                        x: "100.1",
                        y: "201.7",
                        width: "94.4",
                        height: "39"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "100.1",
                      y: "201.7",
                      width: "94.4",
                      height: "39",
                      id: "prefix__x_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st25" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__w_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st26",
                  attrs: {
                    d:
                      "M101,240.3l-0.2-0.5c23.3-10,55.5-22.9,93-37.4l0.2,0.5C156.4,217.4,124.3,230.3,101,240.3"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_12_",
                        filterUnits: "userSpaceOnUse",
                        x: "100.1",
                        y: "214.7",
                        width: "94.5",
                        height: "34"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "100.1",
                      y: "214.7",
                      width: "94.5",
                      height: "34",
                      id: "prefix__z_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st27" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__y_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st28",
                  attrs: {
                    d:
                      "M100.8,248.2l-0.2-0.5c23.4-7.2,55.5-18.4,93.1-32.4l0.2,0.5C156.4,229.8,124.2,240.9,100.8,248.2"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_13_",
                        filterUnits: "userSpaceOnUse",
                        x: "100",
                        y: "227.7",
                        width: "94.6",
                        height: "28.9"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "100",
                      y: "227.7",
                      width: "94.6",
                      height: "28.9",
                      id: "prefix__B_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st29" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__A_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st30",
                  attrs: {
                    d:
                      "M100.7,256l-0.1-0.5c23.4-6.7,55.6-16.1,93.2-27.3l0.1,0.5C156.3,239.9,124.1,249.4,100.7,256"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_14_",
                        filterUnits: "userSpaceOnUse",
                        x: "99.9",
                        y: "240.7",
                        width: "94.6",
                        height: "23.7"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99.9",
                      y: "240.7",
                      width: "94.6",
                      height: "23.7",
                      id: "prefix__D_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st31" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__C_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st32",
                  attrs: {
                    d:
                      "M100.6,263.9l-0.1-0.5c23.4-6.2,55.7-13.8,93.3-22.2l0.1,0.5C156.3,250.1,124,257.8,100.6,263.9"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_15_",
                        filterUnits: "userSpaceOnUse",
                        x: "99.8",
                        y: "253.8",
                        width: "94.6",
                        height: "18.6"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99.8",
                      y: "253.8",
                      width: "94.6",
                      height: "18.6",
                      id: "prefix__F_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st33" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__E_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st34",
                  attrs: {
                    d:
                      "M100.5,271.9l-0.1-0.5c23.4-3.4,55.7-9.2,93.4-17l0.1,0.5C156.2,262.6,123.9,268.5,100.5,271.9"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_16_",
                        filterUnits: "userSpaceOnUse",
                        x: "99.7",
                        y: "267",
                        width: "94.7",
                        height: "13.4"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99.7",
                      y: "267",
                      width: "94.7",
                      height: "13.4",
                      id: "prefix__H_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st35" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__G_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st36",
                  attrs: {
                    d:
                      "M100.3,279.8l-0.1-0.5c23.5-2.9,55.8-6.9,93.5-11.8l0.1,0.5C156.2,272.9,123.9,277,100.3,279.8"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_17_",
                        filterUnits: "userSpaceOnUse",
                        x: "99.6",
                        y: "280.2",
                        width: "94.7",
                        height: "8.1"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99.6",
                      y: "280.2",
                      width: "94.7",
                      height: "8.1",
                      id: "prefix__J_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st37" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__I_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st38",
                  attrs: {
                    d:
                      "M100.2,287.8l0-0.5c23.5-2.3,55.8-4.6,93.6-6.6l0,0.5C156.1,283.2,123.7,285.5,100.2,287.8"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_18_",
                        filterUnits: "userSpaceOnUse",
                        x: "99.6",
                        y: "293.4",
                        width: "94.8",
                        height: "3"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99.6",
                      y: "293.4",
                      width: "94.8",
                      height: "3",
                      id: "prefix__L_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st39" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__K_1_",
                          d: "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st40",
                  attrs: {
                    d:
                      "M120.8,296c-7.5,0-14.4-0.1-20.7-0.2l0-0.5c23.5,0.5,55.9,0.1,93.7-1.3l0,0.5\n      C166.1,295.5,141.3,296,120.8,296"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_19_",
                        filterUnits: "userSpaceOnUse",
                        x: "99.5",
                        y: "302.7",
                        width: "94.9",
                        height: "5.5"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99.5",
                      y: "302.7",
                      width: "94.9",
                      height: "5.5",
                      id: "prefix__N_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st41" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__M_1_",
                          d:
                            "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st42",
                  attrs: {
                    d:
                      "M193.8,307.7c-37.8-1.5-70.3-2.9-93.8-4l0-0.5c23.6,1.1,56,2.4,93.8,4L193.8,307.7L193.8,307.7z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_20_",
                        filterUnits: "userSpaceOnUse",
                        x: "99.3",
                        y: "310.7",
                        width: "95.1",
                        height: "10.9"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99.3",
                      y: "310.7",
                      width: "95.1",
                      height: "10.9",
                      id: "prefix__P_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st43" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__O_1_",
                          d:
                            "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st44",
                  attrs: {
                    d:
                      "M193.8,321.1c-37.9-4.5-70.4-7.7-93.9-9.3l0-0.5c23.5,1.6,56,4.8,94,9.3L193.8,321.1z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_21_",
                        filterUnits: "userSpaceOnUse",
                        x: "99.1",
                        y: "318.7",
                        width: "95.3",
                        height: "16.3"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99.1",
                      y: "318.7",
                      width: "95.3",
                      height: "16.3",
                      id: "prefix__R_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st45" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__Q_1_",
                          d:
                            "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st46",
                  attrs: {
                    d:
                      "M193.8,334.4c-38-5.1-70.5-10.2-94.1-14.6l0.1-0.5c23.5,4.5,56,9.5,94,14.6L193.8,334.4z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_22_",
                        filterUnits: "userSpaceOnUse",
                        x: "99",
                        y: "326.8",
                        width: "95.5",
                        height: "21.7"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "99",
                      y: "326.8",
                      width: "95.5",
                      height: "21.7",
                      id: "prefix__T_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st47" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__S_1_",
                          d:
                            "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st48",
                  attrs: {
                    d:
                      "M193.8,347.9c-39.3-8.3-71-15.1-94.2-20l0.1-0.5c23.1,4.9,54.8,11.7,94.2,20L193.8,347.9z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_23_",
                        filterUnits: "userSpaceOnUse",
                        x: "98.9",
                        y: "334.8",
                        width: "95.6",
                        height: "27.2"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "98.9",
                      y: "334.8",
                      width: "95.6",
                      height: "27.2",
                      id: "prefix__V_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st49" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__U_1_",
                          d:
                            "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st50",
                  attrs: {
                    d:
                      "M193.8,361.4c-38.1-11.1-70.7-19.9-94.3-25.4l0.1-0.5c23.6,5.6,56.2,14.4,94.3,25.4\n      C193.9,360.9,193.8,361.4,193.8,361.4z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_24_",
                        filterUnits: "userSpaceOnUse",
                        x: "98.7",
                        y: "342.9",
                        width: "95.8",
                        height: "32.6"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "98.7",
                      y: "342.9",
                      width: "95.8",
                      height: "32.6",
                      id: "prefix__X_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st51" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__W_1_",
                          d:
                            "M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st52",
                  attrs: {
                    d:
                      "M193.8,374.9c-38.2-11.7-70.8-22.4-94.4-30.9l0.2-0.5c23.6,8.5,56.2,19.2,94.4,30.9L193.8,374.9\n      L193.8,374.9z"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d:
                  "M195.6,349.4l0.5-0.2l-0.2-15l-0.5-1.9L195.6,349.4z M192,350.6l0.5-0.2l-0.4-29.8l-0.5-1.9L192,\n        350.6zM188.2,351.8l0.5-0.2l-0.6-45.3l-0.5-1.9L188.2,351.8z M184.2,353l0.5-0.2l-0.7-61.6l-0.5-1.9L184.2,\n        353z M180,354.3l0.5-0.2l-0.9-78.7l-0.5-1.9L180,354.3z M175.6,355.7l0.5-0.2l-1-96.7l-0.5-1.9L175.6,\n        355.7z M170.9,357.2l0.5-0.2l-1.1-115.6l-0.5-1.9L170.9,357.2z M165.9,358.8l0.5-0.2l-1.2-135.5l-0.5-1.9L165.9,\n        358.8z M160.6,360.4l0.5-0.2l-1.3-156.5l-0.5-1.9L160.6,360.4zM155,\n        362.2l0.5-0.2l-1.4-178.8l-0.3-0.9l-0.2-0.2L155,362.2z M149,364.1l0.5-0.2l-1.2-185.1l-0.5-0.3L149,\n        364.1z M142.6,366.1l0.5-0.2L142,174.8l-0.5-0.3L142.6,366.1z M135.8,\n        368.2l0.5-0.2l-0.9-197.5l-0.5-0.3L135.8,368.2z M128.4,370.5l0.5-0.2l-0.8-204.3l-0.5-0.3L128.4,\n        370.5z M120.6,373l0.5-0.2l-0.5-211.6l-0.5-0.3L120.6,373z M112.1,375.7l0.5-0.2L112.3,156l-0.5-0.3L112.1,\n        375.7zM102.9,214.8v163.7l0.5-0.2v-228l-0.2-0.2L102.9,214.8z"
              }
            }),
            _vm._v(" "),
            _c("g", { attrs: { transform: "translate(5.308 5.444)" } }, [
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_25_",
                      filterUnits: "userSpaceOnUse",
                      x: "96.9",
                      y: "62.7",
                      width: "93.6",
                      height: "92.9"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "96.9",
                    y: "62.7",
                    width: "93.6",
                    height: "92.9",
                    id: "prefix__ah_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st53" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__ag_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st54",
                attrs: {
                  d:
                    "M189.4,154.9c-23.2-22-54.9-53.5-91.8-91.1l0.4-0.3c36.9,37.6,68.6,69.2,91.8,91.1L189.4,154.9L189.4,154.9z\n      "
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_26_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "75.1",
                      width: "93.6",
                      height: "88.2"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "75.1",
                    width: "93.6",
                    height: "88.2",
                    id: "prefix__aj_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st55" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__ai_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st56",
                attrs: {
                  d:
                    "M189.6,162.5c-23.2-21.5-55-51.3-91.9-86.4l0.3-0.4c36.9,35,68.7,64.9,91.9,86.4L189.6,162.5L189.6,162.5z"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_27_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "87.5",
                      width: "93.7",
                      height: "83.4"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "87.5",
                    width: "93.7",
                    height: "83.4",
                    id: "prefix__al_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st57" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__ak_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st58",
                attrs: {
                  d:
                    "M189.7,170.2c-23.2-21-55-49.2-92-81.6l0.3-0.4c37,32.4,68.8,60.6,92,81.6\n      C190,169.9,189.7,170.2,189.7,170.2z"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_28_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "100",
                      width: "93.8",
                      height: "78.6"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "100",
                    width: "93.8",
                    height: "78.6",
                    id: "prefix__an_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st59" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__am_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st60",
                attrs: {
                  d:
                    "M189.8,177.9c-23.2-18.3-55.1-44.9-92.1-76.8l0.3-0.4c37,31.9,68.9,58.5,92.1,76.8L189.8,177.9z"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_29_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "112.6",
                      width: "93.9",
                      height: "73.8"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "112.6",
                    width: "93.9",
                    height: "73.8",
                    id: "prefix__ap_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st61" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__ao_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st62",
                attrs: {
                  d:
                    "M189.9,185.7c-23.2-17.8-55.1-42.7-92.2-72l0.3-0.4c37.1,29.3,69,54.2,92.2,72L189.9,185.7L189.9,185.7z"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_30_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "125.2",
                      width: "94",
                      height: "69"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "125.2",
                    width: "94",
                    height: "69",
                    id: "prefix__ar_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st63" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__aq_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st64",
                attrs: {
                  d:
                    "M190,193.4c-23.3-17.4-55.2-40.6-92.3-67.2l0.3-0.4c37.1,26.5,69.1,49.8,92.3,67.2L190,193.4L190,193.4z"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_31_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "137.8",
                      width: "94.1",
                      height: "64.1"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "137.8",
                    width: "94.1",
                    height: "64.1",
                    id: "prefix__at_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st65" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__as_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st66",
                attrs: {
                  d:
                    "M190.1,201.2c-23.3-14.7-55.2-36.2-92.4-62.3l0.3-0.4c37.2,26.1,69.2,47.6,92.4,62.3L190.1,201.2\n      L190.1,201.2z"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_32_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "150.5",
                      width: "94.2",
                      height: "59.2"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "150.5",
                    width: "94.2",
                    height: "59.2",
                    id: "prefix__av_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st67" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__au_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st68",
                attrs: {
                  d:
                    "M190.2,209c-23.3-14.2-55.3-34.1-92.5-57.4l0.3-0.4c37.2,23.3,69.2,43.2,92.5,57.4L190.2,209L190.2,209z"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_33_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "163.2",
                      width: "94.3",
                      height: "54.2"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "163.2",
                    width: "94.3",
                    height: "54.2",
                    id: "prefix__ax_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st69" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__aw_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st70",
                attrs: {
                  d:
                    "M190.3,216.8c-23.3-13.7-55.3-31.8-92.6-52.4l0.2-0.4c37.3,20.6,69.3,38.7,92.6,52.4\n      C190.6,216.3,190.3,216.8,190.3,216.8z"
                }
              }),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "Adobe_OpacityMaskFilter_34_",
                      filterUnits: "userSpaceOnUse",
                      x: "97",
                      y: "176",
                      width: "94.3",
                      height: "49.3"
                    }
                  },
                  [
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "mask",
                {
                  attrs: {
                    maskUnits: "userSpaceOnUse",
                    x: "97",
                    y: "176",
                    width: "94.3",
                    height: "49.3",
                    id: "prefix__az_1_"
                  }
                },
                [
                  _c("g", { staticClass: "st71" }, [
                    _c("path", {
                      staticClass: "st3",
                      attrs: {
                        id: "prefix__ay_1_",
                        d:
                          "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("path", {
                staticClass: "st72",
                attrs: {
                  d:
                    "M190.5,224.6c-23.3-11-55.4-27.4-92.8-47.5l0.2-0.4c37.3,20.1,69.4,36.5,92.7,47.5\n      C190.7,224.1,190.5,224.6,190.5,224.6z"
                }
              }),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_35_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.1",
                        y: "188.8",
                        width: "94.4",
                        height: "44.2"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.1",
                      y: "188.8",
                      width: "94.4",
                      height: "44.2",
                      id: "prefix__aB_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st73" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aA_1_",
                          d:
                            "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st74",
                  attrs: {
                    d:
                      "M190.6,232.4c-23.4-10.5-55.5-25.2-92.9-42.5l0.2-0.5c37.3,17.3,69.4,32,92.8,42.5L190.6,232.4z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_36_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.1",
                        y: "201.7",
                        width: "94.5",
                        height: "39.2"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.1",
                      y: "201.7",
                      width: "94.5",
                      height: "39.2",
                      id: "prefix__aD_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st75" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aC_1_",
                          d:
                            "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st76",
                  attrs: {
                    d:
                      "M190.7,240.3c-23.4-10-55.5-22.9-93-37.4l0.2-0.5c37.5,14.5,69.6,27.5,93,37.4L190.7,240.3L190.7,240.3z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_37_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.1",
                        y: "214.7",
                        width: "94.5",
                        height: "34.1"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.1",
                      y: "214.7",
                      width: "94.5",
                      height: "34.1",
                      id: "prefix__aF_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st77" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aE_1_",
                          d:
                            "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st78",
                  attrs: {
                    d:
                      "M190.8,248.2c-23.4-7.2-55.6-18.4-93.1-32.4l0.2-0.5c37.5,14,69.7,25.2,93.1,32.4L190.8,248.2L190.8,248.2z\n      "
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_38_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.1",
                        y: "227.7",
                        width: "94.6",
                        height: "29"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.1",
                      y: "227.7",
                      width: "94.6",
                      height: "29",
                      id: "prefix__aH_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st79" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aG_1_",
                          d:
                            "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st80",
                  attrs: {
                    d:
                      "M190.9,256c-23.4-6.7-55.6-16.1-93.2-27.3l0.1-0.5c37.6,11.2,69.8,20.6,93.2,27.3\n      C191.1,255.6,190.9,256,190.9,256z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_39_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.2",
                        y: "240.7",
                        width: "94.6",
                        height: "23.8"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.2",
                      y: "240.7",
                      width: "94.6",
                      height: "23.8",
                      id: "prefix__aJ_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st81" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aI_1_",
                          d:
                            "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st82",
                  attrs: {
                    d:
                      "M191.1,263.9c-23.4-6.2-55.7-13.8-93.3-22.1l0.1-0.5c37.6,8.3,69.9,16,93.3,22.2L191.1,263.9z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_40_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.2",
                        y: "253.8",
                        width: "94.6",
                        height: "18.6"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.2",
                      y: "253.8",
                      width: "94.6",
                      height: "18.6",
                      id: "prefix__aL_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st83" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aK_1_",
                          d:
                            "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st84",
                  attrs: {
                    d:
                      "M191.2,271.9c-23.4-3.4-55.7-9.3-93.4-17l0.1-0.5c37.7,7.7,70,13.6,93.4,17\n      C191.3,271.4,191.2,271.9,191.2,271.9z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_41_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.2",
                        y: "267",
                        width: "94.7",
                        height: "13.4"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.2",
                      y: "267",
                      width: "94.7",
                      height: "13.4",
                      id: "prefix__aN_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st85" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aM_1_",
                          d:
                            "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st86",
                  attrs: {
                    d:
                      "M191.3,279.8c-23.5-2.9-55.8-6.9-93.5-11.8l0.1-0.5c37.7,4.9,70,8.9,93.5,11.8\n      C191.4,279.3,191.3,279.8,191.3,279.8z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_42_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.3",
                        y: "280.2",
                        width: "94.7",
                        height: "8.1"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.3",
                      y: "280.2",
                      width: "94.7",
                      height: "8.1",
                      id: "prefix__aP_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st87" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aO_1_",
                          d:
                            "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st88",
                  attrs: {
                    d:
                      "M191.4,287.8c-23.5-2.3-55.8-4.6-93.6-6.6l0-0.5c37.8,2,70.2,4.3,93.6,6.6L191.4,287.8L191.4,287.8z"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_43_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.3",
                        y: "293.4",
                        width: "94.8",
                        height: "3"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.3",
                      y: "293.4",
                      width: "94.8",
                      height: "3",
                      id: "prefix__aR_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st89" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aQ_1_",
                          d: "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st90",
                  attrs: {
                    d:
                      "M170.9,296c-20.5,0-45.3-0.5-73.1-1.5l0-0.5c37.8,1.4,70.2,1.8,93.7,1.3l0,0.5\n      C185.3,295.9,178.4,296,170.9,296"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_44_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.3",
                        y: "302.7",
                        width: "94.9",
                        height: "5.5"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.3",
                      y: "302.7",
                      width: "94.9",
                      height: "5.5",
                      id: "prefix__aT_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st91" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aS_1_",
                          d: "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st92",
                  attrs: {
                    d:
                      "M97.8,307.7l0-0.5c37.8-1.5,70.2-2.9,93.8-4l0,0.5C168.1,304.8,135.6,306.2,97.8,307.7"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_45_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.2",
                        y: "310.7",
                        width: "95.1",
                        height: "10.8"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.2",
                      y: "310.7",
                      width: "95.1",
                      height: "10.8",
                      id: "prefix__aV_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st93" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aU_1_",
                          d: "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st94",
                  attrs: {
                    d:
                      "M97.9,321.1l-0.1-0.5c37.9-4.5,70.4-7.7,94-9.3l0,0.5C168.2,313.4,135.8,316.6,97.9,321.1"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_46_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.2",
                        y: "318.7",
                        width: "95.3",
                        height: "16.2"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.2",
                      y: "318.7",
                      width: "95.3",
                      height: "16.2",
                      id: "prefix__aX_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st95" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aW_1_",
                          d: "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st96",
                  attrs: {
                    d:
                      "M97.9,334.4l-0.1-0.5c38-5.1,70.5-10.2,94-14.6l0.1,0.5C168.4,324.3,135.9,329.3,97.9,334.4"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_47_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.2",
                        y: "326.8",
                        width: "95.5",
                        height: "21.6"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.2",
                      y: "326.8",
                      width: "95.5",
                      height: "21.6",
                      id: "prefix__aZ_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st97" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__aY_1_",
                          d: "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st98",
                  attrs: {
                    d:
                      "M97.9,347.9l-0.1-0.5c38.8-8.2,71.3-15.1,94.2-20l0.1,0.5C169.2,332.7,136.6,339.7,97.9,347.9"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_48_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.1",
                        y: "334.8",
                        width: "95.6",
                        height: "27"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.1",
                      y: "334.8",
                      width: "95.6",
                      height: "27",
                      id: "prefix__bb_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st99" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__ba_1_",
                          d: "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st100",
                  attrs: {
                    d:
                      "M97.9,361.4l-0.1-0.5c38.1-11.1,70.7-19.9,94.3-25.4l0.1,0.5C168.6,341.5,136,350.3,97.9,361.4"
                  }
                })
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "Adobe_OpacityMaskFilter_49_",
                        filterUnits: "userSpaceOnUse",
                        x: "97.1",
                        y: "342.9",
                        width: "95.8",
                        height: "32.5"
                      }
                    },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "mask",
                  {
                    attrs: {
                      maskUnits: "userSpaceOnUse",
                      x: "97.1",
                      y: "342.9",
                      width: "95.8",
                      height: "32.5",
                      id: "prefix__bd_1_"
                    }
                  },
                  [
                    _c("g", { staticClass: "st101" }, [
                      _c("path", {
                        staticClass: "st3",
                        attrs: {
                          id: "prefix__bc_1_",
                          d: "M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st102",
                  attrs: {
                    d:
                      "M97.9,374.9l-0.1-0.5c38.2-11.7,70.8-22.4,94.4-30.9l0.2,0.5C168.7,352.5,136.1,363.2,97.9,374.9"
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("line", {
              staticClass: "st103",
              attrs: { x1: "-2.5", y1: "382.4", x2: "897.5", y2: "382.4" }
            }),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M196.4,348.2c-6.6-26.3-14.3-52.7-21.8-78.3c-5.6-19.1-11.3-39-16.6-58.6c-6.7-24.9-17.9-32.6-32.2-42.2\n      c-7-4.8-15-10.2-23.5-18.5l0.4-0.4c8.5,8.3,16.4,13.7,23.4,18.5c14.3,9.7,25.6,17.4,32.4,42.6c5.3,19.6,11,\n      39.4,16.6,58.5c7.4,25.6,15.1,52,21.8,78.3C196.9,348.1,196.4,348.2,196.4,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M205.9,348.2c-6.1-25.6-13.4-51.4-20.4-76.3c-5.6-19.8-11.3-40.2-16.5-60.5c-6.2-24.3-16.9-31.8-30.5-41.2\n          c-7.2-5-15.3-10.6-23.9-19.7l0.4-0.4c8.5,9,16.6,14.6,23.8,19.6c13.7,9.5,24.5,17,30.7,41.5c5.2,20.3,10.9,\n          40.7,16.5,60.5c7,24.9,14.3,50.7,20.4,76.3L205.9,348.2L205.9,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M215.5,348.2c-5.7-25.2-12.6-50.5-19.3-74.9c-5.5-20.2-11.2-41-16.2-61.8c-5.7-23.8-16-31.1-29.1-40.3\n          c-7.3-5.1-15.6-11-24-20.7l0.4-0.4c8.4,9.7,16.7,15.5,23.9,20.6c13.1,9.2,23.5,16.5,29.3,40.6c5,20.7,10.7,\n          41.6,16.2,61.8c6.7,24.5,13.6,49.7,19.3,75L215.5,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M225.1,348.2c-5.2-24.9-11.8-49.9-18.2-74c-5.4-20.4-11-41.6-15.8-62.6c-5.3-23.4-15.7-30.8-27.7-39.4\n          c-7.4-5.3-15.7-11.2-24-21.6l0.4-0.3c8.3,10.3,16.6,16.3,23.9,21.5c12.1,8.7,22.6,16.2,27.9,39.8c4.7,21,10.3,\n          42.1,15.8,62.6c6.4,24.1,13,49.1,18.3,74L225.1,348.2L225.1,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M234.6,348.2c-4.8-24.7-11.2-49.5-17.3-73.4c-5.3-20.6-10.8-41.9-15.2-63.1c-4.9-23-14.9-30.3-26.5-38.7\n          c-7.4-5.4-15.8-11.4-23.9-22.5l0.4-0.3c8.1,10.9,16.4,17,23.8,22.3c11.7,8.5,21.9,15.8,26.8,39c4.5,21.2,9.9,\n          42.5,15.2,63.1c6.1,23.9,12.5,48.6,17.3,73.4L234.6,348.2L234.6,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M244.2,348.2c-4.4-24.6-10.5-49.2-16.4-72.9c-5.1-20.7-10.5-42.1-14.7-63.5c-4.4-22.6-14.2-29.7-25.5-38\n          c-7.4-5.5-15.9-11.6-23.7-23.2l0.5-0.3c7.8,11.5,16.2,17.7,23.6,23.1c11.4,8.3,21.2,15.5,25.7,38.4c4.2,21.4,\n          9.5,42.8,14.7,63.5c5.9,23.8,12,48.3,16.4,72.9L244.2,348.2L244.2,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M253.7,348.2c-4.1-24.5-9.9-48.9-15.6-72.5c-5-20.8-10.1-42.3-14.1-63.8c-4.1-22.2-13.5-29.3-24.5-37.4\n          c-7.4-5.5-15.9-11.8-23.4-23.9l0.5-0.3c7.4,12,15.5,18,23.2,23.8c11,8.2,20.6,15.3,24.7,37.8c3.9,21.5,9.1,43,\n          14.1,63.7c5.7,23.6,11.5,48,15.6,72.6L253.7,348.2L253.7,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M263.3,348.2c-3.7-24.4-9.3-48.7-14.8-72.2c-4.8-20.8-9.8-42.4-13.4-64c-3.7-21.9-12.9-28.8-23.5-36.9\n          c-7.8-5.9-15.9-12-23-24.6l0.5-0.3c7.1,12.5,15.1,18.6,22.8,24.4c10.8,8.1,20,15.1,23.8,37.2c3.6,21.6,8.6,\n          43.1,13.4,63.9c5.4,23.5,11.1,47.8,14.8,72.3L263.3,348.2L263.3,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M272.8,348.2c-3.3-24.3-8.7-48.5-13.9-71.9c-4.7-20.9-9.5-42.5-12.8-64.2c-3.3-21.6-12.3-28.4-22.7-36.4\n          c-7.8-5.9-15.8-12.1-22.5-25.2l0.5-0.2c6.6,13,14.6,19.1,22.4,25c10.1,7.7,19.6,14.9,22.9,36.7c3.3,21.7,8.2,\n          43.3,12.8,64.2c5.2,23.4,10.6,47.6,13.9,71.9L272.8,348.2L272.8,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M282.4,348.2c-3-24.3-8.1-48.3-13.1-71.6c-4.5-21-9.2-42.7-12.2-64.5c-3-21.2-12.2-28.4-21.9-35.9\n          c-7.8-6-15.8-12.2-22-25.7l0.5-0.2c6.2,13.4,14.1,19.5,21.8,25.5c9.8,7.6,19.1,14.8,22.1,36.3c3,21.8,7.7,\n          43.5,12.2,64.4c5,23.3,10.2,47.3,13.1,71.6L282.4,348.2L282.4,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M292,348.2c-2.6-24-7.5-47.8-12.3-70.8c-4.4-21.2-8.9-43.2-11.6-65.2c-2.6-20.9-11.6-28-21.1-35.5\n          c-7.7-6.1-15.7-12.3-21.4-26.2l0.5-0.2c5.7,13.7,13.6,19.9,21.3,25.9c9.6,7.6,18.7,14.7,21.3,35.8c2.7,22.1,\n          7.3,44,11.6,65.2c4.7,23,9.6,46.8,12.3,70.8L292,348.2L292,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M301.5,348.2c-2.4-23.5-7-46.9-11.4-69.5c-4.2-21.6-8.6-44-11.1-66.5c-2.3-20.6-11.1-27.6-20.4-35.1\n          c-7.7-6.1-15.6-12.5-20.8-26.6l0.5-0.2c5.1,14,13,20.3,20.6,26.4c9.4,7.5,18.3,14.6,20.6,35.4c2.5,22.5,6.8,\n          44.8,11.1,66.5c4.4,22.6,9,46,11.4,69.5L301.5,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M311.1,348.2c-2.2-23.6-6.5-47.1-10.7-69.9c-3.9-21.5-8-43.8-10.3-66.1c-2.1-20.1-10.7-27.2-19.8-34.6\n          c-7.6-6.2-15.5-12.6-20.2-27l0.5-0.2c4.6,14.2,12.4,20.6,20,26.8c9.2,7.5,17.9,14.6,20,35c2.3,22.3,6.4,44.6,\n          10.3,66.1c4.1,22.7,8.4,46.3,10.7,69.9L311.1,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M320.6,348.2c-2-23.7-6-47.3-9.9-70.1c-3.6-21.5-7.4-43.7-9.5-65.9c-1.9-20-10.4-27-19.3-34.5\n          c-7.5-6.2-15.2-12.7-19.5-27.1l0.5-0.2c4.2,14.3,11.9,20.7,19.3,26.9c9,7.5,17.5,14.6,19.5,34.8c2.1,22.2,5.9,\n          44.4,9.5,65.8c3.9,22.9,7.8,46.5,9.9,70.2L320.6,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M330.2,348.2c-1.7-22.4-5.3-44.8-8.8-66.4c-3.1-19.4-6.3-39.4-8.2-59.4c-2.3-24.3-3.8-28.7-16.2-45.9\n          c-10.8-5.4-18-14.1-21.5-25.9l0.5-0.2c3.4,11.7,10.6,20.3,21.3,25.6l0.1,0.1c12.4,17.2,14.1,22,16.4,46.3c1.9,\n          20,5.1,40,8.2,59.3c3.5,21.6,7.1,44,8.8,66.4L330.2,348.2L330.2,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M339.7,348.2c-1.6-22.4-4.9-44.8-8.1-66.4c-2.8-19.4-5.8-39.4-7.5-59.4c-2-23-3.3-28.5-15-46\n          c-10.4-5.5-17.1-14.2-20.1-25.8l0.5-0.1c3,11.5,9.7,20.1,19.9,25.5l0.1,0.1c11.2,16.7,13.1,22.4,15.1,\n          46.3c1.7,20,4.7,40,7.5,59.4c3.2,21.7,6.5,44.1,8.1,66.5L339.7,348.2L339.7,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M349.3,348.2c-1.4-22.3-4.4-44.8-7.3-66.4c-2.6-19.4-5.3-39.5-6.8-59.5c-1.7-22.1-3.2-29-13.5-46\n          c-9.8-5.6-16-14.3-18.4-25.7l0.5-0.1c2.4,11.3,8.5,19.9,18.2,25.4l0.1,0l0,0.1c10.5,17.1,11.9,24.1,13.6,46.3\n          c1.5,20,4.2,40.1,6.8,59.5c2.9,21.7,5.9,44.1,7.3,66.5L349.3,348.2L349.3,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M358.9,348.2c-1.3-22.3-3.9-44.6-6.5-66.3c-2.3-19.5-4.7-39.7-6.1-59.8c-1.5-21.6-3.1-29.7-12-45.9\n          c-9.1-5.8-14.7-14.5-16.4-25.6l0.5-0.1c1.7,11,7.2,19.5,16.2,25.3l0.1,0.1c8.9,16.4,10.6,24.6,12.1,46.2c1.4,\n          20,3.8,40.2,6.1,59.8c2.6,21.7,5.2,44.1,6.5,66.3L358.9,348.2L358.9,348.2z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M368.4,348.2c-1.1-22.2-3.5-44.5-5.7-66.1c-2.1-19.7-4.2-40-5.4-60.1c-1.2-19.6-2.4-29.2-10.3-45.9\n          c-8.3-6.1-13.1-14.7-14.2-25.5l0.5-0.1c1.1,10.6,5.8,19.1,14,25.1l0.1,0.1c7.9,16.8,9.2,26.5,10.4,46.2\n          c1.2,20.1,3.3,40.4,5.4,60.1c2.3,21.6,4.6,44,5.7,66.1L368.4,348.2L368.4,348.2z M378,348.2c-1-22-3-44.3-5-65.8\n          c-1.8-19.8-3.7-40.3-4.7-60.6c-1-19.6-2.4-30.3-8.6-45.9c-7.4-6.5-11.4-15-11.9-25.4l0.5,0c0.4,10.2,4.4,18.6,\n          11.7,25l0.1,0.1c6.2,15.8,7.6,26.5,8.6,46.1c1,20.3,2.9,40.8,4.7,60.6c2,21.5,4,43.8,5,65.8L378,348.2L378,\n          348.2z M387.5,348.2c-0.8-21.8-2.5-44-4.2-65.3c-1.5-20-3.1-40.7-4-61.2c-0.8-18.5-2.1-30.7-6.9-45.9\n          c-6.4-6.9-9.6-15.4-9.5-25.2l0.5,0c-0.1,9.8,3.1,18.1,9.4,24.9l0.1,0.1c4.8,15.3,6.1,27.5,6.9,46.1c0.9,20.4,\n          2.5,41.1,4,61.1c1.6,21.4,3.3,43.5,4.2,65.4L387.5,348.2L387.5,348.2z M397.1,\n          348.2c-0.7-21.6-2.1-43.6-3.4-64.8c-1.3-20.3-2.6-41.2-3.3-61.8c-0.5-14.8-1.3-29.5-5.2-45.9\n          c-5.3-7.3-7.7-15.7-7.2-25.1l0.5,0c-0.5,9.3,1.9,17.6,7.1,24.8l0,0.1c4,16.5,4.8,31.2,5.3,46.1c0.7,\n          20.6,2,41.6,3.3,61.8c1.3,21.2,2.7,43.2,3.4,64.8L397.1,348.2L397.1,348.2z M406.7,348.2\n          c-0.5-21.4-1.6-43.1-2.6-64.1c-1-20.5-2.1-41.8-2.6-62.7c-0.3-9.8-2.4-20.9-4.4-31.6\n          c-2.6-13.5-5.3-27.4-4.4-39.4l0.5,0c-0.9,11.9,1.8,25.8,4.3,39.2c2.1,10.7,4.2,21.8,4.4,31.6c0.6,20.9,1.6,\n          42.1,2.6,62.6c1,21,2.1,42.7,2.6,64.1L406.7,348.2L406.7,348.2z M416.2,348.2c-0.4-21.1-1.1-42.5-1.9-63.3\n          c-0.7-20.8-1.5-42.4-1.9-63.6c-0.2-9.5-1.5-19.9-2.8-30c-1.8-13.8-3.7-28.1-2.7-40.8l0.5,0c-1,12.7,0.9,26.9,\n          2.7,40.7c1.3,10.1,2.7,20.5,2.8,30.1c0.4,21.2,1.1,42.7,1.9,63.5c0.7,20.7,1.5,42.2,1.9,63.3L416.2,\n          348.2L416.2,348.2z M425.8,348.2c-0.3-24.8-1.6-50.5-3-75.4c-2.1-40.4-4.3-82.2-2.1-122.3l0.5,0c-2.2,40,0,\n          81.8,2.1,122.2c1.3,24.9,2.7,50.6,3,75.4L425.8,348.2L425.8,348.2z M435.3,348.2c-0.1-24.4-0.5-49.3-0.9-73.3\n          c-0.7-40.8-1.4-83-0.6-124.3l0.5,0c-0.9,41.4-0.1,83.5,0.6,124.3c0.4,24,0.8,48.9,0.9,73.3L435.3,\n          348.2z M445.4,348.2h-0.5c0.1-25.9,0.5-52.3,0.8-77.8c0.6-39.3,1.2-79.9,0.7-119.8l0.5,0\n          c0.5,39.9-0.1,80.5-0.7,119.8C445.9,295.8,445.5,322.2,445.4,348.2 M455,348.2l-0.5,0c0.2-26.9,1.5-54.6,\n          2.7-81.3c1.7-38.3,3.5-77.9,2.4-116.3l0.5,0c1.1,38.5-0.7,78.1-2.4,116.4C456.5,293.6,455.2,321.2,455,\n          348.2 M464.6,348.2l-0.5,0c0.4-28.6,2.6-58.1,4.6-86.6c2.7-36.7,5.4-74.6,4.6-111l0.5,0c0.8,36.4-1.9,74.3-4.6,\n          111C467.1,290.1,465,319.6,464.6,348.2M474.1,348.2l-0.5,0c0.4-19.9,1.6-40.1,2.7-59.7c1.3-22.2,2.6-45.2,\n          2.9-67.9c0.1-12.2,2.2-24.2,4.3-35.8c2.1-11.8,4-22.9,4.1-34.3l0.5,0c-0.1,11.5-2.1,23.1-4.1,34.4c-2,11.6-4.1,\n          23.5-4.2,35.7c-0.2,22.7-1.6,45.7-2.9,67.9C475.7,308,474.5,328.2,474.1,348.2 M484.2,324c0.7-12,1.6-23.9,\n          2.4-35.6c1.7-22.2,3.4-45.2,3.7-67.9c-0.2-13.3,0.3-26.8,1.6-40.1c1-5.1,3-9,4.9-12.8c2.4-4.8,4.9-9.7,\n          5.4-17l0.5,0c-0.5,7.4-3,12.4-5.4,17.2c-1.9,3.7-3.9,7.6-4.8,12.6c-1.3,13.2-1.8,26.7-1.6,40c-0.3,22.8-2,\n          45.7-3.7,68c-1.5,19.6-3,39.8-3.5,59.8 M483.7,348.2l-0.5,0c0.2-8,0.6-16.1,1.1-24.2 M493.2,348.2l-0.5,0\n          c0.7-20.1,2.5-40.4,4.3-59.9c2-22.2,4.1-45.2,4.5-68c-0.4-13.3,0.3-26.7,2.1-39.9c1.4-5.4,3.9-9.3,6.4-13.2\n          c3-4.6,6-9.4,7.1-16.6l0.5,0.1c-1.1,7.4-4.2,12.2-7.2,16.9c-2.4,3.8-5,7.7-6.3,13c-1.7,13.1-2.4,26.6-2.1,39.8\n          c-0.4,22.8-2.5,45.8-4.5,68.1C495.7,307.8,493.9,328.1,493.2,348.2 M502.8,348.2l-0.5,0c0.8-20.2,3-40.5,\n          5.1-60.1c2.4-22.2,4.8-45.2,5.3-68.1c-0.5-13.3,0.4-26.7,2.6-39.8c1.7-5.6,4.9-9.7,8-13.7c3.5-4.5,7.1-9.2,\n          8.8-16.1l0.5,0.1c-1.7,7.1-5.4,11.8-8.9,16.3c-3.2,4.1-6.2,8-7.9,13.5c-2.2,13-3.1,26.4-2.6,\n          39.7c-0.5,22.9-2.9,45.9-5.3,68.1C505.7,307.7,503.6,328,502.8,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M512.3,348.2l-0.5,0c0.9-20.3,3.4-40.6,5.8-60.2c2.7-22.2,5.6-45.2,6.1-68.1c-0.6-13.3,0.5-26.6,3.2-39.6\n      c2.6-5.3,6-9.3,9.3-13.1c4.1-4.7,8.3-9.5,10.8-16.7l0.5,0.2c-2.5,7.3-6.8,12.2-10.9,16.9c-3.3,3.8-6.7,7.7-9.2,12.9\n      c-2.7,12.9-3.7,26.2-3.1,39.4c-0.5,23-3.4,46-6.1,68.2C515.8,307.6,513.3,327.9,512.3,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M521.9,348.2l-0.5,0c1-20.4,3.9-40.7,6.6-60.4c3.1-22.2,6.3-45.2,6.9-68.2c-0.7-13.3,0.6-26.6,3.7-39.5\n      c3-5.7,7.1-9.9,11.1-13.9c4.5-4.5,9.1-9.2,12.1-15.9l0.5,0.2c-3.1,6.7-7.8,11.5-12.2,16c-4,4-8.1,8.2-11,13.8\n      c-3.1,12.8-4.4,26-3.7,39.3c-0.6,23-3.8,46-6.9,68.2C525.8,307.5,522.9,327.8,521.9,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M531.5,348.2l-0.5,0c1.2-20.5,4.3-40.8,7.4-60.5c3.5-22.2,7-45.1,7.7-68.2c-0.8-13.3,0.6-26.5,4.2-39.3\n      c3.4-6,8.3-10.6,13.1-14.9c4.7-4.4,9.7-8.9,13.1-14.9l0.5,0.3c-3.5,6.1-8.5,10.6-13.3,15c-4.9,4.5-9.6,8.8-12.9,14.7\n      c-3.5,12.7-4.9,25.9-4.2,39.1c-0.7,23.1-4.3,46.1-7.7,68.3C535.8,307.4,532.6,327.7,531.5,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M541,348.2l-0.5,0c1.3-20.6,4.8-41,8.2-60.7c3.8-22.2,7.8-45.1,8.5-68.3c1-29.2,7.8-37.3,19.1-50.7\n      c4.2-5,8.9-10.6,14.3-18.2l0.4,0.3c-5.4,7.7-10.1,13.3-14.3,18.3c-11.3,13.3-18.1,21.4-19,50.4c-0.8,23.2-4.7,\n      46.1-8.5,68.3C545.8,307.2,542.3,327.6,541,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M550.6,348.2l-0.5,0c1.4-20.7,5.3-41.1,9-60.8c4.2-22.2,8.5-45.1,9.3-68.3c1.1-30.6,8.5-38.6,21.9-53\n      c4.1-4.4,8.7-9.4,14-15.8l0.4,0.3c-5.2,6.4-9.9,11.4-14,15.9c-13.3,14.3-20.7,22.2-21.8,52.6c-0.8,23.3-5.2,\n      46.2-9.3,68.4C555.8,307.1,552,327.5,550.6,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M560.1,348.2l-0.5,0c1.7-21.9,6-43.1,10.2-63.6c3.7-18.4,7.6-37.5,9.6-56.9c0.5-5,0.5-10.2,0.5-15.2\n      c-0.1-12.1-0.1-24.6,7.3-35.5c4.1-6,10.3-10.5,16.2-14.9c4.9-3.6,10-7.3,13.9-11.8l0.4,0.4c-4,4.6-9.1,8.3-14,11.9\n      c-5.9,4.3-12,8.8-16.1,14.7c-7.4,10.8-7.3,23.2-7.2,35.2c0,5,0.1,10.2-0.5,15.3c-1.9,19.4-5.8,38.5-9.6,56.9\n      C566.1,305.1,561.8,326.3,560.1,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M569.7,348.2l-0.5,0c1.8-22,6.5-43.3,11-63.8c4-18.4,8.2-37.5,10.3-57c0.5-5.1,0.5-10.3,0.5-15.3\n      c0-12,0-24.4,7.6-35.3c4.3-6.2,10.7-10.7,17-15.1c4.9-3.5,10-7.1,14-11.4l0.4,0.4c-4,4.4-9.2,8-14.1,11.5\n      c-6.2,4.4-12.6,8.9-16.8,15c-7.5,10.8-7.5,22.5-7.5,35c0,5,0,10.3-0.5,15.3c-2.1,19.5-6.3,38.6-10.3,57\n      C576.2,305,571.5,326.2,569.7,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M579.2,348.2l-0.5,0c2-22.2,7-43.4,11.8-64c4.3-18.4,8.8-37.5,11.1-57.1c0.6-5.1,0.6-10.3,0.7-15.3\n      c0.1-12.2,0.2-23.8,7.9-34.8c4.3-6.2,10.9-10.8,17.3-15.2c5.1-3.5,10.3-7.2,14.4-11.6l0.4,0.4c-4.1,4.5-9.4,\n      8.1-14.5,11.7c-6.3,4.4-12.9,9-17.2,15.1c-7.7,10.8-7.7,22.3-7.8,34.5c0,5-0.1,10.2-0.7,15.3c-2.3,19.6-6.8,\n      38.7-11.1,57.2C586.2,304.8,581.2,326,579.2,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M588.8,348.2l-0.5-0.1c2.1-22.5,7.3-43.9,12.4-64.6c4.4-18.1,9-36.8,11.4-56.2c0.6-5,0.8-10.1,0.9-14.9\n      c0.4-12.4,0.7-24,8.8-35.1c4.5-6.2,11.2-10.8,17.7-15.3c5.2-3.6,10.5-7.3,14.7-11.8l0.4,0.4c-4.2,4.5-9.6,8.2-14.8,\n      11.8c-6.5,4.5-13.1,9.1-17.5,15.2c-7.9,11-8.3,22.6-8.7,34.8c-0.1,4.9-0.3,9.9-1,15c-2.5,19.4-7,38.1-11.5,56.2\n      C596.1,304.3,590.9,325.8,588.8,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M598.4,348.2l-0.5-0.1c2.4-22.6,7.8-44.3,13-65.2c4.5-17.8,9-36.3,11.8-55.3c0.7-5,1-9.9,1.2-14.7\n      c0.7-12.4,1.3-24.2,9.6-35.4c4.6-6.2,11.4-10.9,18-15.4c5.3-3.7,10.8-7.4,15.1-12l0.4,0.4c-4.3,4.5-9.8,8.3-15.1,12\n      c-6.6,4.5-13.3,9.2-17.8,15.3c-8.2,11.1-8.8,22.8-9.5,35.1c-0.3,4.8-0.5,9.7-1.2,14.7c-2.7,19-7.3,37.5-11.8,55.3\n      C606.1,303.9,600.7,325.6,598.4,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M607.9,348.2l-0.5-0.1c2.7-22.6,8.3-44.4,13.6-65.5c4.5-17.7,9.1-36,12.1-54.7c0.8-4.9,1.2-9.7,1.5-14.4\n          c1-12.5,1.9-24.4,10.5-35.7c4.7-6.1,11.6-10.9,18.3-15.5c5.4-3.7,11-7.6,15.4-12.1l0.4,0.4c-4.4,4.6-10,\n          8.5-15.5,12.2c-6.7,4.6-13.6,9.3-18.2,15.4c-8.5,11.2-9.4,23-10.4,35.4c-0.4,4.7-0.7,9.5-1.5,14.4c-3,\n          18.8-7.6,37.1-12.1,54.8C616.2,303.8,610.6,325.6,607.9,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M617.5,348.2l-0.5-0.1c3.1-22.7,8.8-44.6,14.2-65.8c4.5-17.5,9.2-35.6,12.4-54.1c0.8-4.8,1.3-9.5,1.8-14.1\n          c1.3-12.6,2.5-24.6,11.4-36.1c4.8-6.1,11.8-10.9,18.6-15.6c5.6-3.8,11.3-7.7,15.8-12.3l0.4,0.4c-4.5,4.7-10.3,\n          8.6-15.9,12.4c-6.8,4.6-13.8,9.4-18.5,15.5c-8.8,11.4-10,23.2-11.3,35.8c-0.5,4.5-0.9,9.2-1.8,14.1c-3.2,\n          18.5-7.9,36.6-12.4,54.2C626.2,303.6,620.5,325.5,617.5,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M627,348.2l-0.5-0.1c3.4-22.7,9.3-44.8,14.9-66.2c4.6-17.3,9.3-35.2,12.7-53.4c0.9-4.7,1.5-9.3,2-13.7\n          c1.6-12.8,3.1-24.8,12.3-36.4c4.9-6.1,12-11,18.9-15.7c5.7-3.9,11.6-7.8,16.1-12.5l0.4,0.4c-4.6,4.7-10.5,\n          8.7-16.2,12.6c-6.9,4.7-14,9.5-18.8,15.5c-9.1,11.5-10.6,22.9-12.2,36.2c-0.5,4.4-1.1,9-2,13.7c-3.4,\n          18.2-8.2,36.1-12.7,53.5C636.3,303.4,630.5,325.5,627,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M636.6,348.2l-0.5-0.1c3.8-22.8,9.8-45.1,15.6-66.6c4.6-17.1,9.4-34.8,13-52.7c0.9-4.6,1.6-9,2.2-13.2\n          c2-13.5,3.7-25.1,13.3-36.9c5-6.1,12.2-11,19.2-15.7c5.8-3.9,11.8-8,16.5-12.7l0.4,0.4c-4.7,4.8-10.8,8.9-16.6,\n          12.8c-7,4.7-14.1,9.6-19.1,15.6c-9.5,11.7-11.2,23.2-13.2,36.6c-0.6,4.3-1.3,8.7-2.2,13.3c-3.6,17.9-8.4,\n          35.6-13,52.7C646.4,303.1,640.4,325.4,636.6,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M646.2,348.2l-0.5-0.1c4.2-22.9,10.3-45.4,16.3-67.2c4.6-16.9,9.4-34.3,13.2-51.9c1-4.4,1.7-8.7,2.4-12.8\n          c2.3-13.6,4.3-25.4,14.3-37.4c5.1-6.1,12.4-11,19.5-15.8c5.9-4,12.1-8.1,16.9-13l0.4,0.4c-4.8,4.9-11,9-17,13\n          c-7,4.7-14.3,9.6-19.4,15.7c-9.9,11.9-11.9,23.6-14.1,37.1c-0.7,4.1-1.4,8.3-2.4,12.8c-3.8,17.6-8.6,35-13.2,\n          51.9C656.5,302.8,650.3,325.3,646.2,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M655.7,348.2l-0.5-0.1c4.5-23.1,10.9-45.9,17.1-67.9c4.6-16.6,9.4-33.7,13.4-50.8c1-4.3,1.8-8.3,2.5-12.2\n          c2.6-13.8,4.9-25.8,15.3-38c5.2-6.1,12.6-11.1,19.7-15.8c6.1-4.1,12.4-8.3,17.3-13.2l0.4,0.4c-5,4.9-11.3,\n          9.2-17.4,13.2c-7.1,4.8-14.5,9.7-19.6,15.7c-10.3,12.1-12.5,24-15.2,37.7c-0.7,3.9-1.5,8-2.5,12.2c-4,17.2-8.8,\n          34.3-13.4,50.9C666.6,302.3,660.2,325.1,655.7,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M665.3,348.2l-0.5-0.1c4.5-21.4,10.6-42.5,16.5-62.9c5.2-18.1,10.6-36.8,14.9-55.5c0.8-3.4,1.4-6.6,2.1-9.7\n          c3.2-15.4,5.7-27.6,16.9-40.5c5.3-6.1,12.8-11.1,20-15.9c6.2-4.1,12.6-8.4,17.7-13.4l0.4,0.4c-5.1,5-11.5,\n          9.3-17.8,13.5c-7.2,4.8-14.6,9.7-19.9,15.8c-11.1,12.7-13.6,24.9-16.8,40.2c-0.6,3.1-1.3,6.3-2.1,9.7c-4.3,\n          18.8-9.7,37.5-14.9,55.6C675.9,305.7,669.8,326.9,665.3,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M674.8,348.2l-0.5-0.1c4.9-21.7,11.2-43.1,17.3-63.9c5.2-17.7,10.6-36,15-54.2c0.8-3.2,1.5-6.2,2.1-9.1\n          c3.5-15.6,6.3-28,18-41c5.4-6.1,13-11.1,20.3-15.9c6.3-4.2,12.9-8.6,18.1-13.6l0.4,0.4c-5.2,5.1-11.8,9.5-18.2,\n          13.7c-7.3,4.8-14.8,9.8-20.2,15.8c-11.5,13-14.3,25.2-17.8,40.8c-0.7,2.9-1.4,6-2.1,9.2c-4.5,18.3-9.8,36.6-15,\n          54.3C686,305.1,679.7,326.6,674.8,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M684.4,348.2l-0.5-0.1c5.3-21.8,11.8-43.6,18.1-64.7c5.2-17.4,10.6-35.3,15.2-53.2c0.8-2.9,1.4-5.6,2.1-8.3\n          c3.9-15.9,7-28.5,19.2-41.9c5.5-6.1,13.1-11.1,20.5-16c6.5-4.3,13.2-8.7,18.5-13.9l0.4,0.4c-5.4,5.2-12.1,\n          9.6-18.6,13.9c-7.3,4.8-14.9,9.8-20.4,15.9c-12,13.2-15.1,25.8-19,41.6c-0.7,2.7-1.3,5.4-2.1,8.3c-4.7,17.9-10,\n          35.9-15.2,53.2C696.2,304.6,689.7,326.4,684.4,348.2"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M314.1,150.7c-70.6,0-141.3,0-211.6-0.1v-0.6c157.9,0.1,318.4,0,473.7,0c67.1,0,134.3,0,201.4,0v0.5\n          c-67.1,0-134.3,0-201.4,0C490,150.7,402.2,150.7,314.1,150.7 M309.9,157c-67.7,0-135.6-0.4-203-1.6l0-0.5\n          c147.4,2.7,297.1,1.5,441.8,0.5c73.7-0.6,149.9-1.1,224.9-1.2v0.5c-75,0.1-151.2,0.6-224.9,1.2C470.2,156.4,\n          390.2,157,309.9,157M305.8,162.4c-64.2,0-128.7-0.6-192.7-2.3l0-0.6c136.5,3.7,274.7,2.2,408.5,0.8c80.8-0.9,\n          164.3-1.7,246.6-1.5v0.6c-82.3-0.3-165.8,0.6-246.6,1.5C450.6,161.6,378.3,162.4,305.8,162.4 M301.8,166.9\n          c-60.6,0-121.4-0.6-181.8-2.5l0-0.5c125.5,3.8,252.8,2.4,375.8,1c87.1-1,177.2-2,265.9-1.1l0,\n          0.6c-88.8-0.9-178.8,0.1-265.9,1.1C432.1,166.2,367.1,166.9,301.8,166.9M298.2,170.8c-57.1,\n          0-114.4-0.6-171.3-2.3l0-0.5c115.3,3.4,232.3,2.2,345.4,1.1c92.7-1,188.6-1.9,283-0.4l0,0.5\n          c-94.4-1.6-190.3-0.6-283,0.4C415,170.2,356.8,170.8,298.2,170.8 M295.8,174c-54.3,0-108.7-0.5-162.8-2l0-0.5\n          c106.5,2.9,214.6,2,319.2,1.1c97.3-0.9,198-1.7,297,0.5l0,0.5c-99-2.2-199.7-1.4-297-0.5C400.8,173.5,348.4,174,\n          295.8,174M744.1,177c-102.8-2.8-207.4-2-308.4-1.3c-97.7,0.7-198.6,1.5-298-1l0-0.6c99.4,2.5,200.3,1.7,298,1\n          c101.1-0.8,205.6-1.6,308.5,1.3L744.1,177z"
                }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d:
                    "M739.8,179.7c-102.9-2.6-207.6-2-308.7-1.5c-94.7,0.5-192.6,1-288.9-1l0-0.5c96.3,2,194.2,1.5,288.9,1\n          c101.2-0.5,205.8-1.1,308.8,1.5L739.8,179.7L739.8,179.7z M734.7,183.1c-102.5-1.9-206.6-1.6-307.3-1.3\n          c-91.9,0.2-187,0.5-280.5-0.9l0-0.5c93.5,1.4,188.6,1.1,280.5,0.9c100.7-0.3,204.9-0.5,307.3,1.3L734.7,\n          183.1L734.7,183.1zM730,187.4c-104.8-0.8-211.4-0.7-314.5-0.7c-86.7,0-176.4,0.1-264.6-0.4v-0.6c88.2,\n          0.5,177.9,0.4,264.6,0.4c103.1,0,209.6-0.1,314.5,0.7C730,186.9,730,187.4,730,187.4z M313.6,194.7c-53.3,\n          0-106.8,0-159.8-0.1V194c114.3,0.2,230.5,0.1,342.9,0c75.5-0.1,153.5-0.1,230.3-0.1v0.5c-76.8,0-154.8,0-230.3,\n          0.1C436.5,194.6,375.1,194.7,313.6,194.7M276.2,203.9c-40.1,0-80.2-0.1-120.1-0.3V203c98.5,0.5,198.6,0.2,295.4,\n          0c89.5-0.3,182-0.5,272.9-0.1v0.5c-91-0.4-183.5-0.1-272.9,0.1C393.9,203.7,335.1,203.9,276.2,203.9 M255.3,\n          212.7c-32.3,0-64.6-0.1-96.8-0.4v-0.6c90.7,0.7,183,0.2,272.2-0.3c95.5-0.5,194.4-1.1,291.5-0.1l0,\n          0.6c-97.2-1-196-0.4-291.5,0.1C373.1,212.4,314.2,212.7,255.3,212.7M242.6,221.2c-27.3,0-54.7-0.1-81.8-0.4\n          v-0.5c86.1,0.9,173.6,0.1,258.2-0.7c98.7-0.9,200.8-1.8,301.2-0.1l0,0.5c-100.4-1.8-202.4-0.8-301.1,0.1C361.1,\n          220.7,301.8,221.2,242.6,221.2 M220.9,229.2c-19.4,0-38.7-0.1-57.9-0.2v-0.5c79,0.7,159.2-0.2,236.9-1.1\n          c104.3-1.2,212.2-2.5,318.2,0.2l0,0.5c-106-2.7-213.9-1.4-318.2-0.2C341.2,228.5,280.9,229.2,220.9,\n          229.2 M208.8,237c-14.6,0-29.1-0.1-43.6-0.2v-0.6c74.8,0.6,150.9-0.5,224.5-1.5c107-1.5,217.7-3.1,326.4,0.4l0,\n          0.5c-108.7-3.5-219.4-1.9-326.4-0.4C330.4,236.2,269.4,237,208.8,237 M206.8,244.9c-13.2,0-26.3,\n          0-39.4-0.1v-0.6c73.3,0.6,147.9-0.6,220.1-1.8c107.1-1.7,217.8-3.5,326.6,0.5l0,\n          0.5c-108.7-4-219.5-2.2-326.5-0.5C328.3,243.9,267.3,244.9,206.8,244.9 M214.5,252.8c-15,\n          0-29.9-0.1-44.8-0.2V252c74.4,0.7,150-0.6,223.2-1.8c104.7-1.8,212.9-3.7,319.2,0.4l0,\n          0.5c-106.3-4.1-214.5-2.2-319.2-0.4C334.3,251.7,274.2,252.8,214.5,252.8 M231.8,260.8\n          c-20,0-39.9-0.1-59.8-0.4l0-0.5c78,1.1,157.3-0.3,234-1.6c99.6-1.7,202.6-3.5,303.8,0.1l0,\n          0.5c-101.2-3.6-204.2-1.8-303.8-0.1C348.9,259.8,290.2,260.8,231.8,260.8 M259,269.2c-28.3,\n          0-56.5-0.2-84.6-0.8l0-0.5c84.8,1.8,171,0.3,254.3-1.1c91.4-1.6,185.8-3.2,278.7-0.5l0,\n          0.5c-92.9-2.7-187.4-1.1-278.7,0.5C373,268.3,316,269.2,259,269.2 M294.9,278.2c-39.4,\n          0-78.8-0.5-118-1.7l0-0.5c95.7,3,192.9,1.4,287-0.2c78.9-1.3,160.6-2.7,240.9-1.3l0,0.5c-80.3-1.4-161.9,\n          0-240.8,1.3C408.3,277.3,351.7,278.2,294.9,278.2 M335.9,288.1c-52.3,0-104.6-0.8-156.4-3.1l0-0.5c112.8,\n          5,228,2.9,339.4,0.9c60-1.1,122-2.2,182.8-2.2v0.5c-60.8,0-122.8,1.1-182.8,2.2C458.7,286.9,397.3,288.1,335.9,\n          288.1 M331.3,295.4c-49.9,0-99.9-0.7-149.4-2.8l0-0.5c109.5,4.6,221.3,2.6,329.4,0.7c61.6-1.1,125.2-2.2,\n          187.7-2.1v0.5c-62.5-0.1-126.1,1-187.7,2.1C452.1,294.4,391.8,295.4,331.3,295.4 M327,309.3c-47,\n          0-94.1-0.5-140.8-2l0-0.5c105.5,3.3,213,1.8,317,0.3c62.7-0.9,127.6-1.8,191.3-1.6v0.6c-63.7-0.2-128.6,\n          0.7-191.3,1.6C445.2,308.5,386.2,309.3,327,309.3 M326.4,316\n          c-46.2,0-92.4-0.4-138.3-1.5l0-0.5c104.3,2.6,210.4,1.4,313.1,0.2c62.8-0.7,127.7-1.4,191.5-1.3v0.5\n          c-63.8-0.1-128.7,0.6-191.5,1.3C443.7,315.3,385.1,316,326.4,316 M440.6,321.5c19.9-0.1,39.7-0.3,59.4-0.5\n          c62.6-0.5,127.3-1.1,190.9-0.9v0.5c-63.6-0.1-128.3,0.4-190.9,0.9c-57,0.5-115,1-173.2,1 M326.7,322.5c-45.7,\n          0-91.5-0.3-136.9-1.1l0-0.5c83.3,1.5,167.8,1.3,250.8,0.6 M328.1,329c-45.6,0-91.3-0.2-136.6-0.7l0-0.5c102.7,\n          1.3,207.2,0.7,308.3,0.1c62.1-0.3,126.3-0.7,189.4-0.6v0.6c-63.1-0.1-127.3,0.3-189.4,0.6C443.3,328.7,385.8,\n          329,328.1,329 M331.5,335.4c-46.2,0-92.4-0.1-138.3-0.4v-0.5c102.6,0.7,207,0.4,308,0.1c61.1-0.2,124.3-0.4,\n          186.4-0.3v0.6c-62.1,0-125.3,0.1-186.4,0.3C445.4,335.2,388.5,335.4,331.5,335.4 M339.5,341.9c-48.3,0-96.6,\n          0-144.7-0.2v-0.5c103.8,0.3,209.3,0.2,311.3,0.1c58.9-0.1,119.8-0.1,179.7-0.1v0.5c-59.9,0-120.8,0.1-179.7,\n          0.1C451.4,341.8,395.5,341.9,339.5,341.9 M359.1,348.4c-54.2,0-108.3,0-162.5,0v-0.5c108.3,0,216.7,0,325,\n          0l162.5,0v0.5l-162.5,0C467.5,348.4,413.3,348.4,359.1,348.4"
                }
              }),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bm",
                      d:
                        "M153.6,189.1c-1,0-2-0.3-2.9-0.9l-51.3-33.9c-2.4-1.6-3.1-4.9-1.5-7.4\n      c1.6-2.4,4.9-3.1,7.4-1.5l51.3,33.9c2.4,1.6,3.1,4.9,1.5,7.4C157,188.3,155.3,189.1,153.6,189.1"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bm_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-193.21",
                          y1: "751.401",
                          x2: "-193.297",
                          y2: "751.3002",
                          gradientTransform:
                            "matrix(61.8714 0 0 -44.4957 12084.1494 33599.332)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.4693" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D5D5D5" },
                          attrs: { offset: "0.5405" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.7894" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st105",
                      attrs: {
                        id: "prefix__bm_1_",
                        d:
                          "M153.6,189.1c-1,0-2-0.3-2.9-0.9l-51.3-33.9c-2.4-1.6-3.1-4.9-1.5-7.4\n      c1.6-2.4,4.9-3.1,7.4-1.5l51.3,33.9c2.4,1.6,3.1,4.9,1.5,7.4C157,188.3,155.3,189.1,153.6,189.1"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bo",
                      d:
                        "M728.2,189.1c-1.7,0-3.4-0.8-4.4-2.4c-1.6-2.4-0.9-5.7,1.5-7.4l51.3-33.9\n      c2.4-1.6,5.7-0.9,7.4,1.5c1.6,2.4,0.9,5.7-1.5,7.4l-51.3,33.9C730.2,188.8,729.2,189.1,728.2,189.1"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bo_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-193.3336",
                          y1: "751.4563",
                          x2: "-193.2035",
                          y2: "751.3245",
                          gradientTransform:
                            "matrix(61.8724 0 0 -44.4966 12710.1602 33600)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.4693" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#C7C7C7" },
                          attrs: { offset: "0.5385" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.7894" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st106",
                      attrs: {
                        id: "prefix__bo_1_",
                        d:
                          "M728.2,189.1c-1.7,0-3.4-0.8-4.4-2.4c-1.6-2.4-0.9-5.7,1.5-7.4l51.3-33.9\n      c2.4-1.6,5.7-0.9,7.4,1.5c1.6,2.4,0.9,5.7-1.5,7.4l-51.3,33.9C730.2,188.8,729.2,189.1,728.2,189.1"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bq",
                      d:
                        "M731.8,183.4c0.4-1.3,0.1-2.8-0.7-3.9c-0.8-1.1-2.1-1.8-3.5-1.8H153\n      c-1.4,0-2.7,0.7-3.5,1.8c-0.8,1.1-1.1,2.5-0.7,3.9l0.9,3.2h581.3L731.8,183.4z"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bq_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-197.5046",
                          y1: "715.0063",
                          x2: "-197.5046",
                          y2: "714.0063",
                          gradientTransform:
                            "matrix(583.4112 0 0 -8.847 115666.6406 6503.4224)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.456" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#C8C8C8" },
                          attrs: { offset: "0.5975" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.9122" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st107",
                      attrs: {
                        id: "prefix__bq_1_",
                        d:
                          "M731.8,183.4c0.4-1.3,0.1-2.8-0.7-3.9c-0.8-1.1-2.1-1.8-3.5-1.8H153\n      c-1.4,0-2.7,0.7-3.5,1.8c-0.8,1.1-1.1,2.5-0.7,3.9l0.9,3.2h581.3L731.8,183.4z"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bs",
                      d:
                        "M195.8,349.9c0.7,2.3,3.1,3.7,5.5,3c2.4-0.7,3.7-3.1,3.1-5.5l-45.5-160.3h-9.2\n      L195.8,349.9L195.8,349.9z"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bs_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-192.6151",
                          y1: "758.0818",
                          x2: "-192.6337",
                          y2: "758.0654",
                          gradientTransform:
                            "matrix(54.8333 0 0 -165.9138 10739.6133 126042.4063)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#E1E1E1" },
                          attrs: { offset: "0.3323" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.5471" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.7894" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st108",
                      attrs: {
                        id: "prefix__bs_1_",
                        d:
                          "M195.8,349.9c0.7,2.3,3.1,3.7,5.5,3c2.4-0.7,3.7-3.1,3.1-5.5l-45.5-160.3h-9.2\n      L195.8,349.9L195.8,349.9z"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bu",
                      d:
                        "M721.7,187.2l-45.5,160.3c-0.7,2.4,0.7,4.8,3,5.5c0.4,0.1,0.8,0.2,1.2,0.2\n      c1.9,0,3.7-1.3,4.3-3.2l46.2-162.7L721.7,187.2L721.7,187.2z"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bu_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-192.5974",
                          y1: "758.0408",
                          x2: "-192.5786",
                          y2: "758.025",
                          gradientTransform:
                            "matrix(54.8323 0 0 -165.915 11265.832 126043.3203)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#CACACA" },
                          attrs: { offset: "0.4233" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.548" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.7894" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st109",
                      attrs: {
                        id: "prefix__bu_1_",
                        d:
                          "M721.7,187.2l-45.5,160.3c-0.7,2.4,0.7,4.8,3,5.5c0.4,0.1,0.8,0.2,1.2,0.2\n      c1.9,0,3.7-1.3,4.3-3.2l46.2-162.7L721.7,187.2L721.7,187.2z"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bw",
                      d:
                        "M679.6,352.4H200.7c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4h478.9c2.4,0,4.4,2,4.4,4.4\n      C684,350.4,682,352.4,679.6,352.4"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bw_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-197.4054",
                          y1: "715.0012",
                          x2: "-197.4054",
                          y2: "714.0012",
                          gradientTransform:
                            "matrix(487.775 0 0 -8.846 96729.5547 6668.4287)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.4693" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#C6C4C4" },
                          attrs: { offset: "0.5601" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.7894" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st110",
                      attrs: {
                        id: "prefix__bw_1_",
                        d:
                          "M679.6,352.4H200.7c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4h478.9\n      c2.4,0,4.4,2,4.4,4.4C684,350.4,682,352.4,679.6,352.4"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__by",
                      d:
                        "M101.5,382c-1.9,0-3.6-1.2-4.2-3.2c-0.7-2.3,0.6-4.8,2.9-5.5l99.2-29.7\n      c2.3-0.7,4.7,0.7,5.4,3c0.7,2.3-0.6,4.8-2.9,5.5l-99.2,29.7C102.3,382,101.9,382,101.5,382"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__by_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-195.3122",
                          y1: "749.9836",
                          x2: "-195.2908",
                          y2: "749.9586",
                          gradientTransform:
                            "matrix(107.9238 0 0 -38.5112 21226.1543 29243.9727)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.4693" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#C7C7C7" },
                          attrs: { offset: "0.8602" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.9095" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st111",
                      attrs: {
                        id: "prefix__by_1_",
                        d:
                          "M101.5,382c-1.9,0-3.6-1.2-4.2-3.2c-0.7-2.3,0.6-4.8,2.9-5.5l99.2-29.7\n      c2.3-0.7,4.7,0.7,5.4,3c0.7,2.3-0.6,4.8-2.9,5.5l-99.2,29.7C102.3,382,101.9,382,101.5,382"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bA",
                      d:
                        "M780.4,382c-0.4,0-0.8-0.1-1.3-0.2l-100.8-29.7c-2.3-0.7-3.7-3.1-3-5.5\n      c0.7-2.3,3.2-3.7,5.5-3l100.8,29.7c2.3,0.7,3.7,3.1,3,5.5C784,380.8,782.3,382,780.4,382"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bA_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-195.3541",
                          y1: "749.8986",
                          x2: "-195.373",
                          y2: "749.8754",
                          gradientTransform:
                            "matrix(109.6046 0 0 -38.5105 22137.7969 29243.4277)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.4693" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#C1BEBE" },
                          attrs: { offset: "0.6472" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.9305" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st112",
                      attrs: {
                        id: "prefix__bA_1_",
                        d:
                          "M780.4,382c-0.4,0-0.8-0.1-1.3-0.2l-100.8-29.7c-2.3-0.7-3.7-3.1-3-5.5\n      c0.7-2.3,3.2-3.7,5.5-3l100.8,29.7c2.3,0.7,3.7,3.1,3,5.5C784,380.8,782.3,382,780.4,382"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bC",
                      d:
                        "M101.1,381.9h2.4c2.3,0,4.1-1.8,4.1-4.1V155.2h0.1L97,144.9v232.9\n      C97,380.1,98.9,381.9,101.1,381.9"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bC_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-170.4331",
                          y1: "758.7918",
                          x2: "-170.4313",
                          y2: "758.7918",
                          gradientTransform:
                            "matrix(10.697 0 0 -237.04 1925.5055 180127.7969)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.4693" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#CECDCD" },
                          attrs: { offset: "0.5317" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.7894" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st113",
                      attrs: {
                        id: "prefix__bC_1_",
                        d:
                          "M101.1,381.9h2.4c2.3,0,4.1-1.8,4.1-4.1V155.2h0.1L97,144.9v232.9\n      C97,380.1,98.9,381.9,101.1,381.9"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bE",
                      d:
                        "M774.1,155.6v222.2c0,2.3,1.8,4.1,4.1,4.1h2.4c2.3,0,4.1-1.8,4.1-4.1V144.8L774.1,155.6\n      L774.1,155.6z"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bE_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-170.2227",
                          y1: "758.7947",
                          x2: "-170.2209",
                          y2: "758.7947",
                          gradientTransform:
                            "matrix(10.616 0 0 -237.049 2586.5076 180134.6406)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EAEAEA" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#D4D4D4" },
                          attrs: { offset: "0.4756" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#CBCBCB" },
                          attrs: { offset: "0.5433" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.7894" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st114",
                      attrs: {
                        id: "prefix__bE_1_",
                        d:
                          "M774.1,155.6v222.2c0,2.3,1.8,4.1,4.1,4.1h2.4c2.3,0,4.1-1.8,4.1-4.1V144.8\n              L774.1,155.6L774.1,155.6z"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("g", { attrs: { transform: "translate(0 .136)" } }, [
                _c("g", [
                  _c("path", {
                    staticClass: "st104",
                    attrs: {
                      id: "prefix__bG",
                      d:
                        "M784.7,144.6H97v0.2l10.7,10.4h666.4v0.4l10.6-10.7V144.6z"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "g",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "prefix__bG_2_",
                          gradientUnits: "userSpaceOnUse",
                          x1: "-197.5812",
                          y1: "723.9365",
                          x2: "-197.5812",
                          y2: "722.9365",
                          gradientTransform:
                            "matrix(687.692 0 0 -10.978 136315.9219 8091.9858)"
                        }
                      },
                      [
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "0" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#EEEBEB" },
                          attrs: { offset: "0.2148" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#C6C6C6" },
                          attrs: { offset: "0.4693" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#ECECEC" },
                          attrs: { offset: "0.7894" }
                        }),
                        _vm._v(" "),
                        _c("stop", {
                          staticStyle: { "stop-color": "#FFFFFF" },
                          attrs: { offset: "1" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st115",
                      attrs: {
                        id: "prefix__bG_1_",
                        d:
                          "M784.7,144.6H97v0.2l10.7,10.4h666.4v0.4l10.6-10.7V144.6z"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("line", {
            staticClass: "st116",
            attrs: { x1: "-9", y1: "507.7", x2: "891", y2: "507.7" }
          }),
          _vm._v(" "),
          _c("path", { staticClass: "st117", attrs: { d: "M159.9,541.6" } }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st103",
            attrs: {
              d:
                "M702.6,506.6c-54.1,44.6-153.9,74.5-267.9,74.5c-113.4,0-212.7-29.6-267-73.8"
            }
          }),
          _vm._v(" "),
          _c("path", { staticClass: "st117", attrs: { d: "M539.5,327.8" } }),
          _vm._v(" "),
          _c("path", { staticClass: "st117", attrs: { d: "M434.6,319" } }),
          _vm._v(" "),
          _c("line", {
            staticClass: "st103",
            attrs: { x1: "43.2", y1: "384", x2: "-2.5", y2: "407.1" }
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "st103",
            attrs: { x1: "891.7", y1: "440.2", x2: "825.1", y2: "383.2" }
          }),
          _vm._v(" "),
          _c("line", {
            staticClass: "st118",
            attrs: { x1: "193.2", y1: "301.7", x2: "689.9", y2: "300.4" }
          }),
          _vm._v(" "),
          _vm._l(_vm.showPlays, function(play, index) {
            return _c("Ball", {
              key: index,
              attrs: { play: play },
              on: { showTooltip: _vm.showTooltip, hideTooltip: _vm.hideTooltip }
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("Tooltip", { attrs: { data: _vm.dataTooltip } }, [
        _c("div", { staticClass: "tooltip-data has-text-left" }, [
          _vm.sectionType === "team"
            ? _c("div", [
                _c("span", { staticClass: "bold" }, [_vm._v("Jugador: ")]),
                _vm._v(_vm._s(_vm.dataPlay.playerName))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "bold" }, [_vm._v("Minuto: ")]),
            _vm._v(_vm._s(_vm.dataPlay.minute))
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "bold" }, [_vm._v("Rival: ")]),
            _vm._v(_vm._s(_vm.dataPlay.rivalName) + "\n        "),
            _c("img", {
              staticStyle: { "vertical-align": "middle" },
              attrs: { src: _vm.dataPlay.rivalLogo, width: "25" }
            })
          ])
        ])
      ])
    ],
    1
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  var __vue_inject_styles__$4 = function (inject) {
    if (!inject) { return }
    inject("data-v-e5a93978_0", { source: ".goal[data-v-e5a93978] {\n  position: relative;\n  border-radius: 21px;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n  background-image: linear-gradient(to top, #417505, #ffffff 53%);\n}\n.st0[data-v-e5a93978] {\n  opacity: 0.5;\n  fill: #505050;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n  enable-background: new;\n}\n.st1[data-v-e5a93978] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st2[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter);\n}\n.st3[data-v-e5a93978] {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #ffffff;\n}\n.st4[data-v-e5a93978] {\n  mask: url(#prefix__b_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st5[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_1_);\n}\n.st6[data-v-e5a93978] {\n  mask: url(#prefix__d_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st7[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_2_);\n}\n.st8[data-v-e5a93978] {\n  mask: url(#prefix__f_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st9[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_3_);\n}\n.st10[data-v-e5a93978] {\n  mask: url(#prefix__h_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st11[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_4_);\n}\n.st12[data-v-e5a93978] {\n  mask: url(#prefix__j_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st13[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_5_);\n}\n.st14[data-v-e5a93978] {\n  mask: url(#prefix__l_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st15[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_6_);\n}\n.st16[data-v-e5a93978] {\n  mask: url(#prefix__n_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st17[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_7_);\n}\n.st18[data-v-e5a93978] {\n  mask: url(#prefix__p_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st19[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_8_);\n}\n.st20[data-v-e5a93978] {\n  mask: url(#prefix__r_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st21[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_9_);\n}\n.st22[data-v-e5a93978] {\n  mask: url(#prefix__t_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st23[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_10_);\n}\n.st24[data-v-e5a93978] {\n  mask: url(#prefix__v_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st25[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_11_);\n}\n.st26[data-v-e5a93978] {\n  mask: url(#prefix__x_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st27[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_12_);\n}\n.st28[data-v-e5a93978] {\n  mask: url(#prefix__z_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st29[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_13_);\n}\n.st30[data-v-e5a93978] {\n  mask: url(#prefix__B_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st31[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_14_);\n}\n.st32[data-v-e5a93978] {\n  mask: url(#prefix__D_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st33[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_15_);\n}\n.st34[data-v-e5a93978] {\n  mask: url(#prefix__F_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st35[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_16_);\n}\n.st36[data-v-e5a93978] {\n  mask: url(#prefix__H_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st37[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_17_);\n}\n.st38[data-v-e5a93978] {\n  mask: url(#prefix__J_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st39[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_18_);\n}\n.st40[data-v-e5a93978] {\n  mask: url(#prefix__L_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st41[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_19_);\n}\n.st42[data-v-e5a93978] {\n  mask: url(#prefix__N_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st43[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_20_);\n}\n.st44[data-v-e5a93978] {\n  mask: url(#prefix__P_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st45[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_21_);\n}\n.st46[data-v-e5a93978] {\n  mask: url(#prefix__R_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st47[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_22_);\n}\n.st48[data-v-e5a93978] {\n  mask: url(#prefix__T_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st49[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_23_);\n}\n.st50[data-v-e5a93978] {\n  mask: url(#prefix__V_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st51[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_24_);\n}\n.st52[data-v-e5a93978] {\n  mask: url(#prefix__X_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st53[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_25_);\n}\n.st54[data-v-e5a93978] {\n  mask: url(#prefix__ah_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st55[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_26_);\n}\n.st56[data-v-e5a93978] {\n  mask: url(#prefix__aj_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st57[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_27_);\n}\n.st58[data-v-e5a93978] {\n  mask: url(#prefix__al_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st59[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_28_);\n}\n.st60[data-v-e5a93978] {\n  mask: url(#prefix__an_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st61[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_29_);\n}\n.st62[data-v-e5a93978] {\n  mask: url(#prefix__ap_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st63[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_30_);\n}\n.st64[data-v-e5a93978] {\n  mask: url(#prefix__ar_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st65[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_31_);\n}\n.st66[data-v-e5a93978] {\n  mask: url(#prefix__at_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st67[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_32_);\n}\n.st68[data-v-e5a93978] {\n  mask: url(#prefix__av_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st69[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_33_);\n}\n.st70[data-v-e5a93978] {\n  mask: url(#prefix__ax_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st71[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_34_);\n}\n.st72[data-v-e5a93978] {\n  mask: url(#prefix__az_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st73[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_35_);\n}\n.st74[data-v-e5a93978] {\n  mask: url(#prefix__aB_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st75[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_36_);\n}\n.st76[data-v-e5a93978] {\n  mask: url(#prefix__aD_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st77[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_37_);\n}\n.st78[data-v-e5a93978] {\n  mask: url(#prefix__aF_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st79[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_38_);\n}\n.st80[data-v-e5a93978] {\n  mask: url(#prefix__aH_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st81[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_39_);\n}\n.st82[data-v-e5a93978] {\n  mask: url(#prefix__aJ_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st83[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_40_);\n}\n.st84[data-v-e5a93978] {\n  mask: url(#prefix__aL_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st85[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_41_);\n}\n.st86[data-v-e5a93978] {\n  mask: url(#prefix__aN_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st87[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_42_);\n}\n.st88[data-v-e5a93978] {\n  mask: url(#prefix__aP_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st89[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_43_);\n}\n.st90[data-v-e5a93978] {\n  mask: url(#prefix__aR_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st91[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_44_);\n}\n.st92[data-v-e5a93978] {\n  mask: url(#prefix__aT_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st93[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_45_);\n}\n.st94[data-v-e5a93978] {\n  mask: url(#prefix__aV_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st95[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_46_);\n}\n.st96[data-v-e5a93978] {\n  mask: url(#prefix__aX_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st97[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_47_);\n}\n.st98[data-v-e5a93978] {\n  mask: url(#prefix__aZ_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st99[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_48_);\n}\n.st100[data-v-e5a93978] {\n  mask: url(#prefix__bb_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st101[data-v-e5a93978] {\n  filter: url(#Adobe_OpacityMaskFilter_49_);\n}\n.st102[data-v-e5a93978] {\n  mask: url(#prefix__bd_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st103[data-v-e5a93978] {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 6;\n  stroke-miterlimit: 10;\n}\n.st104[data-v-e5a93978] {\n  fill: #ffffff;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st105[data-v-e5a93978] {\n  fill: url(#prefix__bm_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st106[data-v-e5a93978] {\n  fill: url(#prefix__bo_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st107[data-v-e5a93978] {\n  fill: url(#prefix__bq_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st108[data-v-e5a93978] {\n  fill: url(#prefix__bs_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st109[data-v-e5a93978] {\n  fill: url(#prefix__bu_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st110[data-v-e5a93978] {\n  fill: url(#prefix__bw_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st111[data-v-e5a93978] {\n  fill: url(#prefix__by_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st112[data-v-e5a93978] {\n  fill: url(#prefix__bA_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st113[data-v-e5a93978] {\n  fill: url(#prefix__bC_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st114[data-v-e5a93978] {\n  fill: url(#prefix__bE_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st115[data-v-e5a93978] {\n  fill: url(#prefix__bG_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st116[data-v-e5a93978] {\n  fill: #ffffff;\n  stroke: #ffffff;\n  stroke-width: 6;\n  stroke-miterlimit: 10;\n}\n.st117[data-v-e5a93978] {\n  fill: none;\n  stroke: #000000;\n  stroke-width: 10;\n  stroke-miterlimit: 10;\n}\n.st118[data-v-e5a93978] {\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-width: 2;\n  stroke-miterlimit: 10;\n}\n.goal__filters[data-v-e5a93978] {\n  position: absolute;\n  transform: translateX(31%);\n  width: 60%;\n  background-color: #ffffff;\n  opacity: 0.9;\n  border-radius: 15px;\n  padding: 10px;\n  max-width: 80%;\n  font-size: 10px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  bottom: 25px;\n}\n.goal__filters .checkbox[data-v-e5a93978] {\n  padding: 0;\n}\n@media screen and (max-width: 345px) {\n.goal__filters[data-v-e5a93978] {\n    bottom: 10px;\n}\n}\n@media (min-width: 800px) {\n.goal__filters[data-v-e5a93978] {\n    font-size: 11px;\n}\n}\n@media (min-width: 900px) {\n.goal__filters[data-v-e5a93978] {\n    font-size: 13px;\n}\n}\n.is-pointer[data-v-e5a93978] {\n  cursor: default;\n}\n.tooltip-data[data-v-e5a93978] {\n  font-family: \"Avenir-Medium\";\n  font-size: 12px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2;\n  letter-spacing: normal;\n  color: #ffffff;\n}\n.tooltip-data .bold[data-v-e5a93978] {\n  font-family: \"Avenir-Bold\";\n}\n.checkbox-list[data-v-e5a93978] {\n  padding-top: 4px;\n}\n\n/*# sourceMappingURL=SoccerGoal.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/SoccerGoal.vue","SoccerGoal.vue"],"names":[],"mappings":"AAqgEA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,+DAAA;ACpgEA;ADsgEA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;ACngEA;ADqgEA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AClgEA;ADogEA;EACA,qCAAA;ACjgEA;ADmgEA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AChgEA;ADkgEA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC//DA;ADigEA;EACA,wCAAA;AC9/DA;ADggEA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC7/DA;AD+/DA;EACA,wCAAA;AC5/DA;AD8/DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC3/DA;AD6/DA;EACA,wCAAA;AC1/DA;AD4/DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACz/DA;AD2/DA;EACA,wCAAA;ACx/DA;AD0/DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACv/DA;ADy/DA;EACA,wCAAA;ACt/DA;ADw/DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACr/DA;ADu/DA;EACA,wCAAA;ACp/DA;ADs/DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACn/DA;ADq/DA;EACA,wCAAA;ACl/DA;ADo/DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACj/DA;ADm/DA;EACA,wCAAA;ACh/DA;ADk/DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC/+DA;ADi/DA;EACA,wCAAA;AC9+DA;ADg/DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC7+DA;AD++DA;EACA,yCAAA;AC5+DA;AD8+DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC3+DA;AD6+DA;EACA,yCAAA;AC1+DA;AD4+DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACz+DA;AD2+DA;EACA,yCAAA;ACx+DA;AD0+DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACv+DA;ADy+DA;EACA,yCAAA;ACt+DA;ADw+DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACr+DA;ADu+DA;EACA,yCAAA;ACp+DA;ADs+DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACn+DA;ADq+DA;EACA,yCAAA;ACl+DA;ADo+DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACj+DA;ADm+DA;EACA,yCAAA;ACh+DA;ADk+DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC/9DA;ADi+DA;EACA,yCAAA;AC99DA;ADg+DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC79DA;AD+9DA;EACA,yCAAA;AC59DA;AD89DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC39DA;AD69DA;EACA,yCAAA;AC19DA;AD49DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACz9DA;AD29DA;EACA,yCAAA;ACx9DA;AD09DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACv9DA;ADy9DA;EACA,yCAAA;ACt9DA;ADw9DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACr9DA;ADu9DA;EACA,yCAAA;ACp9DA;ADs9DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACn9DA;ADq9DA;EACA,yCAAA;ACl9DA;ADo9DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACj9DA;ADm9DA;EACA,yCAAA;ACh9DA;ADk9DA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC/8DA;ADi9DA;EACA,yCAAA;AC98DA;ADg9DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC78DA;AD+8DA;EACA,yCAAA;AC58DA;AD88DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC38DA;AD68DA;EACA,yCAAA;AC18DA;AD48DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACz8DA;AD28DA;EACA,yCAAA;ACx8DA;AD08DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACv8DA;ADy8DA;EACA,yCAAA;ACt8DA;ADw8DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACr8DA;ADu8DA;EACA,yCAAA;ACp8DA;ADs8DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACn8DA;ADq8DA;EACA,yCAAA;ACl8DA;ADo8DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACj8DA;ADm8DA;EACA,yCAAA;ACh8DA;ADk8DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC/7DA;ADi8DA;EACA,yCAAA;AC97DA;ADg8DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC77DA;AD+7DA;EACA,yCAAA;AC57DA;AD87DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC37DA;AD67DA;EACA,yCAAA;AC17DA;AD47DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACz7DA;AD27DA;EACA,yCAAA;ACx7DA;AD07DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACv7DA;ADy7DA;EACA,yCAAA;ACt7DA;ADw7DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACr7DA;ADu7DA;EACA,yCAAA;ACp7DA;ADs7DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACn7DA;ADq7DA;EACA,yCAAA;ACl7DA;ADo7DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACj7DA;ADm7DA;EACA,yCAAA;ACh7DA;ADk7DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC/6DA;ADi7DA;EACA,yCAAA;AC96DA;ADg7DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC76DA;AD+6DA;EACA,yCAAA;AC56DA;AD86DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC36DA;AD66DA;EACA,yCAAA;AC16DA;AD46DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACz6DA;AD26DA;EACA,yCAAA;ACx6DA;AD06DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACv6DA;ADy6DA;EACA,yCAAA;ACt6DA;ADw6DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACr6DA;ADu6DA;EACA,yCAAA;ACp6DA;ADs6DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACn6DA;ADq6DA;EACA,yCAAA;ACl6DA;ADo6DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;ACj6DA;ADm6DA;EACA,yCAAA;ACh6DA;ADk6DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC/5DA;ADi6DA;EACA,yCAAA;AC95DA;ADg6DA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC75DA;AD+5DA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AC55DA;AD85DA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AC35DA;AD65DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;AC15DA;AD45DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACz5DA;AD25DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACx5DA;AD05DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACv5DA;ADy5DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACt5DA;ADw5DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACr5DA;ADu5DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACp5DA;ADs5DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACn5DA;ADq5DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACl5DA;ADo5DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACj5DA;ADm5DA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;ACh5DA;ADk5DA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AC/4DA;ADi5DA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AC94DA;ADg5DA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AC74DA;AD+4DA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AC54DA;AD84DA;EACA,UAAA;AC54DA;AD+4DA;AACA;IACA,YAAA;AC54DE;AACF;AD84DA;AACA;IACA,eAAA;AC54DE;AACF;AD84DA;AACA;IACA,eAAA;AC54DE;AACF;AD84DA;EACA,eAAA;AC54DA;AD84DA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AC34DA;AD64DA;EACA,0BAAA;AC14DA;AD44DA;EACA,gBAAA;ACz4DA;;AAEA,yCAAyC","file":"SoccerGoal.vue","sourcesContent":["<template>\n  <div class=\"goal\" ref=\"goal\">\n    <div class=\"goal__filters\">\n      <div v-for=\"(category, index) in categories\" :key=\"`${index}-1`\">\n        <BCheckbox\n          v-model=\"categoriesSelected\"\n          :key=\"index\"\n          :native-value=\"category.category_id\"\n          :name=\"category.category_name\"\n          @change.native=\"onClickCategory\"\n        >\n          <div class=\"checkbox-list\">\n            {{ category.category_name }}\n            <IconBall width=\"12px\" height=\"12px\" :color=\"category.category_color\" :st=\"category.st\"> </IconBall>\n          </div>\n        </BCheckbox>\n      </div>\n    </div>\n    <svg\n      version=\"1.1\"\n      id=\"Capa_1\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n      x=\"0px\"\n      y=\"0px\"\n      viewBox=\"0 0 888.5 651.6\"\n      style=\"enable-background:new 0 0 888.5 651.6;\"\n      xml:space=\"preserve\"\n    >\n      <g>\n        <path\n          class=\"st0\"\n          d=\"M680.2,345.5c0.1,0,0.1,0,0.1,0l0.1,0c0.2,0,0.3,0.1,0.4,0.1l100.7,29.7c2.3,0.7,3.7,1.4,3,3.7c-0.6,1.9-2.3,\n          3.2-4.2,3.2c-0.4,0-0.8-0.1-1.3-0.2L679,354.3H201.3L102.8,382c-0.4,0.1-0.8,0.2-1.2,0.2c-1.9,\n          0-3.6-1.3-4.2-3.2c-0.7-2.3,0.6-3,2.9-3.7l98.7-29.5c0.5-0.2,1-0.3,1.6-0.3c0.1,0,0.2,0,0.3,0h478.7C679.7,\n          345.4,680,345.4,680.2,345.5z\"\n        />\n        <path\n          class=\"st1\"\n          d=\"M684.9,334.3l-0.2,15l0.5,0.2l0.2-17L684.9,334.3z M688.7,320.6l-0.4,29.8l0.5,0.2l0.4-31.8L688.7,\n          320.6zM692.6,306.3l-0.6,45.3l0.5,0.2l0.6-47.4L692.6,306.3z M696.8,291.3l-0.7,61.6l0.5,0.2l0.8-63.6L696.8,\n          291.3z M701.2,275.5l-0.9,78.7l0.5,0.2l0.9-80.7L701.2,275.5z M705.7,258.9l-1,96.7l0.5,0.2l1-98.7L705.7,\n          258.9z M710.6,241.5l-1.1,115.6l0.5,0.2l1.2-117.6L710.6,241.5z M715.6,223.1l-1.2,135.5l0.5,\n          0.2l1.3-137.5L715.6,223.1z M721,203.7l-1.3,156.5l0.5,0.2l1.3-158.6L721,203.7z M726.9,182.3l-0.3,\n          0.9L725.3,362l0.5,0.2l1.4-180L726.9,182.3z M732.5,178.8l-1.2,185.1l0.5,0.2l1.2-185.6L732.5,178.8z M738.8,\n          174.8l-1.1,191.1l0.5,0.2l1.1-191.6L738.8,174.8z M745.5,170.6l-0.9,197.5l0.5,0.2l0.9-197.9L745.5,\n          170.6z M752.6,166.1l-0.8,204.3l0.5,0.2l0.8-204.7L752.6,166.1z M760.3,161.3l-0.5,211.6l0.5,\n          0.2l0.5-212.1L760.3,161.3z M768.5,156l-0.3,219.5l0.5,0.2l0.3-219.9L768.5,156z M777.4,150.4v228l0.5,\n          0.2V214.8l-0.2-64.6L777.4,150.4z\"\n        />\n        <g transform=\"translate(583.846 5.444)\">\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"101.2\"\n              y=\"62.7\"\n              width=\"93.6\"\n              height=\"92.5\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"101.2\" y=\"62.7\" width=\"93.6\" height=\"92.5\" id=\"prefix__b_1_\">\n            <g class=\"st2\">\n              <path id=\"prefix__a_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st4\"\n            d=\"M102.2,154.9l-0.3-0.4c23.2-22,54.9-53.5,91.8-91.1l0.4,0.3C157.1,101.4,125.4,132.9,102.2,154.9\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_1_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"101.1\"\n              y=\"75.1\"\n              width=\"93.7\"\n              height=\"87.8\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"101.1\" y=\"75.1\" width=\"93.7\" height=\"87.8\" id=\"prefix__d_1_\">\n            <g class=\"st5\">\n              <path id=\"prefix__c_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st6\"\n            d=\"M102.1,162.5l-0.3-0.4c23.2-21.5,55-51.3,91.9-86.4l0.3,0.4C157.1,111.2,125.3,141.1,102.1,162.5\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_2_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"101\"\n              y=\"87.5\"\n              width=\"93.7\"\n              height=\"83.1\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"101\" y=\"87.5\" width=\"93.7\" height=\"83.1\" id=\"prefix__f_1_\">\n            <g class=\"st7\">\n              <path id=\"prefix__e_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path class=\"st8\" d=\"M102,170.2l-0.3-0.4c23.2-21,55-49.2,92-81.6l0.3,0.4C157,121,125.2,149.2,102,170.2\" />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_3_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"100.9\"\n              y=\"100\"\n              width=\"93.8\"\n              height=\"78.3\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"100.9\" y=\"100\" width=\"93.8\" height=\"78.3\" id=\"prefix__h_1_\">\n            <g class=\"st9\">\n              <path id=\"prefix__g_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st10\"\n            d=\"M101.9,177.9l-0.3-0.4c23.2-18.3,55.1-44.9,92.1-76.8l0.3,0.4C156.9,133,125.1,159.6,101.9,177.9\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_4_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"100.8\"\n              y=\"112.6\"\n              width=\"93.9\"\n              height=\"73.5\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"100.8\" y=\"112.6\" width=\"93.9\" height=\"73.5\" id=\"prefix__j_1_\">\n            <g class=\"st11\">\n              <path id=\"prefix__i_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st12\"\n            d=\"M101.8,185.7l-0.3-0.4c23.3-17.9,55.1-42.8,92.2-72l0.3,0.4C156.9,142.9,125,167.8,101.8,185.7\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_5_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"100.7\"\n              y=\"125.2\"\n              width=\"94\"\n              height=\"68.7\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"100.7\" y=\"125.2\" width=\"94\" height=\"68.7\" id=\"prefix__l_1_\">\n            <g class=\"st13\">\n              <path id=\"prefix__k_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st14\"\n            d=\"M101.7,193.4l-0.3-0.4c23.3-17.4,55.2-40.6,92.3-67.2l0.3,0.4C156.8,152.8,124.9,176,101.7,193.4\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_6_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"100.6\"\n              y=\"137.8\"\n              width=\"94.1\"\n              height=\"63.8\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"100.6\" y=\"137.8\" width=\"94.1\" height=\"63.8\" id=\"prefix__n_1_\">\n            <g class=\"st15\">\n              <path id=\"prefix__m_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st16\"\n            d=\"M101.5,201.2l-0.3-0.4c23.3-14.7,55.2-36.2,92.4-62.3l0.3,0.4C156.8,165,124.8,186.5,101.5,201.2\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_7_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"100.5\"\n              y=\"150.5\"\n              width=\"94.2\"\n              height=\"58.9\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"100.5\" y=\"150.5\" width=\"94.2\" height=\"58.9\" id=\"prefix__p_1_\">\n            <g class=\"st17\">\n              <path id=\"prefix__o_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st18\"\n            d=\"M101.4,209l-0.3-0.4c23.3-14.2,55.3-34.1,92.5-57.4l0.3,0.4C156.8,174.9,124.8,194.7,101.4,209\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_8_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"100.4\"\n              y=\"163.2\"\n              width=\"94.2\"\n              height=\"54\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"100.4\" y=\"163.2\" width=\"94.2\" height=\"54\" id=\"prefix__r_1_\">\n            <g class=\"st19\">\n              <path id=\"prefix__q_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st20\"\n            d=\"M101.3,216.8l-0.3-0.4c23.3-13.7,55.3-31.8,92.6-52.4l0.2,0.4C156.7,184.9,124.6,203.1,101.3,216.8\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_9_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"100.3\"\n              y=\"176\"\n              width=\"94.3\"\n              height=\"49\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"100.3\" y=\"176\" width=\"94.3\" height=\"49\" id=\"prefix__t_1_\">\n            <g class=\"st21\">\n              <path id=\"prefix__s_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n            </g>\n          </mask>\n          <path\n            class=\"st22\"\n            d=\"M101.2,224.6l-0.2-0.5c23.3-11,55.4-27.4,92.7-47.5l0.2,0.4C156.6,197.2,124.5,213.6,101.2,224.6\"\n          />\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_10_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"100.2\"\n                y=\"188.8\"\n                width=\"94.4\"\n                height=\"44\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"100.2\" y=\"188.8\" width=\"94.4\" height=\"44\" id=\"prefix__v_1_\">\n              <g class=\"st23\">\n                <path id=\"prefix__u_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st24\"\n              d=\"M101.1,232.4l-0.2-0.5c23.4-10.5,55.5-25.2,92.9-42.5l0.2,0.5C156.6,207.2,124.4,221.9,101.1,232.4\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_11_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"100.1\"\n                y=\"201.7\"\n                width=\"94.4\"\n                height=\"39\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"100.1\" y=\"201.7\" width=\"94.4\" height=\"39\" id=\"prefix__x_1_\">\n              <g class=\"st25\">\n                <path id=\"prefix__w_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st26\"\n              d=\"M101,240.3l-0.2-0.5c23.3-10,55.5-22.9,93-37.4l0.2,0.5C156.4,217.4,124.3,230.3,101,240.3\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_12_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"100.1\"\n                y=\"214.7\"\n                width=\"94.5\"\n                height=\"34\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"100.1\" y=\"214.7\" width=\"94.5\" height=\"34\" id=\"prefix__z_1_\">\n              <g class=\"st27\">\n                <path id=\"prefix__y_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st28\"\n              d=\"M100.8,248.2l-0.2-0.5c23.4-7.2,55.5-18.4,93.1-32.4l0.2,0.5C156.4,229.8,124.2,240.9,100.8,248.2\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_13_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"100\"\n                y=\"227.7\"\n                width=\"94.6\"\n                height=\"28.9\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"100\" y=\"227.7\" width=\"94.6\" height=\"28.9\" id=\"prefix__B_1_\">\n              <g class=\"st29\">\n                <path id=\"prefix__A_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st30\"\n              d=\"M100.7,256l-0.1-0.5c23.4-6.7,55.6-16.1,93.2-27.3l0.1,0.5C156.3,239.9,124.1,249.4,100.7,256\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_14_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99.9\"\n                y=\"240.7\"\n                width=\"94.6\"\n                height=\"23.7\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99.9\" y=\"240.7\" width=\"94.6\" height=\"23.7\" id=\"prefix__D_1_\">\n              <g class=\"st31\">\n                <path id=\"prefix__C_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st32\"\n              d=\"M100.6,263.9l-0.1-0.5c23.4-6.2,55.7-13.8,93.3-22.2l0.1,0.5C156.3,250.1,124,257.8,100.6,263.9\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_15_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99.8\"\n                y=\"253.8\"\n                width=\"94.6\"\n                height=\"18.6\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99.8\" y=\"253.8\" width=\"94.6\" height=\"18.6\" id=\"prefix__F_1_\">\n              <g class=\"st33\">\n                <path id=\"prefix__E_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st34\"\n              d=\"M100.5,271.9l-0.1-0.5c23.4-3.4,55.7-9.2,93.4-17l0.1,0.5C156.2,262.6,123.9,268.5,100.5,271.9\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_16_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99.7\"\n                y=\"267\"\n                width=\"94.7\"\n                height=\"13.4\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99.7\" y=\"267\" width=\"94.7\" height=\"13.4\" id=\"prefix__H_1_\">\n              <g class=\"st35\">\n                <path id=\"prefix__G_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st36\"\n              d=\"M100.3,279.8l-0.1-0.5c23.5-2.9,55.8-6.9,93.5-11.8l0.1,0.5C156.2,272.9,123.9,277,100.3,279.8\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_17_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99.6\"\n                y=\"280.2\"\n                width=\"94.7\"\n                height=\"8.1\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99.6\" y=\"280.2\" width=\"94.7\" height=\"8.1\" id=\"prefix__J_1_\">\n              <g class=\"st37\">\n                <path id=\"prefix__I_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st38\"\n              d=\"M100.2,287.8l0-0.5c23.5-2.3,55.8-4.6,93.6-6.6l0,0.5C156.1,283.2,123.7,285.5,100.2,287.8\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_18_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99.6\"\n                y=\"293.4\"\n                width=\"94.8\"\n                height=\"3\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99.6\" y=\"293.4\" width=\"94.8\" height=\"3\" id=\"prefix__L_1_\">\n              <g class=\"st39\">\n                <path id=\"prefix__K_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5\" />\n              </g>\n            </mask>\n            <path\n              class=\"st40\"\n              d=\"M120.8,296c-7.5,0-14.4-0.1-20.7-0.2l0-0.5c23.5,0.5,55.9,0.1,93.7-1.3l0,0.5\n        C166.1,295.5,141.3,296,120.8,296\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_19_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99.5\"\n                y=\"302.7\"\n                width=\"94.9\"\n                height=\"5.5\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99.5\" y=\"302.7\" width=\"94.9\" height=\"5.5\" id=\"prefix__N_1_\">\n              <g class=\"st41\">\n                <path id=\"prefix__M_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st42\"\n              d=\"M193.8,307.7c-37.8-1.5-70.3-2.9-93.8-4l0-0.5c23.6,1.1,56,2.4,93.8,4L193.8,307.7L193.8,307.7z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_20_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99.3\"\n                y=\"310.7\"\n                width=\"95.1\"\n                height=\"10.9\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99.3\" y=\"310.7\" width=\"95.1\" height=\"10.9\" id=\"prefix__P_1_\">\n              <g class=\"st43\">\n                <path id=\"prefix__O_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z\" />\n              </g>\n            </mask>\n            <path class=\"st44\" d=\"M193.8,321.1c-37.9-4.5-70.4-7.7-93.9-9.3l0-0.5c23.5,1.6,56,4.8,94,9.3L193.8,321.1z\" />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_21_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99.1\"\n                y=\"318.7\"\n                width=\"95.3\"\n                height=\"16.3\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99.1\" y=\"318.7\" width=\"95.3\" height=\"16.3\" id=\"prefix__R_1_\">\n              <g class=\"st45\">\n                <path id=\"prefix__Q_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st46\"\n              d=\"M193.8,334.4c-38-5.1-70.5-10.2-94.1-14.6l0.1-0.5c23.5,4.5,56,9.5,94,14.6L193.8,334.4z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_22_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"99\"\n                y=\"326.8\"\n                width=\"95.5\"\n                height=\"21.7\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"99\" y=\"326.8\" width=\"95.5\" height=\"21.7\" id=\"prefix__T_1_\">\n              <g class=\"st47\">\n                <path id=\"prefix__S_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st48\"\n              d=\"M193.8,347.9c-39.3-8.3-71-15.1-94.2-20l0.1-0.5c23.1,4.9,54.8,11.7,94.2,20L193.8,347.9z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_23_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"98.9\"\n                y=\"334.8\"\n                width=\"95.6\"\n                height=\"27.2\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"98.9\" y=\"334.8\" width=\"95.6\" height=\"27.2\" id=\"prefix__V_1_\">\n              <g class=\"st49\">\n                <path id=\"prefix__U_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st50\"\n              d=\"M193.8,361.4c-38.1-11.1-70.7-19.9-94.3-25.4l0.1-0.5c23.6,5.6,56.2,14.4,94.3,25.4\n        C193.9,360.9,193.8,361.4,193.8,361.4z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_24_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"98.7\"\n                y=\"342.9\"\n                width=\"95.8\"\n                height=\"32.6\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"98.7\" y=\"342.9\" width=\"95.8\" height=\"32.6\" id=\"prefix__X_1_\">\n              <g class=\"st51\">\n                <path id=\"prefix__W_1_\" class=\"st3\" d=\"M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st52\"\n              d=\"M193.8,374.9c-38.2-11.7-70.8-22.4-94.4-30.9l0.2-0.5c23.6,8.5,56.2,19.2,94.4,30.9L193.8,374.9\n        L193.8,374.9z\"\n            />\n          </g>\n        </g>\n        <path\n          class=\"st1\"\n          d=\"M195.6,349.4l0.5-0.2l-0.2-15l-0.5-1.9L195.6,349.4z M192,350.6l0.5-0.2l-0.4-29.8l-0.5-1.9L192,\n          350.6zM188.2,351.8l0.5-0.2l-0.6-45.3l-0.5-1.9L188.2,351.8z M184.2,353l0.5-0.2l-0.7-61.6l-0.5-1.9L184.2,\n          353z M180,354.3l0.5-0.2l-0.9-78.7l-0.5-1.9L180,354.3z M175.6,355.7l0.5-0.2l-1-96.7l-0.5-1.9L175.6,\n          355.7z M170.9,357.2l0.5-0.2l-1.1-115.6l-0.5-1.9L170.9,357.2z M165.9,358.8l0.5-0.2l-1.2-135.5l-0.5-1.9L165.9,\n          358.8z M160.6,360.4l0.5-0.2l-1.3-156.5l-0.5-1.9L160.6,360.4zM155,\n          362.2l0.5-0.2l-1.4-178.8l-0.3-0.9l-0.2-0.2L155,362.2z M149,364.1l0.5-0.2l-1.2-185.1l-0.5-0.3L149,\n          364.1z M142.6,366.1l0.5-0.2L142,174.8l-0.5-0.3L142.6,366.1z M135.8,\n          368.2l0.5-0.2l-0.9-197.5l-0.5-0.3L135.8,368.2z M128.4,370.5l0.5-0.2l-0.8-204.3l-0.5-0.3L128.4,\n          370.5z M120.6,373l0.5-0.2l-0.5-211.6l-0.5-0.3L120.6,373z M112.1,375.7l0.5-0.2L112.3,156l-0.5-0.3L112.1,\n          375.7zM102.9,214.8v163.7l0.5-0.2v-228l-0.2-0.2L102.9,214.8z\"\n        />\n        <g transform=\"translate(5.308 5.444)\">\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_25_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"96.9\"\n              y=\"62.7\"\n              width=\"93.6\"\n              height=\"92.9\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"96.9\" y=\"62.7\" width=\"93.6\" height=\"92.9\" id=\"prefix__ah_1_\">\n            <g class=\"st53\">\n              <path id=\"prefix__ag_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st54\"\n            d=\"M189.4,154.9c-23.2-22-54.9-53.5-91.8-91.1l0.4-0.3c36.9,37.6,68.6,69.2,91.8,91.1L189.4,154.9L189.4,154.9z\n        \"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_26_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"75.1\"\n              width=\"93.6\"\n              height=\"88.2\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"75.1\" width=\"93.6\" height=\"88.2\" id=\"prefix__aj_1_\">\n            <g class=\"st55\">\n              <path id=\"prefix__ai_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st56\"\n            d=\"M189.6,162.5c-23.2-21.5-55-51.3-91.9-86.4l0.3-0.4c36.9,35,68.7,64.9,91.9,86.4L189.6,162.5L189.6,162.5z\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_27_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"87.5\"\n              width=\"93.7\"\n              height=\"83.4\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"87.5\" width=\"93.7\" height=\"83.4\" id=\"prefix__al_1_\">\n            <g class=\"st57\">\n              <path id=\"prefix__ak_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st58\"\n            d=\"M189.7,170.2c-23.2-21-55-49.2-92-81.6l0.3-0.4c37,32.4,68.8,60.6,92,81.6\n        C190,169.9,189.7,170.2,189.7,170.2z\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_28_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"100\"\n              width=\"93.8\"\n              height=\"78.6\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"100\" width=\"93.8\" height=\"78.6\" id=\"prefix__an_1_\">\n            <g class=\"st59\">\n              <path id=\"prefix__am_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st60\"\n            d=\"M189.8,177.9c-23.2-18.3-55.1-44.9-92.1-76.8l0.3-0.4c37,31.9,68.9,58.5,92.1,76.8L189.8,177.9z\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_29_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"112.6\"\n              width=\"93.9\"\n              height=\"73.8\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"112.6\" width=\"93.9\" height=\"73.8\" id=\"prefix__ap_1_\">\n            <g class=\"st61\">\n              <path id=\"prefix__ao_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st62\"\n            d=\"M189.9,185.7c-23.2-17.8-55.1-42.7-92.2-72l0.3-0.4c37.1,29.3,69,54.2,92.2,72L189.9,185.7L189.9,185.7z\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_30_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"125.2\"\n              width=\"94\"\n              height=\"69\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"125.2\" width=\"94\" height=\"69\" id=\"prefix__ar_1_\">\n            <g class=\"st63\">\n              <path id=\"prefix__aq_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st64\"\n            d=\"M190,193.4c-23.3-17.4-55.2-40.6-92.3-67.2l0.3-0.4c37.1,26.5,69.1,49.8,92.3,67.2L190,193.4L190,193.4z\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_31_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"137.8\"\n              width=\"94.1\"\n              height=\"64.1\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"137.8\" width=\"94.1\" height=\"64.1\" id=\"prefix__at_1_\">\n            <g class=\"st65\">\n              <path id=\"prefix__as_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st66\"\n            d=\"M190.1,201.2c-23.3-14.7-55.2-36.2-92.4-62.3l0.3-0.4c37.2,26.1,69.2,47.6,92.4,62.3L190.1,201.2\n        L190.1,201.2z\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_32_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"150.5\"\n              width=\"94.2\"\n              height=\"59.2\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"150.5\" width=\"94.2\" height=\"59.2\" id=\"prefix__av_1_\">\n            <g class=\"st67\">\n              <path id=\"prefix__au_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st68\"\n            d=\"M190.2,209c-23.3-14.2-55.3-34.1-92.5-57.4l0.3-0.4c37.2,23.3,69.2,43.2,92.5,57.4L190.2,209L190.2,209z\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_33_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"163.2\"\n              width=\"94.3\"\n              height=\"54.2\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"163.2\" width=\"94.3\" height=\"54.2\" id=\"prefix__ax_1_\">\n            <g class=\"st69\">\n              <path id=\"prefix__aw_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st70\"\n            d=\"M190.3,216.8c-23.3-13.7-55.3-31.8-92.6-52.4l0.2-0.4c37.3,20.6,69.3,38.7,92.6,52.4\n        C190.6,216.3,190.3,216.8,190.3,216.8z\"\n          />\n          <defs>\n            <filter\n              id=\"Adobe_OpacityMaskFilter_34_\"\n              filterUnits=\"userSpaceOnUse\"\n              x=\"97\"\n              y=\"176\"\n              width=\"94.3\"\n              height=\"49.3\"\n            >\n              <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n            </filter>\n          </defs>\n          <mask maskUnits=\"userSpaceOnUse\" x=\"97\" y=\"176\" width=\"94.3\" height=\"49.3\" id=\"prefix__az_1_\">\n            <g class=\"st71\">\n              <path id=\"prefix__ay_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n            </g>\n          </mask>\n          <path\n            class=\"st72\"\n            d=\"M190.5,224.6c-23.3-11-55.4-27.4-92.8-47.5l0.2-0.4c37.3,20.1,69.4,36.5,92.7,47.5\n        C190.7,224.1,190.5,224.6,190.5,224.6z\"\n          />\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_35_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.1\"\n                y=\"188.8\"\n                width=\"94.4\"\n                height=\"44.2\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.1\" y=\"188.8\" width=\"94.4\" height=\"44.2\" id=\"prefix__aB_1_\">\n              <g class=\"st73\">\n                <path id=\"prefix__aA_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st74\"\n              d=\"M190.6,232.4c-23.4-10.5-55.5-25.2-92.9-42.5l0.2-0.5c37.3,17.3,69.4,32,92.8,42.5L190.6,232.4z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_36_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.1\"\n                y=\"201.7\"\n                width=\"94.5\"\n                height=\"39.2\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.1\" y=\"201.7\" width=\"94.5\" height=\"39.2\" id=\"prefix__aD_1_\">\n              <g class=\"st75\">\n                <path id=\"prefix__aC_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st76\"\n              d=\"M190.7,240.3c-23.4-10-55.5-22.9-93-37.4l0.2-0.5c37.5,14.5,69.6,27.5,93,37.4L190.7,240.3L190.7,240.3z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_37_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.1\"\n                y=\"214.7\"\n                width=\"94.5\"\n                height=\"34.1\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.1\" y=\"214.7\" width=\"94.5\" height=\"34.1\" id=\"prefix__aF_1_\">\n              <g class=\"st77\">\n                <path id=\"prefix__aE_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st78\"\n              d=\"M190.8,248.2c-23.4-7.2-55.6-18.4-93.1-32.4l0.2-0.5c37.5,14,69.7,25.2,93.1,32.4L190.8,248.2L190.8,248.2z\n        \"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_38_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.1\"\n                y=\"227.7\"\n                width=\"94.6\"\n                height=\"29\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.1\" y=\"227.7\" width=\"94.6\" height=\"29\" id=\"prefix__aH_1_\">\n              <g class=\"st79\">\n                <path id=\"prefix__aG_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st80\"\n              d=\"M190.9,256c-23.4-6.7-55.6-16.1-93.2-27.3l0.1-0.5c37.6,11.2,69.8,20.6,93.2,27.3\n        C191.1,255.6,190.9,256,190.9,256z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_39_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.2\"\n                y=\"240.7\"\n                width=\"94.6\"\n                height=\"23.8\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.2\" y=\"240.7\" width=\"94.6\" height=\"23.8\" id=\"prefix__aJ_1_\">\n              <g class=\"st81\">\n                <path id=\"prefix__aI_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st82\"\n              d=\"M191.1,263.9c-23.4-6.2-55.7-13.8-93.3-22.1l0.1-0.5c37.6,8.3,69.9,16,93.3,22.2L191.1,263.9z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_40_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.2\"\n                y=\"253.8\"\n                width=\"94.6\"\n                height=\"18.6\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.2\" y=\"253.8\" width=\"94.6\" height=\"18.6\" id=\"prefix__aL_1_\">\n              <g class=\"st83\">\n                <path id=\"prefix__aK_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st84\"\n              d=\"M191.2,271.9c-23.4-3.4-55.7-9.3-93.4-17l0.1-0.5c37.7,7.7,70,13.6,93.4,17\n        C191.3,271.4,191.2,271.9,191.2,271.9z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_41_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.2\"\n                y=\"267\"\n                width=\"94.7\"\n                height=\"13.4\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.2\" y=\"267\" width=\"94.7\" height=\"13.4\" id=\"prefix__aN_1_\">\n              <g class=\"st85\">\n                <path id=\"prefix__aM_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st86\"\n              d=\"M191.3,279.8c-23.5-2.9-55.8-6.9-93.5-11.8l0.1-0.5c37.7,4.9,70,8.9,93.5,11.8\n        C191.4,279.3,191.3,279.8,191.3,279.8z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_42_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.3\"\n                y=\"280.2\"\n                width=\"94.7\"\n                height=\"8.1\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.3\" y=\"280.2\" width=\"94.7\" height=\"8.1\" id=\"prefix__aP_1_\">\n              <g class=\"st87\">\n                <path id=\"prefix__aO_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z\" />\n              </g>\n            </mask>\n            <path\n              class=\"st88\"\n              d=\"M191.4,287.8c-23.5-2.3-55.8-4.6-93.6-6.6l0-0.5c37.8,2,70.2,4.3,93.6,6.6L191.4,287.8L191.4,287.8z\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_43_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.3\"\n                y=\"293.4\"\n                width=\"94.8\"\n                height=\"3\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.3\" y=\"293.4\" width=\"94.8\" height=\"3\" id=\"prefix__aR_1_\">\n              <g class=\"st89\">\n                <path id=\"prefix__aQ_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1\" />\n              </g>\n            </mask>\n            <path\n              class=\"st90\"\n              d=\"M170.9,296c-20.5,0-45.3-0.5-73.1-1.5l0-0.5c37.8,1.4,70.2,1.8,93.7,1.3l0,0.5\n        C185.3,295.9,178.4,296,170.9,296\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_44_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.3\"\n                y=\"302.7\"\n                width=\"94.9\"\n                height=\"5.5\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.3\" y=\"302.7\" width=\"94.9\" height=\"5.5\" id=\"prefix__aT_1_\">\n              <g class=\"st91\">\n                <path id=\"prefix__aS_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1\" />\n              </g>\n            </mask>\n            <path\n              class=\"st92\"\n              d=\"M97.8,307.7l0-0.5c37.8-1.5,70.2-2.9,93.8-4l0,0.5C168.1,304.8,135.6,306.2,97.8,307.7\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_45_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.2\"\n                y=\"310.7\"\n                width=\"95.1\"\n                height=\"10.8\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.2\" y=\"310.7\" width=\"95.1\" height=\"10.8\" id=\"prefix__aV_1_\">\n              <g class=\"st93\">\n                <path id=\"prefix__aU_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1\" />\n              </g>\n            </mask>\n            <path\n              class=\"st94\"\n              d=\"M97.9,321.1l-0.1-0.5c37.9-4.5,70.4-7.7,94-9.3l0,0.5C168.2,313.4,135.8,316.6,97.9,321.1\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_46_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.2\"\n                y=\"318.7\"\n                width=\"95.3\"\n                height=\"16.2\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.2\" y=\"318.7\" width=\"95.3\" height=\"16.2\" id=\"prefix__aX_1_\">\n              <g class=\"st95\">\n                <path id=\"prefix__aW_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1\" />\n              </g>\n            </mask>\n            <path\n              class=\"st96\"\n              d=\"M97.9,334.4l-0.1-0.5c38-5.1,70.5-10.2,94-14.6l0.1,0.5C168.4,324.3,135.9,329.3,97.9,334.4\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_47_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.2\"\n                y=\"326.8\"\n                width=\"95.5\"\n                height=\"21.6\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.2\" y=\"326.8\" width=\"95.5\" height=\"21.6\" id=\"prefix__aZ_1_\">\n              <g class=\"st97\">\n                <path id=\"prefix__aY_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1\" />\n              </g>\n            </mask>\n            <path\n              class=\"st98\"\n              d=\"M97.9,347.9l-0.1-0.5c38.8-8.2,71.3-15.1,94.2-20l0.1,0.5C169.2,332.7,136.6,339.7,97.9,347.9\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_48_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.1\"\n                y=\"334.8\"\n                width=\"95.6\"\n                height=\"27\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.1\" y=\"334.8\" width=\"95.6\" height=\"27\" id=\"prefix__bb_1_\">\n              <g class=\"st99\">\n                <path id=\"prefix__ba_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1\" />\n              </g>\n            </mask>\n            <path\n              class=\"st100\"\n              d=\"M97.9,361.4l-0.1-0.5c38.1-11.1,70.7-19.9,94.3-25.4l0.1,0.5C168.6,341.5,136,350.3,97.9,361.4\"\n            />\n          </g>\n          <g>\n            <defs>\n              <filter\n                id=\"Adobe_OpacityMaskFilter_49_\"\n                filterUnits=\"userSpaceOnUse\"\n                x=\"97.1\"\n                y=\"342.9\"\n                width=\"95.8\"\n                height=\"32.5\"\n              >\n                <feColorMatrix type=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0\" />\n              </filter>\n            </defs>\n            <mask maskUnits=\"userSpaceOnUse\" x=\"97.1\" y=\"342.9\" width=\"95.8\" height=\"32.5\" id=\"prefix__bd_1_\">\n              <g class=\"st101\">\n                <path id=\"prefix__bc_1_\" class=\"st3\" d=\"M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1\" />\n              </g>\n            </mask>\n            <path\n              class=\"st102\"\n              d=\"M97.9,374.9l-0.1-0.5c38.2-11.7,70.8-22.4,94.4-30.9l0.2,0.5C168.7,352.5,136.1,363.2,97.9,374.9\"\n            />\n          </g>\n        </g>\n        <line class=\"st103\" x1=\"-2.5\" y1=\"382.4\" x2=\"897.5\" y2=\"382.4\" />\n        <g>\n          <path\n            class=\"st1\"\n            d=\"M196.4,348.2c-6.6-26.3-14.3-52.7-21.8-78.3c-5.6-19.1-11.3-39-16.6-58.6c-6.7-24.9-17.9-32.6-32.2-42.2\n        c-7-4.8-15-10.2-23.5-18.5l0.4-0.4c8.5,8.3,16.4,13.7,23.4,18.5c14.3,9.7,25.6,17.4,32.4,42.6c5.3,19.6,11,\n        39.4,16.6,58.5c7.4,25.6,15.1,52,21.8,78.3C196.9,348.1,196.4,348.2,196.4,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M205.9,348.2c-6.1-25.6-13.4-51.4-20.4-76.3c-5.6-19.8-11.3-40.2-16.5-60.5c-6.2-24.3-16.9-31.8-30.5-41.2\n            c-7.2-5-15.3-10.6-23.9-19.7l0.4-0.4c8.5,9,16.6,14.6,23.8,19.6c13.7,9.5,24.5,17,30.7,41.5c5.2,20.3,10.9,\n            40.7,16.5,60.5c7,24.9,14.3,50.7,20.4,76.3L205.9,348.2L205.9,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M215.5,348.2c-5.7-25.2-12.6-50.5-19.3-74.9c-5.5-20.2-11.2-41-16.2-61.8c-5.7-23.8-16-31.1-29.1-40.3\n            c-7.3-5.1-15.6-11-24-20.7l0.4-0.4c8.4,9.7,16.7,15.5,23.9,20.6c13.1,9.2,23.5,16.5,29.3,40.6c5,20.7,10.7,\n            41.6,16.2,61.8c6.7,24.5,13.6,49.7,19.3,75L215.5,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M225.1,348.2c-5.2-24.9-11.8-49.9-18.2-74c-5.4-20.4-11-41.6-15.8-62.6c-5.3-23.4-15.7-30.8-27.7-39.4\n            c-7.4-5.3-15.7-11.2-24-21.6l0.4-0.3c8.3,10.3,16.6,16.3,23.9,21.5c12.1,8.7,22.6,16.2,27.9,39.8c4.7,21,10.3,\n            42.1,15.8,62.6c6.4,24.1,13,49.1,18.3,74L225.1,348.2L225.1,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M234.6,348.2c-4.8-24.7-11.2-49.5-17.3-73.4c-5.3-20.6-10.8-41.9-15.2-63.1c-4.9-23-14.9-30.3-26.5-38.7\n            c-7.4-5.4-15.8-11.4-23.9-22.5l0.4-0.3c8.1,10.9,16.4,17,23.8,22.3c11.7,8.5,21.9,15.8,26.8,39c4.5,21.2,9.9,\n            42.5,15.2,63.1c6.1,23.9,12.5,48.6,17.3,73.4L234.6,348.2L234.6,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M244.2,348.2c-4.4-24.6-10.5-49.2-16.4-72.9c-5.1-20.7-10.5-42.1-14.7-63.5c-4.4-22.6-14.2-29.7-25.5-38\n            c-7.4-5.5-15.9-11.6-23.7-23.2l0.5-0.3c7.8,11.5,16.2,17.7,23.6,23.1c11.4,8.3,21.2,15.5,25.7,38.4c4.2,21.4,\n            9.5,42.8,14.7,63.5c5.9,23.8,12,48.3,16.4,72.9L244.2,348.2L244.2,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M253.7,348.2c-4.1-24.5-9.9-48.9-15.6-72.5c-5-20.8-10.1-42.3-14.1-63.8c-4.1-22.2-13.5-29.3-24.5-37.4\n            c-7.4-5.5-15.9-11.8-23.4-23.9l0.5-0.3c7.4,12,15.5,18,23.2,23.8c11,8.2,20.6,15.3,24.7,37.8c3.9,21.5,9.1,43,\n            14.1,63.7c5.7,23.6,11.5,48,15.6,72.6L253.7,348.2L253.7,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M263.3,348.2c-3.7-24.4-9.3-48.7-14.8-72.2c-4.8-20.8-9.8-42.4-13.4-64c-3.7-21.9-12.9-28.8-23.5-36.9\n            c-7.8-5.9-15.9-12-23-24.6l0.5-0.3c7.1,12.5,15.1,18.6,22.8,24.4c10.8,8.1,20,15.1,23.8,37.2c3.6,21.6,8.6,\n            43.1,13.4,63.9c5.4,23.5,11.1,47.8,14.8,72.3L263.3,348.2L263.3,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M272.8,348.2c-3.3-24.3-8.7-48.5-13.9-71.9c-4.7-20.9-9.5-42.5-12.8-64.2c-3.3-21.6-12.3-28.4-22.7-36.4\n            c-7.8-5.9-15.8-12.1-22.5-25.2l0.5-0.2c6.6,13,14.6,19.1,22.4,25c10.1,7.7,19.6,14.9,22.9,36.7c3.3,21.7,8.2,\n            43.3,12.8,64.2c5.2,23.4,10.6,47.6,13.9,71.9L272.8,348.2L272.8,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M282.4,348.2c-3-24.3-8.1-48.3-13.1-71.6c-4.5-21-9.2-42.7-12.2-64.5c-3-21.2-12.2-28.4-21.9-35.9\n            c-7.8-6-15.8-12.2-22-25.7l0.5-0.2c6.2,13.4,14.1,19.5,21.8,25.5c9.8,7.6,19.1,14.8,22.1,36.3c3,21.8,7.7,\n            43.5,12.2,64.4c5,23.3,10.2,47.3,13.1,71.6L282.4,348.2L282.4,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M292,348.2c-2.6-24-7.5-47.8-12.3-70.8c-4.4-21.2-8.9-43.2-11.6-65.2c-2.6-20.9-11.6-28-21.1-35.5\n            c-7.7-6.1-15.7-12.3-21.4-26.2l0.5-0.2c5.7,13.7,13.6,19.9,21.3,25.9c9.6,7.6,18.7,14.7,21.3,35.8c2.7,22.1,\n            7.3,44,11.6,65.2c4.7,23,9.6,46.8,12.3,70.8L292,348.2L292,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M301.5,348.2c-2.4-23.5-7-46.9-11.4-69.5c-4.2-21.6-8.6-44-11.1-66.5c-2.3-20.6-11.1-27.6-20.4-35.1\n            c-7.7-6.1-15.6-12.5-20.8-26.6l0.5-0.2c5.1,14,13,20.3,20.6,26.4c9.4,7.5,18.3,14.6,20.6,35.4c2.5,22.5,6.8,\n            44.8,11.1,66.5c4.4,22.6,9,46,11.4,69.5L301.5,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M311.1,348.2c-2.2-23.6-6.5-47.1-10.7-69.9c-3.9-21.5-8-43.8-10.3-66.1c-2.1-20.1-10.7-27.2-19.8-34.6\n            c-7.6-6.2-15.5-12.6-20.2-27l0.5-0.2c4.6,14.2,12.4,20.6,20,26.8c9.2,7.5,17.9,14.6,20,35c2.3,22.3,6.4,44.6,\n            10.3,66.1c4.1,22.7,8.4,46.3,10.7,69.9L311.1,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M320.6,348.2c-2-23.7-6-47.3-9.9-70.1c-3.6-21.5-7.4-43.7-9.5-65.9c-1.9-20-10.4-27-19.3-34.5\n            c-7.5-6.2-15.2-12.7-19.5-27.1l0.5-0.2c4.2,14.3,11.9,20.7,19.3,26.9c9,7.5,17.5,14.6,19.5,34.8c2.1,22.2,5.9,\n            44.4,9.5,65.8c3.9,22.9,7.8,46.5,9.9,70.2L320.6,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M330.2,348.2c-1.7-22.4-5.3-44.8-8.8-66.4c-3.1-19.4-6.3-39.4-8.2-59.4c-2.3-24.3-3.8-28.7-16.2-45.9\n            c-10.8-5.4-18-14.1-21.5-25.9l0.5-0.2c3.4,11.7,10.6,20.3,21.3,25.6l0.1,0.1c12.4,17.2,14.1,22,16.4,46.3c1.9,\n            20,5.1,40,8.2,59.3c3.5,21.6,7.1,44,8.8,66.4L330.2,348.2L330.2,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M339.7,348.2c-1.6-22.4-4.9-44.8-8.1-66.4c-2.8-19.4-5.8-39.4-7.5-59.4c-2-23-3.3-28.5-15-46\n            c-10.4-5.5-17.1-14.2-20.1-25.8l0.5-0.1c3,11.5,9.7,20.1,19.9,25.5l0.1,0.1c11.2,16.7,13.1,22.4,15.1,\n            46.3c1.7,20,4.7,40,7.5,59.4c3.2,21.7,6.5,44.1,8.1,66.5L339.7,348.2L339.7,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M349.3,348.2c-1.4-22.3-4.4-44.8-7.3-66.4c-2.6-19.4-5.3-39.5-6.8-59.5c-1.7-22.1-3.2-29-13.5-46\n            c-9.8-5.6-16-14.3-18.4-25.7l0.5-0.1c2.4,11.3,8.5,19.9,18.2,25.4l0.1,0l0,0.1c10.5,17.1,11.9,24.1,13.6,46.3\n            c1.5,20,4.2,40.1,6.8,59.5c2.9,21.7,5.9,44.1,7.3,66.5L349.3,348.2L349.3,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M358.9,348.2c-1.3-22.3-3.9-44.6-6.5-66.3c-2.3-19.5-4.7-39.7-6.1-59.8c-1.5-21.6-3.1-29.7-12-45.9\n            c-9.1-5.8-14.7-14.5-16.4-25.6l0.5-0.1c1.7,11,7.2,19.5,16.2,25.3l0.1,0.1c8.9,16.4,10.6,24.6,12.1,46.2c1.4,\n            20,3.8,40.2,6.1,59.8c2.6,21.7,5.2,44.1,6.5,66.3L358.9,348.2L358.9,348.2z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M368.4,348.2c-1.1-22.2-3.5-44.5-5.7-66.1c-2.1-19.7-4.2-40-5.4-60.1c-1.2-19.6-2.4-29.2-10.3-45.9\n            c-8.3-6.1-13.1-14.7-14.2-25.5l0.5-0.1c1.1,10.6,5.8,19.1,14,25.1l0.1,0.1c7.9,16.8,9.2,26.5,10.4,46.2\n            c1.2,20.1,3.3,40.4,5.4,60.1c2.3,21.6,4.6,44,5.7,66.1L368.4,348.2L368.4,348.2z M378,348.2c-1-22-3-44.3-5-65.8\n            c-1.8-19.8-3.7-40.3-4.7-60.6c-1-19.6-2.4-30.3-8.6-45.9c-7.4-6.5-11.4-15-11.9-25.4l0.5,0c0.4,10.2,4.4,18.6,\n            11.7,25l0.1,0.1c6.2,15.8,7.6,26.5,8.6,46.1c1,20.3,2.9,40.8,4.7,60.6c2,21.5,4,43.8,5,65.8L378,348.2L378,\n            348.2z M387.5,348.2c-0.8-21.8-2.5-44-4.2-65.3c-1.5-20-3.1-40.7-4-61.2c-0.8-18.5-2.1-30.7-6.9-45.9\n            c-6.4-6.9-9.6-15.4-9.5-25.2l0.5,0c-0.1,9.8,3.1,18.1,9.4,24.9l0.1,0.1c4.8,15.3,6.1,27.5,6.9,46.1c0.9,20.4,\n            2.5,41.1,4,61.1c1.6,21.4,3.3,43.5,4.2,65.4L387.5,348.2L387.5,348.2z M397.1,\n            348.2c-0.7-21.6-2.1-43.6-3.4-64.8c-1.3-20.3-2.6-41.2-3.3-61.8c-0.5-14.8-1.3-29.5-5.2-45.9\n            c-5.3-7.3-7.7-15.7-7.2-25.1l0.5,0c-0.5,9.3,1.9,17.6,7.1,24.8l0,0.1c4,16.5,4.8,31.2,5.3,46.1c0.7,\n            20.6,2,41.6,3.3,61.8c1.3,21.2,2.7,43.2,3.4,64.8L397.1,348.2L397.1,348.2z M406.7,348.2\n            c-0.5-21.4-1.6-43.1-2.6-64.1c-1-20.5-2.1-41.8-2.6-62.7c-0.3-9.8-2.4-20.9-4.4-31.6\n            c-2.6-13.5-5.3-27.4-4.4-39.4l0.5,0c-0.9,11.9,1.8,25.8,4.3,39.2c2.1,10.7,4.2,21.8,4.4,31.6c0.6,20.9,1.6,\n            42.1,2.6,62.6c1,21,2.1,42.7,2.6,64.1L406.7,348.2L406.7,348.2z M416.2,348.2c-0.4-21.1-1.1-42.5-1.9-63.3\n            c-0.7-20.8-1.5-42.4-1.9-63.6c-0.2-9.5-1.5-19.9-2.8-30c-1.8-13.8-3.7-28.1-2.7-40.8l0.5,0c-1,12.7,0.9,26.9,\n            2.7,40.7c1.3,10.1,2.7,20.5,2.8,30.1c0.4,21.2,1.1,42.7,1.9,63.5c0.7,20.7,1.5,42.2,1.9,63.3L416.2,\n            348.2L416.2,348.2z M425.8,348.2c-0.3-24.8-1.6-50.5-3-75.4c-2.1-40.4-4.3-82.2-2.1-122.3l0.5,0c-2.2,40,0,\n            81.8,2.1,122.2c1.3,24.9,2.7,50.6,3,75.4L425.8,348.2L425.8,348.2z M435.3,348.2c-0.1-24.4-0.5-49.3-0.9-73.3\n            c-0.7-40.8-1.4-83-0.6-124.3l0.5,0c-0.9,41.4-0.1,83.5,0.6,124.3c0.4,24,0.8,48.9,0.9,73.3L435.3,\n            348.2z M445.4,348.2h-0.5c0.1-25.9,0.5-52.3,0.8-77.8c0.6-39.3,1.2-79.9,0.7-119.8l0.5,0\n            c0.5,39.9-0.1,80.5-0.7,119.8C445.9,295.8,445.5,322.2,445.4,348.2 M455,348.2l-0.5,0c0.2-26.9,1.5-54.6,\n            2.7-81.3c1.7-38.3,3.5-77.9,2.4-116.3l0.5,0c1.1,38.5-0.7,78.1-2.4,116.4C456.5,293.6,455.2,321.2,455,\n            348.2 M464.6,348.2l-0.5,0c0.4-28.6,2.6-58.1,4.6-86.6c2.7-36.7,5.4-74.6,4.6-111l0.5,0c0.8,36.4-1.9,74.3-4.6,\n            111C467.1,290.1,465,319.6,464.6,348.2M474.1,348.2l-0.5,0c0.4-19.9,1.6-40.1,2.7-59.7c1.3-22.2,2.6-45.2,\n            2.9-67.9c0.1-12.2,2.2-24.2,4.3-35.8c2.1-11.8,4-22.9,4.1-34.3l0.5,0c-0.1,11.5-2.1,23.1-4.1,34.4c-2,11.6-4.1,\n            23.5-4.2,35.7c-0.2,22.7-1.6,45.7-2.9,67.9C475.7,308,474.5,328.2,474.1,348.2 M484.2,324c0.7-12,1.6-23.9,\n            2.4-35.6c1.7-22.2,3.4-45.2,3.7-67.9c-0.2-13.3,0.3-26.8,1.6-40.1c1-5.1,3-9,4.9-12.8c2.4-4.8,4.9-9.7,\n            5.4-17l0.5,0c-0.5,7.4-3,12.4-5.4,17.2c-1.9,3.7-3.9,7.6-4.8,12.6c-1.3,13.2-1.8,26.7-1.6,40c-0.3,22.8-2,\n            45.7-3.7,68c-1.5,19.6-3,39.8-3.5,59.8 M483.7,348.2l-0.5,0c0.2-8,0.6-16.1,1.1-24.2 M493.2,348.2l-0.5,0\n            c0.7-20.1,2.5-40.4,4.3-59.9c2-22.2,4.1-45.2,4.5-68c-0.4-13.3,0.3-26.7,2.1-39.9c1.4-5.4,3.9-9.3,6.4-13.2\n            c3-4.6,6-9.4,7.1-16.6l0.5,0.1c-1.1,7.4-4.2,12.2-7.2,16.9c-2.4,3.8-5,7.7-6.3,13c-1.7,13.1-2.4,26.6-2.1,39.8\n            c-0.4,22.8-2.5,45.8-4.5,68.1C495.7,307.8,493.9,328.1,493.2,348.2 M502.8,348.2l-0.5,0c0.8-20.2,3-40.5,\n            5.1-60.1c2.4-22.2,4.8-45.2,5.3-68.1c-0.5-13.3,0.4-26.7,2.6-39.8c1.7-5.6,4.9-9.7,8-13.7c3.5-4.5,7.1-9.2,\n            8.8-16.1l0.5,0.1c-1.7,7.1-5.4,11.8-8.9,16.3c-3.2,4.1-6.2,8-7.9,13.5c-2.2,13-3.1,26.4-2.6,\n            39.7c-0.5,22.9-2.9,45.9-5.3,68.1C505.7,307.7,503.6,328,502.8,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M512.3,348.2l-0.5,0c0.9-20.3,3.4-40.6,5.8-60.2c2.7-22.2,5.6-45.2,6.1-68.1c-0.6-13.3,0.5-26.6,3.2-39.6\n        c2.6-5.3,6-9.3,9.3-13.1c4.1-4.7,8.3-9.5,10.8-16.7l0.5,0.2c-2.5,7.3-6.8,12.2-10.9,16.9c-3.3,3.8-6.7,7.7-9.2,12.9\n        c-2.7,12.9-3.7,26.2-3.1,39.4c-0.5,23-3.4,46-6.1,68.2C515.8,307.6,513.3,327.9,512.3,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M521.9,348.2l-0.5,0c1-20.4,3.9-40.7,6.6-60.4c3.1-22.2,6.3-45.2,6.9-68.2c-0.7-13.3,0.6-26.6,3.7-39.5\n        c3-5.7,7.1-9.9,11.1-13.9c4.5-4.5,9.1-9.2,12.1-15.9l0.5,0.2c-3.1,6.7-7.8,11.5-12.2,16c-4,4-8.1,8.2-11,13.8\n        c-3.1,12.8-4.4,26-3.7,39.3c-0.6,23-3.8,46-6.9,68.2C525.8,307.5,522.9,327.8,521.9,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M531.5,348.2l-0.5,0c1.2-20.5,4.3-40.8,7.4-60.5c3.5-22.2,7-45.1,7.7-68.2c-0.8-13.3,0.6-26.5,4.2-39.3\n        c3.4-6,8.3-10.6,13.1-14.9c4.7-4.4,9.7-8.9,13.1-14.9l0.5,0.3c-3.5,6.1-8.5,10.6-13.3,15c-4.9,4.5-9.6,8.8-12.9,14.7\n        c-3.5,12.7-4.9,25.9-4.2,39.1c-0.7,23.1-4.3,46.1-7.7,68.3C535.8,307.4,532.6,327.7,531.5,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M541,348.2l-0.5,0c1.3-20.6,4.8-41,8.2-60.7c3.8-22.2,7.8-45.1,8.5-68.3c1-29.2,7.8-37.3,19.1-50.7\n        c4.2-5,8.9-10.6,14.3-18.2l0.4,0.3c-5.4,7.7-10.1,13.3-14.3,18.3c-11.3,13.3-18.1,21.4-19,50.4c-0.8,23.2-4.7,\n        46.1-8.5,68.3C545.8,307.2,542.3,327.6,541,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M550.6,348.2l-0.5,0c1.4-20.7,5.3-41.1,9-60.8c4.2-22.2,8.5-45.1,9.3-68.3c1.1-30.6,8.5-38.6,21.9-53\n        c4.1-4.4,8.7-9.4,14-15.8l0.4,0.3c-5.2,6.4-9.9,11.4-14,15.9c-13.3,14.3-20.7,22.2-21.8,52.6c-0.8,23.3-5.2,\n        46.2-9.3,68.4C555.8,307.1,552,327.5,550.6,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M560.1,348.2l-0.5,0c1.7-21.9,6-43.1,10.2-63.6c3.7-18.4,7.6-37.5,9.6-56.9c0.5-5,0.5-10.2,0.5-15.2\n        c-0.1-12.1-0.1-24.6,7.3-35.5c4.1-6,10.3-10.5,16.2-14.9c4.9-3.6,10-7.3,13.9-11.8l0.4,0.4c-4,4.6-9.1,8.3-14,11.9\n        c-5.9,4.3-12,8.8-16.1,14.7c-7.4,10.8-7.3,23.2-7.2,35.2c0,5,0.1,10.2-0.5,15.3c-1.9,19.4-5.8,38.5-9.6,56.9\n        C566.1,305.1,561.8,326.3,560.1,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M569.7,348.2l-0.5,0c1.8-22,6.5-43.3,11-63.8c4-18.4,8.2-37.5,10.3-57c0.5-5.1,0.5-10.3,0.5-15.3\n        c0-12,0-24.4,7.6-35.3c4.3-6.2,10.7-10.7,17-15.1c4.9-3.5,10-7.1,14-11.4l0.4,0.4c-4,4.4-9.2,8-14.1,11.5\n        c-6.2,4.4-12.6,8.9-16.8,15c-7.5,10.8-7.5,22.5-7.5,35c0,5,0,10.3-0.5,15.3c-2.1,19.5-6.3,38.6-10.3,57\n        C576.2,305,571.5,326.2,569.7,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M579.2,348.2l-0.5,0c2-22.2,7-43.4,11.8-64c4.3-18.4,8.8-37.5,11.1-57.1c0.6-5.1,0.6-10.3,0.7-15.3\n        c0.1-12.2,0.2-23.8,7.9-34.8c4.3-6.2,10.9-10.8,17.3-15.2c5.1-3.5,10.3-7.2,14.4-11.6l0.4,0.4c-4.1,4.5-9.4,\n        8.1-14.5,11.7c-6.3,4.4-12.9,9-17.2,15.1c-7.7,10.8-7.7,22.3-7.8,34.5c0,5-0.1,10.2-0.7,15.3c-2.3,19.6-6.8,\n        38.7-11.1,57.2C586.2,304.8,581.2,326,579.2,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M588.8,348.2l-0.5-0.1c2.1-22.5,7.3-43.9,12.4-64.6c4.4-18.1,9-36.8,11.4-56.2c0.6-5,0.8-10.1,0.9-14.9\n        c0.4-12.4,0.7-24,8.8-35.1c4.5-6.2,11.2-10.8,17.7-15.3c5.2-3.6,10.5-7.3,14.7-11.8l0.4,0.4c-4.2,4.5-9.6,8.2-14.8,\n        11.8c-6.5,4.5-13.1,9.1-17.5,15.2c-7.9,11-8.3,22.6-8.7,34.8c-0.1,4.9-0.3,9.9-1,15c-2.5,19.4-7,38.1-11.5,56.2\n        C596.1,304.3,590.9,325.8,588.8,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M598.4,348.2l-0.5-0.1c2.4-22.6,7.8-44.3,13-65.2c4.5-17.8,9-36.3,11.8-55.3c0.7-5,1-9.9,1.2-14.7\n        c0.7-12.4,1.3-24.2,9.6-35.4c4.6-6.2,11.4-10.9,18-15.4c5.3-3.7,10.8-7.4,15.1-12l0.4,0.4c-4.3,4.5-9.8,8.3-15.1,12\n        c-6.6,4.5-13.3,9.2-17.8,15.3c-8.2,11.1-8.8,22.8-9.5,35.1c-0.3,4.8-0.5,9.7-1.2,14.7c-2.7,19-7.3,37.5-11.8,55.3\n        C606.1,303.9,600.7,325.6,598.4,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M607.9,348.2l-0.5-0.1c2.7-22.6,8.3-44.4,13.6-65.5c4.5-17.7,9.1-36,12.1-54.7c0.8-4.9,1.2-9.7,1.5-14.4\n            c1-12.5,1.9-24.4,10.5-35.7c4.7-6.1,11.6-10.9,18.3-15.5c5.4-3.7,11-7.6,15.4-12.1l0.4,0.4c-4.4,4.6-10,\n            8.5-15.5,12.2c-6.7,4.6-13.6,9.3-18.2,15.4c-8.5,11.2-9.4,23-10.4,35.4c-0.4,4.7-0.7,9.5-1.5,14.4c-3,\n            18.8-7.6,37.1-12.1,54.8C616.2,303.8,610.6,325.6,607.9,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M617.5,348.2l-0.5-0.1c3.1-22.7,8.8-44.6,14.2-65.8c4.5-17.5,9.2-35.6,12.4-54.1c0.8-4.8,1.3-9.5,1.8-14.1\n            c1.3-12.6,2.5-24.6,11.4-36.1c4.8-6.1,11.8-10.9,18.6-15.6c5.6-3.8,11.3-7.7,15.8-12.3l0.4,0.4c-4.5,4.7-10.3,\n            8.6-15.9,12.4c-6.8,4.6-13.8,9.4-18.5,15.5c-8.8,11.4-10,23.2-11.3,35.8c-0.5,4.5-0.9,9.2-1.8,14.1c-3.2,\n            18.5-7.9,36.6-12.4,54.2C626.2,303.6,620.5,325.5,617.5,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M627,348.2l-0.5-0.1c3.4-22.7,9.3-44.8,14.9-66.2c4.6-17.3,9.3-35.2,12.7-53.4c0.9-4.7,1.5-9.3,2-13.7\n            c1.6-12.8,3.1-24.8,12.3-36.4c4.9-6.1,12-11,18.9-15.7c5.7-3.9,11.6-7.8,16.1-12.5l0.4,0.4c-4.6,4.7-10.5,\n            8.7-16.2,12.6c-6.9,4.7-14,9.5-18.8,15.5c-9.1,11.5-10.6,22.9-12.2,36.2c-0.5,4.4-1.1,9-2,13.7c-3.4,\n            18.2-8.2,36.1-12.7,53.5C636.3,303.4,630.5,325.5,627,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M636.6,348.2l-0.5-0.1c3.8-22.8,9.8-45.1,15.6-66.6c4.6-17.1,9.4-34.8,13-52.7c0.9-4.6,1.6-9,2.2-13.2\n            c2-13.5,3.7-25.1,13.3-36.9c5-6.1,12.2-11,19.2-15.7c5.8-3.9,11.8-8,16.5-12.7l0.4,0.4c-4.7,4.8-10.8,8.9-16.6,\n            12.8c-7,4.7-14.1,9.6-19.1,15.6c-9.5,11.7-11.2,23.2-13.2,36.6c-0.6,4.3-1.3,8.7-2.2,13.3c-3.6,17.9-8.4,\n            35.6-13,52.7C646.4,303.1,640.4,325.4,636.6,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M646.2,348.2l-0.5-0.1c4.2-22.9,10.3-45.4,16.3-67.2c4.6-16.9,9.4-34.3,13.2-51.9c1-4.4,1.7-8.7,2.4-12.8\n            c2.3-13.6,4.3-25.4,14.3-37.4c5.1-6.1,12.4-11,19.5-15.8c5.9-4,12.1-8.1,16.9-13l0.4,0.4c-4.8,4.9-11,9-17,13\n            c-7,4.7-14.3,9.6-19.4,15.7c-9.9,11.9-11.9,23.6-14.1,37.1c-0.7,4.1-1.4,8.3-2.4,12.8c-3.8,17.6-8.6,35-13.2,\n            51.9C656.5,302.8,650.3,325.3,646.2,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M655.7,348.2l-0.5-0.1c4.5-23.1,10.9-45.9,17.1-67.9c4.6-16.6,9.4-33.7,13.4-50.8c1-4.3,1.8-8.3,2.5-12.2\n            c2.6-13.8,4.9-25.8,15.3-38c5.2-6.1,12.6-11.1,19.7-15.8c6.1-4.1,12.4-8.3,17.3-13.2l0.4,0.4c-5,4.9-11.3,\n            9.2-17.4,13.2c-7.1,4.8-14.5,9.7-19.6,15.7c-10.3,12.1-12.5,24-15.2,37.7c-0.7,3.9-1.5,8-2.5,12.2c-4,17.2-8.8,\n            34.3-13.4,50.9C666.6,302.3,660.2,325.1,655.7,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M665.3,348.2l-0.5-0.1c4.5-21.4,10.6-42.5,16.5-62.9c5.2-18.1,10.6-36.8,14.9-55.5c0.8-3.4,1.4-6.6,2.1-9.7\n            c3.2-15.4,5.7-27.6,16.9-40.5c5.3-6.1,12.8-11.1,20-15.9c6.2-4.1,12.6-8.4,17.7-13.4l0.4,0.4c-5.1,5-11.5,\n            9.3-17.8,13.5c-7.2,4.8-14.6,9.7-19.9,15.8c-11.1,12.7-13.6,24.9-16.8,40.2c-0.6,3.1-1.3,6.3-2.1,9.7c-4.3,\n            18.8-9.7,37.5-14.9,55.6C675.9,305.7,669.8,326.9,665.3,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M674.8,348.2l-0.5-0.1c4.9-21.7,11.2-43.1,17.3-63.9c5.2-17.7,10.6-36,15-54.2c0.8-3.2,1.5-6.2,2.1-9.1\n            c3.5-15.6,6.3-28,18-41c5.4-6.1,13-11.1,20.3-15.9c6.3-4.2,12.9-8.6,18.1-13.6l0.4,0.4c-5.2,5.1-11.8,9.5-18.2,\n            13.7c-7.3,4.8-14.8,9.8-20.2,15.8c-11.5,13-14.3,25.2-17.8,40.8c-0.7,2.9-1.4,6-2.1,9.2c-4.5,18.3-9.8,36.6-15,\n            54.3C686,305.1,679.7,326.6,674.8,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M684.4,348.2l-0.5-0.1c5.3-21.8,11.8-43.6,18.1-64.7c5.2-17.4,10.6-35.3,15.2-53.2c0.8-2.9,1.4-5.6,2.1-8.3\n            c3.9-15.9,7-28.5,19.2-41.9c5.5-6.1,13.1-11.1,20.5-16c6.5-4.3,13.2-8.7,18.5-13.9l0.4,0.4c-5.4,5.2-12.1,\n            9.6-18.6,13.9c-7.3,4.8-14.9,9.8-20.4,15.9c-12,13.2-15.1,25.8-19,41.6c-0.7,2.7-1.3,5.4-2.1,8.3c-4.7,17.9-10,\n            35.9-15.2,53.2C696.2,304.6,689.7,326.4,684.4,348.2\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M314.1,150.7c-70.6,0-141.3,0-211.6-0.1v-0.6c157.9,0.1,318.4,0,473.7,0c67.1,0,134.3,0,201.4,0v0.5\n            c-67.1,0-134.3,0-201.4,0C490,150.7,402.2,150.7,314.1,150.7 M309.9,157c-67.7,0-135.6-0.4-203-1.6l0-0.5\n            c147.4,2.7,297.1,1.5,441.8,0.5c73.7-0.6,149.9-1.1,224.9-1.2v0.5c-75,0.1-151.2,0.6-224.9,1.2C470.2,156.4,\n            390.2,157,309.9,157M305.8,162.4c-64.2,0-128.7-0.6-192.7-2.3l0-0.6c136.5,3.7,274.7,2.2,408.5,0.8c80.8-0.9,\n            164.3-1.7,246.6-1.5v0.6c-82.3-0.3-165.8,0.6-246.6,1.5C450.6,161.6,378.3,162.4,305.8,162.4 M301.8,166.9\n            c-60.6,0-121.4-0.6-181.8-2.5l0-0.5c125.5,3.8,252.8,2.4,375.8,1c87.1-1,177.2-2,265.9-1.1l0,\n            0.6c-88.8-0.9-178.8,0.1-265.9,1.1C432.1,166.2,367.1,166.9,301.8,166.9M298.2,170.8c-57.1,\n            0-114.4-0.6-171.3-2.3l0-0.5c115.3,3.4,232.3,2.2,345.4,1.1c92.7-1,188.6-1.9,283-0.4l0,0.5\n            c-94.4-1.6-190.3-0.6-283,0.4C415,170.2,356.8,170.8,298.2,170.8 M295.8,174c-54.3,0-108.7-0.5-162.8-2l0-0.5\n            c106.5,2.9,214.6,2,319.2,1.1c97.3-0.9,198-1.7,297,0.5l0,0.5c-99-2.2-199.7-1.4-297-0.5C400.8,173.5,348.4,174,\n            295.8,174M744.1,177c-102.8-2.8-207.4-2-308.4-1.3c-97.7,0.7-198.6,1.5-298-1l0-0.6c99.4,2.5,200.3,1.7,298,1\n            c101.1-0.8,205.6-1.6,308.5,1.3L744.1,177z\"\n          />\n          <path\n            class=\"st1\"\n            d=\"M739.8,179.7c-102.9-2.6-207.6-2-308.7-1.5c-94.7,0.5-192.6,1-288.9-1l0-0.5c96.3,2,194.2,1.5,288.9,1\n            c101.2-0.5,205.8-1.1,308.8,1.5L739.8,179.7L739.8,179.7z M734.7,183.1c-102.5-1.9-206.6-1.6-307.3-1.3\n            c-91.9,0.2-187,0.5-280.5-0.9l0-0.5c93.5,1.4,188.6,1.1,280.5,0.9c100.7-0.3,204.9-0.5,307.3,1.3L734.7,\n            183.1L734.7,183.1zM730,187.4c-104.8-0.8-211.4-0.7-314.5-0.7c-86.7,0-176.4,0.1-264.6-0.4v-0.6c88.2,\n            0.5,177.9,0.4,264.6,0.4c103.1,0,209.6-0.1,314.5,0.7C730,186.9,730,187.4,730,187.4z M313.6,194.7c-53.3,\n            0-106.8,0-159.8-0.1V194c114.3,0.2,230.5,0.1,342.9,0c75.5-0.1,153.5-0.1,230.3-0.1v0.5c-76.8,0-154.8,0-230.3,\n            0.1C436.5,194.6,375.1,194.7,313.6,194.7M276.2,203.9c-40.1,0-80.2-0.1-120.1-0.3V203c98.5,0.5,198.6,0.2,295.4,\n            0c89.5-0.3,182-0.5,272.9-0.1v0.5c-91-0.4-183.5-0.1-272.9,0.1C393.9,203.7,335.1,203.9,276.2,203.9 M255.3,\n            212.7c-32.3,0-64.6-0.1-96.8-0.4v-0.6c90.7,0.7,183,0.2,272.2-0.3c95.5-0.5,194.4-1.1,291.5-0.1l0,\n            0.6c-97.2-1-196-0.4-291.5,0.1C373.1,212.4,314.2,212.7,255.3,212.7M242.6,221.2c-27.3,0-54.7-0.1-81.8-0.4\n            v-0.5c86.1,0.9,173.6,0.1,258.2-0.7c98.7-0.9,200.8-1.8,301.2-0.1l0,0.5c-100.4-1.8-202.4-0.8-301.1,0.1C361.1,\n            220.7,301.8,221.2,242.6,221.2 M220.9,229.2c-19.4,0-38.7-0.1-57.9-0.2v-0.5c79,0.7,159.2-0.2,236.9-1.1\n            c104.3-1.2,212.2-2.5,318.2,0.2l0,0.5c-106-2.7-213.9-1.4-318.2-0.2C341.2,228.5,280.9,229.2,220.9,\n            229.2 M208.8,237c-14.6,0-29.1-0.1-43.6-0.2v-0.6c74.8,0.6,150.9-0.5,224.5-1.5c107-1.5,217.7-3.1,326.4,0.4l0,\n            0.5c-108.7-3.5-219.4-1.9-326.4-0.4C330.4,236.2,269.4,237,208.8,237 M206.8,244.9c-13.2,0-26.3,\n            0-39.4-0.1v-0.6c73.3,0.6,147.9-0.6,220.1-1.8c107.1-1.7,217.8-3.5,326.6,0.5l0,\n            0.5c-108.7-4-219.5-2.2-326.5-0.5C328.3,243.9,267.3,244.9,206.8,244.9 M214.5,252.8c-15,\n            0-29.9-0.1-44.8-0.2V252c74.4,0.7,150-0.6,223.2-1.8c104.7-1.8,212.9-3.7,319.2,0.4l0,\n            0.5c-106.3-4.1-214.5-2.2-319.2-0.4C334.3,251.7,274.2,252.8,214.5,252.8 M231.8,260.8\n            c-20,0-39.9-0.1-59.8-0.4l0-0.5c78,1.1,157.3-0.3,234-1.6c99.6-1.7,202.6-3.5,303.8,0.1l0,\n            0.5c-101.2-3.6-204.2-1.8-303.8-0.1C348.9,259.8,290.2,260.8,231.8,260.8 M259,269.2c-28.3,\n            0-56.5-0.2-84.6-0.8l0-0.5c84.8,1.8,171,0.3,254.3-1.1c91.4-1.6,185.8-3.2,278.7-0.5l0,\n            0.5c-92.9-2.7-187.4-1.1-278.7,0.5C373,268.3,316,269.2,259,269.2 M294.9,278.2c-39.4,\n            0-78.8-0.5-118-1.7l0-0.5c95.7,3,192.9,1.4,287-0.2c78.9-1.3,160.6-2.7,240.9-1.3l0,0.5c-80.3-1.4-161.9,\n            0-240.8,1.3C408.3,277.3,351.7,278.2,294.9,278.2 M335.9,288.1c-52.3,0-104.6-0.8-156.4-3.1l0-0.5c112.8,\n            5,228,2.9,339.4,0.9c60-1.1,122-2.2,182.8-2.2v0.5c-60.8,0-122.8,1.1-182.8,2.2C458.7,286.9,397.3,288.1,335.9,\n            288.1 M331.3,295.4c-49.9,0-99.9-0.7-149.4-2.8l0-0.5c109.5,4.6,221.3,2.6,329.4,0.7c61.6-1.1,125.2-2.2,\n            187.7-2.1v0.5c-62.5-0.1-126.1,1-187.7,2.1C452.1,294.4,391.8,295.4,331.3,295.4 M327,309.3c-47,\n            0-94.1-0.5-140.8-2l0-0.5c105.5,3.3,213,1.8,317,0.3c62.7-0.9,127.6-1.8,191.3-1.6v0.6c-63.7-0.2-128.6,\n            0.7-191.3,1.6C445.2,308.5,386.2,309.3,327,309.3 M326.4,316\n            c-46.2,0-92.4-0.4-138.3-1.5l0-0.5c104.3,2.6,210.4,1.4,313.1,0.2c62.8-0.7,127.7-1.4,191.5-1.3v0.5\n            c-63.8-0.1-128.7,0.6-191.5,1.3C443.7,315.3,385.1,316,326.4,316 M440.6,321.5c19.9-0.1,39.7-0.3,59.4-0.5\n            c62.6-0.5,127.3-1.1,190.9-0.9v0.5c-63.6-0.1-128.3,0.4-190.9,0.9c-57,0.5-115,1-173.2,1 M326.7,322.5c-45.7,\n            0-91.5-0.3-136.9-1.1l0-0.5c83.3,1.5,167.8,1.3,250.8,0.6 M328.1,329c-45.6,0-91.3-0.2-136.6-0.7l0-0.5c102.7,\n            1.3,207.2,0.7,308.3,0.1c62.1-0.3,126.3-0.7,189.4-0.6v0.6c-63.1-0.1-127.3,0.3-189.4,0.6C443.3,328.7,385.8,\n            329,328.1,329 M331.5,335.4c-46.2,0-92.4-0.1-138.3-0.4v-0.5c102.6,0.7,207,0.4,308,0.1c61.1-0.2,124.3-0.4,\n            186.4-0.3v0.6c-62.1,0-125.3,0.1-186.4,0.3C445.4,335.2,388.5,335.4,331.5,335.4 M339.5,341.9c-48.3,0-96.6,\n            0-144.7-0.2v-0.5c103.8,0.3,209.3,0.2,311.3,0.1c58.9-0.1,119.8-0.1,179.7-0.1v0.5c-59.9,0-120.8,0.1-179.7,\n            0.1C451.4,341.8,395.5,341.9,339.5,341.9 M359.1,348.4c-54.2,0-108.3,0-162.5,0v-0.5c108.3,0,216.7,0,325,\n            0l162.5,0v0.5l-162.5,0C467.5,348.4,413.3,348.4,359.1,348.4\"\n          />\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bm\"\n                class=\"st104\"\n                d=\"M153.6,189.1c-1,0-2-0.3-2.9-0.9l-51.3-33.9c-2.4-1.6-3.1-4.9-1.5-7.4\n        c1.6-2.4,4.9-3.1,7.4-1.5l51.3,33.9c2.4,1.6,3.1,4.9,1.5,7.4C157,188.3,155.3,189.1,153.6,189.1\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bm_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-193.21\"\n                y1=\"751.401\"\n                x2=\"-193.297\"\n                y2=\"751.3002\"\n                gradientTransform=\"matrix(61.8714 0 0 -44.4957 12084.1494 33599.332)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.4693\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.5405\" style=\"stop-color:#D5D5D5\" />\n                <stop offset=\"0.7894\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bm_1_\"\n                class=\"st105\"\n                d=\"M153.6,189.1c-1,0-2-0.3-2.9-0.9l-51.3-33.9c-2.4-1.6-3.1-4.9-1.5-7.4\n        c1.6-2.4,4.9-3.1,7.4-1.5l51.3,33.9c2.4,1.6,3.1,4.9,1.5,7.4C157,188.3,155.3,189.1,153.6,189.1\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bo\"\n                class=\"st104\"\n                d=\"M728.2,189.1c-1.7,0-3.4-0.8-4.4-2.4c-1.6-2.4-0.9-5.7,1.5-7.4l51.3-33.9\n        c2.4-1.6,5.7-0.9,7.4,1.5c1.6,2.4,0.9,5.7-1.5,7.4l-51.3,33.9C730.2,188.8,729.2,189.1,728.2,189.1\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bo_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-193.3336\"\n                y1=\"751.4563\"\n                x2=\"-193.2035\"\n                y2=\"751.3245\"\n                gradientTransform=\"matrix(61.8724 0 0 -44.4966 12710.1602 33600)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.4693\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.5385\" style=\"stop-color:#C7C7C7\" />\n                <stop offset=\"0.7894\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bo_1_\"\n                class=\"st106\"\n                d=\"M728.2,189.1c-1.7,0-3.4-0.8-4.4-2.4c-1.6-2.4-0.9-5.7,1.5-7.4l51.3-33.9\n        c2.4-1.6,5.7-0.9,7.4,1.5c1.6,2.4,0.9,5.7-1.5,7.4l-51.3,33.9C730.2,188.8,729.2,189.1,728.2,189.1\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bq\"\n                class=\"st104\"\n                d=\"M731.8,183.4c0.4-1.3,0.1-2.8-0.7-3.9c-0.8-1.1-2.1-1.8-3.5-1.8H153\n        c-1.4,0-2.7,0.7-3.5,1.8c-0.8,1.1-1.1,2.5-0.7,3.9l0.9,3.2h581.3L731.8,183.4z\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bq_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-197.5046\"\n                y1=\"715.0063\"\n                x2=\"-197.5046\"\n                y2=\"714.0063\"\n                gradientTransform=\"matrix(583.4112 0 0 -8.847 115666.6406 6503.4224)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.456\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.5975\" style=\"stop-color:#C8C8C8\" />\n                <stop offset=\"0.9122\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bq_1_\"\n                class=\"st107\"\n                d=\"M731.8,183.4c0.4-1.3,0.1-2.8-0.7-3.9c-0.8-1.1-2.1-1.8-3.5-1.8H153\n        c-1.4,0-2.7,0.7-3.5,1.8c-0.8,1.1-1.1,2.5-0.7,3.9l0.9,3.2h581.3L731.8,183.4z\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bs\"\n                class=\"st104\"\n                d=\"M195.8,349.9c0.7,2.3,3.1,3.7,5.5,3c2.4-0.7,3.7-3.1,3.1-5.5l-45.5-160.3h-9.2\n        L195.8,349.9L195.8,349.9z\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bs_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-192.6151\"\n                y1=\"758.0818\"\n                x2=\"-192.6337\"\n                y2=\"758.0654\"\n                gradientTransform=\"matrix(54.8333 0 0 -165.9138 10739.6133 126042.4063)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.3323\" style=\"stop-color:#E1E1E1\" />\n                <stop offset=\"0.5471\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.7894\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bs_1_\"\n                class=\"st108\"\n                d=\"M195.8,349.9c0.7,2.3,3.1,3.7,5.5,3c2.4-0.7,3.7-3.1,3.1-5.5l-45.5-160.3h-9.2\n        L195.8,349.9L195.8,349.9z\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bu\"\n                class=\"st104\"\n                d=\"M721.7,187.2l-45.5,160.3c-0.7,2.4,0.7,4.8,3,5.5c0.4,0.1,0.8,0.2,1.2,0.2\n        c1.9,0,3.7-1.3,4.3-3.2l46.2-162.7L721.7,187.2L721.7,187.2z\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bu_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-192.5974\"\n                y1=\"758.0408\"\n                x2=\"-192.5786\"\n                y2=\"758.025\"\n                gradientTransform=\"matrix(54.8323 0 0 -165.915 11265.832 126043.3203)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.4233\" style=\"stop-color:#CACACA\" />\n                <stop offset=\"0.548\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.7894\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bu_1_\"\n                class=\"st109\"\n                d=\"M721.7,187.2l-45.5,160.3c-0.7,2.4,0.7,4.8,3,5.5c0.4,0.1,0.8,0.2,1.2,0.2\n        c1.9,0,3.7-1.3,4.3-3.2l46.2-162.7L721.7,187.2L721.7,187.2z\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bw\"\n                class=\"st104\"\n                d=\"M679.6,352.4H200.7c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4h478.9c2.4,0,4.4,2,4.4,4.4\n        C684,350.4,682,352.4,679.6,352.4\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bw_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-197.4054\"\n                y1=\"715.0012\"\n                x2=\"-197.4054\"\n                y2=\"714.0012\"\n                gradientTransform=\"matrix(487.775 0 0 -8.846 96729.5547 6668.4287)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.4693\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.5601\" style=\"stop-color:#C6C4C4\" />\n                <stop offset=\"0.7894\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bw_1_\"\n                class=\"st110\"\n                d=\"M679.6,352.4H200.7c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4h478.9\n        c2.4,0,4.4,2,4.4,4.4C684,350.4,682,352.4,679.6,352.4\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__by\"\n                class=\"st104\"\n                d=\"M101.5,382c-1.9,0-3.6-1.2-4.2-3.2c-0.7-2.3,0.6-4.8,2.9-5.5l99.2-29.7\n        c2.3-0.7,4.7,0.7,5.4,3c0.7,2.3-0.6,4.8-2.9,5.5l-99.2,29.7C102.3,382,101.9,382,101.5,382\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__by_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-195.3122\"\n                y1=\"749.9836\"\n                x2=\"-195.2908\"\n                y2=\"749.9586\"\n                gradientTransform=\"matrix(107.9238 0 0 -38.5112 21226.1543 29243.9727)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.4693\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.8602\" style=\"stop-color:#C7C7C7\" />\n                <stop offset=\"0.9095\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__by_1_\"\n                class=\"st111\"\n                d=\"M101.5,382c-1.9,0-3.6-1.2-4.2-3.2c-0.7-2.3,0.6-4.8,2.9-5.5l99.2-29.7\n        c2.3-0.7,4.7,0.7,5.4,3c0.7,2.3-0.6,4.8-2.9,5.5l-99.2,29.7C102.3,382,101.9,382,101.5,382\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bA\"\n                class=\"st104\"\n                d=\"M780.4,382c-0.4,0-0.8-0.1-1.3-0.2l-100.8-29.7c-2.3-0.7-3.7-3.1-3-5.5\n        c0.7-2.3,3.2-3.7,5.5-3l100.8,29.7c2.3,0.7,3.7,3.1,3,5.5C784,380.8,782.3,382,780.4,382\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bA_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-195.3541\"\n                y1=\"749.8986\"\n                x2=\"-195.373\"\n                y2=\"749.8754\"\n                gradientTransform=\"matrix(109.6046 0 0 -38.5105 22137.7969 29243.4277)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.4693\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.6472\" style=\"stop-color:#C1BEBE\" />\n                <stop offset=\"0.9305\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bA_1_\"\n                class=\"st112\"\n                d=\"M780.4,382c-0.4,0-0.8-0.1-1.3-0.2l-100.8-29.7c-2.3-0.7-3.7-3.1-3-5.5\n        c0.7-2.3,3.2-3.7,5.5-3l100.8,29.7c2.3,0.7,3.7,3.1,3,5.5C784,380.8,782.3,382,780.4,382\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bC\"\n                class=\"st104\"\n                d=\"M101.1,381.9h2.4c2.3,0,4.1-1.8,4.1-4.1V155.2h0.1L97,144.9v232.9\n        C97,380.1,98.9,381.9,101.1,381.9\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bC_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-170.4331\"\n                y1=\"758.7918\"\n                x2=\"-170.4313\"\n                y2=\"758.7918\"\n                gradientTransform=\"matrix(10.697 0 0 -237.04 1925.5055 180127.7969)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.4693\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.5317\" style=\"stop-color:#CECDCD\" />\n                <stop offset=\"0.7894\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bC_1_\"\n                class=\"st113\"\n                d=\"M101.1,381.9h2.4c2.3,0,4.1-1.8,4.1-4.1V155.2h0.1L97,144.9v232.9\n        C97,380.1,98.9,381.9,101.1,381.9\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path\n                id=\"prefix__bE\"\n                class=\"st104\"\n                d=\"M774.1,155.6v222.2c0,2.3,1.8,4.1,4.1,4.1h2.4c2.3,0,4.1-1.8,4.1-4.1V144.8L774.1,155.6\n        L774.1,155.6z\"\n              />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bE_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-170.2227\"\n                y1=\"758.7947\"\n                x2=\"-170.2209\"\n                y2=\"758.7947\"\n                gradientTransform=\"matrix(10.616 0 0 -237.049 2586.5076 180134.6406)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EAEAEA\" />\n                <stop offset=\"0.4756\" style=\"stop-color:#D4D4D4\" />\n                <stop offset=\"0.5433\" style=\"stop-color:#CBCBCB\" />\n                <stop offset=\"0.7894\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path\n                id=\"prefix__bE_1_\"\n                class=\"st114\"\n                d=\"M774.1,155.6v222.2c0,2.3,1.8,4.1,4.1,4.1h2.4c2.3,0,4.1-1.8,4.1-4.1V144.8\n                L774.1,155.6L774.1,155.6z\"\n              />\n            </g>\n          </g>\n          <g transform=\"translate(0 .136)\">\n            <g>\n              <path id=\"prefix__bG\" class=\"st104\" d=\"M784.7,144.6H97v0.2l10.7,10.4h666.4v0.4l10.6-10.7V144.6z\" />\n            </g>\n            <g>\n              <linearGradient\n                id=\"prefix__bG_2_\"\n                gradientUnits=\"userSpaceOnUse\"\n                x1=\"-197.5812\"\n                y1=\"723.9365\"\n                x2=\"-197.5812\"\n                y2=\"722.9365\"\n                gradientTransform=\"matrix(687.692 0 0 -10.978 136315.9219 8091.9858)\"\n              >\n                <stop offset=\"0\" style=\"stop-color:#FFFFFF\" />\n                <stop offset=\"0.2148\" style=\"stop-color:#EEEBEB\" />\n                <stop offset=\"0.4693\" style=\"stop-color:#C6C6C6\" />\n                <stop offset=\"0.7894\" style=\"stop-color:#ECECEC\" />\n                <stop offset=\"1\" style=\"stop-color:#FFFFFF\" />\n              </linearGradient>\n              <path id=\"prefix__bG_1_\" class=\"st115\" d=\"M784.7,144.6H97v0.2l10.7,10.4h666.4v0.4l10.6-10.7V144.6z\" />\n            </g>\n          </g>\n        </g>\n      </g>\n      <line class=\"st116\" x1=\"-9\" y1=\"507.7\" x2=\"891\" y2=\"507.7\" />\n      <path class=\"st117\" d=\"M159.9,541.6\" />\n      <path class=\"st103\" d=\"M702.6,506.6c-54.1,44.6-153.9,74.5-267.9,74.5c-113.4,0-212.7-29.6-267-73.8\" />\n      <path class=\"st117\" d=\"M539.5,327.8\" />\n      <path class=\"st117\" d=\"M434.6,319\" />\n      <line class=\"st103\" x1=\"43.2\" y1=\"384\" x2=\"-2.5\" y2=\"407.1\" />\n      <line class=\"st103\" x1=\"891.7\" y1=\"440.2\" x2=\"825.1\" y2=\"383.2\" />\n      <line class=\"st118\" x1=\"193.2\" y1=\"301.7\" x2=\"689.9\" y2=\"300.4\" />\n      <Ball v-for=\"(play, index) in showPlays\" :play=\"play\" :key=\"index\" @showTooltip=\"showTooltip\" @hideTooltip=\"hideTooltip\" />\n    </svg>\n    <Tooltip :data=\"dataTooltip\">\n      <div class=\"tooltip-data has-text-left\">\n        <div v-if=\"sectionType === 'team'\"><span class=\"bold\">Jugador: </span>{{ dataPlay.playerName }}</div>\n        <div><span class=\"bold\">Minuto: </span>{{ dataPlay.minute }}</div>\n        <div>\n          <span class=\"bold\">Rival: </span>{{ dataPlay.rivalName }}\n          <img :src=\"dataPlay.rivalLogo\" width=\"25\" style=\"vertical-align:middle;\" />\n        </div>\n      </div>\n    </Tooltip>\n  </div>\n</template>\n\n<script>\nimport { mapGetters } from 'vuex';\nimport Ball from './Ball.vue';\nimport IconBall from './IconBall.vue';\nimport Tooltip from './Tooltip.vue';\nimport filtersGoal from '../../data/filters-goal';\nimport getGoalPlayIndexes from '../../data/team-goal-play-indexes';\n\nconst INDEXES = getGoalPlayIndexes();\n\nexport default {\n  name: 'SoccerGoal',\n  components: { Ball, IconBall, Tooltip },\n  props: {\n    players: {\n      type: Array,\n      required: true,\n    },\n    teams: {\n      type: Array,\n      required: true,\n    },\n    plays: {\n      type: Array,\n      required: true,\n    },\n    // Possible values: 'team' or 'player'\n    sectionType: {\n      type: String,\n      required: true,\n    }\n  },\n  data() {\n    return {\n      categories: null,\n      categoriesSelected: [],\n      dataTooltip: { x: 0, y: 0, visible: false },\n      dataPlay: {\n        playerName: '', minute: 0, rivalName: '', rivalLogo: '',\n      },\n    };\n  },\n  mounted() {\n    this.categories = filtersGoal[this.categoryType];\n    this.categoriesSelected = this.categories.map((category) => category.category_id);\n  },\n  computed: {\n    ...mapGetters('playerProfileGames', ['seasonGamesPlayed']),\n    ...mapGetters('playerProfileGeneral', ['player']),\n    /**\n     * Prepare the plays to show.\n     * @return {{st, play_id: *, category_id: *, playerName: *, x: *, category_type: *, y: *, category_color: (string), time: *}[]}\n     */\n    showPlays() {\n      return this.playsFiltered.map((play) => {\n        const game = this.seasonGamesPlayed.find((game) => game.game_id === play[INDEXES.gameId]);\n        let team = {};\n\n        if (game) {\n          const rivalTeamId = play[INDEXES.playingAs] === 1 ? game.visiting_team : game.home_team;\n          team = this.teams.find((team) => team.team_id === rivalTeamId);\n          team = team || {};\n        }\n\n        const matchedPlayer = this.players.find((player) => player.player_id === play[INDEXES.playerId]);\n        return {\n          play_id: play[INDEXES.playId],\n          playerName: matchedPlayer ? matchedPlayer.name : '',\n          time: play[INDEXES.momentOfPlay],\n          category_id: play[INDEXES.categoryId],\n          category_color: this.categories.find((category) => category.category_id === play[INDEXES.categoryId])\n            .category_color,\n          st: this.categories.find((category) => category.category_id === play[INDEXES.categoryId]).st,\n          category_type: play[INDEXES.categoryType],\n          x: play[INDEXES.coordinateX],\n          y: play[INDEXES.coordinateY],\n          rivalName: team.team_name || '',\n          rivalLogo: team.logo || '',\n        };\n      });\n    },\n    /**\n     * Plays Filtered\n     * @return Array\n     */\n    playsFiltered() {\n      return this.plays.filter((play) => {\n        const game = this.seasonGamesPlayed.find((game) => game.game_id === play[INDEXES.gameId]);\n        let rivalTeamId;\n        if (game) {\n          rivalTeamId = play[INDEXES.categoryId] === 12000\n            ? play[INDEXES.playingAs] === 1\n              ? game.visiting_team\n              : game.home_team\n            : null;\n        }\n\n        return (\n          this.categoriesSelected.includes(play[INDEXES.categoryId])\n          && (play[INDEXES.categoryId] !== 12000 ? true : this.player.team_id !== rivalTeamId)\n        );\n      });\n    },\n    ...mapGetters('playerProfileFilter', {\n      categoryType: 'getCategoryType',\n    }),\n  },\n  methods: {\n    /**\n     * Show Tooltip of play\n     * @param dataTooltip\n     * @return void\n     */\n    showTooltip(dataTooltip) {\n      const goalBounds = this.$refs.goal.getBoundingClientRect();\n      dataTooltip.x = dataTooltip.x - goalBounds.x;\n      dataTooltip.y = goalBounds.y < 0 ? dataTooltip.y + (-1 * goalBounds.y) : dataTooltip.y - goalBounds.y;\n      dataTooltip.y += 65;\n      Object.assign(this.dataPlay, dataTooltip);\n      Object.assign(this.dataTooltip, dataTooltip);\n      this.dataTooltip.visible = true;\n    },\n    /**\n     * Hide Tooltip\n     * @return void\n     */\n    hideTooltip() {\n      this.dataPlay = {\n        playerName: '', minute: 0, rivalName: '', rivalLogo: '',\n      };\n      this.dataTooltip.visible = false;\n    },\n    /**\n     * @author Rigoberto Sanchez\n     * @descripcion Emit event when change category\n     */\n    onClickCategory(value) {\n      this.$emit('changeCategory', {\n        name: value.target.name,\n        checked: value.target.checked,\n      });\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"scss\">\n.goal {\n  position: relative;\n  border-radius: 21px;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n  background-image: linear-gradient(to top, #417505, #ffffff 53%);\n}\n.st0 {\n  opacity: 0.5;\n  fill: #505050;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n  enable-background: new;\n}\n.st1 {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st2 {\n  filter: url(#Adobe_OpacityMaskFilter);\n}\n.st3 {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #ffffff;\n}\n.st4 {\n  mask: url(#prefix__b_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st5 {\n  filter: url(#Adobe_OpacityMaskFilter_1_);\n}\n.st6 {\n  mask: url(#prefix__d_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st7 {\n  filter: url(#Adobe_OpacityMaskFilter_2_);\n}\n.st8 {\n  mask: url(#prefix__f_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st9 {\n  filter: url(#Adobe_OpacityMaskFilter_3_);\n}\n.st10 {\n  mask: url(#prefix__h_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st11 {\n  filter: url(#Adobe_OpacityMaskFilter_4_);\n}\n.st12 {\n  mask: url(#prefix__j_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st13 {\n  filter: url(#Adobe_OpacityMaskFilter_5_);\n}\n.st14 {\n  mask: url(#prefix__l_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st15 {\n  filter: url(#Adobe_OpacityMaskFilter_6_);\n}\n.st16 {\n  mask: url(#prefix__n_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st17 {\n  filter: url(#Adobe_OpacityMaskFilter_7_);\n}\n.st18 {\n  mask: url(#prefix__p_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st19 {\n  filter: url(#Adobe_OpacityMaskFilter_8_);\n}\n.st20 {\n  mask: url(#prefix__r_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st21 {\n  filter: url(#Adobe_OpacityMaskFilter_9_);\n}\n.st22 {\n  mask: url(#prefix__t_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st23 {\n  filter: url(#Adobe_OpacityMaskFilter_10_);\n}\n.st24 {\n  mask: url(#prefix__v_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st25 {\n  filter: url(#Adobe_OpacityMaskFilter_11_);\n}\n.st26 {\n  mask: url(#prefix__x_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st27 {\n  filter: url(#Adobe_OpacityMaskFilter_12_);\n}\n.st28 {\n  mask: url(#prefix__z_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st29 {\n  filter: url(#Adobe_OpacityMaskFilter_13_);\n}\n.st30 {\n  mask: url(#prefix__B_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st31 {\n  filter: url(#Adobe_OpacityMaskFilter_14_);\n}\n.st32 {\n  mask: url(#prefix__D_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st33 {\n  filter: url(#Adobe_OpacityMaskFilter_15_);\n}\n.st34 {\n  mask: url(#prefix__F_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st35 {\n  filter: url(#Adobe_OpacityMaskFilter_16_);\n}\n.st36 {\n  mask: url(#prefix__H_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st37 {\n  filter: url(#Adobe_OpacityMaskFilter_17_);\n}\n.st38 {\n  mask: url(#prefix__J_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st39 {\n  filter: url(#Adobe_OpacityMaskFilter_18_);\n}\n.st40 {\n  mask: url(#prefix__L_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st41 {\n  filter: url(#Adobe_OpacityMaskFilter_19_);\n}\n.st42 {\n  mask: url(#prefix__N_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st43 {\n  filter: url(#Adobe_OpacityMaskFilter_20_);\n}\n.st44 {\n  mask: url(#prefix__P_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st45 {\n  filter: url(#Adobe_OpacityMaskFilter_21_);\n}\n.st46 {\n  mask: url(#prefix__R_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st47 {\n  filter: url(#Adobe_OpacityMaskFilter_22_);\n}\n.st48 {\n  mask: url(#prefix__T_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st49 {\n  filter: url(#Adobe_OpacityMaskFilter_23_);\n}\n.st50 {\n  mask: url(#prefix__V_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st51 {\n  filter: url(#Adobe_OpacityMaskFilter_24_);\n}\n.st52 {\n  mask: url(#prefix__X_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st53 {\n  filter: url(#Adobe_OpacityMaskFilter_25_);\n}\n.st54 {\n  mask: url(#prefix__ah_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st55 {\n  filter: url(#Adobe_OpacityMaskFilter_26_);\n}\n.st56 {\n  mask: url(#prefix__aj_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st57 {\n  filter: url(#Adobe_OpacityMaskFilter_27_);\n}\n.st58 {\n  mask: url(#prefix__al_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st59 {\n  filter: url(#Adobe_OpacityMaskFilter_28_);\n}\n.st60 {\n  mask: url(#prefix__an_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st61 {\n  filter: url(#Adobe_OpacityMaskFilter_29_);\n}\n.st62 {\n  mask: url(#prefix__ap_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st63 {\n  filter: url(#Adobe_OpacityMaskFilter_30_);\n}\n.st64 {\n  mask: url(#prefix__ar_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st65 {\n  filter: url(#Adobe_OpacityMaskFilter_31_);\n}\n.st66 {\n  mask: url(#prefix__at_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st67 {\n  filter: url(#Adobe_OpacityMaskFilter_32_);\n}\n.st68 {\n  mask: url(#prefix__av_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st69 {\n  filter: url(#Adobe_OpacityMaskFilter_33_);\n}\n.st70 {\n  mask: url(#prefix__ax_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st71 {\n  filter: url(#Adobe_OpacityMaskFilter_34_);\n}\n.st72 {\n  mask: url(#prefix__az_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st73 {\n  filter: url(#Adobe_OpacityMaskFilter_35_);\n}\n.st74 {\n  mask: url(#prefix__aB_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st75 {\n  filter: url(#Adobe_OpacityMaskFilter_36_);\n}\n.st76 {\n  mask: url(#prefix__aD_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st77 {\n  filter: url(#Adobe_OpacityMaskFilter_37_);\n}\n.st78 {\n  mask: url(#prefix__aF_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st79 {\n  filter: url(#Adobe_OpacityMaskFilter_38_);\n}\n.st80 {\n  mask: url(#prefix__aH_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st81 {\n  filter: url(#Adobe_OpacityMaskFilter_39_);\n}\n.st82 {\n  mask: url(#prefix__aJ_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st83 {\n  filter: url(#Adobe_OpacityMaskFilter_40_);\n}\n.st84 {\n  mask: url(#prefix__aL_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st85 {\n  filter: url(#Adobe_OpacityMaskFilter_41_);\n}\n.st86 {\n  mask: url(#prefix__aN_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st87 {\n  filter: url(#Adobe_OpacityMaskFilter_42_);\n}\n.st88 {\n  mask: url(#prefix__aP_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st89 {\n  filter: url(#Adobe_OpacityMaskFilter_43_);\n}\n.st90 {\n  mask: url(#prefix__aR_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st91 {\n  filter: url(#Adobe_OpacityMaskFilter_44_);\n}\n.st92 {\n  mask: url(#prefix__aT_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st93 {\n  filter: url(#Adobe_OpacityMaskFilter_45_);\n}\n.st94 {\n  mask: url(#prefix__aV_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st95 {\n  filter: url(#Adobe_OpacityMaskFilter_46_);\n}\n.st96 {\n  mask: url(#prefix__aX_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st97 {\n  filter: url(#Adobe_OpacityMaskFilter_47_);\n}\n.st98 {\n  mask: url(#prefix__aZ_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st99 {\n  filter: url(#Adobe_OpacityMaskFilter_48_);\n}\n.st100 {\n  mask: url(#prefix__bb_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st101 {\n  filter: url(#Adobe_OpacityMaskFilter_49_);\n}\n.st102 {\n  mask: url(#prefix__bd_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st103 {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 6;\n  stroke-miterlimit: 10;\n}\n.st104 {\n  fill: #ffffff;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st105 {\n  fill: url(#prefix__bm_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st106 {\n  fill: url(#prefix__bo_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st107 {\n  fill: url(#prefix__bq_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st108 {\n  fill: url(#prefix__bs_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st109 {\n  fill: url(#prefix__bu_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st110 {\n  fill: url(#prefix__bw_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st111 {\n  fill: url(#prefix__by_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st112 {\n  fill: url(#prefix__bA_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st113 {\n  fill: url(#prefix__bC_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st114 {\n  fill: url(#prefix__bE_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st115 {\n  fill: url(#prefix__bG_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n.st116 {\n  fill: #ffffff;\n  stroke: #ffffff;\n  stroke-width: 6;\n  stroke-miterlimit: 10;\n}\n.st117 {\n  fill: none;\n  stroke: #000000;\n  stroke-width: 10;\n  stroke-miterlimit: 10;\n}\n.st118 {\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-width: 2;\n  stroke-miterlimit: 10;\n}\n.goal__filters {\n  position: absolute;\n  transform: translateX(31%);\n  width: 60%;\n  background-color: #ffffff;\n  opacity: 0.9;\n  border-radius: 15px;\n  padding: 10px;\n  max-width: 80%;\n  font-size: 10px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  bottom: 25px;\n\n  & .checkbox {\n    padding: 0;\n  }\n}\n@media screen and (max-width: 345px) {\n  .goal__filters {\n    bottom: 10px;\n  }\n}\n@media (min-width: 800px) {\n  .goal__filters {\n    font-size: 11px;\n  }\n}\n@media (min-width: 900px) {\n  .goal__filters {\n    font-size: 13px;\n  }\n}\n.is-pointer {\n  cursor: default;\n}\n.tooltip-data {\n  font-family: 'Avenir-Medium';\n  font-size: 12px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2;\n  letter-spacing: normal;\n  color: #ffffff;\n}\n.tooltip-data .bold {\n  font-family: 'Avenir-Bold';\n}\n.checkbox-list {\n  padding-top: 4px;\n}\n</style>\n",".goal {\n  position: relative;\n  border-radius: 21px;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n  background-image: linear-gradient(to top, #417505, #ffffff 53%);\n}\n\n.st0 {\n  opacity: 0.5;\n  fill: #505050;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n  enable-background: new;\n}\n\n.st1 {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st2 {\n  filter: url(#Adobe_OpacityMaskFilter);\n}\n\n.st3 {\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #ffffff;\n}\n\n.st4 {\n  mask: url(#prefix__b_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st5 {\n  filter: url(#Adobe_OpacityMaskFilter_1_);\n}\n\n.st6 {\n  mask: url(#prefix__d_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st7 {\n  filter: url(#Adobe_OpacityMaskFilter_2_);\n}\n\n.st8 {\n  mask: url(#prefix__f_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st9 {\n  filter: url(#Adobe_OpacityMaskFilter_3_);\n}\n\n.st10 {\n  mask: url(#prefix__h_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st11 {\n  filter: url(#Adobe_OpacityMaskFilter_4_);\n}\n\n.st12 {\n  mask: url(#prefix__j_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st13 {\n  filter: url(#Adobe_OpacityMaskFilter_5_);\n}\n\n.st14 {\n  mask: url(#prefix__l_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st15 {\n  filter: url(#Adobe_OpacityMaskFilter_6_);\n}\n\n.st16 {\n  mask: url(#prefix__n_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st17 {\n  filter: url(#Adobe_OpacityMaskFilter_7_);\n}\n\n.st18 {\n  mask: url(#prefix__p_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st19 {\n  filter: url(#Adobe_OpacityMaskFilter_8_);\n}\n\n.st20 {\n  mask: url(#prefix__r_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st21 {\n  filter: url(#Adobe_OpacityMaskFilter_9_);\n}\n\n.st22 {\n  mask: url(#prefix__t_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st23 {\n  filter: url(#Adobe_OpacityMaskFilter_10_);\n}\n\n.st24 {\n  mask: url(#prefix__v_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st25 {\n  filter: url(#Adobe_OpacityMaskFilter_11_);\n}\n\n.st26 {\n  mask: url(#prefix__x_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st27 {\n  filter: url(#Adobe_OpacityMaskFilter_12_);\n}\n\n.st28 {\n  mask: url(#prefix__z_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st29 {\n  filter: url(#Adobe_OpacityMaskFilter_13_);\n}\n\n.st30 {\n  mask: url(#prefix__B_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st31 {\n  filter: url(#Adobe_OpacityMaskFilter_14_);\n}\n\n.st32 {\n  mask: url(#prefix__D_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st33 {\n  filter: url(#Adobe_OpacityMaskFilter_15_);\n}\n\n.st34 {\n  mask: url(#prefix__F_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st35 {\n  filter: url(#Adobe_OpacityMaskFilter_16_);\n}\n\n.st36 {\n  mask: url(#prefix__H_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st37 {\n  filter: url(#Adobe_OpacityMaskFilter_17_);\n}\n\n.st38 {\n  mask: url(#prefix__J_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st39 {\n  filter: url(#Adobe_OpacityMaskFilter_18_);\n}\n\n.st40 {\n  mask: url(#prefix__L_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st41 {\n  filter: url(#Adobe_OpacityMaskFilter_19_);\n}\n\n.st42 {\n  mask: url(#prefix__N_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st43 {\n  filter: url(#Adobe_OpacityMaskFilter_20_);\n}\n\n.st44 {\n  mask: url(#prefix__P_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st45 {\n  filter: url(#Adobe_OpacityMaskFilter_21_);\n}\n\n.st46 {\n  mask: url(#prefix__R_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st47 {\n  filter: url(#Adobe_OpacityMaskFilter_22_);\n}\n\n.st48 {\n  mask: url(#prefix__T_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st49 {\n  filter: url(#Adobe_OpacityMaskFilter_23_);\n}\n\n.st50 {\n  mask: url(#prefix__V_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st51 {\n  filter: url(#Adobe_OpacityMaskFilter_24_);\n}\n\n.st52 {\n  mask: url(#prefix__X_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st53 {\n  filter: url(#Adobe_OpacityMaskFilter_25_);\n}\n\n.st54 {\n  mask: url(#prefix__ah_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st55 {\n  filter: url(#Adobe_OpacityMaskFilter_26_);\n}\n\n.st56 {\n  mask: url(#prefix__aj_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st57 {\n  filter: url(#Adobe_OpacityMaskFilter_27_);\n}\n\n.st58 {\n  mask: url(#prefix__al_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st59 {\n  filter: url(#Adobe_OpacityMaskFilter_28_);\n}\n\n.st60 {\n  mask: url(#prefix__an_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st61 {\n  filter: url(#Adobe_OpacityMaskFilter_29_);\n}\n\n.st62 {\n  mask: url(#prefix__ap_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st63 {\n  filter: url(#Adobe_OpacityMaskFilter_30_);\n}\n\n.st64 {\n  mask: url(#prefix__ar_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st65 {\n  filter: url(#Adobe_OpacityMaskFilter_31_);\n}\n\n.st66 {\n  mask: url(#prefix__at_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st67 {\n  filter: url(#Adobe_OpacityMaskFilter_32_);\n}\n\n.st68 {\n  mask: url(#prefix__av_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st69 {\n  filter: url(#Adobe_OpacityMaskFilter_33_);\n}\n\n.st70 {\n  mask: url(#prefix__ax_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st71 {\n  filter: url(#Adobe_OpacityMaskFilter_34_);\n}\n\n.st72 {\n  mask: url(#prefix__az_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st73 {\n  filter: url(#Adobe_OpacityMaskFilter_35_);\n}\n\n.st74 {\n  mask: url(#prefix__aB_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st75 {\n  filter: url(#Adobe_OpacityMaskFilter_36_);\n}\n\n.st76 {\n  mask: url(#prefix__aD_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st77 {\n  filter: url(#Adobe_OpacityMaskFilter_37_);\n}\n\n.st78 {\n  mask: url(#prefix__aF_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st79 {\n  filter: url(#Adobe_OpacityMaskFilter_38_);\n}\n\n.st80 {\n  mask: url(#prefix__aH_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st81 {\n  filter: url(#Adobe_OpacityMaskFilter_39_);\n}\n\n.st82 {\n  mask: url(#prefix__aJ_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st83 {\n  filter: url(#Adobe_OpacityMaskFilter_40_);\n}\n\n.st84 {\n  mask: url(#prefix__aL_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st85 {\n  filter: url(#Adobe_OpacityMaskFilter_41_);\n}\n\n.st86 {\n  mask: url(#prefix__aN_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st87 {\n  filter: url(#Adobe_OpacityMaskFilter_42_);\n}\n\n.st88 {\n  mask: url(#prefix__aP_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st89 {\n  filter: url(#Adobe_OpacityMaskFilter_43_);\n}\n\n.st90 {\n  mask: url(#prefix__aR_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st91 {\n  filter: url(#Adobe_OpacityMaskFilter_44_);\n}\n\n.st92 {\n  mask: url(#prefix__aT_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st93 {\n  filter: url(#Adobe_OpacityMaskFilter_45_);\n}\n\n.st94 {\n  mask: url(#prefix__aV_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st95 {\n  filter: url(#Adobe_OpacityMaskFilter_46_);\n}\n\n.st96 {\n  mask: url(#prefix__aX_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st97 {\n  filter: url(#Adobe_OpacityMaskFilter_47_);\n}\n\n.st98 {\n  mask: url(#prefix__aZ_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st99 {\n  filter: url(#Adobe_OpacityMaskFilter_48_);\n}\n\n.st100 {\n  mask: url(#prefix__bb_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st101 {\n  filter: url(#Adobe_OpacityMaskFilter_49_);\n}\n\n.st102 {\n  mask: url(#prefix__bd_1_);\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st103 {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 6;\n  stroke-miterlimit: 10;\n}\n\n.st104 {\n  fill: #ffffff;\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st105 {\n  fill: url(#prefix__bm_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st106 {\n  fill: url(#prefix__bo_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st107 {\n  fill: url(#prefix__bq_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st108 {\n  fill: url(#prefix__bs_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st109 {\n  fill: url(#prefix__bu_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st110 {\n  fill: url(#prefix__bw_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st111 {\n  fill: url(#prefix__by_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st112 {\n  fill: url(#prefix__bA_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st113 {\n  fill: url(#prefix__bC_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st114 {\n  fill: url(#prefix__bE_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st115 {\n  fill: url(#prefix__bG_2_);\n  stroke: #c9c9c9;\n  stroke-miterlimit: 10;\n}\n\n.st116 {\n  fill: #ffffff;\n  stroke: #ffffff;\n  stroke-width: 6;\n  stroke-miterlimit: 10;\n}\n\n.st117 {\n  fill: none;\n  stroke: #000000;\n  stroke-width: 10;\n  stroke-miterlimit: 10;\n}\n\n.st118 {\n  fill: #d2d2d2;\n  stroke: #c9c9c9;\n  stroke-width: 2;\n  stroke-miterlimit: 10;\n}\n\n.goal__filters {\n  position: absolute;\n  transform: translateX(31%);\n  width: 60%;\n  background-color: #ffffff;\n  opacity: 0.9;\n  border-radius: 15px;\n  padding: 10px;\n  max-width: 80%;\n  font-size: 10px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  bottom: 25px;\n}\n.goal__filters .checkbox {\n  padding: 0;\n}\n\n@media screen and (max-width: 345px) {\n  .goal__filters {\n    bottom: 10px;\n  }\n}\n@media (min-width: 800px) {\n  .goal__filters {\n    font-size: 11px;\n  }\n}\n@media (min-width: 900px) {\n  .goal__filters {\n    font-size: 13px;\n  }\n}\n.is-pointer {\n  cursor: default;\n}\n\n.tooltip-data {\n  font-family: \"Avenir-Medium\";\n  font-size: 12px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2;\n  letter-spacing: normal;\n  color: #ffffff;\n}\n\n.tooltip-data .bold {\n  font-family: \"Avenir-Bold\";\n}\n\n.checkbox-list {\n  padding-top: 4px;\n}\n\n/*# sourceMappingURL=SoccerGoal.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$4 = "data-v-e5a93978";
  /* module identifier */
  var __vue_module_identifier__$4 = undefined;
  /* functional template */
  var __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    createInjector,
    undefined,
    undefined
  );

/**
 * Defines the index position of each value inside a player stat play.
 */
var playerStatPlayValues = [
  'playId',
  'gameId',
  'playerId',
  'momentOfPlay',
  'categoryId',
  'categoryType',
  'matchLapse',
  'section',
  'matchResult',
  'playingAs',
  'total',
  'coordinate1X',
  'coordinate1Y',
  'coordinate2X',
  'coordinate2Y',
  'coordinate3X',
  'coordinate3Y',
  'xGi',
  'xGf' ];

var playerStatPlayIndex = null;

function getPlayerStatPlayIndexes() {
  if (!playerStatPlayIndex) {
    playerStatPlayIndex = getPlayValueIndexesFromArray(playerStatPlayValues);
  }
  return playerStatPlayIndex;
}

var normalPlayer$1 = [
  {
    name: 'Goles',
    color: '#26C6DA',
    points: [1, 2, 3],
    categories: [12],
    negative: false,
  },
  {
    name: 'Asistencias',
    color: '#305496',
    points: [1, 2, 3],
    categories: [10],
    negative: false,
  },
  {
    name: 'Participación en gol',
    color: '#000066',
    points: [1, 2, 3],
    categories: [27],
  },
  {
    name: 'Tiros a gol',
    color: '#FFFF00',
    points: [1, 2, 3],
    categories: [510],
  },
  {
    name: 'Tiros a gol (portería)',
    color: '#9933FF',
    points: [1, 2, 3],
    categories: [537, 540, 544, 547],
  },
  {
    name: 'Centros totales',
    color: '#FFA726',
    points: [1, 2, 3],
    categories: [13, 25],
  },
  {
    name: 'Centros acertados',
    color: '#4DB6AC',
    points: [1, 2, 3],
    categories: [98, 101, 104, 105, 109, 112, 115, 116],
  },
  {
    name: 'Balones ganados en área rival',
    color: '#F06292',
    points: [1, 2],
    categories: [11],
  },
  {
    name: '1vs1 exitosos ofensivos',
    color: '#3A3838',
    points: [1],
    categories: [4],
  },
  {
    name: '1vs1 no exitosos ofensivos',
    color: '#00B050',
    points: [1],
    categories: [208],
  } ];

var goalkeeper$1 = [
  {
    name: 'Juego de pies',
    color: '#F06292',
    points: [1, 2, 3],
    categories: [44],
  },
  {
    name: 'Despejes de mano',
    color: '#9C27B0',
    points: [1, 2],
    categories: [302],
  },
  {
    name: 'Despejes de pie',
    color: '#455A64',
    points: [1, 2],
    categories: [303],
  },
  {
    name: 'Participación en gol',
    color: '#000066',
    points: [1, 2, 3],
    categories: [323],
  },
  {
    name: 'Asistencia',
    color: '#305496',
    points: [1, 2],
    categories: [324],
  },
  {
    name: 'Saque de meta',
    color: '#FFA726',
    points: [1, 2],
    categories: [264],
  } ];

//
var columns$1 = offensiveDataTable.columns;
var expandedRows$1 = offensiveDataTable.expandedRows;
var goalkeeperExpandedRows$1 = offensiveDataTable.goalkeeperExpandedRows;

var script$3 = {
  name: 'PlayerOffensive',
  components: {
    // TopFiveHorizontalScroll,
    SoccerGoal: __vue_component__$4,
    SoccerChalkboard: __vue_component__$7,
    DataTable: __vue_component__$d,
    DataMobileTable: __vue_component__$b,
  },
  mixins: [categoriesDisplayOptions],
  data: function data() {
    return {
      columns: columns$1,
      expandedRows: expandedRows$1,
      chalkboardCategories: normalPlayer$1,
      playerStatsPlayIndexes: getPlayerStatPlayIndexes(),
    };
  },
  beforeMount: function beforeMount() {
    if (this.player.position_id === 1) {
      this.expandedRows = goalkeeperExpandedRows$1;
      this.chalkboardCategories = goalkeeper$1;
    }
  },
  watch: {
    viewData: function viewData(value) {
      analisisDeJugadorTablaGrafica(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    }
  },
  computed: Object.assign({}, {showSoccerGoal: function showSoccerGoal() {
      if (this.player.position_id !== 1) {
        return true;
      } else {
        return false;
      }
    }},
    // ToDo: pending to get updated soccer chalk board to update getters
    mapState('playerProfileGlobal', ['isPremiumUser', 'isGolstats']),
    mapState('teamsOffensive', [
      'categories',
      'featuredPlayers',
      'statistics',
      'data',
      'columnsVisible',
      'expandedColumns' ]),
    mapGetters('playerProfileGeneral', {
      plays: 'getPlays',
    }),
    mapState(['players', 'teams']),
    mapGetters(['availableGames']),
    mapGetters('playerProfileOffensive', [
      'tableData',
      'topFiveCategories',
      'chalkboardPlays',
      'chalkboardGames',
      'goalPlays' ]),
    mapGetters('playerProfileGeneral', ['player', 'playerId', 'teamId']),
    mapGetters('playerProfileTeam', {
      seasonTeams: 'teamsForAnalysis',
      team: 'team',
    }),
    mapGetters({ seasonId: 'playerProfileFilter/getSeasonId', section: 'playerProfileFilter/getCategoryTypeName' })),
  methods: {
    visibilityChanged: function visibilityChanged(isVisible, entry) {
      if (isVisible){
        var sectionName = entry.target.id;
        analisisDeJugadorSeccionVista(this.seasonId, this.teamId, this.playerId, this.section, sectionName, this.isPremiumUser,
        this.isGolstats);
      }
    },
    onShowDetails: function onShowDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, "mostrar", this.isPremiumUser,
      this.isGolstats);
    },
    onHideDetails: function onHideDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, "ocultar", this.isPremiumUser,
      this.isGolstats);
    },
    onChangePerspectiveSoccerChalkboard: function onChangePerspectiveSoccerChalkboard(value) {
      analisisDeJugadorVistaPizarra2D3D(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeSelectAllSoccerChalkboard: function onChangeSelectAllSoccerChalkboard(value) {
      analisisDeJugadorSeleccionTodoPizarra(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeCategorySoccerChalkboard: function onChangeCategorySoccerChalkboard(value) {
      analisisDeJugadorCategoriaDePizarrra(this.seasonId, this.teamId, this.playerId, this.section, value.name, value.checked, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeCategorySoccerGoal: function onChangeCategorySoccerGoal(value){
      analisisDeJugadorCategoriaDePorteria(this.seasonId, this.teamId, this.playerId, this.section, value.name, value.checked, this.isPremiumUser,
      this.isGolstats);
    },
    onOpenSubcategory: function onOpenSubcategory(category) {
      analisisDeJugadorDetallesCategoria(this.seasonId, this.teamId, this.playerId, this.section, category, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeSubcategory: function onChangeSubcategory(subcategory) {
      analisisDeJugadorDetalleSubcategoria(this.seasonId, this.teamId, this.playerId, this.section, subcategory, this.isPremiumUser,
      this.isGolstats);
    },
  },
};

/* script */
var __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c("div", { staticClass: "chalkboard-goal" }, [
      _c(
        "div",
        { staticClass: "is-bordered-box-shadow-main" },
        [
          _c("SoccerChalkboard", {
            attrs: {
              "analysis-type": "offensive",
              "section-type": "player",
              plays: _vm.chalkboardPlays,
              categories: _vm.chalkboardCategories,
              games: _vm.chalkboardGames,
              players: [
                Object.assign({}, _vm.player, {
                  jersey: _vm.player.jersey_number
                })
              ],
              team: _vm.player.team_id,
              playValuesIndex: _vm.playerStatsPlayIndexes
            },
            on: {
              changePerspective: _vm.onChangePerspectiveSoccerChalkboard,
              changeSelectAll: _vm.onChangeSelectAllSoccerChalkboard,
              changeCategory: _vm.onChangeCategorySoccerChalkboard
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.showSoccerGoal
            ? _c("SoccerGoal", {
                attrs: {
                  players: [_vm.player],
                  plays: _vm.goalPlays,
                  teams: _vm.seasonTeams,
                  "section-type": "player"
                },
                on: { changeCategory: _vm.onChangeCategorySoccerGoal }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "categories-container" }, [
      _c("nav", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "observe-visibility",
                  rawName: "v-observe-visibility",
                  value: _vm.visibilityChanged,
                  expression: "visibilityChanged"
                }
              ],
              staticClass: "title-section",
              attrs: { id: "categorias-ofensivas" }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "categories-title is-size-4-mobile has-text-centered-mobile"
                },
                [_vm._v("CATEGORÍAS OFENSIVAS")]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm._e()
      ]),
      _vm._v(" "),
      _vm.viewData === "table"
        ? _c(
            "div",
            [
              _c("DataTable", {
                attrs: {
                  columns: _vm.columns,
                  expandedRows: _vm.expandedRows,
                  data: _vm.tableData
                },
                on: {
                  showDetails: _vm.onShowDetails,
                  hideDetails: _vm.onHideDetails
                }
              }),
              _vm._v(" "),
              _c("DataMobileTable", {
                attrs: {
                  "is-selector-hidden": "",
                  columns: _vm.columns,
                  data: _vm.tableData
                },
                on: {
                  showDetails: _vm.onShowDetails,
                  hideDetails: _vm.onHideDetails,
                  openSubcategory: _vm.onOpenSubcategory,
                  changeSubcategory: _vm.onChangeSubcategory
                }
              })
            ],
            1
          )
        : _vm.viewData === "pie"
        ? _c("div")
        : _vm._e()
    ])
  ])
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  var __vue_inject_styles__$3 = function (inject) {
    if (!inject) { return }
    inject("data-v-5bccf444_0", { source: ".chalkboard-goal[data-v-5bccf444] {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  row-gap: 16px;\n  column-gap: 16px;\n}\n@media screen and (max-width: 1250px) {\n.chalkboard-goal[data-v-5bccf444] {\n    grid-template-columns: 1fr;\n}\n}\n\n/* Top five section */\n.top-five-container[data-v-5bccf444] {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.top-five-title[data-v-5bccf444] {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container[data-v-5bccf444] {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.categories-title[data-v-5bccf444] {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/*# sourceMappingURL=Offensive.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/sections/Offensive.vue","Offensive.vue"],"names":[],"mappings":"AAyNA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;ACxNA;ADyNA;AALA;IAMA,0BAAA;ACtNE;AACF;;ADyNA,qBAAA;AACA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACtNA;ADyNA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;ACtNA;;ADyNA,uBAAA;AACA;EACA,gBAAA;EACA,mBAAA;ACtNA;ADyNA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;ACtNA;;AAEA,wCAAwC","file":"Offensive.vue","sourcesContent":["<template>\n  <div>\n    <!-- Soccer Chalkboard / Goal -->\n    <div class=\"chalkboard-goal\">\n      <div class=\"is-bordered-box-shadow-main\">\n        <SoccerChalkboard\n          analysis-type=\"offensive\"\n          section-type=\"player\"\n          :plays=\"chalkboardPlays\"\n          :categories=\"chalkboardCategories\"\n          :games=\"chalkboardGames\"\n          :players=\"[{ ...player, jersey: player.jersey_number }]\"\n          :team=\"player.team_id\"\n          :playValuesIndex=\"playerStatsPlayIndexes\"\n          @changePerspective=\"onChangePerspectiveSoccerChalkboard\"\n          @changeSelectAll=\"onChangeSelectAllSoccerChalkboard\"\n          @changeCategory=\"onChangeCategorySoccerChalkboard\"\n        />\n      </div>\n      <div>\n        <SoccerGoal\n          v-if=\"showSoccerGoal\"\n          :players=\"[player]\"\n          :plays=\"goalPlays\"\n          :teams=\"seasonTeams\"\n          section-type=\"player\"\n          @changeCategory=\"onChangeCategorySoccerGoal\"\n        />\n      </div>\n    </div>\n    <!-- Timeline -->\n<!--    <div class=\"columns\">-->\n<!--      <div class=\"column\"></div>-->\n<!--    </div>-->\n    <!-- Top Five Categories -->\n    <!--    <div class=\"top-five-container\">-->\n    <!--      <div class=\"top-five-title\">-->\n    <!--        categorias dentro de top 5-->\n    <!--      </div>-->\n    <!--      <TopFiveHorizontalScroll :categories=\"topFiveCategories\" />-->\n    <!--    </div>-->\n    <!-- Player Categories -->\n    <div class=\"categories-container\">\n      <nav class=\"level\">\n        <div class=\"level-left\">\n          <div class=\"title-section\" id=\"categorias-ofensivas\" v-observe-visibility=\"visibilityChanged\">\n            <span class=\"categories-title is-size-4-mobile has-text-centered-mobile\">CATEGORÍAS OFENSIVAS</span>\n          </div>\n        </div>\n        <div class=\"level-right\" v-if=\"false\">\n          <BField class=\"is-hidden-mobile\">\n            <BRadioButton\n              v-for=\"(option, index) in displayOptions\"\n              v-model=\"viewData\"\n              :native-value=\"option.value\"\n              :key=\"index\"\n              :disabled=\"option.value === 'pie'\"\n            >\n              <BIcon :icon=\"option.icon\" />\n            </BRadioButton>\n          </BField>\n        </div>\n      </nav>\n      <!-- Categories Table -->\n      <div v-if=\"viewData === 'table'\">\n        <DataTable :columns=\"columns\" :expandedRows=\"expandedRows\" :data=\"tableData\" @showDetails=\"onShowDetails\" @hideDetails=\"onHideDetails\"/>\n        <DataMobileTable is-selector-hidden\n          :columns=\"columns\"\n          :data=\"tableData\"\n          @showDetails=\"onShowDetails\"\n          @hideDetails=\"onHideDetails\"\n          @openSubcategory=\"onOpenSubcategory\"\n          @changeSubcategory=\"onChangeSubcategory\"\n        />\n      </div>\n      <!-- Categories Pie -->\n      <div v-else-if=\"viewData === 'pie'\"></div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport DataTable from '../elements/DataTable.vue';\nimport offensiveDataTable from '../../data/offensive-table-data';\nimport SoccerChalkboard from '../elements/SoccerChalkboard.vue';\nimport { mapGetters, mapState } from 'vuex';\n// import TopFiveHorizontalScroll from '../elements/TopFiveHorizontalScroll';\nimport DataMobileTable from '../elements/DataMobileTable.vue';\nimport SoccerGoal from '../elements/SoccerGoal.vue';\nimport playerStatsPlayIndexes from '../../data/player-stats-play-indexes';\nimport { categoriesDisplayOptions } from '../../utils/mixins/categories-display-options';\nimport { normalPlayer, goalkeeper } from '../../data/offensive-chalkboard-categories';\nimport {\n  analisisDeJugadorSeccionVista,\n  analisisDeJugadorCategoriasDeTabla,\n  analisisDeJugadorTablaGrafica,\n  analisisDeJugadorCategoriaDePizarrra,\n  analisisDeJugadorSeleccionTodoPizarra,\n  analisisDeJugadorVistaPizarra2D3D,\n  analisisDeJugadorCategoriaDePorteria,\n  analisisDeJugadorDetallesCategoria,\n  analisisDeJugadorDetalleSubcategoria\n} from '../../utils/analytics';\nconst { columns, expandedRows, goalkeeperExpandedRows } = offensiveDataTable;\n\nexport default {\n  name: 'PlayerOffensive',\n  components: {\n    // TopFiveHorizontalScroll,\n    SoccerGoal,\n    SoccerChalkboard,\n    DataTable,\n    DataMobileTable,\n  },\n  mixins: [categoriesDisplayOptions],\n  data() {\n    return {\n      columns,\n      expandedRows,\n      chalkboardCategories: normalPlayer,\n      playerStatsPlayIndexes: playerStatsPlayIndexes(),\n    };\n  },\n  beforeMount() {\n    if (this.player.position_id === 1) {\n      this.expandedRows = goalkeeperExpandedRows;\n      this.chalkboardCategories = goalkeeper;\n    }\n  },\n  watch: {\n    viewData(value) {\n      analisisDeJugadorTablaGrafica(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    }\n  },\n  computed: {\n    showSoccerGoal() {\n      if (this.player.position_id !== 1) {\n        return true;\n      } else {\n        return false;\n      }\n    },\n    // ToDo: pending to get updated soccer chalk board to update getters\n    ...mapState('playerProfileGlobal', ['isPremiumUser', 'isGolstats']),\n    ...mapState('teamsOffensive', [\n      'categories',\n      'featuredPlayers',\n      'statistics',\n      'data',\n      'columnsVisible',\n      'expandedColumns',\n    ]),\n    ...mapGetters('playerProfileGeneral', {\n      plays: 'getPlays',\n    }),\n    ...mapState(['players', 'teams']),\n    ...mapGetters(['availableGames']),\n    ...mapGetters('playerProfileOffensive', [\n      'tableData',\n      'topFiveCategories',\n      'chalkboardPlays',\n      'chalkboardGames',\n      'goalPlays',\n    ]),\n    ...mapGetters('playerProfileGeneral', ['player', 'playerId', 'teamId']),\n    ...mapGetters('playerProfileTeam', {\n      seasonTeams: 'teamsForAnalysis',\n      team: 'team',\n    }),\n    ...mapGetters({ seasonId: 'playerProfileFilter/getSeasonId', section: 'playerProfileFilter/getCategoryTypeName' }),\n  },\n  methods: {\n    visibilityChanged(isVisible, entry) {\n      if (isVisible){\n        const sectionName = entry.target.id;\n        analisisDeJugadorSeccionVista(this.seasonId, this.teamId, this.playerId, this.section, sectionName, this.isPremiumUser,\n        this.isGolstats);\n      }\n    },\n    onShowDetails(category) {\n      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, \"mostrar\", this.isPremiumUser,\n      this.isGolstats);\n    },\n    onHideDetails(category) {\n      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, \"ocultar\", this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangePerspectiveSoccerChalkboard(value) {\n      analisisDeJugadorVistaPizarra2D3D(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeSelectAllSoccerChalkboard(value) {\n      analisisDeJugadorSeleccionTodoPizarra(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeCategorySoccerChalkboard(value) {\n      analisisDeJugadorCategoriaDePizarrra(this.seasonId, this.teamId, this.playerId, this.section, value.name, value.checked, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeCategorySoccerGoal(value){\n      analisisDeJugadorCategoriaDePorteria(this.seasonId, this.teamId, this.playerId, this.section, value.name, value.checked, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onOpenSubcategory(category) {\n      analisisDeJugadorDetallesCategoria(this.seasonId, this.teamId, this.playerId, this.section, category, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeSubcategory(subcategory) {\n      analisisDeJugadorDetalleSubcategoria(this.seasonId, this.teamId, this.playerId, this.section, subcategory, this.isPremiumUser,\n      this.isGolstats);\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"scss\">\n.chalkboard-goal {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  row-gap: 16px;\n  column-gap: 16px;\n  @media screen and (max-width: 1250px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Top five section */\n.top-five-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.top-five-title {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.categories-title {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n</style>\n",".chalkboard-goal {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  row-gap: 16px;\n  column-gap: 16px;\n}\n@media screen and (max-width: 1250px) {\n  .chalkboard-goal {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Top five section */\n.top-five-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.top-five-title {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.categories-title {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/*# sourceMappingURL=Offensive.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$3 = "data-v-5bccf444";
  /* module identifier */
  var __vue_module_identifier__$3 = undefined;
  /* functional template */
  var __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    createInjector,
    undefined,
    undefined
  );

// Data that configures the Player Defensive Table

var defensiveDataTable = {
  columns: baseColumns,
  expandedRows: defensivePlayerTableRowItems.map(function (item) {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
  goalkeeperExpandedRows: defensiveGoalkeeperTableRowItems.map(function (item) {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
};

var normalPlayer = [
  {
    name: 'Balones recuperados (en disputa)',
    color: '#F06292',
    points: [1, 2],
    categories: [483],
  },
  {
    name: 'Balones recuperados (sin disputa)',
    color: '#B4005A',
    points: [1, 2],
    categories: [484],
  },
  {
    name: '1vs1 exitosos defensivos',
    color: '#455A64',
    points: [1],
    categories: [5],
  },
  {
    name: '1vs1 no exitosos defensivos',
    color: '#4CAF50',
    points: [1],
    categories: [209],
  },
  {
    name: 'Balones ganados en área propia',
    color: '#305496',
    points: [1, 2],
    categories: [23],
  },
  {
    name: 'Centros permitidos',
    color: '#FFA726',
    points: [1, 2, 3],
    categories: [517],
  },
  {
    name: 'Rechaces',
    color: '#700000',
    points: [1],
    categories: [34],
  },
  {
    name: 'Barridas',
    color: '#CC0000',
    points: [1],
    categories: [518],
  } ];

var goalkeeper = [
  {
    name: 'Goles recibidos',
    color: '#26C6DA',
    points: [1, 2, 3],
    categories: [40],
  },
  {
    name: 'Atajadas',
    color: '#F06292',
    points: [1, 2],
    categories: [39],
  },
  {
    name: 'Juego aéreo exitoso',
    color: '#455A64',
    points: [1, 2],
    categories: [42],
  },
  {
    name: 'Juego aéreo no exitoso',
    color: '#4CAF50',
    points: [1, 2, 3],
    categories: [43],
  },
  {
    name: '1 vs 1',
    color: '#FFF176',
    points: [1],
    categories: [41],
  },
  {
    name: 'Balones recuperados',
    color: '#FFA726',
    points: [1],
    categories: [312],
  } ];

//
var columns = defensiveDataTable.columns;
var expandedRows = defensiveDataTable.expandedRows;
var goalkeeperExpandedRows = defensiveDataTable.goalkeeperExpandedRows;

var script$2 = {
  name: 'PlayerDefensive',
  components: {
    // TopFiveHorizontalScroll,
    SoccerGoal: __vue_component__$4,
    SoccerChalkboard: __vue_component__$7,
    DataTable: __vue_component__$d,
    DataMobileTable: __vue_component__$b,
  },
  mixins: [categoriesDisplayOptions],
  data: function data() {
    return {
      columns: columns,
      expandedRows: expandedRows,
      chalkboardCategories: normalPlayer,
      playerStatsPlayIndexes: getPlayerStatPlayIndexes(),
    };
  },
  beforeMount: function beforeMount() {
    if (this.player.position_id === 1) {
      this.expandedRows = goalkeeperExpandedRows;
      this.chalkboardCategories = goalkeeper;
    }
  },
  watch: {
    viewData: function viewData(value) {
      analisisDeJugadorTablaGrafica(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    }
  },
  computed: Object.assign({}, {showSoccerGoal: function showSoccerGoal() {
      return this.player.position_id === 1;
    }},
    // ToDo: pending to get updated soccer chalk board to update getters
    mapState('teamsOffensive', [
      'categories',
      'featuredPlayers',
      'statistics',
      'data',
      'columnsVisible',
      'expandedColumns' ]),
    mapState('playerProfileGlobal', ['isPremiumUser','isGolstats']),
    mapGetters('playerProfileGeneral', {
      playsGoal: 'getPlaysGoal',
    }),
    mapGetters('playerProfileGeneral', {
      plays: 'getPlays',
      player: 'player',
    }),
    mapState(['players', 'teams']),
    mapGetters(['availableGames']),
    mapGetters('playerProfileGeneral', ['player', 'playerId', 'teamId']),
    mapGetters('playerProfileDefensive', [
      'tableData',
      'topFiveCategories',
      'chalkboardPlays',
      'chalkboardGames',
      'goalPlays' ]),
    mapGetters('playerProfileTeam', {
      seasonTeams: 'teamsForAnalysis',
      team: 'team',
    }),
     mapGetters({ seasonId: 'playerProfileFilter/getSeasonId', section: 'playerProfileFilter/getCategoryTypeName' })),
  methods: {
    visibilityChanged: function visibilityChanged(isVisible, entry) {
      if (isVisible){
        var sectionName = entry.target.id;
        analisisDeJugadorSeccionVista(this.seasonId, this.teamId, this.playerId, this.section, sectionName, this.isPremiumUser,
        this.isGolstats);
      }
    },
    onShowDetails: function onShowDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, "mostrar", this.isPremiumUser,
      this.isGolstats);
    },
    onHideDetails: function onHideDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, "ocultar", this.isPremiumUser,
      this.isGolstats);
    },
    onChangePerspectiveSoccerChalkboard: function onChangePerspectiveSoccerChalkboard(value) {
      analisisDeJugadorVistaPizarra2D3D(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeSelectAllSoccerChalkboard: function onChangeSelectAllSoccerChalkboard(value) {
      analisisDeJugadorSeleccionTodoPizarra(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeCategorySoccerChalkboard: function onChangeCategorySoccerChalkboard(value) {
      analisisDeJugadorCategoriaDePizarrra(this.seasonId, this.teamId, this.playerId, this.section, value.name, value.checked, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeCategorySoccerGoal: function onChangeCategorySoccerGoal(value){
      analisisDeJugadorCategoriaDePorteria(this.seasonId, this.teamId, this.playerId, this.section, value.name, value.checked, this.isPremiumUser,
      this.isGolstats);
    },
    onOpenSubcategory: function onOpenSubcategory(category) {
      analisisDeJugadorDetallesCategoria(this.seasonId, this.teamId, this.playerId, this.section, category, this.isPremiumUser,
      this.isGolstats);
    },
    onChangeSubcategory: function onChangeSubcategory(subcategory) {
      analisisDeJugadorDetalleSubcategoria(this.seasonId, this.teamId, this.playerId, this.section, subcategory, this.isPremiumUser,
      this.isGolstats);
    },
  },
};

/* script */
var __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c("div", { staticClass: "chalkboard-goal" }, [
      _c(
        "div",
        { staticClass: "is-bordered-box-shadow-main" },
        [
          _c("SoccerChalkboard", {
            attrs: {
              "analysis-type": "defensive",
              "section-type": "player",
              plays: _vm.chalkboardPlays,
              categories: _vm.chalkboardCategories,
              games: _vm.chalkboardGames,
              players: [
                Object.assign({}, _vm.player, {
                  jersey: _vm.player.jersey_number
                })
              ],
              team: _vm.player.team_id,
              playValuesIndex: _vm.playerStatsPlayIndexes
            },
            on: {
              changePerspective: _vm.onChangePerspectiveSoccerChalkboard,
              changeSelectAll: _vm.onChangeSelectAllSoccerChalkboard,
              changeCategory: _vm.onChangeCategorySoccerChalkboard
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.showSoccerGoal
            ? _c("SoccerGoal", {
                attrs: {
                  players: [_vm.player],
                  plays: _vm.goalPlays,
                  teams: _vm.seasonTeams,
                  "section-type": "player"
                },
                on: { changeCategory: _vm.onChangeCategorySoccerGoal }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "categories-container" }, [
      _c("nav", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "observe-visibility",
                  rawName: "v-observe-visibility",
                  value: _vm.visibilityChanged,
                  expression: "visibilityChanged"
                }
              ],
              staticClass: "title-section",
              attrs: { id: "categorias-defensivas" }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "categories-title is-size-4-mobile has-text-centered-mobile"
                },
                [_vm._v("CATEGORÍAS DEFENSIVAS")]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm._e()
      ]),
      _vm._v(" "),
      _vm.viewData === "table"
        ? _c(
            "div",
            [
              _c("DataTable", {
                attrs: {
                  columns: _vm.columns,
                  expandedRows: _vm.expandedRows,
                  data: _vm.tableData
                },
                on: {
                  showDetails: _vm.onShowDetails,
                  hideDetails: _vm.onHideDetails
                }
              }),
              _vm._v(" "),
              _c("DataMobileTable", {
                attrs: {
                  "is-selector-hidden": "",
                  columns: _vm.columns,
                  data: _vm.tableData
                },
                on: {
                  showDetails: _vm.onShowDetails,
                  hideDetails: _vm.onHideDetails,
                  openSubcategory: _vm.onOpenSubcategory,
                  changeSubcategory: _vm.onChangeSubcategory
                }
              })
            ],
            1
          )
        : _vm.viewData === "pie"
        ? _c("div", [_c("PieChartsPossessionTeam")], 1)
        : _vm._e()
    ])
  ])
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  var __vue_inject_styles__$2 = function (inject) {
    if (!inject) { return }
    inject("data-v-293cdeb6_0", { source: ".chalkboard-goal[data-v-293cdeb6] {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  row-gap: 16px;\n  column-gap: 16px;\n}\n@media screen and (max-width: 1250px) {\n.chalkboard-goal[data-v-293cdeb6] {\n    grid-template-columns: 1fr;\n}\n}\n\n/* Top five section */\n.top-five-container[data-v-293cdeb6] {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.top-five-title[data-v-293cdeb6] {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container[data-v-293cdeb6] {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.categories-title[data-v-293cdeb6] {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/*# sourceMappingURL=Defensive.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/sections/Defensive.vue","Defensive.vue"],"names":[],"mappings":"AAiOA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;AChOA;ADiOA;AALA;IAMA,0BAAA;AC9NE;AACF;;ADgOA,qBAAA;AACA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AC7NA;ADgOA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;AC7NA;;ADgOA,uBAAA;AACA;EACA,gBAAA;EACA,mBAAA;AC7NA;ADgOA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;AC7NA;;AAEA,wCAAwC","file":"Defensive.vue","sourcesContent":["<template>\n  <div>\n    <!-- Soccer Chalkboard / Goal -->\n    <div class=\"chalkboard-goal\">\n      <div class=\"is-bordered-box-shadow-main\">\n        <SoccerChalkboard\n          analysis-type=\"defensive\"\n          section-type=\"player\"\n          :plays=\"chalkboardPlays\"\n          :categories=\"chalkboardCategories\"\n          :games=\"chalkboardGames\"\n          :players=\"[{ ...player, jersey: player.jersey_number }]\"\n          :team=\"player.team_id\"\n          :playValuesIndex=\"playerStatsPlayIndexes\"\n          @changePerspective=\"onChangePerspectiveSoccerChalkboard\"\n          @changeSelectAll=\"onChangeSelectAllSoccerChalkboard\"\n          @changeCategory=\"onChangeCategorySoccerChalkboard\"\n        />\n      </div>\n      <div>\n        <SoccerGoal\n          v-if=\"showSoccerGoal\"\n          :players=\"[player]\"\n          :plays=\"goalPlays\"\n          :teams=\"seasonTeams\"\n          section-type=\"player\"\n          @changeCategory=\"onChangeCategorySoccerGoal\"\n        />\n      </div>\n    </div>\n    <!-- Timeline -->\n<!--    <div class=\"columns\">-->\n<!--      <div class=\"column\"></div>-->\n<!--    </div>-->\n    <!-- Top Five Categories -->\n    <!--    <div class=\"top-five-container\">-->\n    <!--      <div class=\"top-five-title\">-->\n    <!--        categorias dentro de top 5-->\n    <!--      </div>-->\n    <!--      <TopFiveHorizontalScroll :categories=\"topFiveCategories\" />-->\n    <!--    </div>-->\n    <!-- Player Categories -->\n    <div class=\"categories-container\">\n      <nav class=\"level\">\n        <div class=\"level-left\">\n          <div class=\"title-section\" id=\"categorias-defensivas\" v-observe-visibility=\"visibilityChanged\">\n            <span class=\"categories-title is-size-4-mobile has-text-centered-mobile\">CATEGORÍAS DEFENSIVAS</span>\n          </div>\n        </div>\n        <div class=\"level-right\" v-if=\"false\">\n          <BField class=\"is-hidden-mobile\">\n            <BRadioButton\n              v-for=\"(option, index) in displayOptions\"\n              v-model=\"viewData\"\n              :native-value=\"option.value\"\n              :key=\"index\"\n              :disabled=\"option.value === 'pie'\"\n            >\n              <BIcon :icon=\"option.icon\" />\n            </BRadioButton>\n          </BField>\n        </div>\n      </nav>\n      <!-- Categories Table -->\n      <div v-if=\"viewData === 'table'\">\n        <DataTable\n          :columns=\"columns\"\n          :expandedRows=\"expandedRows\"\n          :data=\"tableData\"\n          @showDetails=\"onShowDetails\"\n          @hideDetails=\"onHideDetails\"\n        />\n        <DataMobileTable is-selector-hidden\n          :columns=\"columns\"\n          :data=\"tableData\"\n          @showDetails=\"onShowDetails\"\n          @hideDetails=\"onHideDetails\"\n          @openSubcategory=\"onOpenSubcategory\"\n          @changeSubcategory=\"onChangeSubcategory\"\n        />\n      </div>\n      <!-- Categories Pie -->\n      <div v-else-if=\"viewData === 'pie'\">\n        <PieChartsPossessionTeam />\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { mapGetters, mapState } from 'vuex';\nimport DataTable from '../../components/elements/DataTable.vue';\nimport defensiveDataTable from '../../data/defensive-table-data';\nimport SoccerChalkboard from '../../components/elements/SoccerChalkboard.vue';\nimport DataMobileTable from '../../components/elements/DataMobileTable.vue';\n// import TopFiveHorizontalScroll from '../../components/elements/TopFiveHorizontalScroll';\nimport SoccerGoal from '../../components/elements/SoccerGoal.vue';\nimport playerStatsPlayIndexes from '../../data/player-stats-play-indexes';\nimport { categoriesDisplayOptions } from '../../utils/mixins/categories-display-options';\nconst { columns, expandedRows, goalkeeperExpandedRows } = defensiveDataTable;\nimport { normalPlayer, goalkeeper } from '../../data/defensive-chalkboard-categories';\nimport {\n  analisisDeJugadorSeccionVista,\n  analisisDeJugadorCategoriasDeTabla,\n  analisisDeJugadorTablaGrafica,\n  analisisDeJugadorCategoriaDePizarrra,\n  analisisDeJugadorSeleccionTodoPizarra,\n  analisisDeJugadorVistaPizarra2D3D,\n  analisisDeJugadorCategoriaDePorteria,\n  analisisDeJugadorDetallesCategoria,\n  analisisDeJugadorDetalleSubcategoria\n} from '../../utils/analytics';\n\nexport default {\n  name: 'PlayerDefensive',\n  components: {\n    // TopFiveHorizontalScroll,\n    SoccerGoal,\n    SoccerChalkboard,\n    DataTable,\n    DataMobileTable,\n  },\n  mixins: [categoriesDisplayOptions],\n  data() {\n    return {\n      columns,\n      expandedRows,\n      chalkboardCategories: normalPlayer,\n      playerStatsPlayIndexes: playerStatsPlayIndexes(),\n    };\n  },\n  beforeMount() {\n    if (this.player.position_id === 1) {\n      this.expandedRows = goalkeeperExpandedRows;\n      this.chalkboardCategories = goalkeeper;\n    }\n  },\n  watch: {\n    viewData(value) {\n      analisisDeJugadorTablaGrafica(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    }\n  },\n  computed: {\n    showSoccerGoal() {\n      return this.player.position_id === 1;\n    },\n    // ToDo: pending to get updated soccer chalk board to update getters\n    ...mapState('teamsOffensive', [\n      'categories',\n      'featuredPlayers',\n      'statistics',\n      'data',\n      'columnsVisible',\n      'expandedColumns',\n    ]),\n    ...mapState('playerProfileGlobal', ['isPremiumUser','isGolstats']),\n    ...mapGetters('playerProfileGeneral', {\n      playsGoal: 'getPlaysGoal',\n    }),\n    ...mapGetters('playerProfileGeneral', {\n      plays: 'getPlays',\n      player: 'player',\n    }),\n    ...mapState(['players', 'teams']),\n    ...mapGetters(['availableGames']),\n    ...mapGetters('playerProfileGeneral', ['player', 'playerId', 'teamId']),\n    ...mapGetters('playerProfileDefensive', [\n      'tableData',\n      'topFiveCategories',\n      'chalkboardPlays',\n      'chalkboardGames',\n      'goalPlays',\n    ]),\n    ...mapGetters('playerProfileTeam', {\n      seasonTeams: 'teamsForAnalysis',\n      team: 'team',\n    }),\n     ...mapGetters({ seasonId: 'playerProfileFilter/getSeasonId', section: 'playerProfileFilter/getCategoryTypeName' }),\n  },\n  methods: {\n    visibilityChanged(isVisible, entry) {\n      if (isVisible){\n        const sectionName = entry.target.id;\n        analisisDeJugadorSeccionVista(this.seasonId, this.teamId, this.playerId, this.section, sectionName, this.isPremiumUser,\n        this.isGolstats);\n      }\n    },\n    onShowDetails(category) {\n      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, \"mostrar\", this.isPremiumUser,\n      this.isGolstats);\n    },\n    onHideDetails(category) {\n      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, \"ocultar\", this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangePerspectiveSoccerChalkboard(value) {\n      analisisDeJugadorVistaPizarra2D3D(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeSelectAllSoccerChalkboard(value) {\n      analisisDeJugadorSeleccionTodoPizarra(this.seasonId, this.teamId, this.playerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeCategorySoccerChalkboard(value) {\n      analisisDeJugadorCategoriaDePizarrra(this.seasonId, this.teamId, this.playerId, this.section, value.name, value.checked, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeCategorySoccerGoal(value){\n      analisisDeJugadorCategoriaDePorteria(this.seasonId, this.teamId, this.playerId, this.section, value.name, value.checked, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onOpenSubcategory(category) {\n      analisisDeJugadorDetallesCategoria(this.seasonId, this.teamId, this.playerId, this.section, category, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onChangeSubcategory(subcategory) {\n      analisisDeJugadorDetalleSubcategoria(this.seasonId, this.teamId, this.playerId, this.section, subcategory, this.isPremiumUser,\n      this.isGolstats);\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"scss\">\n.chalkboard-goal {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  row-gap: 16px;\n  column-gap: 16px;\n  @media screen and (max-width: 1250px) {\n    grid-template-columns: 1fr;\n  }\n}\n/* Top five section */\n.top-five-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.top-five-title {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.categories-title {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n</style>\n",".chalkboard-goal {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  row-gap: 16px;\n  column-gap: 16px;\n}\n@media screen and (max-width: 1250px) {\n  .chalkboard-goal {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Top five section */\n.top-five-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.top-five-title {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/* Categories section */\n.categories-container {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.categories-title {\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-transform: uppercase;\n}\n\n/*# sourceMappingURL=Defensive.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$2 = "data-v-293cdeb6";
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$1 = {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [filterMixin],
  data: function () { return ({
    sections: [1, 2, 3, 4, 5, 6],
    results: [1, 2, 3],
    playingAs: null,
    playingType: [
      {
        playingAs: null,
        label: 'Todos',
      },
      {
        playingAs: 1,
        label: 'Local',
      },
      {
        playingAs: 2,
        label: 'Visitante',
      } ],
    resultsKey: 0,
    sectionsKey: 0,
  }); },
  watch: {
    showModal: function showModal() {
      this.setSections();
      this.setResults();
    },
    sections: function sections(newValue, oldValue) {
      if (newValue.length === 0) {
        this.sections = oldValue;
        this.sectionsKey++;
      }
      this.setSections();
    },
    results: function results(newValue, oldValue) {
      if (newValue.length === 0) {
        this.results = oldValue;
        this.resultsKey++;
      }
      this.setResults();
    },
    playingAs: function playingAs() {
      this.setPlayingAs();
    },
  },
  computed: Object.assign({}, mapGetters('playerProfileFilter', {
      seasons: 'getSeasons',
      seasonId: 'getSeasonId',
      stadisticId: 'getStadisticId',
    })),
  methods: {
    /**
     * @author José Rafael Gutierrez
     * Set property sections in filterGeneral module.
     * @return void
     */
    setSections: function setSections() {
      this.$store.commit('playerProfileFilter/setSections', this.sections);
      this.$emit('sectionsChanged', this.sections);
    },
    /**
     * @author José Rafael Gutierrez
     * Set property results in filterGeneral module.
     * @return void
     */
    setResults: function setResults() {
      try {
        this.$store.commit('playerProfileFilter/setResults', this.results);
        this.$emit('resultsChanged', this.results);
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * @author José Rafael Gutierrez
     * Set property playingAs in filterGeneral module.
     * @return void
     */
    setPlayingAs: function setPlayingAs() {
      try {
        this.$store.commit('playerProfileFilter/setPlayingAs', this.playingAs);
      } catch (err) {
        console.error(err);
      }
    },
    onSeasonChanged: function onSeasonChanged(value) {
      if (this.$store.getters['playerProfileFilter/getSeasonId'] !== value) {
        this.$store.commit('playerProfileFilter/setSeasonId', value);
        this.$emit('seasonChanged');
      }
    },
    /**
     * @author Cristhian Gómez
     * Set property stadisticId in filterGeneral module.
     * @return void
     */
    onStadisticChanged: function onStadisticChanged(value) {
      this.$store.commit('playerProfileFilter/setStadisticId', value);
      this.$emit('statisticsChanged', value);
    },
    onPlayingAsChanged: function onPlayingAsChanged(value) {
      var type = this.playingType.find(function (p) { return p.playingAs == value; }).label;
      this.$emit('playingAsChanged', type);
    },
  },
};

/* script */
var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.showModal
    ? _c("div", { staticClass: "overlay filter-mobile" }, [
        _c("div", { staticClass: "modal-card  is-gapless" }, [
          _c(
            "header",
            { staticClass: "modal-card-title" },
            [
              _vm._v("\n      Filtro Avanzado\n      "),
              _c("BIcon", {
                staticClass: "img-close",
                attrs: { icon: "close" },
                nativeOn: {
                  click: function($event) {
                    return _vm.$emit("hide")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              { staticClass: "columns not-margin is-mobile is-centered" },
              [
                _c(
                  "div",
                  {
                    staticClass: "column m is-12",
                    on: { click: _vm.onItemClick }
                  },
                  [
                    _c("div", { staticClass: "modal-card-subtitle" }, [
                      _vm._v("Torneo:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "BField",
                      [
                        _c(
                          "BSelect",
                          {
                            class: _vm.clickModifier,
                            attrs: {
                              value: _vm.seasonId,
                              placeholder: "Filtros",
                              expanded: "",
                              size: "is-medium"
                            },
                            on: { input: _vm.onSeasonChanged }
                          },
                          _vm._l(_vm.seasons, function(season) {
                            return _c(
                              "option",
                              {
                                key: season.id,
                                domProps: { value: season.id }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(season.name) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "columns not-margin is-mobile is-centered" },
              [
                _c(
                  "div",
                  {
                    staticClass: "column m is-12 ",
                    on: { click: _vm.onItemClick }
                  },
                  [
                    _c("div", { staticClass: "modal-card-subtitle" }, [
                      _vm._v("Estadísticas:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "BField",
                      [
                        _c(
                          "BSelect",
                          {
                            class: _vm.clickModifier,
                            attrs: {
                              value: _vm.stadisticId,
                              placeholder: "Filtros",
                              expanded: "",
                              ize: "is-medium"
                            },
                            on: { input: _vm.onStadisticChanged }
                          },
                          [
                            _c("option", { domProps: { value: 0 } }, [
                              _vm._v(
                                "\n                Promedio por partido\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("option", { domProps: { value: 1 } }, [
                              _vm._v(
                                "\n                Totales\n              "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "columns not-margin is-mobile is-centered" },
              [
                _c(
                  "div",
                  {
                    staticClass: "column m is-12",
                    on: { click: _vm.onItemClick }
                  },
                  [
                    _c("div", { staticClass: "modal-card-subtitle" }, [
                      _vm._v("Partidos:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "BField",
                      [
                        _c(
                          "BSelect",
                          {
                            class: _vm.clickModifier,
                            attrs: {
                              placeholder: "Filtros",
                              expanded: "",
                              size: "is-medium"
                            },
                            on: { input: _vm.onPlayingAsChanged },
                            model: {
                              value: _vm.playingAs,
                              callback: function($$v) {
                                _vm.playingAs = $$v;
                              },
                              expression: "playingAs"
                            }
                          },
                          _vm._l(_vm.playingType, function(playing, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                domProps: { value: playing.playingAs }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(playing.label) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "columns not-margin is-mobile is-centered" },
              [
                _c(
                  "div",
                  {
                    staticClass: "column m is-12 m-medium-checks",
                    on: { click: _vm.onItemClick }
                  },
                  [
                    _c("div", { staticClass: "modal-card-subtitle" }, [
                      _vm._v("Resultados:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { key: _vm.resultsKey, staticClass: "checkbox-group" },
                      [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c(
                              "BCheckbox",
                              {
                                class: _vm.clickModifier,
                                attrs: { "native-value": 1 },
                                model: {
                                  value: _vm.results,
                                  callback: function($$v) {
                                    _vm.results = $$v;
                                  },
                                  expression: "results"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Ganados\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c(
                              "BCheckbox",
                              {
                                class: _vm.clickModifier,
                                attrs: { "native-value": 3 },
                                model: {
                                  value: _vm.results,
                                  callback: function($$v) {
                                    _vm.results = $$v;
                                  },
                                  expression: "results"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Empatados\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c(
                              "BCheckbox",
                              {
                                class: _vm.clickModifier,
                                attrs: { "native-value": 2 },
                                model: {
                                  value: _vm.results,
                                  callback: function($$v) {
                                    _vm.results = $$v;
                                  },
                                  expression: "results"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Perdidos\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "column not-padding m is-12 m-small-checks filter-mobile__option",
                    on: { click: _vm.onItemClick }
                  },
                  [
                    _c("div", { staticClass: "modal-card-subtitle" }, [
                      _vm._v("Resultados:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { key: _vm.resultsKey, staticClass: "checkbox-group" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "field filter-mobile__option__game-result"
                          },
                          [
                            _c(
                              "BCheckbox",
                              {
                                class: _vm.clickModifier,
                                attrs: { "native-value": 1, size: "is-small" },
                                model: {
                                  value: _vm.results,
                                  callback: function($$v) {
                                    _vm.results = $$v;
                                  },
                                  expression: "results"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Ganados\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "field filter-mobile__option__game-result"
                          },
                          [
                            _c(
                              "BCheckbox",
                              {
                                class: _vm.clickModifier,
                                attrs: { "native-value": 3, size: "is-small" },
                                model: {
                                  value: _vm.results,
                                  callback: function($$v) {
                                    _vm.results = $$v;
                                  },
                                  expression: "results"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Empatados\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "field filter-mobile__option__game-result"
                          },
                          [
                            _c(
                              "BCheckbox",
                              {
                                class: _vm.clickModifier,
                                attrs: { "native-value": 2, size: "is-small" },
                                model: {
                                  value: _vm.results,
                                  callback: function($$v) {
                                    _vm.results = $$v;
                                  },
                                  expression: "results"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Perdidos\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "columns not-margin not-border is-centered" },
              [
                _c(
                  "div",
                  {
                    staticClass: "column is-12",
                    on: { click: _vm.onItemClick }
                  },
                  [
                    _c("div", { staticClass: "modal-card-subtitle" }, [
                      _vm._v("Tiempo")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        key: _vm.sectionsKey + "s",
                        staticClass:
                          "columns not-border not-margin is-mobile is-centered m-medium-btn"
                      },
                      [
                        _c("div", { staticClass: "column is-6 is-centered" }, [
                          _c(
                            "div",
                            { staticClass: "btn-group" },
                            [
                              _c(
                                "BField",
                                [
                                  _c(
                                    "BCheckboxButton",
                                    {
                                      class: _vm.clickModifier,
                                      attrs: { "native-value": 1 },
                                      model: {
                                        value: _vm.sections,
                                        callback: function($$v) {
                                          _vm.sections = $$v;
                                        },
                                        expression: "sections"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "value-hidden" },
                                        [_vm._v("0")]
                                      ),
                                      _vm._v("0-15\n                  ")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "BCheckboxButton",
                                    {
                                      class: _vm.clickModifier,
                                      attrs: { "native-value": 2 },
                                      model: {
                                        value: _vm.sections,
                                        callback: function($$v) {
                                          _vm.sections = $$v;
                                        },
                                        expression: "sections"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    16-30\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "BCheckboxButton",
                                    {
                                      class: _vm.clickModifier,
                                      attrs: { "native-value": 3 },
                                      model: {
                                        value: _vm.sections,
                                        callback: function($$v) {
                                          _vm.sections = $$v;
                                        },
                                        expression: "sections"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    31-45\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "column is-6 is-centered" }, [
                          _c(
                            "div",
                            { staticClass: "btn-group" },
                            [
                              _c(
                                "BField",
                                [
                                  _c(
                                    "BCheckboxButton",
                                    {
                                      class: _vm.clickModifier,
                                      attrs: { "native-value": 4 },
                                      model: {
                                        value: _vm.sections,
                                        callback: function($$v) {
                                          _vm.sections = $$v;
                                        },
                                        expression: "sections"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    46-60\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "BCheckboxButton",
                                    {
                                      class: _vm.clickModifier,
                                      attrs: { "native-value": 5 },
                                      model: {
                                        value: _vm.sections,
                                        callback: function($$v) {
                                          _vm.sections = $$v;
                                        },
                                        expression: "sections"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    61-75\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "BCheckboxButton",
                                    {
                                      class: _vm.clickModifier,
                                      attrs: { "native-value": 6 },
                                      model: {
                                        value: _vm.sections,
                                        callback: function($$v) {
                                          _vm.sections = $$v;
                                        },
                                        expression: "sections"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    76-90\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        key: _vm.sectionsKey,
                        staticClass:
                          "columns not-border not-margin is-centered m-small-btn"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "column not-border is-6 is-centered",
                            on: { click: _vm.onItemClick }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "btn-group" },
                              [
                                _c(
                                  "BField",
                                  [
                                    _c(
                                      "BCheckboxButton",
                                      {
                                        class: _vm.clickModifier,
                                        attrs: { "native-value": 1 },
                                        model: {
                                          value: _vm.sections,
                                          callback: function($$v) {
                                            _vm.sections = $$v;
                                          },
                                          expression: "sections"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "value-hidden" },
                                          [_vm._v("0")]
                                        ),
                                        _vm._v("0-15\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "BCheckboxButton",
                                      {
                                        class: _vm.clickModifier,
                                        attrs: { "native-value": 2 },
                                        model: {
                                          value: _vm.sections,
                                          callback: function($$v) {
                                            _vm.sections = $$v;
                                          },
                                          expression: "sections"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    16-30\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "BCheckboxButton",
                                      {
                                        class: _vm.clickModifier,
                                        attrs: { "native-value": 3 },
                                        model: {
                                          value: _vm.sections,
                                          callback: function($$v) {
                                            _vm.sections = $$v;
                                          },
                                          expression: "sections"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    31-45\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "column is-6 is-centered",
                            on: { click: _vm.onItemClick }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "btn-group" },
                              [
                                _c(
                                  "BField",
                                  [
                                    _c(
                                      "BCheckboxButton",
                                      {
                                        class: _vm.clickModifier,
                                        attrs: { "native-value": 4 },
                                        model: {
                                          value: _vm.sections,
                                          callback: function($$v) {
                                            _vm.sections = $$v;
                                          },
                                          expression: "sections"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    46-60\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "BCheckboxButton",
                                      {
                                        class: _vm.clickModifier,
                                        attrs: { "native-value": 5 },
                                        model: {
                                          value: _vm.sections,
                                          callback: function($$v) {
                                            _vm.sections = $$v;
                                          },
                                          expression: "sections"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    61-75\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "BCheckboxButton",
                                      {
                                        class: _vm.clickModifier,
                                        attrs: { "native-value": 6 },
                                        model: {
                                          value: _vm.sections,
                                          callback: function($$v) {
                                            _vm.sections = $$v;
                                          },
                                          expression: "sections"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    76-90\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "column is-12" }, [
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c(
                    "BButton",
                    {
                      staticClass: "btn-is-primary",
                      attrs: { type: "is-primary" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("hide")
                        }
                      }
                    },
                    [_vm._v("\n            Aceptar\n          ")]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    : _vm._e()
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = function (inject) {
    if (!inject) { return }
    inject("data-v-7d086254_0", { source: ".filter-mobile .filter-mobile__option .filter-mobile__option__game-result .checkbox[data-v-7d086254] {\n  padding: 0;\n}\n.not-margin[data-v-7d086254] {\n  margin: 0 !important;\n}\n.checks[data-v-7d086254] {\n  justify-content: space-around;\n  border-bottom: none !important;\n  margin-right: 0px !important;\n  flex-wrap: wrap;\n}\n.value-hidden[data-v-7d086254] {\n  visibility: hidden;\n}\n.checkbox-group[data-v-7d086254] {\n  display: flex;\n  height: 48px;\n  justify-content: space-evenly;\n  font-family: Avenir-Medium;\n  align-items: center;\n  margin: 6px 1px 0 2px;\n  padding: 10px 4px 2px 4px;\n  border-radius: 8px;\n  flex-wrap: wrap;\n  border: solid 1px #b4b4b4;\n}\n.checkbox-group .field[data-v-7d086254]:not(:last-child) {\n  margin-bottom: 0px;\n}\n.checkbox-group .b-checkbox.checkbox input[type=checkbox] + .check[data-v-7d086254] {\n  border: 2px solid #d3d3d3;\n}\n.btn-is-primary[data-v-7d086254] {\n  padding: 20px 40px;\n  font-family: Avenir-Demi;\n  font-size: 18px;\n  font-style: normal;\n  line-height: 0.79;\n  text-align: center;\n  color: #ffffff;\n}\n.columns[data-v-7d086254] {\n  padding: 6px 0px;\n}\n.columns .is-centered[data-v-7d086254] {\n  width: 100%;\n  border-bottom: solid 1px #b4b4b4;\n}\n.overlay[data-v-7d086254] {\n  z-index: 1;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  align-items: flex-end;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.modal-card[data-v-7d086254] {\n  height: 90%;\n  width: 100%;\n  padding: 0px;\n  margin: 0px;\n  background-color: #f9f9f9;\n  border-radius: 24px 24px 0px 0px;\n}\n.modal-card-body[data-v-7d086254] {\n  padding: 0px 30px;\n  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.07);\n  background-color: #f3f3f3;\n}\n.modal-card-title[data-v-7d086254] {\n  width: 100%;\n  height: 80px;\n  line-height: 40px;\n  padding: 25px 0px;\n  font-family: \"Avenir-Demi\";\n  flex-shrink: 1;\n  flex-grow: 0;\n  font-size: 24px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #6f6f6f;\n}\n.modal-card-title .img-close[data-v-7d086254] {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  cursor: pointer;\n}\n.modal-card-subtitle[data-v-7d086254] {\n  font-family: \"Avenir-Demi-Medium\";\n  font-size: 14px;\n  padding-bottom: 5px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: -0.04px;\n  color: #494a4b;\n  text-align: left;\n}\n.button-group[data-v-7d086254] {\n  display: flex;\n  justify-content: space-evenly;\n}\n.button-group .btn-letter[data-v-7d086254] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  border: solid 1px #4e4e4e;\n  background-color: #ffffff;\n  width: 35px;\n  height: 35px;\n  border: solid 1px #4e4e4e;\n  background-color: #ffffff;\n  font-family: Circular-Std;\n  font-size: 20px;\n  text-align: center;\n  color: #494a4b;\n  font-weight: bold;\n  outline: none;\n}\n.button-group .btn-letter[data-v-7d086254]:hover {\n  background-color: #cce8b5;\n}\n.btn-group-pair[data-v-7d086254] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.btn-group-pair button[data-v-7d086254] {\n  width: 80px;\n  height: 36px;\n  border-radius: 6px;\n  background-color: #fdfdfd;\n  border: solid 1px #4e4e4e;\n  font-family: Circular-Std;\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: -0.05px;\n  text-align: center;\n  color: #494a4b;\n}\n.btn-group-pair button[data-v-7d086254]:hover {\n  background-color: #adadad;\n}\n.btn-group-pair button[data-v-7d086254]:first-child {\n  border-radius: 6px 0px 0px 6px;\n}\n.btn-group-pair button[data-v-7d086254]:last-child {\n  border-radius: 0px 6px 6px 0px;\n}\n.btn-group[data-v-7d086254] {\n  display: flex;\n  justify-content: space-evenly;\n}\n.btn-group button[data-v-7d086254] {\n  width: 58px;\n  height: 40px;\n  font-family: \"Circular-Std-Medium\";\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.04px;\n  text-align: center;\n  color: #494a4b;\n  border: solid 1px #4e4e4e;\n}\n.btn-group button[data-v-7d086254]:hover {\n  background-color: #cce8b5;\n}\n.btn-group button[data-v-7d086254]:first-child {\n  border-radius: 6px 0px 0px 6px;\n}\n.btn-group button[data-v-7d086254]:last-child {\n  border-radius: 0px 6px 6px 0px;\n}\nbutton[data-v-7d086254] {\n  outline: none;\n  cursor: pointer;\n}\n.not-border[data-v-7d086254] {\n  border: 0px !important;\n  border-bottom: 0px solid gray !important;\n}\n.not-padding[data-v-7d086254] {\n  padding: 10px 0px !important;\n}\n.m-small-checks[data-v-7d086254],\n.m-small-btn[data-v-7d086254] {\n  display: none;\n}\n@media screen and (max-width: 520px) {\n.m-medium-checks[data-v-7d086254],\n.m-medium-btn[data-v-7d086254] {\n    display: none;\n}\n.m-small-checks[data-v-7d086254],\n.m-small-btn[data-v-7d086254] {\n    display: inline-block;\n}\n}\n\n/*# sourceMappingURL=FilterMobile.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/components/elements/FilterMobile.vue","FilterMobile.vue"],"names":[],"mappings":"AAuYA;EACA,UAAA;ACtYA;ADwYA;EACA,oBAAA;ACrYA;ADuYA;EACA,6BAAA;EACA,8BAAA;EACA,4BAAA;EACA,eAAA;ACpYA;ADsYA;EACA,kBAAA;ACnYA;ADqYA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AClYA;ADmYA;EACA,kBAAA;ACjYA;ADmYA;EACA,yBAAA;ACjYA;ADoYA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;ACjYA;ADmYA;EACA,gBAAA;AChYA;ADiYA;EACA,WAAA;EACA,gCAAA;AC/XA;ADkYA;EACA,UAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,qBAAA;EACA,oCAAA;AC/XA;ADiYA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,gCAAA;AC9XA;ADgYA;EACA,iBAAA;EACA,iDAAA;EACA,yBAAA;AC7XA;AD+XA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AC5XA;AD8XA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AC5XA;AD+XA;EACA,iCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AC5XA;AD8XA;EACA,aAAA;EACA,6BAAA;AC3XA;AD4XA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;AC1XA;AD4XA;EACA,yBAAA;AC1XA;AD8XA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AC3XA;AD6XA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AC3XA;AD6XA;EACA,yBAAA;AC3XA;AD6XA;EACA,8BAAA;AC3XA;AD6XA;EACA,8BAAA;AC3XA;AD+XA;EACA,aAAA;EACA,6BAAA;AC5XA;AD6XA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AC3XA;AD6XA;EACA,yBAAA;AC3XA;AD8XA;EACA,8BAAA;AC5XA;AD8XA;EACA,8BAAA;AC5XA;AD+XA;EACA,aAAA;EACA,eAAA;AC5XA;AD8XA;EACA,sBAAA;EACA,wCAAA;AC3XA;AD6XA;EACA,4BAAA;AC1XA;AD4XA;;EAEA,aAAA;ACzXA;AD2XA;AACA;;IAEA,aAAA;ACxXE;AD0XF;;IAEA,qBAAA;ACvXE;AACF;;AAEA,2CAA2C","file":"FilterMobile.vue","sourcesContent":["<template>\n  <div class=\"overlay filter-mobile\" v-if=\"showModal\">\n    <div class=\"modal-card  is-gapless\">\n      <header class=\"modal-card-title\">\n        Filtro Avanzado\n        <BIcon icon=\"close\" class=\"img-close\" @click.native=\"$emit('hide')\"> </BIcon>\n      </header>\n      <section class=\"modal-card-body\">\n        <div class=\"columns not-margin is-mobile is-centered\">\n          <div class=\"column m is-12\" @click=\"onItemClick\">\n            <div class=\"modal-card-subtitle\">Torneo:</div>\n            <BField>\n              <BSelect\n                :value=\"seasonId\"\n                placeholder=\"Filtros\"\n                expanded size=\"is-medium\"\n                :class=\"clickModifier\"\n                @input=\"onSeasonChanged\"\n              >\n                <option v-for=\"season in seasons\" :key=\"season.id\" :value=\"season.id\">\n                  {{ season.name }}\n                </option>\n              </BSelect>\n            </BField>\n          </div>\n        </div>\n        <div class=\"columns not-margin is-mobile is-centered\">\n          <div class=\"column m is-12 \" @click=\"onItemClick\">\n            <div class=\"modal-card-subtitle\">Estadísticas:</div>\n            <BField>\n              <BSelect\n                :value=\"stadisticId\"\n                placeholder=\"Filtros\"\n                expanded\n                ize=\"is-medium\"\n                :class=\"clickModifier\"\n                @input=\"onStadisticChanged\"\n              >\n                <option :value=\"0\">\n                  Promedio por partido\n                </option>\n                <option :value=\"1\">\n                  Totales\n                </option>\n              </BSelect>\n            </BField>\n          </div>\n        </div>\n        <div class=\"columns not-margin is-mobile is-centered\">\n          <div class=\"column m is-12\" @click=\"onItemClick\">\n            <div class=\"modal-card-subtitle\">Partidos:</div>\n            <BField>\n              <BSelect\n                placeholder=\"Filtros\"\n                v-model=\"playingAs\"\n                expanded\n                size=\"is-medium\"\n                :class=\"clickModifier\"\n                @input=\"onPlayingAsChanged\"\n              >\n                <option v-for=\"(playing, index) in playingType\" :key=\"index\" :value=\"playing.playingAs\">\n                  {{ playing.label }}\n                </option>\n              </BSelect>\n            </BField>\n          </div>\n        </div>\n        <div class=\"columns not-margin is-mobile is-centered\">\n          <div class=\"column m is-12 m-medium-checks\" @click=\"onItemClick\">\n            <div class=\"modal-card-subtitle\">Resultados:</div>\n            <div :key=\"resultsKey\" class=\"checkbox-group\">\n              <div class=\"field\">\n                <BCheckbox\n                  v-model=\"results\"\n                  :native-value=\"1\"\n                  :class=\"clickModifier\"\n                >\n                  Ganados\n                </BCheckbox>\n              </div>\n              <div class=\"field\">\n                <BCheckbox\n                  v-model=\"results\"\n                  :class=\"clickModifier\"\n                  :native-value=\"3\"\n                >\n                  Empatados\n                </BCheckbox>\n              </div>\n              <div class=\"field\">\n                <BCheckbox\n                  v-model=\"results\"\n                  :class=\"clickModifier\"\n                  :native-value=\"2\"\n                >\n                  Perdidos\n                </BCheckbox>\n              </div>\n            </div>\n          </div>\n          <div class=\"column not-padding m is-12 m-small-checks filter-mobile__option\" @click=\"onItemClick\">\n            <div class=\"modal-card-subtitle\">Resultados:</div>\n            <div :key=\"resultsKey\" class=\"checkbox-group\">\n              <div class=\"field filter-mobile__option__game-result\">\n                <BCheckbox\n                  v-model=\"results\"\n                  :native-value=\"1\"\n                      :class=\"clickModifier\"\n                  size=\"is-small\"\n                >\n                  Ganados\n                </BCheckbox>\n              </div>\n              <div class=\"field filter-mobile__option__game-result\">\n                <BCheckbox\n                  v-model=\"results\"\n                  :native-value=\"3\"\n                      :class=\"clickModifier\"\n                  size=\"is-small\"\n                >\n                  Empatados\n                </BCheckbox>\n              </div>\n              <div class=\"field filter-mobile__option__game-result\">\n                <BCheckbox\n                  v-model=\"results\"\n                  :native-value=\"2\"\n                      :class=\"clickModifier\"\n                  size=\"is-small\"\n                >\n                  Perdidos\n                </BCheckbox>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"columns not-margin not-border is-centered\">\n          <div class=\"column is-12\" @click=\"onItemClick\">\n            <div class=\"modal-card-subtitle\">Tiempo</div>\n            <div :key=\"`${sectionsKey}s`\" class=\"columns not-border not-margin is-mobile is-centered m-medium-btn\">\n              <div class=\"column is-6 is-centered\">\n                <div class=\"btn-group\">\n                  <BField>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :class=\"clickModifier\"\n                      :native-value=\"1\"\n                    >\n                      <span class=\"value-hidden\">0</span>0-15\n                    </BCheckboxButton>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :class=\"clickModifier\"\n                      :native-value=\"2\"\n                    >\n                      16-30\n                    </BCheckboxButton>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :class=\"clickModifier\"\n                      :native-value=\"3\"\n                    >\n                      31-45\n                    </BCheckboxButton>\n                  </BField>\n                </div>\n              </div>\n              <div class=\"column is-6 is-centered\">\n                <div class=\"btn-group\">\n                  <BField>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :class=\"clickModifier\"\n                      :native-value=\"4\"\n                    >\n                      46-60\n                    </BCheckboxButton>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :class=\"clickModifier\"\n                      :native-value=\"5\"\n                    >\n                      61-75\n                    </BCheckboxButton>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :class=\"clickModifier\"\n                      :native-value=\"6\"\n                    >\n                      76-90\n                    </BCheckboxButton>\n                  </BField>\n                </div>\n              </div>\n            </div>\n            <div :key=\"sectionsKey\" class=\"columns not-border not-margin is-centered m-small-btn\">\n              <div class=\"column not-border is-6 is-centered\" @click=\"onItemClick\">\n                <div class=\"btn-group\">\n                  <BField>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :native-value=\"1\"\n                      :class=\"clickModifier\"\n                    >\n                      <span class=\"value-hidden\">0</span>0-15\n                    </BCheckboxButton>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :native-value=\"2\"\n                      :class=\"clickModifier\"\n                    >\n                      16-30\n                    </BCheckboxButton>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :native-value=\"3\"\n                      :class=\"clickModifier\"\n                    >\n                      31-45\n                    </BCheckboxButton>\n                  </BField>\n                </div>\n              </div>\n              <div class=\"column is-6 is-centered\" @click=\"onItemClick\">\n                <div class=\"btn-group\">\n                  <BField>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :native-value=\"4\"\n                      :class=\"clickModifier\"\n                    >\n                      46-60\n                    </BCheckboxButton>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :native-value=\"5\"\n                      :class=\"clickModifier\"\n                    >\n                      61-75\n                    </BCheckboxButton>\n                    <BCheckboxButton\n                      v-model=\"sections\"\n                      :native-value=\"6\"\n                      :class=\"clickModifier\"\n                    >\n                      76-90\n                    </BCheckboxButton>\n                  </BField>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"column is-12\">\n          <div class=\"filter-item\">\n            <BButton\n              type=\"is-primary\"\n              class=\"btn-is-primary\"\n              @click=\"$emit('hide')\"\n            >\n              Aceptar\n            </BButton>\n          </div>\n        </div>\n      </section>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { mapGetters } from 'vuex';\nimport filterMixin from '../../utils/mixins/filter-mixin'\n\nexport default {\n  props: {\n    showModal: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  mixins: [filterMixin],\n  data: () => ({\n    sections: [1, 2, 3, 4, 5, 6],\n    results: [1, 2, 3],\n    playingAs: null,\n    playingType: [\n      {\n        playingAs: null,\n        label: 'Todos',\n      },\n      {\n        playingAs: 1,\n        label: 'Local',\n      },\n      {\n        playingAs: 2,\n        label: 'Visitante',\n      },\n    ],\n    resultsKey: 0,\n    sectionsKey: 0,\n  }),\n  watch: {\n    showModal() {\n      this.setSections();\n      this.setResults();\n    },\n    sections(newValue, oldValue) {\n      if (newValue.length === 0) {\n        this.sections = oldValue;\n        this.sectionsKey++;\n      }\n      this.setSections();\n    },\n    results(newValue, oldValue) {\n      if (newValue.length === 0) {\n        this.results = oldValue;\n        this.resultsKey++;\n      }\n      this.setResults();\n    },\n    playingAs() {\n      this.setPlayingAs();\n    },\n  },\n  computed: {\n    ...mapGetters('playerProfileFilter', {\n      seasons: 'getSeasons',\n      seasonId: 'getSeasonId',\n      stadisticId: 'getStadisticId',\n    }),\n  },\n  methods: {\n    /**\n     * @author José Rafael Gutierrez\n     * Set property sections in filterGeneral module.\n     * @return void\n     */\n    setSections() {\n      this.$store.commit('playerProfileFilter/setSections', this.sections);\n      this.$emit('sectionsChanged', this.sections);\n    },\n    /**\n     * @author José Rafael Gutierrez\n     * Set property results in filterGeneral module.\n     * @return void\n     */\n    setResults() {\n      try {\n        this.$store.commit('playerProfileFilter/setResults', this.results);\n        this.$emit('resultsChanged', this.results);\n      } catch (err) {\n        console.error(err);\n      }\n    },\n    /**\n     * @author José Rafael Gutierrez\n     * Set property playingAs in filterGeneral module.\n     * @return void\n     */\n    setPlayingAs() {\n      try {\n        this.$store.commit('playerProfileFilter/setPlayingAs', this.playingAs);\n      } catch (err) {\n        console.error(err);\n      }\n    },\n    onSeasonChanged(value) {\n      if (this.$store.getters['playerProfileFilter/getSeasonId'] !== value) {\n        this.$store.commit('playerProfileFilter/setSeasonId', value);\n        this.$emit('seasonChanged');\n      }\n    },\n    /**\n     * @author Cristhian Gómez\n     * Set property stadisticId in filterGeneral module.\n     * @return void\n     */\n    onStadisticChanged(value) {\n      this.$store.commit('playerProfileFilter/setStadisticId', value);\n      this.$emit('statisticsChanged', value);\n    },\n    onPlayingAsChanged(value) {\n      let type = this.playingType.find(p => p.playingAs == value).label;\n      this.$emit('playingAsChanged', type);\n    },\n  },\n};\n</script>\n\n<style lang=\"scss\" scoped>\n.filter-mobile .filter-mobile__option .filter-mobile__option__game-result .checkbox {\n  padding: 0;\n}\n.not-margin {\n  margin: 0 !important;\n}\n.checks {\n  justify-content: space-around;\n  border-bottom: none !important;\n  margin-right: 0px !important;\n  flex-wrap: wrap;\n}\n.value-hidden {\n  visibility: hidden;\n}\n.checkbox-group {\n  display: flex;\n  height: 48px;\n  justify-content: space-evenly;\n  font-family: Avenir-Medium;\n  align-items: center;\n  margin: 6px 1px 0 2px;\n  padding: 10px 4px 2px 4px;\n  border-radius: 8px;\n  flex-wrap: wrap;\n  border: solid 1px #b4b4b4;\n  .field:not(:last-child) {\n    margin-bottom: 0px;\n  }\n  .b-checkbox.checkbox input[type='checkbox'] + .check {\n    border: 2px solid #d3d3d3;\n  }\n}\n.btn-is-primary {\n  padding: 20px 40px;\n  font-family: Avenir-Demi;\n  font-size: 18px;\n  font-style: normal;\n  line-height: 0.79;\n  text-align: center;\n  color: #ffffff;\n}\n.columns {\n  padding: 6px 0px;\n  .is-centered {\n    width: 100%;\n    border-bottom: solid 1px #b4b4b4;\n  }\n}\n.overlay {\n  z-index: 1;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  align-items: flex-end;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.modal-card {\n  height: 90%;\n  width: 100%;\n  padding: 0px;\n  margin: 0px;\n  background-color: #f9f9f9;\n  border-radius: 24px 24px 0px 0px;\n}\n.modal-card-body {\n  padding: 0px 30px;\n  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.07);\n  background-color: #f3f3f3;\n}\n.modal-card-title {\n  width: 100%;\n  height: 80px;\n  line-height: 40px;\n  padding: 25px 0px;\n  font-family: 'Avenir-Demi';\n  flex-shrink: 1;\n  flex-grow: 0;\n  font-size: 24px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #6f6f6f;\n\n  .img-close {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    cursor: pointer;\n  }\n}\n.modal-card-subtitle {\n  font-family: 'Avenir-Demi-Medium';\n  font-size: 14px;\n  padding-bottom: 5px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: -0.04px;\n  color: #494a4b;\n  text-align: left;\n}\n.button-group {\n  display: flex;\n  justify-content: space-evenly;\n  .btn-letter {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n    border: solid 1px #4e4e4e;\n    background-color: #ffffff;\n    width: 35px;\n    height: 35px;\n    border: solid 1px #4e4e4e;\n    background-color: #ffffff;\n    font-family: Circular-Std;\n    font-size: 20px;\n    text-align: center;\n    color: #494a4b;\n    font-weight: bold;\n    outline: none;\n\n    &:hover {\n      background-color: #cce8b5;\n    }\n  }\n}\n.btn-group-pair {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  button {\n    width: 80px;\n    height: 36px;\n    border-radius: 6px;\n    background-color: #fdfdfd;\n    border: solid 1px #4e4e4e;\n    font-family: Circular-Std;\n    font-size: 18px;\n    font-weight: bold;\n    letter-spacing: -0.05px;\n    text-align: center;\n    color: #494a4b;\n\n    &:hover {\n      background-color: #adadad;\n    }\n    &:first-child {\n      border-radius: 6px 0px 0px 6px;\n    }\n    &:last-child {\n      border-radius: 0px 6px 6px 0px;\n    }\n  }\n}\n.btn-group {\n  display: flex;\n  justify-content: space-evenly;\n  button {\n    width: 58px;\n    height: 40px;\n    font-family: 'Circular-Std-Medium';\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: -0.04px;\n    text-align: center;\n    color: #494a4b;\n    border: solid 1px #4e4e4e;\n\n    &:hover {\n      background-color: #cce8b5;\n    }\n  }\n  button:first-child {\n    border-radius: 6px 0px 0px 6px;\n  }\n  button:last-child {\n    border-radius: 0px 6px 6px 0px;\n  }\n}\nbutton {\n  outline: none;\n  cursor: pointer;\n}\n.not-border {\n  border: 0px !important;\n  border-bottom: 0px solid gray !important;\n}\n.not-padding {\n  padding: 10px 0px !important;\n}\n.m-small-checks,\n.m-small-btn {\n  display: none;\n}\n@media screen and (max-width: 520px) {\n  .m-medium-checks,\n  .m-medium-btn {\n    display: none;\n  }\n  .m-small-checks,\n  .m-small-btn {\n    display: inline-block;\n  }\n}\n</style>\n",".filter-mobile .filter-mobile__option .filter-mobile__option__game-result .checkbox {\n  padding: 0;\n}\n\n.not-margin {\n  margin: 0 !important;\n}\n\n.checks {\n  justify-content: space-around;\n  border-bottom: none !important;\n  margin-right: 0px !important;\n  flex-wrap: wrap;\n}\n\n.value-hidden {\n  visibility: hidden;\n}\n\n.checkbox-group {\n  display: flex;\n  height: 48px;\n  justify-content: space-evenly;\n  font-family: Avenir-Medium;\n  align-items: center;\n  margin: 6px 1px 0 2px;\n  padding: 10px 4px 2px 4px;\n  border-radius: 8px;\n  flex-wrap: wrap;\n  border: solid 1px #b4b4b4;\n}\n.checkbox-group .field:not(:last-child) {\n  margin-bottom: 0px;\n}\n.checkbox-group .b-checkbox.checkbox input[type=checkbox] + .check {\n  border: 2px solid #d3d3d3;\n}\n\n.btn-is-primary {\n  padding: 20px 40px;\n  font-family: Avenir-Demi;\n  font-size: 18px;\n  font-style: normal;\n  line-height: 0.79;\n  text-align: center;\n  color: #ffffff;\n}\n\n.columns {\n  padding: 6px 0px;\n}\n.columns .is-centered {\n  width: 100%;\n  border-bottom: solid 1px #b4b4b4;\n}\n\n.overlay {\n  z-index: 1;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  align-items: flex-end;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.modal-card {\n  height: 90%;\n  width: 100%;\n  padding: 0px;\n  margin: 0px;\n  background-color: #f9f9f9;\n  border-radius: 24px 24px 0px 0px;\n}\n\n.modal-card-body {\n  padding: 0px 30px;\n  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.07);\n  background-color: #f3f3f3;\n}\n\n.modal-card-title {\n  width: 100%;\n  height: 80px;\n  line-height: 40px;\n  padding: 25px 0px;\n  font-family: \"Avenir-Demi\";\n  flex-shrink: 1;\n  flex-grow: 0;\n  font-size: 24px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #6f6f6f;\n}\n.modal-card-title .img-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  cursor: pointer;\n}\n\n.modal-card-subtitle {\n  font-family: \"Avenir-Demi-Medium\";\n  font-size: 14px;\n  padding-bottom: 5px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: -0.04px;\n  color: #494a4b;\n  text-align: left;\n}\n\n.button-group {\n  display: flex;\n  justify-content: space-evenly;\n}\n.button-group .btn-letter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  border: solid 1px #4e4e4e;\n  background-color: #ffffff;\n  width: 35px;\n  height: 35px;\n  border: solid 1px #4e4e4e;\n  background-color: #ffffff;\n  font-family: Circular-Std;\n  font-size: 20px;\n  text-align: center;\n  color: #494a4b;\n  font-weight: bold;\n  outline: none;\n}\n.button-group .btn-letter:hover {\n  background-color: #cce8b5;\n}\n\n.btn-group-pair {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.btn-group-pair button {\n  width: 80px;\n  height: 36px;\n  border-radius: 6px;\n  background-color: #fdfdfd;\n  border: solid 1px #4e4e4e;\n  font-family: Circular-Std;\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: -0.05px;\n  text-align: center;\n  color: #494a4b;\n}\n.btn-group-pair button:hover {\n  background-color: #adadad;\n}\n.btn-group-pair button:first-child {\n  border-radius: 6px 0px 0px 6px;\n}\n.btn-group-pair button:last-child {\n  border-radius: 0px 6px 6px 0px;\n}\n\n.btn-group {\n  display: flex;\n  justify-content: space-evenly;\n}\n.btn-group button {\n  width: 58px;\n  height: 40px;\n  font-family: \"Circular-Std-Medium\";\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.04px;\n  text-align: center;\n  color: #494a4b;\n  border: solid 1px #4e4e4e;\n}\n.btn-group button:hover {\n  background-color: #cce8b5;\n}\n.btn-group button:first-child {\n  border-radius: 6px 0px 0px 6px;\n}\n.btn-group button:last-child {\n  border-radius: 0px 6px 6px 0px;\n}\n\nbutton {\n  outline: none;\n  cursor: pointer;\n}\n\n.not-border {\n  border: 0px !important;\n  border-bottom: 0px solid gray !important;\n}\n\n.not-padding {\n  padding: 10px 0px !important;\n}\n\n.m-small-checks,\n.m-small-btn {\n  display: none;\n}\n\n@media screen and (max-width: 520px) {\n  .m-medium-checks,\n.m-medium-btn {\n    display: none;\n  }\n\n  .m-small-checks,\n.m-small-btn {\n    display: inline-block;\n  }\n}\n\n/*# sourceMappingURL=FilterMobile.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$1 = "data-v-7d086254";
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script = {
  name: 'PlayerProfile',
  components: {
    PlayerDefensive: __vue_component__$2,
    PlayerHeader: __vue_component__$j,
    PlayerHeaderMobile: __vue_component__$i,
    PlayerAnalysis: __vue_component__$g,
    PlayerFilter: __vue_component__$f,
    PlayerPossession: __vue_component__$9,
    PlayerOffensive: __vue_component__$3,
    FilterMobile: __vue_component__$1,
  },
  props: {
    seasonId: {
      type: [Number, String],
      required: true,
    },
    playerId: {
      type: [Number, String],
      required: true,
    },
    useLocalLoading: {
      type: Boolean,
      default: false,
    },
    isAuthenticationHeaderDisabled: {
      type: Boolean,
      default: false,
    },
    requestsToken: {
      type: String,
      default: '',
    },
    isPremiumUser: {
      type: Boolean,
      default: false,
    },
    isGolstats: {
      type: Boolean,
      default: false
    },
  },
  data: function data() {
    return {
      showMobileFilter: false,
      playerSection: 2,
      currentPlayerId: 0,
    };
  },
  created: function created() {
    window.addEventListener('resize', this.updateWindowWidth);
    this.setCategoryType();
    this.loadPlayerInfo();
  },
  mounted: function mounted() {
    this.updateWindowWidth();
    this.$store.commit('playerProfileTeam/updateTeam', {});
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  watch: {
    playerSection: function playerSection() {
      this.setCategoryType();
    },
    playerId: function playerId() {
      this.loadPlayerInfo();
    },
    requestsToken: {
      immediate: true,
      handler: function handler(newValue) {
        this.setRequestsToken(newValue);
      },
    },
    isPremiumUser: {
      immediate: true,
      handler: function handler(newValue) {
        this.setIsPremiumUser(newValue);
      },
    },
    isGolstats: {
      immediate: true,
      handler: function handler(newValue) {
        this.setIsGolstats(newValue);
      },
    },
    player: {
      deep: true,
      handler: function handler(newValue) {
        if (newValue.position_id === 1) {
          this.playerSection = 3;
        }
      },
    },
  },
  computed: Object.assign({}, mapGetters('playerProfileGeneral', ['playerSeasons', 'player']),
    mapGetters({
      selectedSeasonId: 'playerProfileFilter/getSeasonId',
      section: 'playerProfileFilter/getCategoryTypeName',
    }),
    mapState('playerProfileGlobal', ['isSectionLoading']),
    {teamId: function teamId() {
      return this.player.team_id || 0;
    },
    selectedPlayerId: function selectedPlayerId() {
      return this.player.player_id || 0;
    },
    showLoading: function showLoading() {
      var showLoading = this.isSectionLoading && this.useLocalLoading;
      this.$emit('loading-changed', this.isSectionLoading);
      return showLoading;
    }}),
  methods: Object.assign({}, mapMutations(
      'playerProfileGlobal', ['setSeasonId', 'setWindowWidth', 'setRequestsToken', 'setIsPremiumUser', 'setIsGolstats']
    ),
    /**
     * @param {number} teamClass - possible values are 1 for national or 0 for club
     */
    {updateStatisticData: function updateStatisticData(teamClass) {
      analisisDeJugadorFiltroTemporada(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, this.isPremiumUser,
      this.isGolstats);
      try {
        this.$store.dispatch('playerProfileGeneral/fillStatisticData', teamClass);
      } catch (e) {
        console.error('Error, Player updateStatisticData: ', e);
      }
    },
    /**
     * @author José Rafael Gutierrez
     * Set property sections in filterGeneral module.
     * @return void
     */
    setCategoryType: function setCategoryType() {
      if (this.teamId && this.selectedSeasonId && this.selectedPlayerId){
        switch(this.playerSection) {
          case 1: analisisDeJugadorPosesion(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.isPremiumUser,
          this.isGolstats); break;
          case 2: analisisDeJugadorOfensivo(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.isPremiumUser,
          this.isGolstats); break;
          case 3: analisisDeJugadorDefensivo(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.isPremiumUser,
          this.isGolstats); break;
        }
      }
      this.$store.commit('playerProfileFilter/setCategoryType', this.playerSection);
    },
    /**
     * @author Rigoberto Sanchez
     * @description
     */
    onClickFilterMobile: function onClickFilterMobile() {
      analisisDeJugadorFiltros(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, this.isPremiumUser, this.isGolstats);
      this.showMobileFilter = true;
    },
    onStatisticsChanged: function onStatisticsChanged(value) {
      analisisDeJugadorFiltroEstadistica(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
    onPlayingAsChanged: function onPlayingAsChanged(value) {
      analisisDeJugadorFiltroJugadoComo(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
    onResultsChanged: function onResultsChanged(value) {
      analisisDeJugadorFiltroPorResultado(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
    onSectionsChanged: function onSectionsChanged(value) {
      analisisDeJugadorFiltroPorTiempo(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, value, this.isPremiumUser,
      this.isGolstats);
    },
    updateWindowWidth: function updateWindowWidth() {
      this.setWindowWidth(window.innerWidth);
    },
    loadPlayerInfo: async function loadPlayerInfo() {
      try {
        if (this.playerId === this.currentPlayerId) { return; }
        window.playerProfileIsAuthorizationHeaderDisabled = this.isAuthenticationHeaderDisabled;
        this.setSeasonId(this.seasonId);
        await this.$store.dispatch('playerProfileGeneral/cleanData');
        await this.$store.dispatch('playerProfileGeneral/checkState', Number(this.playerId));
      } catch (e) {
        throw new Error(e);
      }
    }}),
};

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "container is-fluid", attrs: { id: "player-profile" } },
    [
      _c("BLoading", {
        attrs: { "is-full-page": "", active: _vm.showLoading }
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-8" },
          [
            _c("PlayerHeader", {
              attrs: { player: _vm.player },
              on: { teamChanged: _vm.updateStatisticData }
            }),
            _vm._v(" "),
            _c("PlayerHeaderMobile", {
              attrs: { player: _vm.player },
              on: { teamChanged: _vm.updateStatisticData }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column is-4" },
          [
            _c("PlayerAnalysis", {
              model: {
                value: _vm.playerSection,
                callback: function($$v) {
                  _vm.playerSection = $$v;
                },
                expression: "playerSection"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "player-profile__filters" }, [
        _c(
          "div",
          { staticClass: "is-hidden-mobile" },
          [
            _c("PlayerFilter", {
              on: {
                seasonChanged: _vm.updateStatisticData,
                statisticsChanged: _vm.onStatisticsChanged,
                playingAsChanged: _vm.onPlayingAsChanged,
                resultsChanged: _vm.onResultsChanged,
                sectionsChanged: _vm.onSectionsChanged,
                "premium-disabled-clicked": function($event) {
                  return _vm.$emit("premium-disabled-clicked")
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "is-hidden-tablet" },
          [
            _c(
              "button",
              {
                staticClass: "button filter-button is-dark",
                staticStyle: { display: "none" }
              },
              [
                _c("BIcon", { attrs: { icon: "tune" } }),
                _vm._v(" "),
                _c("span", [_vm._v("EXPORTAR INFO")])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button filter-button is-primary",
                on: { click: _vm.onClickFilterMobile }
              },
              [
                _c("BIcon", { attrs: { icon: "tune" } }),
                _vm._v(" "),
                _c("span", [_vm._v("FILTROS")])
              ],
              1
            ),
            _vm._v(" "),
            _c("FilterMobile", {
              attrs: { "show-modal": _vm.showMobileFilter },
              on: {
                seasonChanged: _vm.updateStatisticData,
                statisticsChanged: _vm.onStatisticsChanged,
                playingAsChanged: _vm.onPlayingAsChanged,
                resultsChanged: _vm.onResultsChanged,
                sectionsChanged: _vm.onSectionsChanged,
                hide: function($event) {
                  _vm.showMobileFilter = false;
                },
                "premium-disabled-clicked": function($event) {
                  return _vm.$emit("premium-disabled-clicked")
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.playerSection === 1
        ? _c("div", [_c("PlayerPossession")], 1)
        : _vm.playerSection === 2
        ? _c("div", [_c("PlayerOffensive")], 1)
        : _c("div", [_c("PlayerDefensive")], 1)
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-721d118a_0", { source: ".filter-button {\n  margin: 5px;\n}\n.is-hidden-tablet > .filter-button:first-child {\n  visibility: hidden;\n}\n.filter-button {\n  margin: 5px;\n}\n.is-hidden-tablet > .filter-button:first-child {\n  visibility: hidden;\n}\n.title-section > h1 {\n  margin-left: 2rem;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-align: left;\n}\n.subtitle-section {\n  font-size: 25px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #808285;\n}\n.modal-card.animation-content {\n  padding: 0 15px;\n}\n.is-bordered, .is-bordered-box-shadow-secondary, .is-bordered-box-shadow-main {\n  border-radius: 4px;\n  background-color: #ffffff;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 8px;\n}\n.is-bordered-box-shadow-main {\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n}\n.is-bordered-box-shadow-secondary {\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.26);\n}\n.is-clickable {\n  cursor: pointer;\n}\n.team-profile__filter--sticky {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.95);\n  width: 100%;\n  padding-bottom: 16px;\n  justify-content: space-around !important;\n  padding-left: 5px;\n  padding-right: 5px;\n  -webkit-box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n}\ndiv.desktop-table .b-table .table {\n  border-collapse: collapse;\n  border-radius: 24px;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n}\ndiv.desktop-table .table thead {\n  display: table-header-group;\n  border: none;\n  border-radius: 24px;\n  background-color: #7ed321;\n  color: white;\n}\ndiv.desktop-table .table thead th {\n  color: #ffffff !important;\n}\ndiv.desktop-table .table thead:first-child tr:first-child th:first-child {\n  border-radius: 24px 0 0 0;\n  border: none;\n}\ndiv.desktop-table .table thead:first-child tr:last-child th:last-child {\n  border-radius: 0 24px 0 0;\n  border: none;\n}\ndiv.desktop-table .b-table .table.is-bordered th.is-current-sort, div.desktop-table .b-table .table.is-bordered-box-shadow-main th.is-current-sort, div.desktop-table .b-table .table.is-bordered-box-shadow-secondary th.is-current-sort, div.desktop-table .b-table .table.is-bordered th.is-sortable:hover, div.desktop-table .b-table .table.is-bordered-box-shadow-main th.is-sortable:hover, div.desktop-table .b-table .table.is-bordered-box-shadow-secondary th.is-sortable:hover {\n  border-color: #dbdbdb;\n  background: #7ed321;\n}\ndiv.desktop-table .b-table .chevron-cell + tr {\n  background: red;\n}\ndiv.desktop-table .chevron-cell, div.desktop-table .has-detail-rows {\n  font-weight: bold;\n  background: whitesmoke;\n  color: #808285;\n}\ndiv.desktop-table .detailed-row {\n  line-height: 30px;\n  color: #808285;\n}\n.player-profile__filters {\n  margin-bottom: 8px;\n}\n#player-profile {\n  font-family: Avenir-Demi, sans-serif;\n  padding-bottom: 20px;\n}\n#player-profile div.columns {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n#player-profile .button.is-primary {\n  background-color: #7dd421;\n  color: white;\n}\n#player-profile .button:focus, #player-profile .button.is-focused {\n  border-color: #7dd421;\n}\n#player-profile .button:focus:not(:active), #player-profile .button.is-focused:not(:active) {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n#player-profile .b-checkbox.checkbox input[type=checkbox]:checked + .check {\n  background: #7dd421 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:white' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #7dd421;\n}\n#player-profile .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled) + .check {\n  border-color: #7dd421;\n}\n#player-profile .b-checkbox.checkbox input[type=checkbox]:focus:checked + .check {\n  box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n}\n#player-profile .switch input[type=checkbox]:checked + .check {\n  background: #7dd421;\n}\n#player-profile .switch:hover input[type=checkbox] + .check.is-primary-passive {\n  background: #7dd421;\n}\n#player-profile .switch input[type=checkbox]:focus + .check.is-primary-passive, #player-profile .switch input[type=checkbox]:active + .check.is-primary-passive {\n  -webkit-box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n  box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n}\n#player-profile .select:not(.is-multiple):not(.is-loading)::after {\n  border-color: #7dd421;\n}\n#player-profile .input:active, #player-profile .input:focus, #player-profile .is-active.input, #player-profile .is-active.textarea, #player-profile .is-focused.input, #player-profile .is-focused.textarea, #player-profile .select select.is-active, #player-profile .select select.is-focused, #player-profile .select select:active, #player-profile .select select:focus, #player-profile .taginput .is-active.taginput-container.is-focusable, #player-profile .taginput .is-focused.taginput-container.is-focusable, #player-profile .taginput .taginput-container.is-focusable:active, #player-profile .taginput .taginput-container.is-focusable:focus, #player-profile .textarea:active, #player-profile .textarea:focus {\n  border-color: #3273dc;\n  box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);\n  -webkit-box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);\n}\n#player-profile .element-click--disabled {\n  pointer-events: none;\n}\n#player-profile .element-click--enabled {\n  pointer-events: auto;\n}\n@media screen and (max-width: 768px) {\n.column.is-8 {\n    padding-bottom: 0;\n}\n}\n\n/*# sourceMappingURL=player-profile.vue.map */", map: {"version":3,"sources":["/home/aletsmart/Proyectos/npm-packages/player-profile/src/player-profile.vue","player-profile.vue"],"names":[],"mappings":"AAmRA;EACA,WAAA;AClRA;ADoRA;EACA,kBAAA;ACjRA;ADoRA;EACA,WAAA;ACjRA;ADoRA;EACA,kBAAA;ACjRA;ADoRA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;ACjRA;ADoRA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;ACjRA;ADoRA;EACA,eAAA;ACjRA;ADoRA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;ACjRA;ADoRA;EAEA,4CAAA;AClRA;ADqRA;EAEA,6CAAA;ACnRA;ADuRA;EACA,eAAA;ACpRA;ADuRA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,oBAAA;EACA,wCAAA;EACA,iBAAA;EACA,kBAAA;EACA,wDAAA;EACA,qDAAA;EACA,gDAAA;ACpRA;ADwRA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;ACrRA;ADuRA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;ACrRA;ADuRA;EACA,yBAAA;ACrRA;ADuRA;EACA,yBAAA;EACA,YAAA;ACrRA;ADuRA;EACA,yBAAA;EACA,YAAA;ACrRA;ADuRA;EAEA,qBAAA;EACA,mBAAA;ACtRA;ADwRA;EACA,eAAA;ACtRA;ADwRA;EAEA,iBAAA;EACA,sBAAA;EACA,cAAA;ACvRA;ADyRA;EACA,iBAAA;EACA,cAAA;ACvRA;AD2RA;EACA,kBAAA;ACxRA;AD4RA;EACA,oCAAA;EACA,oBAAA;ACzRA;AD0RA;EACA,0BAAA;EACA,yBAAA;ACxRA;AD2RA;EACA,yBA9IA;EA+IA,YAAA;ACzRA;AD4RA;EACA,qBAnJA;ACvIA;AD6RA;EACA,wBAAA;EACA,gBAAA;AC3RA;AD+RA;EACA,8WAAA;EACA,qBA9JA;AC/HA;ADgSA;EACA,qBAlKA;AC5HA;ADiSA;EACA,6CAAA;AC/RA;ADmSA;EACA,mBA3KA;ACtHA;ADoSA;EACA,mBA/KA;ACnHA;ADqSA;EACA,qDAAA;EACA,6CAAA;ACnSA;ADuSA;EACA,qBAzLA;AC5GA;ADuSA;EACA,qBA3LA;EA4LA,kDAAA;EACA,0DAAA;ACrSA;ADwSA;EACA,oBAAA;ACtSA;ADySA;EACA,oBAAA;ACvSA;AD2SA;AACA;IACA,iBAAA;ACxSE;AACF;;AAEA,6CAA6C","file":"player-profile.vue","sourcesContent":["<template>\n  <div id=\"player-profile\" class=\"container is-fluid\">\n    <BLoading is-full-page :active=\"showLoading\" />\n    <br />\n    <!-- Header -->\n    <div class=\"columns\">\n      <div class=\"column is-8\">\n        <PlayerHeader :player=\"player\" @teamChanged=\"updateStatisticData\" />\n        <PlayerHeaderMobile :player=\"player\" @teamChanged=\"updateStatisticData\" />\n      </div>\n      <div class=\"column is-4\">\n        <PlayerAnalysis v-model=\"playerSection\" />\n      </div>\n    </div>\n    <!-- Filters -->\n    <div class=\"player-profile__filters\">\n      <div class=\"is-hidden-mobile\">\n        <PlayerFilter\n          @seasonChanged=\"updateStatisticData\"\n          @statisticsChanged=\"onStatisticsChanged\"\n          @playingAsChanged=\"onPlayingAsChanged\"\n          @resultsChanged=\"onResultsChanged\"\n          @sectionsChanged=\"onSectionsChanged\"\n          @premium-disabled-clicked=\"$emit('premium-disabled-clicked')\"\n        />\n      </div>\n      <div class=\"is-hidden-tablet\">\n        <button class=\"button filter-button is-dark\" style=\"display: none\">\n          <BIcon icon=\"tune\"> </BIcon>\n          <span>EXPORTAR INFO</span>\n        </button>\n        <button class=\"button filter-button is-primary\" @click=\"onClickFilterMobile\">\n          <BIcon icon=\"tune\"> </BIcon>\n          <span>FILTROS</span>\n        </button>\n        <FilterMobile\n          @seasonChanged=\"updateStatisticData\"\n          @statisticsChanged=\"onStatisticsChanged\"\n          @playingAsChanged=\"onPlayingAsChanged\"\n          @resultsChanged=\"onResultsChanged\"\n          @sectionsChanged=\"onSectionsChanged\"\n          :show-modal=\"showMobileFilter\"\n          @hide=\"showMobileFilter = false\"\n          @premium-disabled-clicked=\"$emit('premium-disabled-clicked')\"\n        />\n      </div>\n    </div>\n    <!-- Sections -->\n    <div v-if=\"playerSection === 1\">\n      <PlayerPossession />\n    </div>\n    <div v-else-if=\"playerSection === 2\">\n      <PlayerOffensive />\n    </div>\n    <div v-else>\n      <PlayerDefensive />\n    </div>\n  </div>\n</template>\n\n<script>\nimport PlayerHeader from './components/elements/PlayerHeader.vue';\nimport PlayerHeaderMobile from './components/elements/PlayerHeaderMobile.vue';\nimport PlayerAnalysis from './components/elements/Analisis.vue';\nimport PlayerFilter from './components/elements/Filter.vue';\nimport PlayerPossession from './components/sections/Possession.vue';\nimport PlayerOffensive from './components/sections/Offensive.vue';\nimport PlayerDefensive from './components/sections/Defensive.vue';\nimport FilterMobile from './components/elements/FilterMobile.vue';\nimport { mapGetters, mapState, mapMutations } from 'vuex';\nimport {\n  analisisDeJugadorPosesion,\n  analisisDeJugadorOfensivo,\n  analisisDeJugadorDefensivo,\n  analisisDeJugadorFiltros,\n  analisisDeJugadorFiltroTemporada,\n  analisisDeJugadorFiltroEstadistica,\n  analisisDeJugadorFiltroJugadoComo,\n  analisisDeJugadorFiltroPorResultado,\n  analisisDeJugadorFiltroPorTiempo,\n} from './utils/analytics';\n\nexport default {\n  name: 'PlayerProfile',\n  components: {\n    PlayerDefensive,\n    PlayerHeader,\n    PlayerHeaderMobile,\n    PlayerAnalysis,\n    PlayerFilter,\n    PlayerPossession,\n    PlayerOffensive,\n    FilterMobile,\n  },\n  props: {\n    seasonId: {\n      type: [Number, String],\n      required: true,\n    },\n    playerId: {\n      type: [Number, String],\n      required: true,\n    },\n    useLocalLoading: {\n      type: Boolean,\n      default: false,\n    },\n    isAuthenticationHeaderDisabled: {\n      type: Boolean,\n      default: false,\n    },\n    requestsToken: {\n      type: String,\n      default: '',\n    },\n    isPremiumUser: {\n      type: Boolean,\n      default: false,\n    },\n    isGolstats: {\n      type: Boolean,\n      default: false\n    },\n  },\n  data() {\n    return {\n      showMobileFilter: false,\n      playerSection: 2,\n      currentPlayerId: 0,\n    };\n  },\n  created() {\n    window.addEventListener('resize', this.updateWindowWidth);\n    this.setCategoryType();\n    this.loadPlayerInfo();\n  },\n  mounted() {\n    this.updateWindowWidth();\n    this.$store.commit('playerProfileTeam/updateTeam', {});\n  },\n  beforeDestroy() {\n    window.removeEventListener('resize', this.updateWindowWidth);\n  },\n  watch: {\n    playerSection() {\n      this.setCategoryType();\n    },\n    playerId() {\n      this.loadPlayerInfo();\n    },\n    requestsToken: {\n      immediate: true,\n      handler(newValue) {\n        this.setRequestsToken(newValue)\n      },\n    },\n    isPremiumUser: {\n      immediate: true,\n      handler(newValue) {\n        this.setIsPremiumUser(newValue)\n      },\n    },\n    isGolstats: {\n      immediate: true,\n      handler(newValue) {\n        this.setIsGolstats(newValue)\n      },\n    },\n    player: {\n      deep: true,\n      handler(newValue) {\n        if (newValue.position_id === 1) {\n          this.playerSection = 3;\n        }\n      },\n    },\n  },\n  computed: {\n    ...mapGetters('playerProfileGeneral', ['playerSeasons', 'player']),\n    ...mapGetters({\n      selectedSeasonId: 'playerProfileFilter/getSeasonId',\n      section: 'playerProfileFilter/getCategoryTypeName',\n    }),\n    ...mapState('playerProfileGlobal', ['isSectionLoading']),\n    teamId() {\n      return this.player.team_id || 0;\n    },\n    selectedPlayerId() {\n      return this.player.player_id || 0;\n    },\n    showLoading() {\n      const showLoading = this.isSectionLoading && this.useLocalLoading;\n      this.$emit('loading-changed', this.isSectionLoading);\n      return showLoading;\n    },\n  },\n  methods: {\n    ...mapMutations(\n      'playerProfileGlobal', ['setSeasonId', 'setWindowWidth', 'setRequestsToken', 'setIsPremiumUser', 'setIsGolstats']\n    ),\n    /**\n     * @param {number} teamClass - possible values are 1 for national or 0 for club\n     */\n    updateStatisticData(teamClass) {\n      analisisDeJugadorFiltroTemporada(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, this.isPremiumUser,\n      this.isGolstats);\n      try {\n        this.$store.dispatch('playerProfileGeneral/fillStatisticData', teamClass);\n      } catch (e) {\n        console.error('Error, Player updateStatisticData: ', e);\n      }\n    },\n    /**\n     * @author José Rafael Gutierrez\n     * Set property sections in filterGeneral module.\n     * @return void\n     */\n    setCategoryType() {\n      if (this.teamId && this.selectedSeasonId && this.selectedPlayerId){\n        switch(this.playerSection) {\n          case 1: analisisDeJugadorPosesion(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.isPremiumUser,\n          this.isGolstats); break;\n          case 2: analisisDeJugadorOfensivo(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.isPremiumUser,\n          this.isGolstats); break;\n          case 3: analisisDeJugadorDefensivo(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.isPremiumUser,\n          this.isGolstats); break;\n        }\n      }\n      this.$store.commit('playerProfileFilter/setCategoryType', this.playerSection);\n    },\n    /**\n     * @author Rigoberto Sanchez\n     * @description\n     */\n    onClickFilterMobile() {\n      analisisDeJugadorFiltros(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, this.isPremiumUser, this.isGolstats);\n      this.showMobileFilter = true;\n    },\n    onStatisticsChanged(value) {\n      analisisDeJugadorFiltroEstadistica(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onPlayingAsChanged(value) {\n      analisisDeJugadorFiltroJugadoComo(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onResultsChanged(value) {\n      analisisDeJugadorFiltroPorResultado(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n    onSectionsChanged(value) {\n      analisisDeJugadorFiltroPorTiempo(this.selectedSeasonId, this.teamId, this.selectedPlayerId, this.section, value, this.isPremiumUser,\n      this.isGolstats);\n    },\n    updateWindowWidth() {\n      this.setWindowWidth(window.innerWidth);\n    },\n    async loadPlayerInfo() {\n      try {\n        if (this.playerId === this.currentPlayerId) return;\n        window.playerProfileIsAuthorizationHeaderDisabled = this.isAuthenticationHeaderDisabled;\n        this.setSeasonId(this.seasonId);\n        await this.$store.dispatch('playerProfileGeneral/cleanData');\n        await this.$store.dispatch('playerProfileGeneral/checkState', Number(this.playerId));\n      } catch (e) {\n        throw new Error(e);\n      }\n    },\n  },\n};\n</script>\n\n<style lang=\"scss\">\n$primary: #7dd421;\n$active: #3273dc;\n.filter-button {\n  margin: 5px;\n}\n.is-hidden-tablet > .filter-button:first-child {\n  visibility: hidden;\n}\n\n.filter-button {\n  margin: 5px;\n}\n\n.is-hidden-tablet > .filter-button:first-child {\n  visibility: hidden;\n}\n\n.title-section > h1 {\n  margin-left: 2rem;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-align: left;\n}\n\n.subtitle-section {\n  font-size: 25px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #808285;\n}\n\n.modal-card.animation-content{\n  padding: 0 15px;\n}\n// Global class for every section that requires a border like a card\n.is-bordered {\n  border-radius: 4px;\n  background-color: #ffffff;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 8px;\n}\n\n.is-bordered-box-shadow-main {\n  @extend .is-bordered;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n}\n\n.is-bordered-box-shadow-secondary {\n  @extend .is-bordered;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.26);\n}\n\n// Clickable elements\n.is-clickable {\n  cursor: pointer;\n}\n\n.team-profile__filter--sticky {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.95);\n  width: 100%;\n  padding-bottom: 16px;\n  justify-content: space-around !important;\n  padding-left: 5px;\n  padding-right: 5px;\n  -webkit-box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n}\n\ndiv.desktop-table {\n  & .b-table .table {\n    border-collapse: collapse;\n    border-radius: 24px;\n    box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n  }\n  & .table thead {\n    display: table-header-group;\n    border: none;\n    border-radius: 24px;\n    background-color: #7ed321;\n    color: white;\n  }\n  & .table thead th {\n    color: #ffffff !important;\n  }\n  & .table thead:first-child tr:first-child th:first-child {\n    border-radius: 24px 0 0 0;\n    border: none;\n  }\n  & .table thead:first-child tr:last-child th:last-child {\n    border-radius: 0 24px 0 0;\n    border: none;\n  }\n  & .b-table .table.is-bordered th.is-current-sort,\n  & .b-table .table.is-bordered th.is-sortable:hover {\n    border-color: #dbdbdb;\n    background: #7ed321;\n  }\n  & .b-table .chevron-cell + tr {\n    background: red;\n  }\n  & .chevron-cell,\n  & .has-detail-rows {\n    font-weight: bold;\n    background: whitesmoke;\n    color: #808285;\n  }\n  & .detailed-row {\n    line-height: 30px;\n    color: #808285;\n  }\n}\n\n.player-profile__filters {\n  margin-bottom: 8px;\n}\n\n// override bulma primary color and define main component scope styles\n#player-profile {\n  font-family: Avenir-Demi, sans-serif;\n  padding-bottom: 20px;\n  & div.columns {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  // buttons\n  .button.is-primary {\n    background-color: $primary;\n    color: white;\n  }\n\n  .button:focus, .button.is-focused {\n    border-color: $primary;\n  }\n\n  .button:focus:not(:active), .button.is-focused:not(:active) {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n\n  // checkboxes\n  .b-checkbox.checkbox input[type=checkbox]:checked + .check {\n    background: $primary url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:white' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n    border-color: $primary;\n  }\n\n  .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled) + .check {\n    border-color: $primary;\n  }\n\n  .b-checkbox.checkbox input[type=checkbox]:focus:checked + .check {\n    box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n  }\n\n  // switches\n  .switch input[type=checkbox]:checked + .check {\n    background: $primary;\n  }\n\n  .switch:hover input[type=checkbox] + .check.is-primary-passive {\n    background: $primary;\n  }\n\n  .switch input[type=checkbox]:focus + .check.is-primary-passive, .switch input[type=checkbox]:active + .check.is-primary-passive {\n    -webkit-box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n    box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n  }\n\n  // arrow inside select\n  .select:not(.is-multiple):not(.is-loading)::after {\n    border-color: $primary;\n  }\n  .input:active, .input:focus, .is-active.input, .is-active.textarea, .is-focused.input, .is-focused.textarea, .select select.is-active, .select select.is-focused, .select select:active, .select select:focus, .taginput .is-active.taginput-container.is-focusable, .taginput .is-focused.taginput-container.is-focusable, .taginput .taginput-container.is-focusable:active, .taginput .taginput-container.is-focusable:focus, .textarea:active, .textarea:focus {\n    border-color: $active;\n    box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 25%);\n    -webkit-box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 25%);\n  }\n\n  .element-click--disabled {\n    pointer-events: none;\n  }\n\n  .element-click--enabled {\n    pointer-events: auto;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .column.is-8 {\n    padding-bottom: 0;\n  }\n}\n</style>\n",".filter-button {\n  margin: 5px;\n}\n\n.is-hidden-tablet > .filter-button:first-child {\n  visibility: hidden;\n}\n\n.filter-button {\n  margin: 5px;\n}\n\n.is-hidden-tablet > .filter-button:first-child {\n  visibility: hidden;\n}\n\n.title-section > h1 {\n  margin-left: 2rem;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  font-size: 40px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.85;\n  letter-spacing: normal;\n  color: #808285;\n  text-align: left;\n}\n\n.subtitle-section {\n  font-size: 25px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #808285;\n}\n\n.modal-card.animation-content {\n  padding: 0 15px;\n}\n\n.is-bordered, .is-bordered-box-shadow-secondary, .is-bordered-box-shadow-main {\n  border-radius: 4px;\n  background-color: #ffffff;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 8px;\n}\n\n.is-bordered-box-shadow-main {\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n}\n\n.is-bordered-box-shadow-secondary {\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.26);\n}\n\n.is-clickable {\n  cursor: pointer;\n}\n\n.team-profile__filter--sticky {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.95);\n  width: 100%;\n  padding-bottom: 16px;\n  justify-content: space-around !important;\n  padding-left: 5px;\n  padding-right: 5px;\n  -webkit-box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 10px 17px -13px rgba(0, 0, 0, 0.5);\n}\n\ndiv.desktop-table .b-table .table {\n  border-collapse: collapse;\n  border-radius: 24px;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\n}\ndiv.desktop-table .table thead {\n  display: table-header-group;\n  border: none;\n  border-radius: 24px;\n  background-color: #7ed321;\n  color: white;\n}\ndiv.desktop-table .table thead th {\n  color: #ffffff !important;\n}\ndiv.desktop-table .table thead:first-child tr:first-child th:first-child {\n  border-radius: 24px 0 0 0;\n  border: none;\n}\ndiv.desktop-table .table thead:first-child tr:last-child th:last-child {\n  border-radius: 0 24px 0 0;\n  border: none;\n}\ndiv.desktop-table .b-table .table.is-bordered th.is-current-sort, div.desktop-table .b-table .table.is-bordered-box-shadow-main th.is-current-sort, div.desktop-table .b-table .table.is-bordered-box-shadow-secondary th.is-current-sort, div.desktop-table .b-table .table.is-bordered th.is-sortable:hover, div.desktop-table .b-table .table.is-bordered-box-shadow-main th.is-sortable:hover, div.desktop-table .b-table .table.is-bordered-box-shadow-secondary th.is-sortable:hover {\n  border-color: #dbdbdb;\n  background: #7ed321;\n}\ndiv.desktop-table .b-table .chevron-cell + tr {\n  background: red;\n}\ndiv.desktop-table .chevron-cell, div.desktop-table .has-detail-rows {\n  font-weight: bold;\n  background: whitesmoke;\n  color: #808285;\n}\ndiv.desktop-table .detailed-row {\n  line-height: 30px;\n  color: #808285;\n}\n\n.player-profile__filters {\n  margin-bottom: 8px;\n}\n\n#player-profile {\n  font-family: Avenir-Demi, sans-serif;\n  padding-bottom: 20px;\n}\n#player-profile div.columns {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n#player-profile .button.is-primary {\n  background-color: #7dd421;\n  color: white;\n}\n#player-profile .button:focus, #player-profile .button.is-focused {\n  border-color: #7dd421;\n}\n#player-profile .button:focus:not(:active), #player-profile .button.is-focused:not(:active) {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n#player-profile .b-checkbox.checkbox input[type=checkbox]:checked + .check {\n  background: #7dd421 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:white' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #7dd421;\n}\n#player-profile .b-checkbox.checkbox:hover input[type=checkbox]:not(:disabled) + .check {\n  border-color: #7dd421;\n}\n#player-profile .b-checkbox.checkbox input[type=checkbox]:focus:checked + .check {\n  box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n}\n#player-profile .switch input[type=checkbox]:checked + .check {\n  background: #7dd421;\n}\n#player-profile .switch:hover input[type=checkbox] + .check.is-primary-passive {\n  background: #7dd421;\n}\n#player-profile .switch input[type=checkbox]:focus + .check.is-primary-passive, #player-profile .switch input[type=checkbox]:active + .check.is-primary-passive {\n  -webkit-box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n  box-shadow: 0 0 0.5em rgba(125, 212, 33, 0.8);\n}\n#player-profile .select:not(.is-multiple):not(.is-loading)::after {\n  border-color: #7dd421;\n}\n#player-profile .input:active, #player-profile .input:focus, #player-profile .is-active.input, #player-profile .is-active.textarea, #player-profile .is-focused.input, #player-profile .is-focused.textarea, #player-profile .select select.is-active, #player-profile .select select.is-focused, #player-profile .select select:active, #player-profile .select select:focus, #player-profile .taginput .is-active.taginput-container.is-focusable, #player-profile .taginput .is-focused.taginput-container.is-focusable, #player-profile .taginput .taginput-container.is-focusable:active, #player-profile .taginput .taginput-container.is-focusable:focus, #player-profile .textarea:active, #player-profile .textarea:focus {\n  border-color: #3273dc;\n  box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);\n  -webkit-box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);\n}\n#player-profile .element-click--disabled {\n  pointer-events: none;\n}\n#player-profile .element-click--enabled {\n  pointer-events: auto;\n}\n\n@media screen and (max-width: 768px) {\n  .column.is-8 {\n    padding-bottom: 0;\n  }\n}\n\n/*# sourceMappingURL=player-profile.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

/**
 * @author Alejandro
 * @description Reduce the given play's list to an object with possession, offensive
 * and defensive lists.
 * @param {Array} playList - The play's list to filter
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @return {{possession: Array, offensive: Array, defensive: Array}}
 */
function filterByCategoryType(playList, playValuesIndex) {
  return playList.reduce(
    function (accumulator, play) {
      switch (play[playValuesIndex.categoryType]) {
        // Possession
        case 1:
          accumulator.possession.push(play);
          break;
        //  Offensive
        case 2:
          accumulator.offensive.push(play);
          break;
        //  Defensive
        case 3:
          accumulator.defensive.push(play);
          break;
      }
      return accumulator;
    },
    {
      possession: [],
      offensive: [],
      defensive: [],
    }
  );
}

/**
 * @author Alejandro
 * @description Filter a play list by location and result
 * @param {Array} playList - The play list to filter
 * @param {Array<number>} selectedLocation - The selected location in filter component
 * @param {Array<number>} selectedResults - The selected results in filter component
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @param {Number} teamId - Id analysis team
 * @return {Array} - The filtered play list
 */
function filterByGameLocationsAndResults(playList, selectedLocation, selectedResults, playValuesIndex, teamId) {
  // Check if all options are selected to avoid filter iteration

  if (!selectedLocation && selectedResults.length === 3) {
    return playList;
  }

  var selectedResultsRival = selectedResults.map(function (r) { return (r === 1 ? 2 : (r === 2 ? 1 : 3)); });

  var filtered = playList.filter(function (play) {
    var isRivalPlay = teamId && play[playValuesIndex.teamId] ? play[playValuesIndex.teamId] !== teamId : false;
    var rivalPlayingAs = selectedLocation === 1 ? 2 : 1;

    return (
      (!selectedLocation || (isRivalPlay ? rivalPlayingAs : selectedLocation) === play[playValuesIndex.playingAs]) &&
      ((selectedResults.includes(play[playValuesIndex.matchResult]) && play[playValuesIndex.teamId] === teamId) ||
        (selectedResultsRival.includes(play[playValuesIndex.matchResult]) && play[playValuesIndex.teamId] !== teamId))
    );
  });
  return filtered
}

var store$1 = null;

function setStore(storeInstance) {
  store$1 = storeInstance;
}

function getStore() {
  return store$1;
}

var store = null;
/**
 * Allows retrying a failed get request.
 * @author José Rafael Gutierrez
 * @param url
 * @param options
 * @param retries
 * @return {Promise<AxiosResponse<T>>}
 */
async function fetchRetry(ref
  ) {
  var url = ref.url;
  var options = ref.options;
  var retries = ref.retries; if ( retries === void 0 ) retries = 3;

  if (!store) {
    store = getStore();
  }
  var token = !window.playerProfileIsAuthorizationHeaderDisabled && store
    ? store.getters['playerProfileGlobal/getRequestsToken']
    : '';
  if (options) {
    if (options.headers) {
      options.headers.Authorization = token;
    } else {
      options.headers = { Authorization: token };
    }
  } else {
    options = { headers: { Authorization: token } };
  }
  return await axios
    .get(url, options)
    .then(function (response) { return response; })
    .catch(function (e) {
      if (retries > 0) { return fetchRetry({ url: url, options: options, retries: retries - 1 }); }
      return e;
    });
}

/**
 * @author Alejandro
 * @description Fetch player's info and seasons
 * @param {Object} params
 * @param {number} params.seasonId
 * @param {number} params.playerId
 */
async function getPlayerInfoAndSeasons(ref) {
  var seasonId = ref.seasonId;
  var playerId = ref.playerId;

  try {
    // golstats url: https://uof4tt5l46.execute-api.us-west-2.amazonaws.com/prod/v2/playerInfo/${seasonId}/${playerId}
    var ref$1 = await fetchRetry({
      url: ("https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/playerInfo/" + seasonId + "/" + playerId),
    });
    var data = ref$1.data;
    return data;
  } catch (e) {
    throw new Error(e);
  }
}

/**
 * @author Alejandro
 * @description Get player's statistics from the server.
 * @param {Object} params
 * @param {number} params.seasonId
 * @param {number} params.playerId
 */
async function getPlayerStatisticsBySeason(ref) {
  var seasonId = ref.seasonId;
  var playerId = ref.playerId;

  try {
    // golstats url: https://fn0z0dd0u3.execute-api.us-west-2.amazonaws.com/prod/statsPlayerBySeason/${seasonId}/${playerId}
    var url = "https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/statsPlayerBySeason/" + seasonId + "/" + playerId;
    return await fetchRetry({ url: url });
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 *
 * @param {Object} params
 * @param {(number|string)} params.seasonId
 * @param {(number|string)=} params.teamId
 * @return {Promise}
 */
async function getPlayersBySeasonAndTeam(ref) {
  var seasonId = ref.seasonId;
  var teamId = ref.teamId;

  try {
    // golstats url: https://pa3kubpuhg.execute-api.us-west-2.amazonaws.com/prod/playersByTeamAndSeason/${seasonId}/${teamId
    //       || ''}
    var url = "https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/playersByTeamAndSeason/" + seasonId + "/" + (teamId
      || '');
    return await fetchRetry({ url: url });
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 *
 * @param {Object} params
 * @param {(number|string)} params.seasonId
 * @return {Promise}
 */
async function fetchPlayersBySeason(ref) {
  var seasonId = ref.seasonId;

  try {
    // golstats url: https://pa3kubpuhg.execute-api.us-west-2.amazonaws.com/prod/playersByTeamAndSeason/${seasonId}/${teamId
    //       || ''}
    var url = "https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/playersBySeason/" + seasonId;
    return await fetchRetry({ url: url });
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 * @author Alejandro
 * @param {Object} params
 * @param {(number|string)} params.seasonId
 * @param {(number|string)} params.playerId
 * @return {Promise}
 */
async function getGoalsPlayerBySeason(ref) {
  var seasonId = ref.seasonId;
  var playerId = ref.playerId;

  try {
    // golstats url: https://lktcjrffmb.execute-api.us-west-2.amazonaws.com/prod/goalsPlayerBySeason/${seasonId}/${playerId}
    // not qa url: https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/goalsPlayerBySeason/${seasonId}/${playerId}
    // qa url: https://j6by4hgx3d.execute-api.us-west-2.amazonaws.com/qa/goalsPlayerBySeason/${seasonId}/${playerId}
    var url = "https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/goalsPlayerBySeason/" + seasonId + "/" + playerId;
    return await fetchRetry({ url: url });
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 * Defines the index position of each value inside a goal stat play.
 */
var goalPlayValues = [
  'playId',
  'gameId',
  'playerId',
  'momentOfPlay',
  'categoryId',
  'categoryType',
  'matchLapse',
  'section',
  'matchResult',
  'playingAs',
  'total',
  'coordinateX',
  'coordinateY' ];

var goalPlayIndex = null;

function getGoalPlayIndexes() {
  if (!goalPlayIndex) {
    goalPlayIndex = getPlayValueIndexesFromArray(goalPlayValues);
  }
  return goalPlayIndex;
}

var state$5 = {
  player: {},
  seasonPlayers: [],
  currentTeamPlayers: [],
  playerSeasons: {
    0: {},
    1: {},
  },
  playerTeamClass: null,
  lastPlayersForPlayersView: [],
  lastTeamForPlayersView: 0,
  lastSeasonForSeasonPlayers: 0,
  lastSeasonPlayers: [],
  playerBasePlays: [],
};

var mutations$5 = {
  updateSeasonPlayers: function updateSeasonPlayers(state, playersByTeam) {
    state.lastSeasonPlayers = playersByTeam;
    state.seasonPlayers = playersByTeam.reduce(function (accumulator, team) {
      accumulator.push.apply(accumulator, team.players);
      return accumulator;
    }, []);
  },
  updatePlayerSeasons: function updatePlayerSeasons(state, ref) {
    var teamClass = ref.teamClass; if ( teamClass === void 0 ) teamClass = 0;
    var seasons = ref.seasons; if ( seasons === void 0 ) seasons = {};

    state.playerSeasons[teamClass] = seasons;
  },
  updatePlayer: function updatePlayer(state, playerInfo) {
    state.player = playerInfo;
  },
  updateCurrentTeamPlayers: function updateCurrentTeamPlayers(state, players) {
    state.currentTeamPlayers = players;
  },
  updatePlayerTeamClass: function updatePlayerTeamClass(state, teamClass) {
    state.playerTeamClass = teamClass;
  },
  updateTeamForPlayersView: function updateTeamForPlayersView(state, teamId) {
    state.lastTeamForPlayersView = teamId;
  },
  updatePlayersForPlayersView: function updatePlayersForPlayersView(state, players) {
    state.lastPlayersForPlayersView = players;
  },
  updateLastSeasonForSeasonPlayers: function updateLastSeasonForSeasonPlayers(state, seasonId) {
    state.lastSeasonForSeasonPlayers = seasonId;
  },
  setPlayerBasePlays: function setPlayerBasePlays(state, playerBasePlays) {
    state.playerBasePlays = playerBasePlays;
  }
};

var actions$1 = {
  /**
   * @author Cristhian Gomez
   * @description This action cleans baseplayerstack
   * @return {void}
   */
  cleanData: function cleanData(ref) {
    var commit = ref.commit;

    commit('playerProfilePossession/updatePlaysStack', [], { root: true });
  },
  /**
   * @author Alejandro
   * @description This action is called when a user opens player analysis, and checks the data
   * required in the storage.
   * @param {Object} context
   * @param {number} playerId - The team id provided by the url teamsAnalysis/:teamId
   * @return {Promise<void>}
   */
  checkState: async function checkState(ref, playerId) {
    var commit = ref.commit;
    var dispatch = ref.dispatch;
    var rootState = ref.rootState;

    try {
      commit('playerProfileGlobal/setIsSectionLoading', true, { root: true });
      commit('updatePlayerTeamClass', null);
      commit('updatePlayer', { player_id: playerId });
      commit('playerProfileFilter/setSeasonId', rootState.playerProfileGlobal.seasonId, { root: true });
      var promises = [getPlayerInfoAndSeasons({ seasonId: rootState.playerProfileGlobal.seasonId, playerId: playerId })];
      await dispatch('fillStatisticData', { teamClass: 0, promises: promises });
    } catch (e) {
      // commit('playerProfileGlobal/setIsSectionLoading', false, { root: true });
      throw new Error(e);
    }
  },
  /**
   * @author Alejandro
   * @description This function fill the statistic data for player, is triggered by the action 'checkState'
   * or by the view Player.vue when a season changes or the team changes from club to national
   * @param dispatch
   * @param commit
   * @param state
   * @param rootGetters
   * @param {number} teamClass - 1 for national team and 0 for club
   * @param {Object} payload
   * @return {Promise<never>}
   */
  fillStatisticData: async function fillStatisticData(
    ref,
    payload
  ) {
    var dispatch = ref.dispatch;
    var commit = ref.commit;
    var state = ref.state;
    var rootGetters = ref.rootGetters;
    var rootState = ref.rootState;
    if ( payload === void 0 ) payload = { teamClass: 0, promises: [undefined] };

    try {
      if (!rootState.isSectionLoading) {
        commit('playerProfileGlobal/setIsSectionLoading', true, { root: true });
      }
      payload.promises.push(dispatch('getPlayersBySeason', true));
      payload.promises.push(dispatch('playerProfileTeam/getTeamsBySeasonForAnalysis', true, { root: true }));
      payload.promises.push(dispatch('playerProfileGames/getSeasonGames', true, { root: true }));
      payload.promises.push(dispatch('playerProfileLeague/getSeasonPlays', true, { root: true }));
      payload.promises.push(
        getGoalsPlayerBySeason({
          seasonId: rootGetters['playerProfileFilter/getSeasonId'],
          playerId: state.player.player_id,
        })
      );
      payload.promises.push(
        getPlayerStatisticsBySeason({
          seasonId: rootGetters['playerProfileFilter/getSeasonId'],
          playerId: state.player.player_id,
        })
      );
      var ref$1 = await Promise.all(payload.promises);
      var playerInfoAndSeasons = ref$1[0];
      var seasonPlayers = ref$1[1];
      var seasonTeams = ref$1[2];
      var seasonGames = ref$1[3];
      var seasonPlays = ref$1[4];
      var data_combination = ref$1[5].data.data_combination;
      var ref$1_6_data_data = ref$1[6].data.data;
      var posession = ref$1_6_data_data.posession;
      var offensive = ref$1_6_data_data.offensive;
      var defensive = ref$1_6_data_data.defensive;
      if (playerInfoAndSeasons) {
        commit('updatePlayerSeasons', { teamClass: 0, seasons: Object.assign({}, playerInfoAndSeasons.seasons) });
        commit('updatePlayerSeasons', { teamClass: 1, seasons: Object.assign({}, playerInfoAndSeasons.national_seasons) });
        delete playerInfoAndSeasons.seasons;
        delete playerInfoAndSeasons.national_seasons;
        commit('updatePlayer', playerInfoAndSeasons);
      }
      if (state.playerTeamClass !== payload.teamClass) {
        await dispatch(
          'playerProfileFilter/updateSeasons',
          { seasons: state.playerSeasons[payload.teamClass] },
          { root: true }
        );
        commit('updatePlayerTeamClass', payload.teamClass);
      }
      if (seasonPlayers) {
        commit('updateSeasonPlayers', seasonPlayers);
      }
      if (seasonTeams) {
        if (rootState.playerProfileTeam.seasonTeams.length === 0) {
          commit('playerProfileTeam/updateTeams', seasonTeams, { root: true });
        }
        commit('playerProfileTeam/updateTeamsForAnalysis', seasonTeams, { root: true });
      }
      if (seasonGames) {
        commit('playerProfileGames/updateSeasonGames', seasonGames, { root: true });
      }
      commit('playerProfileLeague/updateSeasonPlays', seasonPlays, { root: true });
      var filteredGoalPlays = filterByCategoryType(data_combination, getGoalPlayIndexes());
      commit('playerProfileOffensive/updateGoalPlaysStack', filteredGoalPlays.offensive, { root: true });
      commit('playerProfileDefensive/updateGoalPlaysStack', filteredGoalPlays.defensive, { root: true });
      commit('playerProfilePossession/updatePlaysStack', posession, { root: true });
      commit('playerProfileOffensive/updatePlaysStack', offensive, { root: true });
      commit('playerProfileDefensive/updatePlaysStack', defensive, { root: true });
      commit('playerProfileGlobal/setIsSectionLoading', false, { root: true });
      commit('setPlayerBasePlays', posession.concat( offensive, defensive));
    } catch (e) {
      // commit('playerProfileGlobal/setIsSectionLoading', false, { root: true });
      return Promise.reject(e);
    }
  },
  /**
   * @author Alejandro
   * @param {Object} context
   * @param {Object} payload
   * @param {number} payload.seasonId
   * @param {number} payload.playerId
   */
  getPlayerStatisticsBySeason: async function getPlayerStatisticsBySeason$1(context, payload) {
    try {
      var response = await getPlayerStatisticsBySeason(payload);
      context.commit('playerProfilePossession/updatePlaysStack', response.data.data.posession, { root: true });
      context.commit('playerProfileOffensive/updatePlaysStack', response.data.data.offensive, { root: true });
      context.commit('playerProfileDefensive/updatePlaysStack', response.data.data.defensive, { root: true });
    } catch (e) {
      return Promise.reject(e);
    }
  },
  /**
   * @param {Object} context
   * @param {Object} payload
   * @param {number} payload.seasonId
   * @param {number} payload.playerId
   * @return {Promise}
   */
  // async getPlayerInfo({ commit }, payload) {
  //   try {
  //     const playerInfo = await getPlayerInfo(payload);
  //     commit('updatePlayer', playerInfo);
  //   } catch (e) {
  //     return Promise.reject(e);
  //   }
  // },
  /**
   * @author Alejandro
   * @param {Object} context
   * @param {Object} payload
   * @param {(number|string)} payload.teamId
   * @param {boolean} payload.showLoading
   */
  getPlayersBySeasonAndTeam: async function getPlayersBySeasonAndTeam$1(ref, ref$1) {
    var commit = ref.commit;
    var rootGetters = ref.rootGetters;
    var teamId = ref$1.teamId;
    var showLoading = ref$1.showLoading;

    try {
      if (showLoading) { commit('playerProfileGlobal/setIsSectionLoading', true, { root: true }); }
      var seasonId = rootGetters['playerProfileFilter/getSeasonId'];
      var response = await getPlayersBySeasonAndTeam({ seasonId: seasonId, teamId: teamId });
      if (showLoading) { commit('playerProfileGlobal/setIsSectionLoading', false, { root: true }); }
      return response.data[0].players;
    } catch (e) {
      // commit('playerProfileGlobal/setIsSectionLoading', false, { root: true });
      return Promise.reject(e);
    }
  },

  getPlayersBySeason: async function getPlayersBySeason(ref, returnData) {
    var state = ref.state;
    var commit = ref.commit;
    var rootGetters = ref.rootGetters;
    if ( returnData === void 0 ) returnData = false;

    try {
      var seasonId = rootGetters['playerProfileFilter/getSeasonId'];
      if (state.lastSeasonForSeasonPlayers === seasonId) {
        return state.lastSeasonPlayers;
      }
      commit('updateLastSeasonForSeasonPlayers', seasonId);
      var ref$1 = await fetchPlayersBySeason({ seasonId: seasonId });
      var data = ref$1.data;
      if (returnData) {
        return data;
      }
      commit('updateSeasonPlayers', data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  // async getPlayersForPlayersView({ state, dispatch, commit }, { teamId }) {
  //   if (state.lastTeamForPlayersView !== teamId) {
  //     commit('updatePlayersForPlayersView', []);
  //     const players = await dispatch('getPlayersBySeasonAndTeam', {
  //       teamId: teamId,
  //       showLoading: true,
  //     });
  //     commit('updatePlayersForPlayersView', players);
  //     commit('updateTeamForPlayersView', teamId);
  //   }
  // },
};

var getters$5 = {
  player: function player(state) {
    return state.player;
  },
  playerId: function playerId() {
    return state$5.player.player_id;
  },
  teamId: function teamId() {
    return state$5.player.team_id;
  },
  seasonPlayers: function seasonPlayers(state) {
    return state.seasonPlayers;
  },
  // getPlaysGoal(state, rootState, rootGetters) {
  //   const sections = rootGetters.filterGeneral.sections;
  //   const results = rootGetters.filterGeneral.results;
  //   const playingAs = rootGetters.filterGeneral.playingAs;
  //   const categoryType = rootGetters.filterGeneral.categoryType;
  //   return state.playsGoal.filter(play => {
  //     return (
  //       // TODO: player_id estático hasta recibir de la API.
  //       //play[2] === state.player.player_id &&
  //       play[2] === 2002 &&
  //       play[5] === categoryType &&
  //       sections.includes(play[7]) &&
  //       results.includes(play[8]) &&
  //       (playingAs === null ? true : play[9] === playingAs)
  //     );
  //   });
  // },
  /**
   * @author José Rafael Gutierrez
   * @param state
   * @param rootState
   * @param rootGetters
   * @return Array
   */
  // getPlays: (state, rootState, rootGetters) => {
  //   const sections = rootGetters.filterGeneral.sections;
  //   const results = rootGetters.filterGeneral.results;
  //   const playingAs = rootGetters.filterGeneral.playingAs;
  //   const categoryType = rootGetters.filterGeneral.categoryType;
  //   return state.plays.filter(play => {
  //     return (
  //       // TODO: player_id estático hasta recibir de la API.
  //       //play[2] === state.player.player_id &&
  //       play[2] === 2002 &&
  //       play[5] === categoryType &&
  //       sections.includes(play[7]) &&
  //       results.includes(play[8]) &&
  //       (playingAs === null ? true : play[9] === playingAs)
  //     );
  //   });
  // },
};

var playerProfileGeneral = {
  namespaced: true,
  state: state$5,
  mutations: mutations$5,
  actions: actions$1,
  getters: getters$5,
};

var x0 = 0;
var x1 = 0.25;
var x2 = 0.5;
var x3 = 0.75;
var x4 = 1;
var y0 = 0;
var y1 = 0.2789115646258504;
var y2 = 0.5;
var y3 = 0.7210884353741496;
var y4 = 1;

var fieldAreas = [
  // x1, y1, x2, y2
  [x0, y0, x1, y1],
  [x1, y0, x2, y1],
  [x2, y0, x3, y1],
  [x3, y0, x4, y1],
  [x0, y1, x1, y2],
  [x1, y1, x2, y2],
  [x2, y1, x3, y2],
  [x3, y1, x4, y2],
  [x0, y2, x1, y3],
  [x1, y2, x2, y3],
  [x2, y2, x3, y3],
  [x3, y2, x4, y3],
  [x0, y3, x1, y4],
  [x1, y3, x2, y4],
  [x2, y3, x3, y4],
  [x3, y3, x4, y4] ];

var emptyData = [
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0] ];

function getEmptyField() {
  var emptyField = [];
  for (var i = 0; i < 16; i++) {
    emptyField.push(0);
  }
  return emptyField;
}

/**
 * @author Alejandro
 * @description Determines at witch area of the field the given point belongs
 * @param {number} x
 * @param {number} y
 * @return {number} - The field's area index, can be any between 0 and 15
 */
function findFieldArea(x, y) {
  // If 'y' is bigger than 0.5 search in half field only
  var fieldAreaIndex = 0;
  for (var i = y > y2 ? 8 : 0; i < fieldAreas.length; i++) {
    if (x >= fieldAreas[i][0] && x <= fieldAreas[i][2] && y >= fieldAreas[i][1] && y <= fieldAreas[i][3]) {
      fieldAreaIndex = i;
      break;
    }
  }
  return fieldAreaIndex;
}

/**
 * @author Alejandro
 * @description Converts a field array with length of 16 items, to a matrix of 4 x 4 items
 * @param {Array} fieldArray
 * @return {Array}
 */
function createFieldMatrixFromArray(fieldArray) {
  var fieldMatrix = [];
  while (fieldArray.length) {
    fieldMatrix.push(fieldArray.splice(0, 4));
  }
  return fieldMatrix;
}

/**
 * @author Alejandro
 * @description Get an object with all fields sections filled.
 * @param {Array} playList - All plays to be filtered
 * @param {Array<number>} timeSelected
 * @param {Object} valuesToFilter - Contains categoriesId to filter
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @param {number=} teamId
 * @return {Array<Object>}
 */
function getStatisticsFields(playList, timeSelected, valuesToFilter, playValuesIndex, teamId) {
  if (!playList || playList.length === 0) {
    return getEmptyData(Object.values(valuesToFilter));
  }
  var fieldsToShow = {};
  for (var [k, v] of Object.entries(valuesToFilter)) {
    fieldsToShow[k] = {
      name: v.name,
      fieldCount: getEmptyField(),
      position: v.position,
      isNegative: v.isNegative,
    };
  }
  for (var play of playList) {
    if (
      teamId
        ? teamId === play[playValuesIndex.teamId] && timeSelected.includes(play[playValuesIndex.section])
        : timeSelected.includes(play[playValuesIndex.section])
    ) {
      for (var key of Object.keys(valuesToFilter)) {
        if (valuesToFilter[key].categoryIds.includes(play[playValuesIndex.categoryId])) {
          fieldsToShow[key].fieldCount[
            findFieldArea(
              play[playValuesIndex[("coordinate" + (valuesToFilter[key].coordinatePoint) + "X")]],
              play[playValuesIndex[("coordinate" + (valuesToFilter[key].coordinatePoint) + "Y")]]
            )
          ]++;
        }
      }
    }
  }
  return Object.values(fieldsToShow).reduce(function (accumulator, ref) {
    var name = ref.name;
    var fieldCount = ref.fieldCount;
    var isNegative = ref.isNegative;

    accumulator.push({
      name: name,
      data: createFieldMatrixFromArray(fieldCount),
      isNegative: isNegative,
    });
    return accumulator
  }, [])
}

/**
 * @author Alejandro Martinez
 * @param {Array<{
 *   categoryIds: Array<number>,
 *   coordinatePoint: number
 *   isNegative: boolean,
 *   name: string,
 *   position: number
 * }>} valuesToFilter
 * @return {Array<{
 *   name: string,
 *   data: Array<Array<number>>
 * }>}
 */
function getEmptyData(valuesToFilter) {
  return valuesToFilter.map(function (value) {
    return {
      name: value.name,
      data: emptyData,
      isNegative: false,
    };
  });
}

/**
 * Defines the index position of each value inside a team stat play.
 */
var leaguePlayValues = ['categoryId', 'matchLapse', 'section', 'matchResult', 'playingAs', 'total'];

var leaguePlayIndex = null;

function getLeaguePlayIndexes() {
  if (!leaguePlayIndex) {
    leaguePlayIndex = getPlayValueIndexesFromArray(leaguePlayValues);
  }
  return leaguePlayIndex;
}

/**
 * @author Alejandro
 * @description Fill all table data
 * @param {number} analysisType - Can be 1 = Possession, 2 = Offensive, 3 = Defensive
 * @param {boolean} isGoalKeeper
 * @param {Array} playList
 * @param {Array} leaguePlays
 * @param {Array<number>} timeSelected
 * @param {number} totalSeasonGamesOrTeams
 * @return {*}
 */
function getPlayerTableData(
  analysisType,
  isGoalKeeper,
  playList,
  leaguePlays,
  timeSelected,
  totalSeasonGamesOrTeams
) {
  var playerDataRows = null;
  if (isGoalKeeper) {
    switch (analysisType) {
      case 2:
        playerDataRows = createOffensiveGoalkeeperRows();
        break;
      case 3:
        playerDataRows = createDefensiveGoalkeeperRows();
        break;
      default:
        playerDataRows = createPossessionGoalkeeperRows();
    }
  } else {
    switch (analysisType) {
      case 2:
        playerDataRows = createOffensivePlayerRows();
        break;
      case 3:
        playerDataRows = createDefensivePlayerRows();
        break;
      default:
        playerDataRows = createPossessionPlayerRows();
    }
  }
  return getFilledTableRows(
    playerDataRows,
    playList,
    leaguePlays,
    timeSelected,
    totalSeasonGamesOrTeams,
    getPlayerStatPlayIndexes(),
    getLeaguePlayIndexes()
  );
}

var commonValues = {
  successfulPasses: {
    name: 'Pases Acertados',
    categoryIds: [2, 20],
    position: 1,
    coordinatePoint: 3,
    isNegative: false,
  },
  unsuccessfulPasses: {
    name: 'Pases no Acertados',
    categoryIds: [3, 21],
    position: 2,
    coordinatePoint: 3,
    isNegative: true,
  },
  recoveredBalls: {
    name: 'Balón Recuperado',
    categoryIds: [482],
    position: 3,
    coordinatePoint: 1,
    isNegative: false,
  },
  lostBalls: {
    name: 'Balón Perdido',
    categoryIds: [493],
    position: 4,
    coordinatePoint: 3,
    isNegative: true,
  },
};

var goalkeeperValues = {
  successfulFistFootClearance: {
    name: 'Despeje mano/pie Acertado',
    categoryIds: [304, 306],
    position: 1,
    coordinatePoint: 3,
    isNegative: false,
  },
  unsuccessfulFistFootClearance: {
    name: 'Despeje mano/pie no Acertado',
    categoryIds: [305, 307],
    position: 2,
    coordinatePoint: 3,
    isNegative: true,
  },
  successfulFootPlay: {
    name: 'Juego de Pie Acertado',
    categoryIds: [310, 308],
    position: 3,
    coordinatePoint: 3,
    isNegative: false,
  },
  unsuccessfulFootPlay: {
    name: 'Juego de Pie no Acertado',
    categoryIds: [311, 309],
    position: 4,
    coordinatePoint: 3,
    isNegative: true,
  },
};

var state$4 = {
  basePlaysStack: [],
  lastFilterValues: null,
};

var mutations$4 = {
  updatePlaysStack: function updatePlaysStack(state, playsStack) {
    state.basePlaysStack = playsStack;
  },
};

var getters$4 = {
  getBasePlaysStack: function (state) { return state.basePlaysStack; },
  filteredPlaysStack: function filteredPlaysStack(state, getters, rootState, rootGetters) {
    return filterByGameLocationsAndResults(
      state.basePlaysStack,
      rootGetters['playerProfileFilter/getPlayingAs'],
      rootGetters['playerProfileFilter/getResults'],
      getPlayerStatPlayIndexes(),
      rootGetters['playerProfileTeam/team'].team_id
    );
  },
  fieldStatistics: function fieldStatistics(state, getters, rootState, rootGetters) {
    return getStatisticsFields(
      getters.filteredPlaysStack,
      rootGetters['playerProfileFilter/getSections'],
      rootGetters['playerProfileGeneral/player'].position_id === 1 ? goalkeeperValues : commonValues,
      getPlayerStatPlayIndexes()
    );
  },
  tableData: function tableData(state, getters, rootState, rootGetters) {
    if (!rootGetters['playerProfileGeneral/player'].position_id) {
      return [];
    }
    return getPlayerTableData(
      1,
      rootGetters['playerProfileGeneral/player'].position_id === 1,
      getters.filteredPlaysStack,
      rootGetters['playerProfileLeague/filteredPlaysStack'],
      rootGetters['playerProfileFilter/getSections'],
      rootGetters['playerProfileFilter/getGamesPlayed']
    );
  },
  topFiveCategories: function topFiveCategories() {
    return [
      {
        name: 'participación en goles',
        rank: 1,
        total: 44,
        max: 'owner',
      },
      {
        name: 'cabeceo área rival',
        rank: 2,
        total: 13,
        max: 20,
      },
      {
        name: 'tiros a gol',
        rank: 3,
        total: 20,
        max: 26,
      },
      {
        name: '1 vs 1 ofensivo exitoso',
        rank: 4,
        total: 22,
        max: 32,
      },
      {
        name: 'asistencias',
        rank: 4,
        total: 2,
        max: 4,
      } ];
  },
};

var playerProfilePossession = {
  namespaced: true,
  state: state$4,
  mutations: mutations$4,
  getters: getters$4,
};

/**
 * @author Alejandro
 * @description Filter a goal play list by location and result and time section.
 * @param {Array} goalPlayList - The play list to filter
 * @param {number} selectedLocation - The selected location in filter component
 * @param {Array<number>} selectedResults - The selected results in filter component
 * @param {Array<number>} selectedSections - The selected time sections in filter component
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @return {Array} - The filtered play list
 */
function getSoccerGoalData(goalPlayList, selectedLocation, selectedResults, selectedSections, playValuesIndex) {
  // If conditional is true, it means that all options are selected, thus avoiding the filter loop
  if (!selectedLocation && selectedResults.length === 3 && selectedSections.length === 6) {
    return goalPlayList;
  }
  return goalPlayList.filter(function (play) {
    return (
      (!selectedLocation || selectedLocation === play[playValuesIndex.playingAs]) &&
      selectedResults.includes(play[playValuesIndex.matchResult]) &&
      selectedSections.includes(play[playValuesIndex.section])
    );
  });
}

function getChalkboardPlayList(playList, timeSelected, playValuesIndex) {
  // If time selected length is equal to 6, means that all time sections are selected,
  // thus avoid loop
  if (timeSelected.length === 6) { return playList; }
  return playList.filter(function (play) { return timeSelected.includes(play[playValuesIndex.section]); });
}

function getChalkboardGames(teams, games) {
  return games.map(function (g) {
    var home_team = teams.find(function (t) { return t.team_id === g.home_team; });
    var visiting_team = teams.find(function (t) { return t.team_id === g.visiting_team; });
    if (home_team && visiting_team) {
      return {
        gameId: g.game_id,
        title: ((home_team.team_name) + " VS " + (visiting_team.team_name)),
        homeTeamId: g.home_team,
        homeTeamName: home_team.team_name,
        homeTeamLogo: home_team.logo,
        visitingTeamId: g.visiting_team,
        visitingTeamName: visiting_team.team_name,
        visitingTeamLogo: visiting_team.logo,
      };
    }
  });
}

var state$3 = {
  basePlaysStack: [],
  goalPlaysStack: [],
};

var mutations$3 = {
  updatePlaysStack: function updatePlaysStack(state, playsStack) {
    state.basePlaysStack = playsStack;
  },
  updateGoalPlaysStack: function updateGoalPlaysStack(state, goalPlaysStack) {
    state.goalPlaysStack = goalPlaysStack;
  },
};

var getters$3 = {
  getBasePlaysStack: function (state) { return state.basePlaysStack; },
  filteredPlaysStack: function filteredPlaysStack(state, getters, rootState, rootGetters) {
    return filterByGameLocationsAndResults(
      state.basePlaysStack,
      rootGetters['playerProfileFilter/getPlayingAs'],
      rootGetters['playerProfileFilter/getResults'],
      getPlayerStatPlayIndexes(),
      rootGetters['playerProfileTeam/team'].team_id
    );
  },
  tableData: function tableData(state, getters, rootState, rootGetters) {
    return getPlayerTableData(
      2,
      rootGetters['playerProfileGeneral/player'].position_id === 1,
      getters.filteredPlaysStack,
      rootGetters['playerProfileLeague/filteredPlaysStack'],
      rootGetters['playerProfileFilter/getSections'],
      rootGetters['playerProfileFilter/getGamesPlayed']
    );
  },
  chalkboardPlays: function chalkboardPlays(state, getters, rootState, rootGetters) {
    return getChalkboardPlayList(
      getters.filteredPlaysStack,
      rootGetters['playerProfileFilter/getSections'],
      getPlayerStatPlayIndexes()
    );
  },
  chalkboardGames: function chalkboardGames(state, getters, rootState, rootGetters) {
    return getChalkboardGames(
      rootGetters['playerProfileTeam/teamsForAnalysis'],
      rootGetters['playerProfileGames/seasonGamesPlayed']
    );
  },
  goalPlays: function goalPlays(state, getters, rootState, rootGetters) {
    return getSoccerGoalData(
      state.goalPlaysStack,
      rootGetters['playerProfileFilter/getPlayingAs'],
      rootGetters['playerProfileFilter/getResults'],
      rootGetters['playerProfileFilter/getSections'],
      getGoalPlayIndexes()
    );
  },
  topFiveCategories: function topFiveCategories() {
    return [
      {
        name: 'participación en goles',
        rank: 1,
        total: 44,
        max: 'owner',
      },
      {
        name: 'cabeceo área rival',
        rank: 2,
        total: 13,
        max: 20,
      },
      {
        name: 'tiros a gol',
        rank: 3,
        total: 20,
        max: 26,
      },
      {
        name: '1 vs 1 ofensivo exitoso',
        rank: 4,
        total: 22,
        max: 32,
      },
      {
        name: 'asistencias',
        rank: 4,
        total: 2,
        max: 4,
      } ];
  },
};

var playerProfileOffensive = {
  namespaced: true,
  state: state$3,
  mutations: mutations$3,
  getters: getters$3,
};

var state$2 = {
  basePlaysStack: [],
  goalPlaysStack: [],
};

var mutations$2 = {
  updatePlaysStack: function updatePlaysStack(state, playsStack) {
    state.basePlaysStack = playsStack;
  },
  updateGoalPlaysStack: function updateGoalPlaysStack(state, playsStack) {
    state.goalPlaysStack = playsStack;
  },
};

var getters$2 = {
  getBasePlaysStack: function (state) { return state.basePlaysStack; },
  filteredPlaysStack: function filteredPlaysStack(state, getters, rootState, rootGetters) {
    return filterByGameLocationsAndResults(
      state.basePlaysStack,
      rootGetters['playerProfileFilter/getPlayingAs'],
      rootGetters['playerProfileFilter/getResults'],
      getPlayerStatPlayIndexes(),
      rootGetters['playerProfileTeam/team'].team_id
    );
  },
  tableData: function tableData(state, getters, rootState, rootGetters) {
    return getPlayerTableData(
      3,
      rootGetters['playerProfileGeneral/player'].position_id === 1,
      getters.filteredPlaysStack,
      rootGetters['playerProfileLeague/filteredPlaysStack'],
      rootGetters['playerProfileFilter/getSections'],
      rootGetters['playerProfileFilter/getGamesPlayed']
    );
  },
  chalkboardPlays: function chalkboardPlays(state, getters, rootState, rootGetters) {
    return getChalkboardPlayList(
      getters.filteredPlaysStack,
      rootGetters['playerProfileFilter/getSections'],
      getPlayerStatPlayIndexes()
    );
  },
  chalkboardGames: function chalkboardGames(state, getters, rootState, rootGetters) {
    return getChalkboardGames(
      rootGetters['playerProfileTeam/teamsForAnalysis'],
      rootGetters['playerProfileGames/seasonGamesPlayed']
    );
  },
  goalPlays: function goalPlays(state, getters, rootState, rootGetters) {
    return getSoccerGoalData(
      state.goalPlaysStack,
      rootGetters['playerProfileFilter/getPlayingAs'],
      rootGetters['playerProfileFilter/getResults'],
      rootGetters['playerProfileFilter/getSections'],
      getGoalPlayIndexes()
    );
  },
  topFiveCategories: function topFiveCategories() {
    return [
      {
        name: 'participación en goles',
        rank: 1,
        total: 44,
        max: 'owner',
      },
      {
        name: 'cabeceo área rival',
        rank: 2,
        total: 13,
        max: 20,
      },
      {
        name: 'tiros a gol',
        rank: 3,
        total: 20,
        max: 26,
      },
      {
        name: '1 vs 1 ofensivo exitoso',
        rank: 4,
        total: 22,
        max: 32,
      },
      {
        name: 'asistencias',
        rank: 4,
        total: 2,
        max: 4,
      } ];
  },
};

var playerProfileDefensive = {
  namespaced: true,
  state: state$2,
  mutations: mutations$2,
  getters: getters$2,
};

/**
 * Created by Alejandro Martinez on 16/07/20.
 */

var player = {
  playerProfileGeneral: playerProfileGeneral,
  playerProfilePossession: playerProfilePossession,
  playerProfileOffensive: playerProfileOffensive,
  playerProfileDefensive: playerProfileDefensive,
};

var playerPlayIndexes = getPlayerStatPlayIndexes();

var playerProfileFilter = {
  namespaced: true,
  state: {
    sections: [],
    results: [],
    playingAs: null,
    seasonId: null,
    categoryType: null,
    seasons: [],
    stadisticId: 1, // Establecer por defecto 0 = Promedio por Partido 1 = Totales
  },
  getters: {
    getSections: function (state) { return state.sections; },
    getResults: function (state) { return state.results; },
    getPlayingAs: function (state) { return state.playingAs; },
    getCategoryType: function (state) { return state.categoryType; },
    getSeasons: function (state) { return state.seasons; },
    getSeasonId: function getSeasonId(state, getter, rootState) {
      return state.seasonId || rootState.playerProfileGlobal.seasonId;
    },
    getGamesPlayed: function getGamesPlayed(state, getter, rootState, rootGetters) {
      var STADISTIC_ID = getter.getStadisticId;
      var PLAYER = rootGetters['playerProfileGeneral/player'];
      var GOALKEEPER_POSITION_ID = 1;
      var POSITION_ID = PLAYER ? PLAYER.position_id : null;
      var PLAYERS = rootGetters['playerProfileGeneral/seasonPlayers'].filter(function (p) {
        var add = POSITION_ID === null ? p.position_id !== GOALKEEPER_POSITION_ID : false;
        if (POSITION_ID) {
          add =
            POSITION_ID === GOALKEEPER_POSITION_ID
              ? p.position_id === GOALKEEPER_POSITION_ID
              : p.position_id !== GOALKEEPER_POSITION_ID;
        }
        return add;
      }).length;
      // todo: check if the formula is ok without TEAMS
      var TEAMS = rootGetters['playerProfileTeam/teamsForAnalysis'].length;
      //Stadistic_id helps to select if data should be total or average
      if (STADISTIC_ID === 0) {
        var GAMES = rootGetters['playerProfileGames/seasonGamesPlayed'];
        return (GAMES.filter(function (game) { return game.game_status !== 0; }).length * PLAYERS) / TEAMS;
      } else {
        return PLAYERS;
      }
    },
    getGamesPlayedByTeam: function getGamesPlayedByTeam(state, getter, rootState, rootGetters) {
      var STADISTIC_ID = getter.getStadisticId;
      // Stadistic_id helps to select if data should be total or average
      if (STADISTIC_ID === 0) {
        var GAMES = rootGetters['playerProfileGames/seasonGamesPlayed'];
        var TEAM_ID = rootGetters['playerProfileGeneral/teamId'];
        var playedGames = GAMES.filter(function (game) { return game.game_status !== 0; })
          .filter(function (game) {
            var add;
            if (state.playingAs === null) { add = game.home_team === TEAM_ID || game.visiting_team === TEAM_ID; }
            else if (state.playingAs === 1) { add = game.home_team === TEAM_ID; }
            else { add = game.visiting_team === TEAM_ID; }
            return add;
          })
          .filter(function (game) {
            var IS_HOME = game.home_team === TEAM_ID;
            var result = 1;
            if ((game.score[0] > game.score[1] && !IS_HOME) || (game.score[0] < game.score[1] && IS_HOME)) { result = 2; }
            else if (game.score[0] === game.score[1]) { result = 3; }
            return state.results.includes(result);
          }).length;
        return playedGames;
      }
      return 1;
    },
    getGamesPlayedByPlayer: function (state, getters, rootState) {
      if (getters.getStadisticId === 0) {
        if (rootState.playerProfileGeneral.playerBasePlays.length > 0) {
          var games = rootState.playerProfileGeneral.playerBasePlays.reduce(function (accumulator, play) {
              if (
                (state.playingAs === null || play[playerPlayIndexes.playingAs] === state.playingAs) &&
                state.results.includes(play[playerPlayIndexes.matchResult])
              ) {
                accumulator.add(play[playerPlayIndexes.gameId]);
              }
              return accumulator;
            }, new Set());
          return games.size;
        }
        return 0;
      }
      return 1;
    },
    getStadisticId: function (state) { return state.stadisticId; },
    getCategoryTypeName: function getCategoryTypeName(state) {
      var name;
      switch (state.categoryType) {
        case 1: name = 'posesion'; break;
        case 2: name = 'ofensivo'; break;
        case 3: name = 'defensivo'; break;
      }
      return name;
    },
  },
  mutations: {
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param sections
     */
    setSections: function (state, sections) {
      state.sections = sections;
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param results
     */
    setResults: function (state, results) {
      state.results = results;
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param playingAs
     */
    setPlayingAs: function (state, playingAs) {
      state.playingAs = playingAs;
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param seasonId
     */
    setSeasonId: function (state, seasonId) {
      state.seasonId = seasonId;
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param categoryType
     */
    setCategoryType: function (state, categoryType) {
      state.categoryType = categoryType;
    },
    /**
     * @author Alejandro
     * @param {Object} state
     * @param {Array<{id: number, name: string}>} seasons
     */
    setSeasons: function setSeasons(state, seasons) {
      state.seasons = seasons;
    },
    /**
     * @author Cristhian Gómez
     * @param {Object} state
     * @param {number} stadisticId
     */
    setStadisticId: function (state, stadisticId) {
      state.stadisticId = stadisticId;
    },
  },
  actions: {
    /**
     * @author Alejandro
     * @param {Object} context
     * @param {Object} payload
     * @param {Object} payload.seasons - Available seasons for selected team or player, object is a dictionary
     * in the form { "seasonId": "seasonName" }
     */
    updateSeasons: function updateSeasons(ref, ref$1) {
      var state = ref.state;
      var commit = ref.commit;
      var seasons = ref$1.seasons;

      if (seasons) {
        var unorderedSeasons = Object.entries(seasons).map(function (ref) {
          var k = ref[0];
          var v = ref[1];

          return ({ id: Number(k), name: v });
        });
        commit(
          'setSeasons',
          unorderedSeasons.sort(function (a, b) { return b.id - a.id; })
        );
        if (!state.seasonId) {
          commit('setSeasonId', unorderedSeasons[0].id);
        }
      }
    },
  },
};

var state$1 = {
  isSectionLoading: false,
  seasonId: 0,
  windowWidth: 0,
  requestsToken: null,
  isPremiumUser: false,
  isGolstats: 0
};

var getters$1 = {
  getRequestsToken: function (state) { return state.requestsToken; },
};

var mutations$1 = {
  setIsSectionLoading: function setIsSectionLoading(state, isSectionLoading) {
    state.isSectionLoading = isSectionLoading;
  },
  setSeasonId: function setSeasonId(state, seasonId) {
    state.seasonId = seasonId;
  },
  setWindowWidth: function setWindowWidth(state, windowWidth) {
    state.windowWidth = windowWidth ? windowWidth : window.innerWidth;
  },
  setRequestsToken: function setRequestsToken(state, requestsToken) {
    state.requestsToken = requestsToken;
  },
  setIsPremiumUser: function setIsPremiumUser(state, isPremiumUser) {
    state.isPremiumUser = isPremiumUser;
  },
  setIsGolstats: function setIsGolstats(state, isGolstats) {
    state.isGolstats = isGolstats;
  }
};

var playerProfileGlobal = {
  namespaced: true,
  state: state$1,
  mutations: mutations$1,
  getters: getters$1,
};

/**
 * @author Alejandro
 * @param {Object} params
 * @param {number} params.seasonId
 * @return {Promise<{type: ArrayConstructor, required: boolean}|{type: Array | ArrayConstructor, required: boolean}|[{score: number[], data: string, visiting_team: number, season_id: number, home_team: number, game_id: number}, {score: number[], data: string, visiting_team: number, season_id: number, home_team: number, game_id: number}]>}
 */
async function getGamesBySeason(ref) {
  var seasonId = ref.seasonId;

  try {
    // golstats url: https://8tvo5bp9ai.execute-api.us-west-2.amazonaws.com/prod/gamesBySeason/${seasonId}
    var url = "https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/gamesBySeason/" + seasonId;
    var response = await fetchRetry({ url: url });
    return response.data.games;
  } catch (e) {
    return Promise.reject(e);
  }
}

var playerProfileGames = {
  namespaced: true,
  state: {
    seasonGames: [],
    lastSeasonForSeasonGames: 0,
  },
  getters: {
    // seasonGames: state => state.seasonGames,
    seasonGamesPlayed: function (state) { return state.seasonGames.filter(function (game) { return game.game_status === 1; }); },
    gamesPlayed: function gamesPlayed(state, getters, rootState, rootGetters) {
      var PLAYING_AS = rootGetters['playerProfileFilter/getPlayingAs'];
      var RESULTS = rootGetters['playerProfileFilter/getResults'];
      return (
        getters.seasonGamesPlayed
          .filter(function () { return PLAYING_AS === null || PLAYING_AS === 1; })
          .filter(function (game) {
            var result = 1;
            if (game.score[0] < game.score[1]) { result = 2; }
            else if (game.score[0] === game.score[1]) { result = 3; }
            return RESULTS.includes(result);
          }).length
        + getters.seasonGamesPlayed
          .filter(function () { return PLAYING_AS === null || PLAYING_AS === 2; })
          .filter(function (game) {
            var result = 1;
            if (game.score[0] > game.score[1]) { result = 2; }
            else if (game.score[0] === game.score[1]) { result = 3; }
            return RESULTS.includes(result);
          }).length
      );
    },
  },
  mutations: {
    updateSeasonGames: function updateSeasonGames(state, seasonGames) {
      state.seasonGames = seasonGames;
    },
    updateLastSeasonForSeasonGames: function updateLastSeasonForSeasonGames(state, seasonId) {
      state.lastSeasonForSeasonGames = seasonId;
    },
  },
  actions: {
    getSeasonGames: async function getSeasonGames(ref, returnData) {
      var state = ref.state;
      var commit = ref.commit;
      var rootState = ref.rootState;
      if ( returnData === void 0 ) returnData = false;

      try {
        var seasonId = rootState.playerProfileFilter.seasonId;
        if (state.lastSeasonForSeasonGames === seasonId) {
          return undefined;
        }
        commit('updateLastSeasonForSeasonGames', seasonId);
        var seasonGames = await getGamesBySeason({ seasonId: seasonId });
        if (returnData) {
          return seasonGames;
        }
        commit('updateSeasonGames', seasonGames);
      } catch (e) {
        throw new Error(e);
      }
    },
  },
};

async function getLeaguePlaysBySeason(ref) {
  var seasonId = ref.seasonId;

  try {
    // golstats url: https://b5lrr2nc0h.execute-api.us-west-2.amazonaws.com/prod/statisticsLeagueBySeason/${seasonId}
    // golstats url json: https://golstats-microservices.s3-us-west-2.amazonaws.com/statsLeagueBySeason-${seasonId}.json
    var options = {
      url: ("https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/statsLeagueBySeason/" + seasonId),
    };
    var ref$1 = await fetchRetry(options);
    var data = ref$1.data.data;
    return data;
  } catch (e) {
    throw new Error(e);
  }
}

/**
 * @author Alejandro
 * @description Get all teams by a seasonId
 * @param {Object} params
 * @param {string|number} params.seasonId
 * @return {Promise<unknown>}
 */
async function getTeamsBySeason(params) {
  try {
    // golstats url: https://d2oco6mqmc.execute-api.us-west-2.amazonaws.com/prod/teamsBySeason/${params.seasonId}
    var url = "https://q9uu10dkd0.execute-api.us-west-2.amazonaws.com/prod/teamsBySeason/" + (params.seasonId);
    var response = await fetchRetry({ url: url });
    return response.data;
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 * This store must have all global league data, like all league games per season,
 * all league plays by season, all league teams per season, all league players by season, etc.
 */
var playerProfileLeague = {
  namespaced: true,
  state: {
    seasonPlays: [],
    // todo: how to get current season games, because user's login may return another season
    currentSeasonGames: [],
    currentSeasonTeams: [],
    selectedRound: 1,
  },
  getters: {
    seasonPlays: function (state) { return state.seasonPlays; },
    filteredPlaysStack: function filteredPlaysStack(state, getters, rootState, rootGetters) {
      return filterByGameLocationsAndResults(
        state.seasonPlays,
        rootGetters['playerProfileFilter/getPlayingAs'],
        rootGetters['playerProfileFilter/getResults'],
        getLeaguePlayIndexes(),
        rootGetters['playerProfileGeneral/teamId']
      );
    },
  },
  mutations: {
    updateSeasonPlays: function updateSeasonPlays(state, seasonPlays) {
      state.seasonPlays = seasonPlays;
    },
    updateCurrentSeasonTeams: function updateCurrentSeasonTeams(state, currentSeasonTeams) {
      state.currentSeasonTeams = currentSeasonTeams;
    },
    updateCurrentSeasonGames: function updateCurrentSeasonGames(state, currentSeasonGames) {
      state.currentSeasonGames = currentSeasonGames;
    },
    updateSelectedRound: function updateSelectedRound(state, selectedRound) {
      state.selectedRound = selectedRound;
    },
  },
  actions: {
    getSeasonPlays: async function getSeasonPlays(ref, returnData) {
      var commit = ref.commit;
      var rootState = ref.rootState;
      if ( returnData === void 0 ) returnData = false;

      try {
        var seasonPlays = await getLeaguePlaysBySeason({ seasonId: rootState.playerProfileFilter.seasonId });
        if (returnData) {
          return seasonPlays;
        }
        commit('updateSeasonPlays', seasonPlays);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getCurrentSeasonGames: async function getCurrentSeasonGames(ref) {
      var commit = ref.commit;
      var rootState = ref.rootState;

      try {
        var currentSeasonGames = await getGamesBySeason({ seasonId: rootState.playerProfileGlobal.seasonId });
        commit('updateCurrentSeasonGames', currentSeasonGames);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getCurrentSeasonTeams: async function getCurrentSeasonTeams(ref) {
      var commit = ref.commit;
      var rootState = ref.rootState;

      try {
        var response = await getTeamsBySeason({ seasonId: rootState.playerProfileGlobal.seasonId });
        commit('updateCurrentSeasonTeams', response.teams);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    isDataFilled: async function isDataFilled(ref) {
      var state = ref.state;
      var dispatch = ref.dispatch;
      var commit = ref.commit;

      try {
        if (state.currentSeasonGames.length > 0 && state.currentSeasonTeams.length > 0) {
          commit('playerProfileGlobal/setIsSectionLoading', false, { root: true });
          return true;
        }
        var promises = [undefined, undefined];
        if (state.currentSeasonGames.length === 0) {
          promises[0] = dispatch('getCurrentSeasonGames');
        }
        if (state.currentSeasonTeams.length === 0) {
          promises[1] = dispatch('getCurrentSeasonTeams');
        }
        await Promise.all(promises);
        return false;
      } catch (e) {
        throw new Error(e);
      }
    },
  },
};

var state = {
  team: {},
  seasonTeams: [],
  seasonTeamsAnalysis: [],
  teamSeasons: {},
  gamesBySeason: [],
  lastSeasonForSeasonTeamsAnalysis: 0,
};

var mutations = {
  updateTeam: function updateTeam(state, newTeam) {
    state.team = newTeam;
  },
  updateTeams: function updateTeams(state, newTeams) {
    state.seasonTeams = newTeams;
  },
  updateGames: function updateGames(state, newGames) {
    state.gamesBySeason = newGames;
  },
  updateTeamsForAnalysis: function updateTeamsForAnalysis(state, newTeams) {
    state.seasonTeamsAnalysis = newTeams;
  },
  updateLastSeasonForSeasonTeamsAnalysis: function updateLastSeasonForSeasonTeamsAnalysis(state, seasonId) {
    state.lastSeasonForSeasonTeamsAnalysis = seasonId;
  },
};

var actions = {
  /**
   * @author Alejandro
   * @param {Object} context
   * @param {boolean} holdLoading
   * @return {Promise}
   */
  getTeamsBySeason: async function getTeamsBySeason$1(ref, holdLoading) {
    var commit = ref.commit;
    var rootState = ref.rootState;
    var rootGetters = ref.rootGetters;

    try {
      if (!rootState.isSectionLoading) { commit('setIsSectionLoading', true, { root: true }); }
      var seasonId = rootGetters['loginGeneral/seasonId'];
      var result = await getTeamsBySeason({ seasonId: seasonId });
      commit('updateTeams', result.teams);
      if (!holdLoading) { commit('setIsSectionLoading', false, { root: true }); }
    } catch (e) {
      // commit('setIsSectionLoading', false, { root: true });
      return Promise.reject(e);
    }
  },

  /**
   * @author Alejandro
   * @param {Object} context
   * @param {boolean} returnData
   * @return {Promise}
   */
  getTeamsBySeasonForAnalysis: async function getTeamsBySeasonForAnalysis(ref, returnData) {
    var commit = ref.commit;
    var rootGetters = ref.rootGetters;
    if ( returnData === void 0 ) returnData = false;

    try {
      var seasonId = rootGetters['playerProfileFilter/getSeasonId'];
      if (state.lastSeasonForSeasonTeamsAnalysis === seasonId) {
        return undefined;
      }
      var ref$1 = await getTeamsBySeason({ seasonId: seasonId });
      var teams = ref$1.teams;
      commit('updateLastSeasonForSeasonTeamsAnalysis', seasonId);
      if (returnData) {
        return teams;
      }
      commit('updateTeamsForAnalysis', teams);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};

var getters = {
  team: function (state) { return state.team; },
  teams: function (state) { return state.seasonTeams; },
  teamId: function (state) { return state.team.team_id; },
  teamsForAnalysis: function (state) {
    return state.seasonTeamsAnalysis;
  },
  seasonTeams: function seasonTeams(state) {
    return state.seasonTeams;
  },
  /**
   * @author José Rafael Gutierrez
   * @param state
   * @param rootState
   * @param rootGetters
   * @return Array
   */
  getPlays: function (state, rootState, rootGetters) {
    var sections = rootGetters.filterGeneral.sections;
    var results = rootGetters.filterGeneral.results;
    var playingAs = rootGetters.filterGeneral.playingAs;
    var categoryType = rootGetters.filterGeneral.categoryType;
    return state.plays.filter(function (play) {
      return (
        play[5] === categoryType &&
        sections.includes(play[7]) &&
        results.includes(play[8]) &&
        (playingAs === null ? true : play[9] === playingAs)
      );
    });
  },
  getGamesBySeason: function getGamesBySeason(state) {
    return state.gamesBySeason;
  },
};

var playerProfileTeam = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};

var modules = Object.assign({}, player,
  {playerProfileFilter: playerProfileFilter,
  playerProfileGames: playerProfileGames,
  playerProfileGlobal: playerProfileGlobal,
  playerProfileLeague: playerProfileLeague,
  playerProfileTeam: playerProfileTeam});

(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }
})();

function ceilMod(num, decQty) {
  var decimalsToNegative = decQty * -1;
  return Math.ceil10(num, decimalsToNegative)
}

var nationalities = {
  2: 'Afgano',
  3: 'Albanés',
  4: 'Argelino',
  6: 'Andorrano',
  7: 'Angoleño',
  8: 'Anguillan',
  9: 'Antiguan',
  10: 'Argentino',
  11: 'Armenio',
  12: 'Arubeño',
  13: 'Australiano',
  14: 'Austriaco',
  15: 'Azerbaiyano',
  16: 'Bahameño',
  17: 'Bareiní',
  18: 'Bangladesí',
  19: 'Barbadense',
  20: 'Bielorruso',
  21: 'Belga',
  22: 'Beliceño',
  23: 'Beninés',
  24: 'Bermudeño',
  25: 'Butanés',
  26: 'Boliviano',
  27: 'Bosnio',
  28: 'Botsuano',
  29: 'Brasileño',
  30: 'Islas Vírgenes Británicas',
  31: 'Bruneano',
  32: 'Bulgaro',
  33: 'Burkinés',
  34: 'Birmano',
  35: 'Burundés',
  36: 'Camboyano',
  37: 'Cameroonian',
  38: 'Canadiense',
  39: 'Caboverdiano',
  40: 'Caimanés',
  41: 'Centro Africano',
  42: 'Chadiano',
  43: 'Chileno',
  44: 'Chino',
  45: 'Isla de Navidad',
  46: 'Cocos Island',
  47: 'Colombiano',
  48: 'Comoriense',
  49: 'Congoleño',
  50: 'Cookiano',
  51: 'Costarriqueño',
  52: 'Marfileño',
  53: 'Croata',
  54: 'Cubano',
  55: 'Chipriota',
  56: 'Checo',
  57: 'Danés',
  58: 'Yibutiano',
  59: 'Dominicano',
  60: 'Dominicano',
  61: 'Timorense',
  62: 'Ecuatoriano',
  63: 'Egipcio',
  64: 'Salvadoreño',
  65: 'Inglés',
  66: 'Ecuatoguineano',
  67: 'Eritreo',
  68: 'Estonio',
  69: 'Etíope',
  70: 'Islas Malvinas',
  71: 'Feroés',
  72: 'Fiyiano',
  73: 'Finés',
  74: 'Francés',
  75: 'Guayana Francesa',
  76: 'Francopolinecio',
  77: 'Gabonés',
  78: 'Gambiano',
  79: 'Georgiano',
  80: 'Alemán',
  81: 'Ghanés',
  82: 'Gibraltareño',
  83: 'Británico',
  84: 'Griego',
  85: 'Groenlandés',
  86: 'Granadino',
  87: 'Guadeloupeño',
  88: 'Guatemalteco',
  89: 'Guatemalteco',
  90: 'Guineano',
  91: 'Guyanés',
  92: 'Haitiano',
  93: 'Hondureño',
  94: 'Hongkongese',
  95: 'Húngaro',
  96: 'Islandés',
  97: 'Indio',
  98: 'Indonesio',
  99: 'Iraní',
  100: 'Iraquí',
  101: 'Irlandés',
  102: 'Manés',
  103: 'Israelí',
  104: 'Italiano',
  105: 'Jamaiquino',
  106: 'Japonés',
  107: 'Jordano',
  108: 'Kazajo',
  109: 'Keniano',
  110: 'Kiribatiano',
  111: 'Norcoreano',
  112: 'Surcoreano',
  113: 'Kosovan',
  114: 'Kuwaití',
  115: 'Kirguis',
  116: 'Laosiano',
  117: 'Letón',
  118: 'Libanés',
  119: 'Basotho',
  120: 'Liberiano',
  121: 'Libio',
  122: 'Liechtenstein',
  123: 'Lituano',
  124: 'Luxemburgués',
  125: 'Macaneso',
  126: 'Macedónio',
  127: 'Madagascarí',
  128: 'Malawi',
  129: 'Malasio',
  130: 'Maldivo',
  131: 'Maliense',
  132: 'Maltés',
  133: 'Marshallese',
  134: 'Martinicano',
  135: 'Mauritano',
  136: 'Mauriciano',
  137: 'Mahoran',
  138: 'Mexicano',
  139: 'Micronesio',
  140: 'Moldavo',
  141: 'Monacan',
  142: 'Mongol',
  143: 'Montenegrino',
  144: 'Montserratiano',
  145: 'Marroquí',
  146: 'Pozambiqueño',
  147: 'Namibio',
  148: 'Nauruan',
  149: 'Nepalí',
  150: 'Dolandés',
  151: 'Neocaledonio',
  152: 'Neozelandés',
  153: 'Nicaragüense',
  154: 'Niueño',
  155: 'Nigerino',
  156: 'Nigeriano',
  157: 'Noruego',
  158: 'Normariano',
  159: 'Omaní',
  160: 'Pakistaní',
  161: 'Palestino',
  162: 'Palauan',
  163: 'Panameño',
  164: 'Papú',
  165: 'Paraguayo',
  166: 'Peruano',
  167: 'Filipino',
  168: 'Pitcairnés',
  169: 'Polaco',
  170: 'Portugués',
  171: 'Puerto Riqueño',
  172: 'Catarí',
  173: 'Reunionés',
  174: 'Rumano',
  175: 'Ruso',
  176: 'Ruandés',
  177: 'Santa Elena',
  178: 'Sancristobaleño',
  179: 'Santa Lucía',
  180: 'Miquelonnais',
  181: 'Vicenciano',
  182: 'Samoano',
  183: 'Sanmariense',
  184: 'Santotomense',
  185: 'Saudí',
  186: 'Escocés',
  187: 'Senegalés',
  188: 'Serbio',
  189: 'Seychellense',
  190: 'Sierraleonés',
  191: 'Singapurense',
  192: 'Eslovaco',
  193: 'Esloveno',
  194: 'Salomonense',
  195: 'Somalí',
  196: 'Surafrincano',
  197: 'Surosetio',
  198: 'Español',
  199: 'Esrilanques',
  200: 'Sudanés',
  201: 'Surinamés',
  202: 'Swazi',
  203: 'Sueco',
  204: 'Suizo',
  205: 'Sirio',
  206: 'Taiwanés',
  207: 'Tayiko',
  208: 'Tanzano',
  209: 'Tailandés',
  210: 'Togolés',
  211: 'Tongano',
  212: 'Trinitense',
  213: 'Tunecino',
  214: 'Turco',
  215: 'Turcomano',
  216: 'none',
  217: 'Tuvaluano',
  218: 'Ugandés',
  219: 'Ucranio',
  220: 'Emiratí',
  221: 'Británico',
  222: 'Americano',
  223: 'Uruguayo',
  224: 'Uzbeko',
  225: 'Vanuatuense',
  226: 'Venezolano',
  227: 'Vietnamita',
  228: 'Islas Vírgenes',
  229: 'Galés',
  230: 'Walisiano',
  231: 'Saharaui',
  232: 'Yemenita',
  233: 'Zambiano',
  234: 'Zimbabuo',
  236: 'Curazoleño',
  237: 'San Martín',
  238: 'Afgano',
  239: 'Debutantes',
};

var playerPositions = {
  1: 'Portero',
  2: 'Defensa Central',
  3: 'Lateral por izquierda',
  4: 'Lateral por derecha',
  5: 'Volante por izquierda',
  6: 'Volante por derecha',
  7: 'Volante defensivo',
  8: 'Volante ofensivo',
  9: 'Delantero',
};

function filters(Vue) {
  // nationalityId must be an integer
  Vue.filter('toNationalityName', function (nationalityId) {
    return nationalityId ? nationalities[nationalityId] : '';
  });

// playerPositionId must be an integer
  Vue.filter('toPlayerPositionName', function (playerPositionId) {
    return playerPositionId ? playerPositions[playerPositionId] : '';
  });

// dateOfBirth must be a valid date format string
  Vue.filter('toAge', function (dateOfBirth) {
    return dateOfBirth ? differenceInYears(new Date(), new Date(dateOfBirth)) : '';
  });

  // ceil decimals
  Vue.filter('ceilMod', function (num, decQty) {
    if ( decQty === void 0 ) decQty = 2;

    return ceilMod(num, decQty);
  });

  // Should be decimal, rounds 2 values
  Vue.filter('fixed', function (value) {
    var isFloat = function (x) { return !!(x % 1); };
    if (isFloat(value)) {
      return value.toFixed(2);
    }
    return value;
  });
}

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue, options) {
  if (install.installed) { return; }
  install.installed = true;
  setStore(options.store);
  filters(Vue);
  // directives(Vue);
  for (var [k, v] of Object.entries(modules)) {
    options.store.registerModule(k, v);
  }
  Vue.component('PlayerProfile', __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

__vue_component__.install = install;

export default __vue_component__;
export { install };
